import React, { useEffect, useRef, useState } from "react";
import "react-form-wizard-component/dist/style.css";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { camelCase, capitalCase } from "change-case";

import Gotop from "../components/gotop";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";

import { FaPlus, FaBook, FaFilePdf } from "react-icons/fa";
import { AWSUpload } from "../Upload/awsupload";
import { callApi } from "../constant/callApi";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import DeputationModal from "./alertModal"; // Adjust path as needed

import "react-tabs/style/react-tabs.css";
import {
  IoCheckmarkCircleOutline,
  IoCloseCircleOutline,
  IoEyeOutline,
} from "react-icons/io5";
import {
  Alert,
  Badge,
  Button,
  ButtonGroup,
  Card,
  Form,
  ModalHeader,
  Spinner,
  Table,
} from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HamburgerMenu from "../assets/Mobile Menu/HamburgerMenu";
import DomicileOfOdisha from "./DynamicComplexInputs/DomicileOfOdisha";
import PersonWithDisability from "./DynamicComplexInputs/PersonWithDisability";
import AreYouASportsMan from "./DynamicComplexInputs/AreYouASportsMan";
import ReservationCategory from "./DynamicComplexInputs/ReservationCategory";
import DepartmentalCandidate from "./DynamicComplexInputs/DepartmentalCandidate";
import Preloader from "../components/preloader";
import ExServicemen from "./DynamicComplexInputs/Exservicemen";
import Declaration from "./DynamicComplexInputs/declaration";
import ReactToPrint from "react-to-print";
import FinalFormSubmitModal from "./finalFormSubmitModal";
import pdf from "../assets/images/pdf.png";
import omclogo from "../assets/images/logo-removebg-preview.png";
import countriesData from "../masterFunctions/countries.json";
import { IoMdClose } from "react-icons/io";
import { MdDeleteOutline } from "react-icons/md";
import { FaCheckCircle } from "react-icons/fa";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import ExperienceInputs from "./DynamicComplexInputs/ExperienceInputs";
import pdfIcon from "../assets/images/pdf-icon.png";
import waringSign from "../assets/images/warnOmc.png";

function formatDate(inputDate) {
  // Create a Date object from the input string
  const date = new Date(inputDate);
  console.log({ date });

  // Get the year, month, and day from the Date object
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, "0");

  // Return the formatted date
  return `${day}/${month}/${year}`;
}

const DynamicApplicationFrom = () => {
  const [OpenImageModal, SetImageModalOpen] = useState(false);
  const [applicationDetails, setApplicationDetails] = useState(null);
  const [applicationForm, setApplicationForm] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndexFromDb, setTabIndexFromDb] = useState(0);
  const [checkedValues, setCheckedValues] = useState([]);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [isAICheck, setIsAICheck] = useState(false);
  const [responceAiCheck, setResponceAiCheck] = useState("");
  const [application, setApplication] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [applicationID, setApplicationID] = useState(null);
  const [Loading, setLoading] = useState(true);
  const [finalSubmitModal, setFinalSubmitModal] = useState(false);
  const [showDeputationModal, setShowDeputationModal] = useState(false);

  const [showIframe, setShowIframe] = useState(false);
  const [fieldErrors, setFieldErrors] = useState([]);
  const [saveAndNextLoader, setSaveAndNextLoader] = useState(false);
  const [errorFromBackend, setErrorFromBackend] = useState({});
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showIntegratedLLBDialog, setShowIntegratedLLBDialog] = useState(false);
  const [showNotEligibleModal, setShowNotEligibleModal] = useState(false);
  const [hideLLBSection, setHideLLBSection] = useState(false);
  const [closingDate, setClosingDate] = useState();
  const [relation, setRelation] = useState("Son");

  // SAS Token for blob storage access - loaded from environment variable with fallback
  const sasToken =
    process.env.REACT_APP_SAS_TOKEN ||
    "sp=racwd&st=2025-11-05T04:53:36Z&se=2027-01-01T13:08:36Z&spr=https&sv=2024-11-04&sr=c&sig=hQ%2BFCGxIoCVboFWlW7S%2Bp2BYyN2m%2FfAIYtu41mcHoPI%3D";

  // Helper function to build URL with SAS token
  const buildUserManualUrl = (path) => {
    const baseUrl = `https://odishminingblobsg.blob.core.windows.net/blobcontainer-sg/blobcontainer-sg/${path}`;
    return `${baseUrl}?${sasToken}`;
  };

  // User Manual PDF URLs mapping with SAS token
  const userManualUrls = {
    "PERSONAL DETAILS": buildUserManualUrl(
      "User%20Manual/1-PersonalDetails.pdf"
    ),
    "COMMUNICATION DETAILS": buildUserManualUrl(
      "User%20Manual/2-CommunicationDetails.pdf"
    ),
    "ESSENTIAL QUALIFICATION": buildUserManualUrl(
      "User%20Manual/3-EssentialQualification.pdf"
    ),
    "ADDITIONAL QUALIFICATION": buildUserManualUrl(
      "User%20Manual/4-AdditionalQualification.pdf"
    ),
    "TRAINING DETAILS": buildUserManualUrl(
      "User%20Manual/5-TrainingDetails.pdf"
    ),
    EXPERIENCE: buildUserManualUrl("User%20Manual/6-ExperienceDetails.pdf"),
    "OTHER ESSENTIAL": buildUserManualUrl("User%20Manual/7-OtherEssential.pdf"),
    DOCUMENTS: buildUserManualUrl("User%20Manual/8-DocumentUpload.pdf"),
  };

  // Function to open user manual in new tab
  const openUserManual = (tabName) => {
    const manualUrl = userManualUrls[tabName?.toUpperCase()];
    if (manualUrl) {
      window.open(manualUrl, "_blank", "noopener,noreferrer");
    } else {
      toast.warning("User manual not available for this tab.");
    }
  };

  // Add useEffect to check graduation course when applicationDetails loads
  useEffect(() => {
    if (applicationDetails) {
      // Find the graduation course field value - check all fields for "Integrated LLB"
      const hasIntegratedLLB = Object.values(applicationDetails).some(
        (value) => {
          return value === "Integrated LLB";
        }
      );

      if (hasIntegratedLLB) {
        // If Integrated LLB is found, hide the LLB section
        setHideLLBSection(true);
      } else {
        // If no Integrated LLB found, show the LLB section
        setHideLLBSection(false);
      }
    }
  }, [applicationDetails]);

  // Sync verification status from dynamicFields to applicationDetails
  // This ensures checkErrorsClass can find verification status for array fields (Training Details)
  // and prevents "Please verify" error from showing when file is already verified
  useEffect(() => {
    if (!dynamicFields || dynamicFields.length === 0) return;

    let hasUpdates = false;
    const updates = {};
    const errorsToClear = [];

    dynamicFields.forEach((fieldSet) => {
      fieldSet.fields.forEach((field) => {
        const fieldId = field?.values?._id;
        const fieldType = field?.values?.inputFieldType;
        const fieldValue = field?.value;
        const isVerified = field?.verified === true;

        // Only process file upload fields that are verified
        if (
          (fieldType === "pdf" || fieldType === "image") &&
          fieldValue &&
          typeof fieldValue === "string" &&
          fieldValue.trim() !== "" &&
          isVerified
        ) {
          const camelCaseKey = fieldId + fieldSet.id;
          const verifiedKeyByCamelCase = `${camelCaseKey}verified`;
          const verifiedKeyById = fieldId ? `${fieldId}verified` : null;

          // Update applicationDetails if not already set
          if (applicationDetails[verifiedKeyByCamelCase] !== true) {
            updates[verifiedKeyByCamelCase] = true;
            hasUpdates = true;
          }

          if (verifiedKeyById && applicationDetails[verifiedKeyById] !== true) {
            updates[verifiedKeyById] = true;
            hasUpdates = true;
          }

          // Track which fields need error clearing
          errorsToClear.push(camelCaseKey);
        }
      });
    });

    // Update applicationDetails if there are changes
    if (hasUpdates) {
      setApplicationDetails((prev) => ({
        ...prev,
        ...updates,
      }));
    }

    // Clear verification errors for verified fields
    if (errorsToClear.length > 0) {
      setFieldErrors((prevErrors) => {
        let hasErrorUpdates = false;
        const updatedErrors = { ...prevErrors };

        errorsToClear.forEach((camelCaseKey) => {
          const currentErrors = prevErrors?.[camelCaseKey]?.errors || [];
          const hasVerificationErrors = currentErrors.some(
            (err) =>
              err.includes("verify") ||
              err.includes("Verify") ||
              err.includes("verification")
          );

          if (hasVerificationErrors) {
            hasErrorUpdates = true;
            const filteredErrors = currentErrors.filter(
              (err) =>
                err !== "This field is required." &&
                !err.includes("verify") &&
                !err.includes("Verify") &&
                !err.includes("verification") &&
                !err.includes("Please Verify The File") &&
                !err.includes(
                  "Please verify the uploaded document before proceeding."
                ) &&
                !err.includes(
                  "Please verify all uploaded documents before proceeding."
                )
            );
            updatedErrors[camelCaseKey] = {
              errors: filteredErrors,
              touched: true,
            };
          }
        });

        return hasErrorUpdates ? updatedErrors : prevErrors;
      });
    }
  }, [dynamicFields]);

  let countryHolder = "66a66fd74db5f02d6861e873";
  let stateHolder = "66a6705e4db5f02d6861e894";

  // COMMUNICATION DETAILS - address field IDs for correspondence vs permanent (to avoid state/district crossover)
  const CORR_COUNTRY_ID = "66a66fd74db5f02d6861e873";
  const CORR_STATE_ID = "66a6705e4db5f02d6861e894";
  const CORR_DISTRICT_ID = "66a6705e4db5f02d6861e895";
  const PERM_COUNTRY_ID = "66a672c14db5f02d6861e931";
  const PERM_STATE_ID = "66a672c14db5f02d6861e932";
  const PERM_DISTRICT_ID = "66a672c14db5f02d6861e933";

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChangeDeclare = (event) => {
    const checked = event.target.checked;

    setIsChecked(checked);
    setApplicationDetails((prev) => ({
      ...prev,
      finalSubmitDeclaration: checked,
      relationDeclaration: `I ${prev?.applicantSFullName} ${relation} of ${prev["66a4cb29fc50e50a0b885535"]} do hereby
        declare that all the statements made in the application are true and
        correct to the best of my knowledge and belief. In the event of any
        information being found false, my candidature/appointment is liable to
        be cancelled/terminated without any reference & notice to me.`, // Updated declaration text
    }));

    // Trigger validation on change
    checkErrorFn(
      { values: { isRequired: true } },
      "finalSubmitDeclaration",
      checked
    );
  };

  const handleRelationChange = (e) => {
    const value = e.target.value;
    setRelation(value);

    setApplicationDetails((prev) => ({
      ...prev,
      relationDeclaration: `I ${prev.applicantSFullName} ${value}  do hereby
        declare that all the statements made in the application are true and
        correct to the best of my knowledge and belief. In the event of any
        information being found false, my candidature/appointment is liable to
        be cancelled/terminated without any reference & notice to me.`,
    }));

    // Validate relation selection
    checkErrorFn(
      { values: { isRequired: true } },
      "relationDeclaration",
      value
    );
  };

  const [fieldValue, setFieldValue] = useState("");
  const [camelCaseKey, setCamelCaseKey] = useState("");

  const getDisplayErrors = (key, { hideVerificationErrors = false } = {}) => {
    const errors = fieldErrors?.[key]?.errors || [];
    if (!hideVerificationErrors) {
      return errors;
    }
    return errors.filter((error) => {
      if (!error) return false;
      const normalized = error.toString().toLowerCase();
      return (
        !normalized.includes("verify") && !normalized.includes("verification")
      );
    });
  };

  const handleViewFile = (key, file) => {
    setCamelCaseKey(key);
    setFieldValue(file);
    setShowIframe(key);
  };

  // Function to close the modal and redirect to all jobs page if eligibility error
  const handleModalClose = () => {
    setShowErrorModal(false);
    // Redirect to all jobs page if there's an eligibility error
    if (
      errorFromBackend?.ageEligibilityError?.message ||
      errorFromBackend?.experienceEligibilityError?.message
    ) {
      navigate("/all-jobs");
    }
  };

  // Automatically show modal when age eligibility error is set
  useEffect(() => {
    if (
      errorFromBackend?.ageEligibilityError?.message ||
      errorFromBackend?.experienceEligibilityError?.message
    ) {
      setShowErrorModal(true);
    }
  }, [
    errorFromBackend?.ageEligibilityError,
    errorFromBackend?.experienceEligibilityError,
  ]);

  // const handleSubmitForm = () => {
  //   // Add your form submission logic here
  //   if (errorFromBackend?.ageEligibilityError?.message || errorFromBackend?.experienceEligibilityError?.message) {
  //     setShowErrorModal(true); // Show modal if there are errors
  //   } else {
  //     // Proceed with form submission
  //   }
  // };

  function sentenceCase(text) {
    if (!text) return "";
    const sentences = text.split(/(?<=[.!?])\s+/);
    return sentences
      .map((sentence) => {
        return sentence
          .split("/")
          .map((part) => {
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
          })
          .join("/");
      })
      .join(" ");
  }

  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const getApplicationById = async (id) => {
    setLoading(true);
    try {
      const config = {
        method: "post",
        url: "application/application/getApplicationById",
        data: {
          id: id,
        },
      };
      const response = await callApi(config);

      if (response.data.code === 200) {
        setApplication(response.data.data);

        setLoading(false);
      } else {
        // navigate("/alljoblist");
      }
      setIsLoading2(false);
    } catch (error) {
      // console.log(error);
      // navigate("/alljoblist");
    } finally {
      setIsLoading2(false);
    }
  };

  useEffect(() => {
    let applicationId = searchParams.get("__application_id");
    // console.log("__application_id", applicationId);
    if (applicationId) {
      getApplicationById(applicationId);
    } else {
      // navigate("/alljoblist");
    }
  }, []);

  const style = {};
  style.label = {
    color: "#000",
    marginTop: "15px",
    marginBottom: "-10px",
    fontFamily: "'Roboto', sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    // fontSize: "10px",
    // fontWeight: "400px",
  };
  style.input = {
    borderRadius: "5px",
    height: "35px",
    color: "black",
    padding: "5px",
    color: "#000",
    fontSize: "13px",
    fontWeight: "500",
    border: "2px solid #E6E6E6",
    marginTop: "4px",
    // fontSize: "10px",
    // fontWeight: "350",
  };
  style.errorSpan = {
    color: "red",
    fontSize: "12px",
  };
  style.errorBox = {
    border: "1px solid red",
  };

  const inputBoxStyle = {
    height: "35px",
    borderRadius: "5px",
    paddingLeft: "10px",
  };

  const handleCheckboxChange = (e, item) => {
    const { checked, value } = e.target; // Extract 'checked' status and 'value'

    if (checked) {
      setCheckedValues([...checkedValues, value]);
    } else {
      setCheckedValues(checkedValues.filter((v) => v !== value));
    }
  };

  const handleAddFieldSet = (template, formTab, index) => {
    const newFieldSet = {
      id: uuidv4(),
      fields: JSON.parse(JSON.stringify(template)),
      tab: camelCase(formTab),
    };
    setDynamicFields((prev) => [...prev, newFieldSet]);
  };

  const handleBlankAddFieldSet = (template, formTab, index) => {
    // Disable automatic addition - only add when explicitly called
    return;

    // Original logic commented out to prevent automatic addition
    // const DataPresent = dynamicFields.filter(
    //   (e) => e.tab == camelCase(formTab)
    // );
    // const isDataPresent = DataPresent.length > 0;

    // if (!isDataPresent) {
    //   const newFieldSet = {
    //     id: index + "Ind",
    //     fields: JSON.parse(JSON.stringify(template)),
    //     tab: camelCase(formTab),
    //   };
    //   setDynamicFields((prev) => [...prev, newFieldSet]);
    // }
  };

  function getCurrentDateTime() {
    const now = new Date();

    // Format the date
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;

    // Format the time
    const hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${ampm}`;

    return { date: formattedDate, time: formattedTime };
  }

  const handleAddFieldSetWithValuesDynamic = (values, formTab, index) => {
    // Check if values has actual data (not empty or just spaces)
    const hasData = Object.values(values || {}).some((val) => {
      return (
        val &&
        typeof val === "string" &&
        val.trim() !== "" &&
        val.trim() !== " "
      );
    });

    // Don't add if there's no actual data
    if (!hasData) {
      return;
    }

    let keyAll = application?.inputElements?.filter((e) => {
      return camelCase(e.formTab) == formTab;
    });
    let val_ = keyAll.map((e) => {
      return { key: camelCase(e.inputFieldName), valuess: e };
    });
    let template = [];
    for (let index = 0; index < val_?.length; index++) {
      const obKey = val_[index].key;
      let data = {
        tab: formTab,
        value: values[obKey] || " ",
        values: val_[index].valuess,
      };
      template.push(data);
    }

    const newFieldSet = {
      id: uuidv4(),
      fields: JSON.parse(JSON.stringify(template)),
      tab: formTab,
    };

    // Restore verification status for file upload fields (like DepartmentalCandidate)
    // Check sessionStorage by file URL to restore verification even when fieldSet.id changes
    // NOTE: This only runs when loading data from database, not for new uploads
    setTimeout(() => {
      const userId = sessionStorage.getItem("userId");
      if (!userId) return;

      const updatedFields = newFieldSet.fields.map((field) => {
        const fieldId = field?.values?._id;
        const fieldType = field?.values?.inputFieldType;
        const fieldValue = field?.value;

        // Check if this is a file upload field with a value
        // IMPORTANT: Only restore verification if field doesn't already have verified: false
        // This prevents auto-verifying newly uploaded files
        if (
          (fieldType === "pdf" || fieldType === "image") &&
          fieldValue &&
          typeof fieldValue === "string" &&
          fieldValue.trim() !== "" &&
          field?.verified !== false
        ) {
          // Only restore if not explicitly set to false (new upload)

          const camelCaseKey = fieldId + newFieldSet.id;

          // Check sessionStorage for verification by file URL
          let isVerified = false;

          // Method 1: Check by current camelCaseKey (unlikely to match, but try first)
          const sessionKey = `verification_${userId}_${camelCaseKey}`;
          if (sessionStorage.getItem(sessionKey) === "true") {
            isVerified = true;
          }

          // Method 2: Check by file URL (extract pathname for stable key)
          if (!isVerified) {
            try {
              let fileIdentifier = fieldValue;
              try {
                const url = new URL(fieldValue);
                fileIdentifier = url.pathname || fieldValue;
              } catch (e) {
                fileIdentifier = fieldValue;
              }

              // Try pathname-based key
              const fileUrlKey = `verification_${userId}_file_${fileIdentifier.substring(
                0,
                200
              )}`;
              if (sessionStorage.getItem(fileUrlKey) === "true") {
                isVerified = true;
              }

              // Try base64 encoded full URL
              if (!isVerified) {
                const fileUrlKeyBase64 = `verification_${userId}_file_b64_${btoa(
                  fieldValue
                ).substring(0, 150)}`;
                if (sessionStorage.getItem(fileUrlKeyBase64) === "true") {
                  isVerified = true;
                }
              }
            } catch (e) {
              // If encoding fails, continue
            }
          }

          // Method 3: Iterate through all sessionStorage keys to find matching file URL
          if (!isVerified) {
            for (let i = 0; i < sessionStorage.length; i++) {
              const key = sessionStorage.key(i);
              if (
                key &&
                key.startsWith(`verification_${userId}_file_`) &&
                sessionStorage.getItem(key) === "true"
              ) {
                try {
                  if (key.includes("_file_b64_")) {
                    const storedUrl = atob(
                      key.replace(`verification_${userId}_file_b64_`, "")
                    );
                    if (
                      storedUrl === fieldValue ||
                      fieldValue.includes(storedUrl) ||
                      storedUrl.includes(fieldValue)
                    ) {
                      isVerified = true;
                      break;
                    }
                  } else {
                    const storedIdentifier = key.replace(
                      `verification_${userId}_file_`,
                      ""
                    );
                    try {
                      const url1 = new URL(fieldValue);
                      const pathname1 = url1.pathname || fieldValue;
                      if (
                        pathname1.includes(storedIdentifier) ||
                        storedIdentifier.includes(pathname1)
                      ) {
                        isVerified = true;
                        break;
                      }
                    } catch (e) {
                      if (
                        fieldValue.includes(storedIdentifier) ||
                        storedIdentifier.includes(fieldValue)
                      ) {
                        isVerified = true;
                        break;
                      }
                    }
                  }
                } catch (e) {
                  // Continue searching
                }
              }
            }
          }

          // Restore verification status in field object (like DepartmentalCandidate)
          // Only if verification was found in sessionStorage
          if (isVerified) {
            // Also update applicationDetails immediately so checkErrorsClass can find it
            const fieldId = field?.values?._id;
            const verifiedKeyByCamelCase = `${camelCaseKey}verified`;
            const verifiedKeyById = fieldId ? `${fieldId}verified` : null;

            setApplicationDetails((prev) => {
              const updated = { ...prev };
              updated[verifiedKeyByCamelCase] = true;
              if (verifiedKeyById) {
                updated[verifiedKeyById] = true;
              }
              return updated;
            });

            return { ...field, verified: true };
          } else {
            // If no verification found, explicitly set to false to prevent auto-verification
            return { ...field, verified: false };
          }
        }

        return field;
      });

      // Update the fieldSet with restored verification status
      newFieldSet.fields = updatedFields;

      // Update dynamicFields with the restored verification (only update, don't add)
      // The fieldSet was already added at line 629, so we just update it if it exists
      setDynamicFields((prev) => {
        const existingIndex = prev.findIndex((fs) => fs.id === newFieldSet.id);
        if (existingIndex !== -1) {
          // FieldSet exists, update it with verification status
          const updated = [...prev];
          updated[existingIndex] = newFieldSet;
          return updated;
        }
        // FieldSet doesn't exist yet (shouldn't happen, but handle gracefully)
        return prev;
      });
    }, 100);

    // Add the fieldSet immediately (without verification status)
    setDynamicFields((prev) => {
      // Check if fieldSet already exists to prevent duplicates
      const exists = prev.some((fs) => {
        // Check if this fieldSet is a duplicate by comparing tab and field values
        if (fs.tab === newFieldSet.tab) {
          // Compare field values to detect duplicates
          const fsFields = fs.fields || [];
          const newFields = newFieldSet.fields || [];
          if (fsFields.length === newFields.length) {
            // Check if all field values match (excluding fieldSet.id)
            const allFieldsMatch = fsFields.every((f, idx) => {
              const newField = newFields[idx];
              return (
                f?.values?._id === newField?.values?._id &&
                f?.value === newField?.value
              );
            });
            if (allFieldsMatch) {
              return true; // Duplicate found
            }
          }
        }
        return false;
      });

      if (exists) {
        // Duplicate detected, don't add
        return prev;
      }

      // No duplicate, add the new fieldSet
      return [...prev, newFieldSet];
    });
  };

  // Handler to delete a specific field set
  const handleDeleteFieldSet = (fieldSet, indexOfFieldSet) => {
    // Also update applicationDetails to remove the deleted qualification BEFORE removing from dynamicFields
    // This ensures the deletion persists when the page is reloaded
    if (
      fieldSet?.tab === "additionalQualification" &&
      applicationDetails?.additionalQualification
    ) {
      // Get all fieldSets for additionalQualification BEFORE deletion to find the correct index
      const allAdditionalQualFields = dynamicFields.filter(
        (fs) => fs.tab === "additionalQualification"
      );

      // Find the index of the deleted fieldSet in the filtered list
      const deletedIndex = allAdditionalQualFields.findIndex(
        (fs) => fs.id === fieldSet.id
      );

      // Remove from applicationDetails using the index
      if (
        deletedIndex >= 0 &&
        deletedIndex < applicationDetails.additionalQualification.length
      ) {
        setApplicationDetails((prev) => {
          if (!prev?.additionalQualification) return prev;

          const updatedQualifications = prev.additionalQualification.filter(
            (_, index) => index !== deletedIndex
          );

          return {
            ...prev,
            additionalQualification: updatedQualifications,
          };
        });
      }
    }

    // Remove from dynamicFields
    setDynamicFields((prev) =>
      prev.filter((fieldSet, index) => indexOfFieldSet !== index)
    );
  };

  const { state } = useLocation();

  const isDepartmentalCandidateSelected =
    String(applicationDetails?.departmentalCandidate || "")
      .trim()
      .toLowerCase() === "yes";

  const deriveGradeName = () =>
    applicationDetails?.vacancyId?.grade?.gradeName ||
    state?.post?.posting?.grade?.gradeName ||
    state?.post?.posting?.grade ||
    "";

  const formatAgeIneligibilityMessage = ({
    applicantAge,
    ageDetails,
    maxAgeLimit,
    gradeLabel = deriveGradeName(),
    isDepartmentalCandidate = isDepartmentalCandidateSelected,
    extraNote = "",
  }) => {
    const safeApplicantAge =
      applicantAge === undefined || applicantAge === null ? "" : applicantAge;
    const safeMaxLimit =
      maxAgeLimit === undefined || maxAgeLimit === null ? "" : maxAgeLimit;
    const safeGradeLabel = gradeLabel || deriveGradeName();

    if (safeApplicantAge === "" || safeMaxLimit === "" || !safeGradeLabel) {
      const fallbackMessage =
        "You are not eligible for this post. As per the provided details, your age exceeds the permissible limit for this post.";
      return extraNote ? `${fallbackMessage} ${extraNote}` : fallbackMessage;
    }

    // Format age string - use detailed format if ageDetails is provided
    let ageString = "";
    if (
      ageDetails &&
      typeof ageDetails === "object" &&
      ageDetails.years !== undefined
    ) {
      const { years, months = 0, days = 0 } = ageDetails;
      const parts = [];
      if (years > 0) parts.push(`${years} ${years === 1 ? "year" : "years"}`);
      if (months > 0)
        parts.push(`${months} ${months === 1 ? "month" : "months"}`);
      if (days > 0) parts.push(`${days} ${days === 1 ? "day" : "days"}`);
      ageString = parts.length > 0 ? parts.join(", ") : `${years} years`;
    } else {
      ageString = `${safeApplicantAge} years`;
    }

    const baseMessage = `You are not eligible for this post. As per the details provided, your age is ${ageString}, which exceeds the prescribed maximum age limit of ${safeMaxLimit} years${
      isDepartmentalCandidate
        ? " (Base Limit + 10 years for departmental candidate)"
        : ""
    } for this post.`;

    return extraNote ? `${baseMessage} ${extraNote}` : baseMessage;
  };

  const resolveAgeLimitValue = (ageData) =>
    ageData?.relaxedAge ??
    ageData?.maxAge ??
    ageData?.maxAgeLimit ??
    ageData?.maximumAge ??
    ageData?.maximumAgeLimit ??
    ageData?.baseAge ??
    ageData?.baseAgeLimit ??
    ageData?.allowedAge ??
    ageData?.ageLimit ??
    "";

  const toSentenceCase = (str) => {
    if (!str) return str;
    return str
      .toLowerCase()
      .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
  };
  const userId = sessionStorage.getItem("userId");

  const collectUserApplicationData = async (tResultArray) => {
    try {
      let config = {
        method: "post",
        url: "Portal/jobApplication/portal/getApplicationByUser",
        data: {
          AdVId: state?.item?._id,
          vacancyId: state?.post?.posting?._id,
        },
      };

      let response = await callApi(config);
      if (response?.data?.code === 200) {
        if (response?.data?.data == null) {
          setApplicationDetails([]);
        } else {
          // Preserve verification status when loading data from database
          const newDetails = response?.data?.data?.details;
          const currentVerificationStatus = {};

          // Extract current verification status from applicationDetails
          if (applicationDetails) {
            Object.keys(applicationDetails).forEach((key) => {
              if (key.endsWith("verified")) {
                currentVerificationStatus[key] = applicationDetails[key];
              }
            });
          }

          // Load verification status from sessionStorage
          const userId = sessionStorage.getItem("userId");
          const sessionVerificationStatus = {};
          if (userId) {
            // Check for all possible verification keys in sessionStorage
            for (let i = 0; i < sessionStorage.length; i++) {
              const key = sessionStorage.key(i);
              if (key && key.startsWith(`verification_${userId}_`)) {
                const fieldName = key.replace(`verification_${userId}_`, "");
                sessionVerificationStatus[`${fieldName}verified`] =
                  sessionStorage.getItem(key) === "true";
              }
            }
          }

          // Merge new details with preserved verification status and sessionStorage status
          const mergedDetails = {
            ...newDetails,
            ...currentVerificationStatus,
            ...sessionVerificationStatus,
          };
          setApplicationDetails(mergedDetails);
          // Also add applicationSerialIds to applicationDetails for email functionality
          const mergedDetailsWithAppId = {
            ...mergedDetails,
            applicationSerialIds: response?.data?.data?.applicationSerialIds,
          };
          setApplicationDetails(mergedDetailsWithAppId);

          if (response?.data?.data?.details?.[countryHolder]) {
            const newStates = getStatesByCountry(
              response?.data?.data?.details?.[countryHolder]
            );
            setStates(newStates);
          }
          if (
            response?.data?.data?.details?.[stateHolder] &&
            response?.data?.data?.details?.[countryHolder]
          ) {
            setSelectedState(response?.data?.data?.details?.[stateHolder]);
            const newDistricts = getDistrictsByState(
              response?.data?.data?.details?.[countryHolder],
              response?.data?.data?.details?.[stateHolder]
            );
            setDistricts(newDistricts);
          }
          setApplicationID(response?.data?.data?.applicationSerialIds);
          setResponceAiCheck(response?.data?.data?.isAICheck);
          let dyEl = Object.keys(response?.data?.data?.details);
          setTabIndex(response?.data?.data?.lastSubmittedIndex || 0);
          setTabIndexFromDb(response?.data?.data?.lastSubmittedIndex || 0);

          // Clear existing dynamicFields for array fields before loading new data to prevent duplicates
          // This ensures that when data is reloaded from the backend, we don't add duplicates
          // Only clear fields that are arrays (like Training Details), not single-value fields
          setDynamicFields((prev) => {
            // Get list of tabs that are arrays in the response
            const arrayTabs = dyEl
              .filter((obKey) =>
                Array.isArray(response?.data?.data?.details?.[obKey])
              )
              .map((obKey) => camelCase(obKey));

            // Only clear dynamicFields for tabs that are arrays in the response
            // This preserves other dynamicFields that might not be in the response
            if (arrayTabs.length > 0) {
              return prev.filter((fs) => !arrayTabs.includes(fs.tab));
            }
            return prev;
          });

          for (let index = 0; index < dyEl?.length; index++) {
            const obKey = dyEl?.[index];
            const sentenceCaseKey = camelCase(obKey);

            if (Array.isArray(response?.data?.data?.details?.[obKey])) {
              for (
                let innerIndex = 0;
                innerIndex < response?.data?.data?.details?.[obKey]?.length;
                innerIndex++
              ) {
                const value =
                  response?.data?.data?.details?.[obKey]?.[innerIndex];
                handleAddFieldSetWithValuesDynamic(
                  value,
                  sentenceCaseKey,
                  index
                );
              }
            } else {
            }
          }
        }

        toast.success(response?.data?.message, { autoClose: 2000 });
      } else {
        await handleSubmitForm("", true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateApplicationTabIndex = async (tResultArray) => {
    try {
      let config = {
        method: "post",
        url: "Portal/jobApplication/portal/getApplicationByUser",
        data: {
          AdVId: state?.item?._id,
          vacancyId: state?.post?.posting?._id,
        },
      };

      let response = await callApi(config);
      if (response?.data?.code === 200) {
        if (response?.data?.data == null) {
          setApplicationDetails([]);
        } else {
          setTabIndexFromDb(response?.data?.data?.lastSubmittedIndex || 0);
          setApplicationDetails(response?.data?.data?.details);
        }
      } else {
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setIsLoading(false);
    }
  };
  function getOrdinalSuffix(num) {
    if (num % 100 >= 11 && num % 100 <= 13) {
      return num + "th";
    }

    // Determine the suffix based on the last digit of the number
    switch (num % 10) {
      case 1:
        return num + "st";
      case 2:
        return num + "nd";
      case 3:
        return num + "rd";
      default:
        return num + "th";
    }
  }
  useEffect(() => {
    const func = async () => {
      if (state && application?.inputElements) {
        const groupedData = await groupByFormTab(application.inputElements);
        const resultArray = await convertGroupedDataToArray(groupedData);
        setApplicationForm(resultArray);
        collectUserApplicationData(userId, resultArray);
      }
    };

    func();
  }, [application?.inputElements, state]); // Ensure you only depend on specific changes

  //   Image   And Pdf Validation Function is here
  const isValidFile = (file) => {
    const allowedTypes = [
      "application/pdf",
      "image/jpeg",
      "image/jpg",
      "image/png",
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.warn(`${file.name} is not a valid file.`);
      return false;
    }

    return true;
  };

  const handleUploadImage = async (event, fieldName) => {
    try {
      event?.preventDefault();
      const file = event?.target?.files[0];

      if (file) {
        if (!isValidFile(file)) {
          return null;
        }

        const imageUrl = await AWSUpload(file);

        setApplicationDetails((prevDetails) => ({
          ...prevDetails,
          [fieldName]: imageUrl,
          [fieldName + "verified"]: false,
        }));

        // Clear validation errors for this field after successful upload
        if (imageUrl) {
          setFieldErrors((prevState) => ({
            ...prevState,
            [fieldName]: {
              errors: (prevState?.[fieldName]?.errors || []).filter(
                (err) => err !== "This field is required."
              ),
              touched: prevState?.[fieldName]?.touched || true,
            },
          }));
        }

        return imageUrl;
      } else {
        setApplicationDetails((prevDetails) => ({
          ...prevDetails,
          [fieldName]: null,
          [fieldName + "verified"]: false,
        }));
        return null;
      }
    } catch (error) {
      console.error("Error in handleUploadImage:", error);
      toast.error("Something went wrong while uploading the image.");
      return null;
    }
  };

  const handleUploadImageArray = async (event, fieldName, updateFieldValue) => {
    try {
      event?.preventDefault();
      const file = event?.target?.files[0];

      if (file) {
        if (!isValidFile(file)) {
          return;
        }

        const imageUrl = await AWSUpload(file);
        updateFieldValue(imageUrl);

        if (imageUrl) {
          setFieldErrors((prevState) => ({
            ...prevState,
            [fieldName]: {
              errors: (prevState?.[fieldName]?.errors || []).filter(
                (err) => err !== "This field is required."
              ),
              touched: prevState?.[fieldName]?.touched || true,
            },
          }));
        }
      } else {
        updateFieldValue(null);
      }
    } catch (error) {
      console.error("Error in handleUploadImageArray:", error);
      toast.error("Something went wrong while uploading the image.");
    }
  };

  const handleUploadImagesArray = async (
    event,
    fieldName,
    updateFieldValue,
    currentFieldValue
  ) => {
    try {
      event?.preventDefault();
      const file = event?.target?.files?.[0];
      if (!file) return;

      // Convert current value to array format if it's a string
      let existingFiles = [];
      if (currentFieldValue) {
        if (typeof currentFieldValue === "string") {
          // Legacy format: comma-separated URLs
          const urls = currentFieldValue.split(",").filter(Boolean);
          existingFiles = urls.map((url) => {
            try {
              const queryParams = new URL(url).searchParams;
              const name = queryParams.get("name") || "";
              return { file: url, name: name, verified: false };
            } catch {
              return { file: url, name: "", verified: false };
            }
          });
        } else if (Array.isArray(currentFieldValue)) {
          existingFiles = currentFieldValue;
        }
      }

      // Validate file
      if (!isValidFile(file)) {
        return;
      }

      // Check if PDF
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        toast.warn("Invalid file type. Only PDF files are allowed.");
        return;
      }

      // Upload file
      const fileUrl = await AWSUpload(file);
      if (fileUrl) {
        // Add new file to array
        const newFile = { file: fileUrl, name: "", verified: false };
        const updatedFiles = [...existingFiles, newFile];

        setApplicationDetails({
          ...applicationDetails,
          [`${fieldName}verified`]: false,
        });
        updateFieldValue(updatedFiles);

        // Reset input
        event.target.value = null;
      }
    } catch (error) {
      console.error("Error in handleUploadImagesArray:", error);
      toast.error("Something went wrong while uploading the file.");
    }
  };

  const handleUploadImages = async (event, fieldName) => {
    try {
      event?.preventDefault();
      const file = event?.target?.files?.[0];
      if (!file) return;

      // Convert current value to array format if it's a string
      let existingFiles = [];
      if (applicationDetails[fieldName]) {
        if (typeof applicationDetails[fieldName] === "string") {
          // Legacy format: comma-separated URLs
          const urls = applicationDetails[fieldName].split(",").filter(Boolean);
          existingFiles = urls.map((url) => {
            try {
              const queryParams = new URL(url).searchParams;
              const name = queryParams.get("name") || "";
              return { file: url, name: name, verified: false };
            } catch {
              return { file: url, name: "", verified: false };
            }
          });
        } else if (Array.isArray(applicationDetails[fieldName])) {
          existingFiles = applicationDetails[fieldName];
        }
      }

      // Validate file
      if (!isValidFile(file)) {
        return;
      }

      // Check if PDF
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        toast.warn("Invalid file type. Only PDF files are allowed.");
        return;
      }

      // Upload file
      const fileUrl = await AWSUpload(file);
      if (fileUrl) {
        // Add new file to array
        const newFile = { file: fileUrl, name: "", verified: false };
        const updatedFiles = [...existingFiles, newFile];

        setApplicationDetails({
          ...applicationDetails,
          [fieldName]: updatedFiles,
          [fieldName + "verified"]: false,
        });

        // Reset input
        event.target.value = null;
      }
    } catch (error) {
      console.error("Error in handleUploadImages:", error);
      toast.error("Something went wrong while uploading the file.");
    }
  };

  const groupByFormTab = (data) => {
    const groupedData = {};

    data?.forEach((item) => {
      const { formTab, ...values } = item;
      if (!groupedData[formTab]) {
        groupedData[formTab] = [];
      }
      groupedData[formTab].push({ values });
    });

    return groupedData; // Return the grouped data object
  };
  const convertGroupedDataToArray = (groupedData) => {
    const resultArray = [];
    for (const formTab in groupedData) {
      if (groupedData.hasOwnProperty(formTab)) {
        resultArray.push({
          formTab, // FormTab key,
          isArray: groupedData?.[formTab]?.[0]?.values?.isArray,
          values: groupedData[formTab], // Array of value objects
        });
      }
    }

    return resultArray;
  };

  const toCamelCaseKeys = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(toCamelCaseKeys);
    } else if (
      obj !== null &&
      obj !== undefined &&
      obj?.constructor === Object
    ) {
      return Object.keys(obj).reduce((result, key) => {
        const camelKey = camelCase(key);
        result[camelKey] = toCamelCaseKeys(obj[key]);
        return result;
      }, {});
    }
    return obj;
  };

  const [onlyWomenAllowed, setOnlyWomenAllowed] = useState(false);
  const [allowedCategory, setAllowedCategory] = useState([]);

  useEffect(() => {
    let catAvailable = state?.post?.posting?.category;
    let otherAllowed = catAvailable?.some((item) => item?.total > item?.women);
    setOnlyWomenAllowed(!otherAllowed);
  }, [state]);

  function getAllowedCategoriesByGender(data, gender) {
    if (applicationDetails?.["domicileOfOdisha"]?.toLowerCase() !== "odisha") {
      return data
        .filter((item) => item?.category === "UR")
        .map((item) => item?.category);
    } else if (
      gender === "Female" ||
      gender === "Male" ||
      gender === "Transgender"
    ) {
      // Return categories where women are allowed (i.e., women > 0)
      return data.map((item) => item?.category);
    } else {
      return []; // Invalid gender input
    }
  }

  useEffect(() => {
    if (
      applicationDetails?.["66a37bab1b102d1ba93eee2e"] &&
      state?.post?.posting?.category
    ) {
      setAllowedCategory(
        getAllowedCategoriesByGender(
          state?.post?.posting?.category,
          applicationDetails?.["66a37bab1b102d1ba93eee2e"]
        )
      );
    }
    // console.log("state?.post?.posting?.category", state)
    setClosingDate(state.item.advertisementClosingDate);
  }, [applicationDetails]);

  const checkErrorsClass = () => {
    return new Promise((resolve) => {
      let Divid = "captureErrorFor_" + tabIndex;
      const specificDivs = document.querySelectorAll(`.${Divid}`);
      let err = 0;
      let firstErrorElement = null; // To store the first error element
      // console.log({ specificDivs }, { Divid });

      const customErrorMessages = [
        "Sum of Post Wise Experiences does not match the Total Experience.",
        "Sum of Relevant Experiences exceeds the Total Experience.",
      ];

      // Explicitly validate State field and Conversion Formula fields
      const currentTabForm = applicationForm && applicationForm[tabIndex];

      // Define conversion formula fields with their condition field IDs
      const conversionFormulaFields = [
        {
          fieldId: "6719d53d3ac83738a0ba587a", // 10th Conversion Formula
          conditionFieldId: "66a687874db5f02d6861ed04", // 10th Mark Type
        },
        {
          fieldId: "6719d8603ac83738a0ba5fd7", // 12th Conversion Formula
          conditionFieldId: "66a728ec9680c25e280d6bf6", // 12th Mark Type
        },
        {
          fieldId: "6719d9653ac83738a0ba6155", // Graduation Conversion Formula
          conditionFieldId: "66a687874db5f02d6861ed0e", // Graduation Mark Type
        },
        {
          fieldId: "676a57139e167618b7ec04b5", // Post-Graduation Conversion Formula
          conditionFieldId: "676a57139e167618b7ec04ab", // Post-Graduation Mark Type
        },
        {
          fieldId: "68ecd888eb422bea55aa71b8", // LLB Conversion Formula
          conditionFieldId: "68ecd888eb422bea55aa71ae", // LLB Mark Type
        },
      ];

      // Validate State field if it exists in the current tab
      if (currentTabForm && currentTabForm.inputElements) {
        currentTabForm.inputElements.forEach((field) => {
          const fieldLabel = field.values?.inputFieldName;
          const fieldId = field.values?._id;
          const isCountryField = fieldLabel === "Country";
          const isStateField = fieldLabel === "State";
          const isDistrictField = fieldLabel === "District";

          // Validate Country field
          if (isCountryField) {
            const camelCaseKey = camelCase(fieldId);
            let fieldValue = applicationDetails?.[camelCaseKey];
            if (
              !fieldValue ||
              fieldValue === "" ||
              fieldValue === "Select Country"
            ) {
              fieldValue = "";
            }

            if (!fieldErrors?.[camelCaseKey]?.touched) {
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: prevState?.[camelCaseKey]?.errors || [],
                  touched: true,
                },
              }));
            }

            // Force isRequired to true for Country fields
            const fieldToValidate = {
              ...field,
              values: { ...field.values, isRequired: true },
            };
            checkErrorFn(fieldToValidate, camelCaseKey, fieldValue);
          }

          if (isStateField) {
            // Use the same camelCaseKey generation as in renderNonArrayFields
            const camelCaseKey = camelCase(fieldId);

            // Get the field value
            let fieldValue = applicationDetails?.[camelCaseKey];
            if (
              !fieldValue ||
              fieldValue === "" ||
              fieldValue === "Select State"
            ) {
              fieldValue = "";
            }

            // Mark field as touched first to ensure validation runs
            if (!fieldErrors?.[camelCaseKey]?.touched) {
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: prevState?.[camelCaseKey]?.errors || [],
                  touched: true,
                },
              }));
            }

            // Force isRequired to true for State fields
            const fieldToValidate = {
              ...field,
              values: { ...field.values, isRequired: true },
            };
            checkErrorFn(fieldToValidate, camelCaseKey, fieldValue);
          }

          // Add District field validation (same logic as State)
          if (isDistrictField) {
            // Use the same camelCaseKey generation as in renderNonArrayFields
            const camelCaseKey = camelCase(fieldId);

            // Get the field value
            let fieldValue = applicationDetails?.[camelCaseKey];
            if (
              !fieldValue ||
              fieldValue === "" ||
              fieldValue === "Select District"
            ) {
              fieldValue = "";
            }

            // Mark field as touched first to ensure validation runs
            if (!fieldErrors?.[camelCaseKey]?.touched) {
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: prevState?.[camelCaseKey]?.errors || [],
                  touched: true,
                },
              }));
            }

            // Force isRequired to true for District fields
            const fieldToValidate = {
              ...field,
              values: { ...field.values, isRequired: true },
            };
            checkErrorFn(fieldToValidate, camelCaseKey, fieldValue);
          }
        });
      }

      // Validate ALL conversion formula fields directly (regardless of whether they're in inputElements)
      // This ensures we check them even if they're conditionally rendered
      conversionFormulaFields.forEach((conversionFormulaField) => {
        const conditionValue =
          applicationDetails?.[conversionFormulaField.conditionFieldId];
        const isFieldVisible =
          conditionValue === "CGPA/OGPA" || conditionValue === "Grade";

        if (isFieldVisible) {
          // Field is visible, so validate it
          const camelCaseKey = camelCase(conversionFormulaField.fieldId);

          // Get the field value
          let fieldValue = applicationDetails?.[camelCaseKey];
          if (!fieldValue || fieldValue === "") {
            fieldValue = "";
          }

          // Find the field in the form to check if it's required
          let fieldInForm = null;
          if (currentTabForm && currentTabForm.inputElements) {
            fieldInForm = currentTabForm.inputElements.find(
              (f) => f.values?._id === conversionFormulaField.fieldId
            );
          }

          // If field not found in current tab, check all tabs
          if (!fieldInForm && applicationForm) {
            for (const tab of applicationForm) {
              if (tab && tab.inputElements) {
                fieldInForm = tab.inputElements.find(
                  (f) => f.values?._id === conversionFormulaField.fieldId
                );
                if (fieldInForm) break;
              }
            }
          }

          // Validate if field is required (assume required if visible and field exists in form)
          const isRequired = fieldInForm?.values?.isRequired ?? true;

          if (isRequired) {
            // If field has a value, clear any "This field is required." errors first
            if (fieldValue && fieldValue !== "") {
              const currentErrors = fieldErrors?.[camelCaseKey]?.errors || [];
              const hasRequiredError = currentErrors.includes(
                "This field is required."
              );
              if (hasRequiredError) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [camelCaseKey]: {
                    errors: currentErrors.filter(
                      (err) => err !== "This field is required."
                    ),
                    touched: prevState?.[camelCaseKey]?.touched || true,
                  },
                }));
              }
            }

            // Mark field as touched first to ensure validation runs
            if (!fieldErrors?.[camelCaseKey]?.touched) {
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: prevState?.[camelCaseKey]?.errors || [],
                  touched: true,
                },
              }));
            }

            // Validate the field - checkErrorFn will handle required validation
            if (fieldInForm) {
              checkErrorFn(fieldInForm, camelCaseKey, fieldValue);
            } else {
              // If field not found, manually check and set error if empty
              if (!fieldValue || fieldValue === "") {
                const currentErrors = fieldErrors?.[camelCaseKey]?.errors || [];
                const hasRequiredError = currentErrors.includes(
                  "This field is required."
                );
                if (!hasRequiredError) {
                  setFieldErrors((prevState) => ({
                    ...prevState,
                    [camelCaseKey]: {
                      errors: [...currentErrors, "This field is required."],
                      touched: true,
                    },
                  }));
                }
              }
            }
          }
        }
      });

      for (let i = 0; i < specificDivs.length; i++) {
        const div = specificDivs[i];
        const inputs = div.querySelectorAll(
          "input, select , textarea, button ",
          "checkbox",
          "file"
        );

        for (let j = 0; j < inputs.length; j++) {
          inputs[j].focus();
          inputs[j].blur();
        }
      }

      // Manually trigger validation for experience fields (especially select elements)
      if (typeof window.validateExperienceFields === "function") {
        window.validateExperienceFields();
      }

      // Introduce a slight delay to allow DOM to update and state to sync
      setTimeout(() => {
        const specificDivsWithError = document.querySelectorAll(`.${Divid}`);
        // console.log({ specificDivsWithError }, { Divid });

        for (let i = 0; i < specificDivsWithError.length; i++) {
          const div = specificDivsWithError[i];

          // Check for input errors
          const errorSpans = div.querySelectorAll("span.errorPresent");
          // console.log({ errorSpans });

          // Check Business Excellence Certification value to determine if Upload Certificate should be optional
          const BUSINESS_EXCELLENCE_CERTIFICATION_ID =
            "693682fe4c6c63e650c921b8";
          const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
          const businessExcellenceValue =
            applicationDetails?.[BUSINESS_EXCELLENCE_CERTIFICATION_ID] ||
            applicationDetails?.[
              camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID)
            ];

          const hasBusinessExcellenceValue =
            businessExcellenceValue &&
            businessExcellenceValue !== "Select" &&
            businessExcellenceValue !== "" &&
            ((Array.isArray(businessExcellenceValue) &&
              businessExcellenceValue.length > 0 &&
              businessExcellenceValue.some((item) => {
                if (typeof item === "string")
                  return item.trim() !== "" && item.trim() !== "Select";
                if (typeof item === "object" && item !== null)
                  return (
                    item.value &&
                    item.value.trim() !== "" &&
                    item.value.trim() !== "Select"
                  );
                return false;
              })) ||
              (typeof businessExcellenceValue === "string" &&
                businessExcellenceValue.trim() !== "" &&
                businessExcellenceValue.trim() !== "Select"));

          for (let j = 0; j < errorSpans.length; j++) {
            const errorSpan = errorSpans[j];
            const errorText = errorSpan.textContent || "";

            // Check if this error is for Upload Certificate field
            let isUploadCertificateError = false;
            if (!hasBusinessExcellenceValue) {
              // Check if this error span is for Upload Certificate field
              const parentDiv = errorSpan.closest("div");
              if (parentDiv) {
                const label = parentDiv.querySelector("label");
                if (label && label.textContent) {
                  isUploadCertificateError =
                    label.textContent.includes("Upload Certificate") ||
                    label.textContent.includes("Certificate");
                }
                // Also check by field ID in the DOM
                const fieldIdAttr = parentDiv.querySelector(
                  `[data-field-id="${UPLOAD_CERTIFICATE_ID}"]`
                );
                if (fieldIdAttr) {
                  isUploadCertificateError = true;
                }
              }
            }

            // Skip counting Upload Certificate errors if Business Excellence Certification is empty
            if (isUploadCertificateError) {
              continue; // Skip this error
            }

            // Check if this is a verification error for a conversion formula field that's verified
            const isVerificationError =
              errorText.includes("verify") ||
              errorText.includes("Verify") ||
              errorText.includes("verification") ||
              errorText.includes("Please verify");

            let shouldCountError = true;
            if (isVerificationError) {
              // Check if this error is for a conversion formula field that's verified
              const conversionFormulaFields = [
                {
                  fieldId: "6719d53d3ac83738a0ba587a",
                  camelCaseKey: camelCase("6719d53d3ac83738a0ba587a"),
                },
                {
                  fieldId: "6719d8603ac83738a0ba5fd7",
                  camelCaseKey: camelCase("6719d8603ac83738a0ba5fd7"),
                },
                {
                  fieldId: "6719d9653ac83738a0ba6155",
                  camelCaseKey: camelCase("6719d9653ac83738a0ba6155"),
                },
                {
                  fieldId: "676a57139e167618b7ec04b5",
                  camelCaseKey: camelCase("676a57139e167618b7ec04b5"),
                },
                {
                  fieldId: "68ecd888eb422bea55aa71b8",
                  camelCaseKey: camelCase("68ecd888eb422bea55aa71b8"),
                },
              ];

              // Check if the error is for a conversion formula field that's verified
              // Try to find the file input in the same container
              let fileInput = errorSpan
                .closest(".imageDiv")
                ?.querySelector("input[type='file']");
              if (!fileInput) {
                // Try to find in parent containers
                fileInput = errorSpan
                  .closest("div")
                  ?.querySelector("input[type='file']");
              }
              if (!fileInput) {
                // Try to find by checking all file inputs in the div
                const allFileInputs =
                  div.querySelectorAll("input[type='file']");
                if (allFileInputs.length > 0) {
                  // Try to match by proximity or ID
                  for (const fi of allFileInputs) {
                    const fiId = fi.id;
                    if (fiId && fiId.includes("fileInput")) {
                      fileInput = fi;
                      break;
                    }
                  }
                }
              }

              if (fileInput && fileInput.id) {
                const fileInputId = fileInput.id;
                const conversionField = conversionFormulaFields.find(
                  (cff) => fileInputId === `${cff.camelCaseKey}_fileInput`
                );
                if (conversionField) {
                  // Check if this field is verified
                  const verifiedKeyById = `${conversionField.fieldId}verified`;
                  const verifiedKeyByCamelCase = `${conversionField.camelCaseKey}verified`;
                  const isVerified =
                    applicationDetails?.[verifiedKeyById] === true ||
                    applicationDetails?.[verifiedKeyByCamelCase] === true;
                  if (isVerified) {
                    // File is verified, don't count verification error
                    shouldCountError = false;
                  }
                }
              } else {
                // If we can't find the file input by ID, check fieldErrors state and conversion formula fields
                // to see if any are verified and might be related to this error
                const errorContainer =
                  errorSpan.closest("div.imageDiv") || errorSpan.closest("div");

                // Check if this verification error is in fieldErrors for a verified field
                for (const conversionField of conversionFormulaFields) {
                  const verifiedKeyById = `${conversionField.fieldId}verified`;
                  const verifiedKeyByCamelCase = `${conversionField.camelCaseKey}verified`;
                  const isVerified =
                    applicationDetails?.[verifiedKeyById] === true ||
                    applicationDetails?.[verifiedKeyByCamelCase] === true;
                  const fieldValue =
                    applicationDetails?.[conversionField.camelCaseKey] ||
                    applicationDetails?.[conversionField.fieldId];

                  // If field has value and is verified, don't count verification errors for it
                  if (isVerified && fieldValue) {
                    // Check if error container contains conversion formula text
                    if (
                      errorContainer &&
                      errorContainer.textContent.includes("Conversion formula")
                    ) {
                      shouldCountError = false;
                      break;
                    } else {
                      // Even if we can't find the container, if field is verified and has value,
                      // and this is a verification error, don't count it
                      // Check all conversion formula fields to see if any verified field might be related
                      const allVerifiedFields = conversionFormulaFields.filter(
                        (cff) => {
                          const vKeyById = `${cff.fieldId}verified`;
                          const vKeyByCamelCase = `${cff.camelCaseKey}verified`;
                          const isV =
                            applicationDetails?.[vKeyById] === true ||
                            applicationDetails?.[vKeyByCamelCase] === true;
                          const fValue =
                            applicationDetails?.[cff.camelCaseKey] ||
                            applicationDetails?.[cff.fieldId];
                          return isV && fValue;
                        }
                      );
                      // If there are verified conversion formula fields, exclude verification errors
                      if (allVerifiedFields.length > 0) {
                        shouldCountError = false;
                        break;
                      }
                    }
                  }
                }
              }
            }

            if (shouldCountError) {
              err++;
              if (firstErrorElement === null) {
                firstErrorElement = errorSpan;
              }
            }
          }

          // Check for custom error divs
          const customErrorDivs = div.querySelectorAll("div.text-danger.mt-2");
          // console.log({ customErrorDivs });
          for (let k = 0; k < customErrorDivs.length; k++) {
            const errorDiv = customErrorDivs[k];
            // Check if the error message matches any of the specified messages
            if (
              customErrorMessages.some((msg) =>
                errorDiv.textContent.includes(msg)
              )
            ) {
              err++;
              if (firstErrorElement === null) {
                firstErrorElement = errorDiv;
              }
            }
          }
        }
        if (firstErrorElement) {
          const inputToFocus = firstErrorElement
            .closest("div")
            ?.querySelector("input, select, textarea, checkbox, file, button");
          if (inputToFocus) {
            inputToFocus.focus();
          } else if (firstErrorElement.scrollIntoView) {
            firstErrorElement.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }

        // Double check Country, State, and District fields in fieldErrors state
        // Always validate these fields regardless of isRequired flag (like Pin Code)
        if (currentTabForm && currentTabForm.inputElements) {
          currentTabForm.inputElements.forEach((field) => {
            const fieldLabel = field.values?.inputFieldName;
            const fieldId = field.values?._id;
            const isCountryField = fieldLabel === "Country";
            const isStateField = fieldLabel === "State";
            const isDistrictField = fieldLabel === "District";

            // Validate Country field
            if (isCountryField) {
              const camelCaseKey = camelCase(fieldId);
              let fieldValue = applicationDetails?.[camelCaseKey];
              if (
                !fieldValue ||
                fieldValue === "" ||
                fieldValue === "Select Country"
              ) {
                fieldValue = "";
              }

              const isEmpty = !fieldValue || fieldValue === "";
              const hasError =
                fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched;

              if (hasError) {
                err++;
                if (firstErrorElement === null) {
                  const allErrorSpans = Array.from(
                    document.querySelectorAll(`.${Divid} span.errorPresent`)
                  );
                  for (const span of allErrorSpans) {
                    const errorText = fieldErrors?.[camelCaseKey]?.errors?.[0];
                    if (errorText && span.textContent.includes(errorText)) {
                      firstErrorElement = span;
                      break;
                    }
                  }
                  if (!firstErrorElement) {
                    const selects = Array.from(
                      document.querySelectorAll(`.${Divid} select`)
                    );
                    for (const select of selects) {
                      const label =
                        select.previousElementSibling?.textContent || "";
                      if (
                        label.includes(fieldLabel) ||
                        select.value === "" ||
                        select.value === "Select Country"
                      ) {
                        firstErrorElement = select;
                        break;
                      }
                    }
                  }
                }
              } else if (isEmpty) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [camelCaseKey]: {
                    errors: ["This field is required."],
                    touched: true,
                  },
                }));
                err++;
                if (firstErrorElement === null) {
                  const selects = Array.from(
                    document.querySelectorAll(`.${Divid} select`)
                  );
                  for (const select of selects) {
                    const label =
                      select.previousElementSibling?.textContent || "";
                    if (
                      label.includes(fieldLabel) ||
                      select.value === "" ||
                      select.value === "Select Country"
                    ) {
                      firstErrorElement = select;
                      break;
                    }
                  }
                }
              }
            }

            // Validate State field
            if (isStateField) {
              const camelCaseKey = camelCase(fieldId);
              let fieldValue = applicationDetails?.[camelCaseKey];
              if (
                !fieldValue ||
                fieldValue === "" ||
                fieldValue === "Select State"
              ) {
                fieldValue = "";
              }

              const isEmpty = !fieldValue || fieldValue === "";
              const hasError =
                fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched;

              if (hasError) {
                err++;
                if (firstErrorElement === null) {
                  const allErrorSpans = Array.from(
                    document.querySelectorAll(`.${Divid} span.errorPresent`)
                  );
                  for (const span of allErrorSpans) {
                    const errorText = fieldErrors?.[camelCaseKey]?.errors?.[0];
                    if (errorText && span.textContent.includes(errorText)) {
                      firstErrorElement = span;
                      break;
                    }
                  }
                  if (!firstErrorElement) {
                    const selects = Array.from(
                      document.querySelectorAll(`.${Divid} select`)
                    );
                    for (const select of selects) {
                      const label =
                        select.previousElementSibling?.textContent || "";
                      if (
                        label.includes(fieldLabel) ||
                        select.value === "" ||
                        select.value === "Select State"
                      ) {
                        firstErrorElement = select;
                        break;
                      }
                    }
                  }
                }
              } else if (isEmpty) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [camelCaseKey]: {
                    errors: ["This field is required."],
                    touched: true,
                  },
                }));
                err++;
                if (firstErrorElement === null) {
                  const selects = Array.from(
                    document.querySelectorAll(`.${Divid} select`)
                  );
                  for (const select of selects) {
                    const label =
                      select.previousElementSibling?.textContent || "";
                    if (
                      label.includes(fieldLabel) ||
                      select.value === "" ||
                      select.value === "Select State"
                    ) {
                      firstErrorElement = select;
                      break;
                    }
                  }
                }
              }
            }

            // Validate District field
            if (isDistrictField) {
              const camelCaseKey = camelCase(fieldId);
              let fieldValue = applicationDetails?.[camelCaseKey];
              if (
                !fieldValue ||
                fieldValue === "" ||
                fieldValue === "Select District"
              ) {
                fieldValue = "";
              }

              const isEmpty = !fieldValue || fieldValue === "";
              const hasError =
                fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched;

              if (hasError) {
                err++;
                if (firstErrorElement === null) {
                  const allErrorSpans = Array.from(
                    document.querySelectorAll(`.${Divid} span.errorPresent`)
                  );
                  for (const span of allErrorSpans) {
                    const errorText = fieldErrors?.[camelCaseKey]?.errors?.[0];
                    if (errorText && span.textContent.includes(errorText)) {
                      firstErrorElement = span;
                      break;
                    }
                  }
                  if (!firstErrorElement) {
                    const selects = Array.from(
                      document.querySelectorAll(`.${Divid} select`)
                    );
                    for (const select of selects) {
                      const label =
                        select.previousElementSibling?.textContent || "";
                      if (
                        label.includes(fieldLabel) ||
                        select.value === "" ||
                        select.value === "Select District"
                      ) {
                        firstErrorElement = select;
                        break;
                      }
                    }
                  }
                }
              } else if (isEmpty) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [camelCaseKey]: {
                    errors: ["This field is required."],
                    touched: true,
                  },
                }));
                err++;
                if (firstErrorElement === null) {
                  const selects = Array.from(
                    document.querySelectorAll(`.${Divid} select`)
                  );
                  for (const select of selects) {
                    const label =
                      select.previousElementSibling?.textContent || "";
                    if (
                      label.includes(fieldLabel) ||
                      select.value === "" ||
                      select.value === "Select District"
                    ) {
                      firstErrorElement = select;
                      break;
                    }
                  }
                }
              }
            }
          });
        }

        // Double check ALL conversion formula fields (regardless of whether they're in inputElements)
        conversionFormulaFields.forEach((conversionFormulaField) => {
          const conditionValue =
            applicationDetails?.[conversionFormulaField.conditionFieldId];
          const isFieldVisible =
            conditionValue === "CGPA/OGPA" || conditionValue === "Grade";

          if (isFieldVisible) {
            // Field is visible, so validate it
            const camelCaseKey = camelCase(conversionFormulaField.fieldId);

            // Get field value
            let fieldValue = applicationDetails?.[camelCaseKey];
            if (!fieldValue || fieldValue === "") {
              fieldValue = "";
            }

            // Find the field in the form to check if it's required
            let fieldInForm = null;
            if (currentTabForm && currentTabForm.inputElements) {
              fieldInForm = currentTabForm.inputElements.find(
                (f) => f.values?._id === conversionFormulaField.fieldId
              );
            }

            // If field not found in current tab, check all tabs
            if (!fieldInForm && applicationForm) {
              for (const tab of applicationForm) {
                if (tab && tab.inputElements) {
                  fieldInForm = tab.inputElements.find(
                    (f) => f.values?._id === conversionFormulaField.fieldId
                  );
                  if (fieldInForm) break;
                }
              }
            }

            // Validate if field is required (assume required if visible and field exists in form)
            const isRequired = fieldInForm?.values?.isRequired ?? true;

            if (isRequired) {
              // Check if field is empty
              const isEmpty = !fieldValue || fieldValue === "";

              // Check verification status using both possible keys
              const fieldId = conversionFormulaField.fieldId;
              const verifiedKeyById = `${fieldId}verified`;
              const verifiedKeyByCamelCase = `${camelCaseKey}verified`;
              const isVerified =
                applicationDetails?.[verifiedKeyById] === true ||
                applicationDetails?.[verifiedKeyByCamelCase] === true;

              // If field has a value, clear any "This field is required." errors and verification errors if verified
              if (!isEmpty && fieldValue) {
                const currentErrors = fieldErrors?.[camelCaseKey]?.errors || [];
                const hasRequiredError = currentErrors.includes(
                  "This field is required."
                );

                // If verified, also clear verification errors
                let errorsToKeep = currentErrors;
                if (isVerified) {
                  errorsToKeep = currentErrors.filter(
                    (err) =>
                      !err.includes("verify") &&
                      !err.includes("Verify") &&
                      !err.includes("verification") &&
                      !err.includes("Please verify")
                  );
                }

                if (
                  hasRequiredError ||
                  (isVerified && errorsToKeep.length < currentErrors.length)
                ) {
                  // Clear the errors
                  setFieldErrors((prevState) => ({
                    ...prevState,
                    [camelCaseKey]: {
                      errors: hasRequiredError
                        ? errorsToKeep.filter(
                            (err) => err !== "This field is required."
                          )
                        : errorsToKeep,
                      touched: prevState?.[camelCaseKey]?.touched || true,
                    },
                  }));
                }

                // If file is verified, don't count verification errors
                // Only count non-verification errors
                const nonVerificationErrors = errorsToKeep.filter(
                  (err) =>
                    !err.includes("verify") &&
                    !err.includes("Verify") &&
                    !err.includes("verification") &&
                    !err.includes("Please verify")
                );
                if (
                  nonVerificationErrors.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                ) {
                  // There are non-verification errors, count them
                  err++;
                  if (firstErrorElement === null) {
                    const allErrorSpans = Array.from(
                      document.querySelectorAll(`.${Divid} span.errorPresent`)
                    );
                    for (const span of allErrorSpans) {
                      const errorText = nonVerificationErrors[0];
                      if (errorText && span.textContent.includes(errorText)) {
                        firstErrorElement = span;
                        break;
                      }
                    }
                    if (!firstErrorElement) {
                      const fileInputs = Array.from(
                        document.querySelectorAll(
                          `.${Divid} input[type="file"]`
                        )
                      );
                      for (const fileInput of fileInputs) {
                        const button =
                          fileInput.previousElementSibling?.querySelector(
                            "button"
                          );
                        if (
                          button &&
                          fileInput.id === `${camelCaseKey}_fileInput`
                        ) {
                          firstErrorElement = button;
                          break;
                        }
                      }
                    }
                  }
                }
              } else if (isEmpty) {
                // Field is empty and required - check if error needs to be set
                const currentErrors = fieldErrors?.[camelCaseKey]?.errors || [];
                const hasRequiredError = currentErrors.includes(
                  "This field is required."
                );
                // Don't count verification errors if file is not uploaded
                const nonVerificationErrors = currentErrors.filter(
                  (err) =>
                    !err.includes("verify") &&
                    !err.includes("Verify") &&
                    !err.includes("verification") &&
                    !err.includes("Please verify")
                );
                const hasError =
                  nonVerificationErrors.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched;

                if (hasError) {
                  // Error already exists in state (but not verification errors)
                  err++;
                  if (firstErrorElement === null) {
                    // Find the error span in DOM
                    const allErrorSpans = Array.from(
                      document.querySelectorAll(`.${Divid} span.errorPresent`)
                    );
                    for (const span of allErrorSpans) {
                      const errorText = nonVerificationErrors[0];
                      if (errorText && span.textContent.includes(errorText)) {
                        firstErrorElement = span;
                        break;
                      }
                    }
                    // If error span not found, find the file input element
                    if (!firstErrorElement) {
                      const fileInputs = Array.from(
                        document.querySelectorAll(
                          `.${Divid} input[type="file"]`
                        )
                      );
                      for (const fileInput of fileInputs) {
                        const button =
                          fileInput.previousElementSibling?.querySelector(
                            "button"
                          );
                        if (
                          button &&
                          fileInput.id === `${camelCaseKey}_fileInput`
                        ) {
                          firstErrorElement = button;
                          break;
                        }
                      }
                    }
                  }
                } else if (!hasRequiredError) {
                  // Field is empty and required but no error set - set error
                  setFieldErrors((prevState) => ({
                    ...prevState,
                    [camelCaseKey]: {
                      errors: ["This field is required."],
                      touched: true,
                    },
                  }));
                  err++;
                  if (firstErrorElement === null) {
                    const fileInputs = Array.from(
                      document.querySelectorAll(`.${Divid} input[type="file"]`)
                    );
                    for (const fileInput of fileInputs) {
                      const button =
                        fileInput.previousElementSibling?.querySelector(
                          "button"
                        );
                      if (
                        button &&
                        fileInput.id === `${camelCaseKey}_fileInput`
                      ) {
                        firstErrorElement = button;
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
        });

        // Validate Essential Qualification document verification
        const currentTab = applicationForm && applicationForm[tabIndex];
        if (currentTab && currentTab.formTab === "ESSENTIAL QUALIFICATION") {
          // Get all PDF/image fields (single and multiple) from Essential Qualification tab
          const essentialQualFields = application?.inputElements?.filter(
            (field) =>
              field.formTab === "ESSENTIAL QUALIFICATION" &&
              (field.inputFieldType === "pdf" ||
                field.inputFieldType === "image" ||
                field.inputFieldType === "multiplePdf" ||
                field.inputFieldType === "multipleImage")
          );

          if (essentialQualFields && essentialQualFields.length > 0) {
            essentialQualFields.forEach((field) => {
              const fieldId = field._id;
              const camelCaseKey = camelCase(fieldId);
              const fieldValue =
                applicationDetails?.[camelCaseKey] ||
                applicationDetails?.[fieldId];
              const isMultipleUpload =
                field.inputFieldType === "multiplePdf" ||
                field.inputFieldType === "multipleImage";

              // Check if field has a file uploaded
              const hasFile =
                fieldValue &&
                (typeof fieldValue === "string"
                  ? fieldValue.trim() !== ""
                  : Array.isArray(fieldValue)
                  ? fieldValue.length > 0
                  : fieldValue);

              if (hasFile) {
                let isVerified = false;

                if (isMultipleUpload) {
                  // For multiple uploads, check each file in the array
                  if (Array.isArray(fieldValue) && fieldValue.length > 0) {
                    // Check if any file is unverified - if so, block navigation
                    const hasUnverifiedFile = fieldValue.some(
                      (file) => !file?.verified || file?.verified !== true
                    );
                    isVerified = !hasUnverifiedFile; // Verified only if all files are verified
                  } else if (
                    typeof fieldValue === "string" &&
                    fieldValue.trim() !== ""
                  ) {
                    // Legacy format: check the verified flag
                    const verifiedKeyById = `${fieldId}verified`;
                    const verifiedKeyByCamelCase = `${camelCaseKey}verified`;
                    isVerified =
                      applicationDetails?.[verifiedKeyById] === true ||
                      applicationDetails?.[verifiedKeyByCamelCase] === true;
                  } else {
                    isVerified = false; // No files uploaded
                  }
                } else {
                  // For single uploads, check verification status using both possible keys
                  const verifiedKeyById = `${fieldId}verified`;
                  const verifiedKeyByCamelCase = `${camelCaseKey}verified`;
                  isVerified =
                    applicationDetails?.[verifiedKeyById] === true ||
                    applicationDetails?.[verifiedKeyByCamelCase] === true;
                }

                if (!isVerified) {
                  // File(s) uploaded but not verified - add error
                  err++;
                  if (firstErrorElement === null) {
                    // Try to find the file input or verify button in DOM
                    const fileInputs = Array.from(
                      document.querySelectorAll(`.${Divid} input[type="file"]`)
                    );
                    for (const fileInput of fileInputs) {
                      if (
                        fileInput.id === `${camelCaseKey}_fileInput` ||
                        fileInput.id === `${fieldId}_fileInput` ||
                        fileInput.id?.includes(camelCaseKey) ||
                        fileInput.id?.includes(fieldId)
                      ) {
                        // Try to find verify button near the file input
                        const verifyButton = fileInput
                          .closest("div")
                          ?.querySelector(".verifybutton, .verifyBtn");
                        if (verifyButton) {
                          firstErrorElement = verifyButton;
                        } else {
                          firstErrorElement = fileInput;
                        }
                        break;
                      }
                    }
                    // If file input not found, try to find by label
                    if (!firstErrorElement) {
                      const labels = Array.from(
                        document.querySelectorAll(`.${Divid} label`)
                      );
                      for (const label of labels) {
                        if (
                          label.textContent &&
                          (label.textContent.includes(field.inputFieldName) ||
                            field.inputFieldName.includes(
                              label.textContent.trim()
                            ))
                        ) {
                          const parentDiv = label.closest("div");
                          if (parentDiv) {
                            const verifyBtn = parentDiv.querySelector(
                              ".verifybutton, .verifyBtn"
                            );
                            if (verifyBtn) {
                              firstErrorElement = verifyBtn;
                              break;
                            }
                          }
                        }
                      }
                    }
                  }

                  // Set field error to show "Please verify" message
                  setFieldErrors((prevState) => {
                    const currentErrors =
                      prevState?.[camelCaseKey]?.errors || [];
                    const hasVerifyError = currentErrors.some(
                      (e) =>
                        e.includes("verify") ||
                        e.includes("Verify") ||
                        e.includes("Please verify")
                    );
                    if (!hasVerifyError) {
                      return {
                        ...prevState,
                        [camelCaseKey]: {
                          errors: [
                            ...currentErrors,
                            "Please verify all uploaded documents before proceeding.",
                          ],
                          touched: true,
                        },
                      };
                    }
                    return prevState;
                  });
                }
              }
            });
          }
        }

        // Clear Upload Certificate errors if Business Excellence Certification is "Select" or empty
        const BUSINESS_EXCELLENCE_CERTIFICATION_ID = "693682fe4c6c63e650c921b8";
        const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
        const uploadCertificateCamelCaseKey = camelCase(UPLOAD_CERTIFICATE_ID);

        const businessExcellenceValue =
          applicationDetails?.[BUSINESS_EXCELLENCE_CERTIFICATION_ID] ||
          applicationDetails?.[camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID)];

        // Check if Business Excellence Certification is empty or "Select"
        const hasBusinessExcellenceValue =
          businessExcellenceValue &&
          businessExcellenceValue !== "Select" &&
          businessExcellenceValue !== "" &&
          ((Array.isArray(businessExcellenceValue) &&
            businessExcellenceValue.length > 0 &&
            businessExcellenceValue.some((item) => {
              if (typeof item === "string")
                return item.trim() !== "" && item.trim() !== "Select";
              if (typeof item === "object" && item !== null)
                return (
                  item.value &&
                  item.value.trim() !== "" &&
                  item.value.trim() !== "Select"
                );
              return false;
            })) ||
            (typeof businessExcellenceValue === "string" &&
              businessExcellenceValue.trim() !== "" &&
              businessExcellenceValue.trim() !== "Select"));

        // If Business Excellence Certification is empty/Select, clear Upload Certificate errors
        if (!hasBusinessExcellenceValue) {
          const uploadCertificateErrors =
            fieldErrors?.[uploadCertificateCamelCaseKey];
          if (
            uploadCertificateErrors &&
            uploadCertificateErrors.errors?.length > 0
          ) {
            // Clear all errors for Upload Certificate
            setFieldErrors((prevState) => {
              const newState = { ...prevState };
              if (newState[uploadCertificateCamelCaseKey]) {
                newState[uploadCertificateCamelCaseKey] = {
                  ...newState[uploadCertificateCamelCaseKey],
                  errors: [],
                };
              }
              return newState;
            });

            // Remove Upload Certificate errors from error count
            // Find and remove any error spans for Upload Certificate from DOM error count
            const uploadCertErrorSpans = Array.from(
              document.querySelectorAll(`.${Divid} span.errorPresent`)
            ).filter((span) => {
              // Check if this error span is for Upload Certificate field
              const parentDiv = span.closest("div");
              if (parentDiv) {
                const label = parentDiv.querySelector("label");
                if (label && label.textContent) {
                  return (
                    label.textContent.includes("Upload Certificate") ||
                    label.textContent.includes("Certificate")
                  );
                }
              }
              return false;
            });

            // Subtract the Upload Certificate errors from error count
            err = Math.max(0, err - uploadCertErrorSpans.length);
          }
        }

        console.log({ err });
        resolve(err == 0);
      }, 500); // Increased timeout to allow React state updates
    });
  };

  //   sendMail Api
  const sendMail = async () => {
    try {
      const config = {
        method: "Post",
        url: "Portal/jobApplication/portal/sendMailAfterSubmit",
        data: {
          email: applicationDetails?.email,
          name: applicationDetails.applicantSFullName,
          applicationId: applicationDetails?.applicationSerialIds,
          mobileNumber: applicationDetails?.mobileNumber,
        },
      };
      const response = await callApi(config);
      if (response?.data?.code == 200) {
        console.log("email sent Successfully");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitForm = async (value, isInitialSubmit) => {
    checkErrorsClass().then(async (noErrors) => {
      if (noErrors || isInitialSubmit) {
        try {
          // Frontend age eligibility validation (only for fields that exist in dynamic form)
          const birthDateId = "66a37bab1b102d1ba93eee2f";
          const dobField = application?.inputElements?.find(
            (field) => field._id === birthDateId
          );
          const departmentalCandidateField = application?.inputElements?.find(
            (field) => field.inputFieldType === "DepartmentalCandidate"
          );

          // Only validate if DOB field exists in the form
          if (dobField) {
            const dob = applicationDetails?.[birthDateId];
            const closingDate =
              applicationDetails?.advertisement?.advertisementClosingDate;
            const gradeName = applicationDetails?.vacancyId?.grade?.gradeName;

            if (dob && closingDate && gradeName) {
              // Parse dates
              const parseDate = (dateStr) => {
                if (!dateStr) return null;
                if (dateStr instanceof Date && !isNaN(dateStr))
                  return new Date(
                    dateStr.getFullYear(),
                    dateStr.getMonth(),
                    dateStr.getDate()
                  );
                if (typeof dateStr !== "string") {
                  const d = new Date(dateStr);
                  return isNaN(d)
                    ? null
                    : new Date(d.getFullYear(), d.getMonth(), d.getDate());
                }

                const str = dateStr.trim();
                if (str.includes("/")) {
                  const parts = str.split("/").map((p) => p.trim());
                  if (parts.length === 3) {
                    const dd = parseInt(parts[0], 10);
                    const mm = parseInt(parts[1], 10);
                    const yyyy = parseInt(parts[2], 10);
                    if (![dd, mm, yyyy].some(Number.isNaN))
                      return new Date(yyyy, mm - 1, dd);
                  }
                }
                if (str.includes("-")) {
                  const parts = str.split("-").map((p) => p.trim());
                  if (parts.length === 3) {
                    if (parts[0].length === 4) {
                      const yyyy = parseInt(parts[0], 10);
                      const mm = parseInt(parts[1], 10);
                      const dd = parseInt(parts[2], 10);
                      if (![yyyy, mm, dd].some(Number.isNaN))
                        return new Date(yyyy, mm - 1, dd);
                    } else {
                      const dd = parseInt(parts[0], 10);
                      const mm = parseInt(parts[1], 10);
                      const yyyy = parseInt(parts[2], 10);
                      if (![dd, mm, yyyy].some(Number.isNaN))
                        return new Date(yyyy, mm - 1, dd);
                    }
                  }
                }
                const d = new Date(str);
                return isNaN(d)
                  ? null
                  : new Date(d.getFullYear(), d.getMonth(), d.getDate());
              };

              const birthDate = parseDate(dob);
              const closing = parseDate(closingDate);

              if (birthDate && closing) {
                // Calculate age
                let ageYears = closing.getFullYear() - birthDate.getFullYear();
                let ageMonths = closing.getMonth() - birthDate.getMonth();
                let ageDays = closing.getDate() - birthDate.getDate();

                if (ageMonths < 0 || (ageMonths === 0 && ageDays < 0)) {
                  ageYears -= 1;
                  ageMonths += 12;
                  if (ageDays < 0) {
                    const daysInPrevMonth = new Date(
                      closing.getFullYear(),
                      closing.getMonth(),
                      0
                    ).getDate();
                    ageDays =
                      closing.getDate() +
                      (daysInPrevMonth - birthDate.getDate());
                  }
                } else if (ageDays < 0) {
                  const daysInPrevMonth = new Date(
                    closing.getFullYear(),
                    closing.getMonth(),
                    0
                  ).getDate();
                  ageDays += daysInPrevMonth;
                  ageMonths -= 1;
                }

                if (ageMonths < 0) {
                  ageMonths += 12;
                  ageYears -= 1;
                }

                // Age limits for grades
                const ageLimits = {
                  "E-4": 40,
                  "E-5": 44,
                  "E-6": 50,
                  "E-7": 55,
                };

                // Special case: E-5 with Legal department has age limit of 50
                const departmentName =
                  applicationDetails?.vacancyId?.department?.name;
                const isLegalDepartment =
                  departmentName &&
                  departmentName.trim().toLowerCase() === "legal";

                let baseAgeLimit = ageLimits[gradeName];

                // Override for E-5 Legal posts
                if (gradeName === "E-5" && isLegalDepartment) {
                  baseAgeLimit = 50;
                }

                if (baseAgeLimit) {
                  // Check if departmental candidate field exists and if candidate is departmental
                  let isDepartmentalCandidate = false;
                  if (departmentalCandidateField) {
                    const departmentalValue =
                      applicationDetails?.departmentalCandidate;
                    isDepartmentalCandidate = departmentalValue === "Yes";
                  }

                  // Calculate age limit (base + 10 if departmental)
                  const appliedAgeLimit = isDepartmentalCandidate
                    ? baseAgeLimit + 10
                    : baseAgeLimit;

                  // For testing: Log age validation details
                  console.log("Age Validation Details:", {
                    ageYears,
                    gradeName,
                    departmentName,
                    isLegalDepartment,
                    baseAgeLimit,
                    isDepartmentalCandidate,
                    appliedAgeLimit,
                    isValid: ageYears <= appliedAgeLimit,
                  });

                  // Validate age against limit (age must be <= limit)
                  if (ageYears > appliedAgeLimit) {
                    const errorMessage = formatAgeIneligibilityMessage({
                      applicantAge: ageYears,
                      ageDetails: {
                        years: ageYears,
                        months: ageMonths,
                        days: ageDays,
                      },
                      maxAgeLimit: appliedAgeLimit,
                      gradeLabel: gradeName,
                      isDepartmentalCandidate,
                    });

                    setErrorFromBackend((prevState) => ({
                      ...prevState,
                      ageEligibilityError: {
                        message: errorMessage,
                        applicantAge: ageYears,
                        relaxedAge: appliedAgeLimit,
                      },
                    }));

                    setShowErrorModal(true);
                    setIsLoading(false);
                    setSaveAndNextLoader(false);
                    return; // Stop form submission
                  } else {
                    // Clear age eligibility error if validation passes
                    setErrorFromBackend((prevState) => {
                      const { ageEligibilityError, ...rest } = prevState;
                      return { ...rest };
                    });
                  }
                }
              }
            }
          }

          const result = {};
          dynamicFields.forEach((entry) => {
            const record = {};
            entry?.fields.forEach((field) => {
              const tab = field?.tab;

              if (!result[tab]) {
                result[tab] = [];
              }
              const fieldName = camelCase(field.values.inputFieldName);
              record[fieldName] = field.value;
            });

            result[entry?.fields[1]?.tab]?.push(record); // Add only once
          });
          const camelCaseApplicationDetails =
            toCamelCaseKeys(applicationDetails);

          if (value === "Submit") {
            // Check if vacancy has reserved categories (SC/ST/OBC/EWS) for age relaxation validation
            const vacancyCategories = state?.post?.posting?.category || [];
            const hasReservedCategories = vacancyCategories.some(
              (cat) =>
                cat?.category &&
                cat.category !== "UR" &&
                (cat.category === "SC" ||
                  cat.category === "ST" ||
                  cat.category === "OBC" ||
                  cat.category === "EWS")
            );

            const config = {
              method: "post",
              url: "Portal/jobApplication/portal/findApplicationByIdAndUpdateOrCreate",
              data: {
                details: {
                  ...camelCaseApplicationDetails,
                  skills: checkedValues,
                  advertisement: state?.item?._id,
                  vacancyId: state?.post?.posting?._id,
                  finalSubmit: true,
                  finalSubmitDate: getCurrentDateTime().date,
                  finalSubmitTime: getCurrentDateTime().time,
                  // Add flag to indicate if vacancy has reserved categories
                  // This helps backend determine if age relaxation should apply
                  hasReservedCategories: hasReservedCategories,
                  ...result,
                },
                userId: userId,
                dynamicApplicationForm: application,
                isAICheck: true,
                tabIndex: Number(tabIndex),
              },
            };

            const response = await callApi(config);
            if (response?.data?.code == 200) {
              await collectUserApplicationData();
              await sendMail();
              toast.success(response?.data?.message, { autoClose: 2000 });
              navigate("/candidateDashboard");
            }
          } else {
            setSaveAndNextLoader(true);

            // Check if vacancy has reserved categories (SC/ST/OBC/EWS) for age relaxation validation
            const vacancyCategories = state?.post?.posting?.category || [];
            const hasReservedCategories = vacancyCategories.some(
              (cat) =>
                cat?.category &&
                cat.category !== "UR" &&
                (cat.category === "SC" ||
                  cat.category === "ST" ||
                  cat.category === "OBC" ||
                  cat.category === "EWS")
            );

            const config = {
              method: "post",
              url: "Portal/jobApplication/portal/findApplicationByIdAndUpdateOrCreate",
              data: {
                details: {
                  ...camelCaseApplicationDetails,
                  skills: checkedValues,
                  advertisement: state?.item?._id,
                  vacancyId: state?.post?.posting?._id,
                  // Add flag to indicate if vacancy has reserved categories
                  // This helps backend determine if age relaxation should apply
                  hasReservedCategories: hasReservedCategories,
                  ...result,
                  tabIndex: tabIndex,
                },
                userId: userId,
                isAICheck: isAICheck,
                dynamicApplicationForm: application,
                tabIndex: Number(tabIndex),
              },
            };

            const response = await callApi(config);
            if (response?.data?.code == 201) {
              console.log("Step1-- in if block");
              await collectUserApplicationData();
              console.log("Step2-- in if block");
              toast.success(response?.data?.message, { autoClose: 2000 });
            }
            setIsLoading(false);
            setSaveAndNextLoader(false);
            if (response?.data?.code == 200) {
              // console.log("data", response?.data);

              // Enforce strict age limit for all E-4 posts (including Business Excellence)
              // purely from frontend DOB calculation, independent of backend relaxation.
              // Rule: max 40 years, or 50 years for departmental candidates.
              try {
                const birthDateIdForE4 = "66a37bab1b102d1ba93eee2f";
                const dobForE4 = applicationDetails?.[birthDateIdForE4];
                const closingDateForE4 =
                  applicationDetails?.advertisement?.advertisementClosingDate;
                const gradeNameForE4 =
                  applicationDetails?.vacancyId?.grade?.gradeName;

                if (dobForE4 && closingDateForE4 && gradeNameForE4 === "E-4") {
                  const parseSimpleDate = (dateStr) => {
                    if (!dateStr) return null;
                    const d = new Date(dateStr);
                    return isNaN(d)
                      ? null
                      : new Date(d.getFullYear(), d.getMonth(), d.getDate());
                  };

                  const birthDateE4 = parseSimpleDate(dobForE4);
                  const closingE4 = parseSimpleDate(closingDateForE4);

                  if (birthDateE4 && closingE4) {
                    let ageYearsE4 =
                      closingE4.getFullYear() - birthDateE4.getFullYear();
                    let ageMonthsE4 =
                      closingE4.getMonth() - birthDateE4.getMonth();
                    let ageDaysE4 = closingE4.getDate() - birthDateE4.getDate();

                    if (
                      ageMonthsE4 < 0 ||
                      (ageMonthsE4 === 0 && ageDaysE4 < 0)
                    ) {
                      ageYearsE4 -= 1;
                      ageMonthsE4 += 12;
                      if (ageDaysE4 < 0) {
                        const daysInPrevMonthE4 = new Date(
                          closingE4.getFullYear(),
                          closingE4.getMonth(),
                          0
                        ).getDate();
                        ageDaysE4 =
                          closingE4.getDate() +
                          (daysInPrevMonthE4 - birthDateE4.getDate());
                      }
                    } else if (ageDaysE4 < 0) {
                      const daysInPrevMonthE4 = new Date(
                        closingE4.getFullYear(),
                        closingE4.getMonth(),
                        0
                      ).getDate();
                      ageDaysE4 += daysInPrevMonthE4;
                      ageMonthsE4 -= 1;
                    }

                    if (ageMonthsE4 < 0) {
                      ageMonthsE4 += 12;
                      ageYearsE4 -= 1;
                    }

                    const frontendBaseLimitE4 = isDepartmentalCandidateSelected
                      ? 50
                      : 40;

                    // Treat any age greater than EXACTLY the limit (including months/days)
                    // as overage: e.g., 40 years 1 month > 40 years.
                    const isOverLimitE4 =
                      ageYearsE4 > frontendBaseLimitE4 ||
                      (ageYearsE4 === frontendBaseLimitE4 &&
                        (ageMonthsE4 > 0 || ageDaysE4 > 0));

                    if (isOverLimitE4) {
                      const errorMessageE4 = formatAgeIneligibilityMessage({
                        applicantAge: ageYearsE4,
                        ageDetails: {
                          years: ageYearsE4,
                          months: ageMonthsE4,
                          days: ageDaysE4,
                        },
                        maxAgeLimit: frontendBaseLimitE4,
                        gradeLabel: gradeNameForE4,
                        isDepartmentalCandidate:
                          isDepartmentalCandidateSelected,
                      });

                      setErrorFromBackend((prevState) => ({
                        ...prevState,
                        ageEligibilityError: {
                          ...(response?.data?.ageEligibility || {}),
                          message: errorMessageE4,
                        },
                      }));
                      setShowErrorModal(true);
                      return; // Stop further processing / navigation
                    }
                  }
                }
              } catch (e) {
                console.error("E-4 frontend age enforcement error:", e);
              }

              await updateApplicationTabIndex();
              let allowFurtherEducation =
                response?.data?.ageEligibility?.isValidAgeForApplication;

              let errorCount = 0;
              if (!allowFurtherEducation) {
                errorCount++;

                let ageEligibility = response?.data?.ageEligibility;

                // Check if vacancy has reserved categories (SC/ST/OBC/EWS)
                const vacancyCategories = state?.post?.posting?.category || [];
                const hasReservedCategories = vacancyCategories.some(
                  (cat) =>
                    cat?.category &&
                    cat.category !== "UR" &&
                    (cat.category === "SC" ||
                      cat.category === "ST" ||
                      cat.category === "OBC" ||
                      cat.category === "EWS")
                );

                // If vacancy has NO reserved categories, age relaxation should not apply
                // Even if backend returns relaxedAge, we should validate against base age only
                const userGender =
                  applicationDetails?.["66a37bab1b102d1ba93eee2e"];
                const isFemale = userGender === "Female";

                // If vacancy has no reserved categories and user is female,
                // but backend is applying relaxation, we need to handle this
                const gradeLabelForMessage = deriveGradeName();
                const ageLimitForMessage = resolveAgeLimitValue(ageEligibility);

                // Special case: For Business Excellence E-4 posts, maximum age
                // must be strictly 40 years for all (except departmental +10, which
                // is already handled in the frontend DOB-based validation).
                // So for this combination, we should NOT apply any additional
                // relaxation based on gender/category coming from the backend.
                const departmentNameForMessage =
                  applicationDetails?.vacancyId?.department?.name;
                const isBusinessExcellenceE4 =
                  gradeLabelForMessage === "E-4" &&
                  departmentNameForMessage &&
                  departmentNameForMessage
                    .trim()
                    .toLowerCase()
                    .includes("business excellence");

                // Calculate age details (years, months, days) from date of birth
                let calculatedAgeDetails = null;
                const birthDateId = "66a37bab1b102d1ba93eee2f";
                const dob = applicationDetails?.[birthDateId];
                const closingDate =
                  applicationDetails?.advertisement?.advertisementClosingDate;

                if (dob && closingDate) {
                  const parseDate = (dateStr) => {
                    if (!dateStr) return null;
                    const d = new Date(dateStr);
                    return isNaN(d)
                      ? null
                      : new Date(d.getFullYear(), d.getMonth(), d.getDate());
                  };

                  const birthDate = parseDate(dob);
                  const closing = parseDate(closingDate);

                  if (birthDate && closing) {
                    let ageYears =
                      closing.getFullYear() - birthDate.getFullYear();
                    let ageMonths = closing.getMonth() - birthDate.getMonth();
                    let ageDays = closing.getDate() - birthDate.getDate();

                    if (ageMonths < 0 || (ageMonths === 0 && ageDays < 0)) {
                      ageYears -= 1;
                      ageMonths += 12;
                      if (ageDays < 0) {
                        const daysInPrevMonth = new Date(
                          closing.getFullYear(),
                          closing.getMonth(),
                          0
                        ).getDate();
                        ageDays =
                          closing.getDate() +
                          (daysInPrevMonth - birthDate.getDate());
                      }
                    } else if (ageDays < 0) {
                      const daysInPrevMonth = new Date(
                        closing.getFullYear(),
                        closing.getMonth(),
                        0
                      ).getDate();
                      ageDays += daysInPrevMonth;
                      ageMonths -= 1;
                    }

                    if (ageMonths < 0) {
                      ageMonths += 12;
                      ageYears -= 1;
                    }

                    calculatedAgeDetails = {
                      years: ageYears,
                      months: ageMonths,
                      days: ageDays,
                    };
                  }
                }

                if (
                  (isBusinessExcellenceE4 || !hasReservedCategories) &&
                  isFemale &&
                  ageEligibility.relaxedAge
                ) {
                  // Vacancy has no reserved positions, so no relaxation should apply
                  // Show error based on base age only (not relaxed age)
                  setErrorFromBackend((prevState) => ({
                    ...prevState,
                    ageEligibilityError: {
                      ...ageEligibility,
                      message: formatAgeIneligibilityMessage({
                        applicantAge: ageEligibility?.applicantAge,
                        ageDetails: calculatedAgeDetails,
                        maxAgeLimit:
                          ageEligibility?.baseAge ??
                          ageEligibility?.baseAgeLimit ??
                          ageEligibility?.maxAge ??
                          ageEligibility?.maxAgeLimit ??
                          ageEligibility?.maximumAge ??
                          ageEligibility?.maximumAgeLimit ??
                          ageEligibility?.allowedAge ??
                          ageEligibility?.ageLimit ??
                          ageEligibility?.relaxedAge,
                        gradeLabel: gradeLabelForMessage,
                        isDepartmentalCandidate:
                          isDepartmentalCandidateSelected,
                      }),
                    },
                  }));
                } else if (ageEligibility.relaxedAge) {
                  // Normal case: vacancy has reserved categories, relaxation applies
                  setErrorFromBackend((prevState) => ({
                    ...prevState,
                    ageEligibilityError: {
                      ...ageEligibility,
                      message: formatAgeIneligibilityMessage({
                        applicantAge: ageEligibility?.applicantAge,
                        ageDetails: calculatedAgeDetails,
                        maxAgeLimit:
                          ageLimitForMessage || ageEligibility?.relaxedAge,
                        gradeLabel: gradeLabelForMessage,
                        isDepartmentalCandidate:
                          isDepartmentalCandidateSelected,
                      }),
                    },
                  }));
                } else {
                  // No relaxation case
                  setErrorFromBackend((prevState) => ({
                    ...prevState,
                    ageEligibilityError: {
                      ...ageEligibility,
                      message: formatAgeIneligibilityMessage({
                        applicantAge: ageEligibility?.applicantAge,
                        ageDetails: calculatedAgeDetails,
                        maxAgeLimit: ageLimitForMessage,
                        gradeLabel: gradeLabelForMessage,
                        isDepartmentalCandidate:
                          isDepartmentalCandidateSelected,
                        extraNote: ageEligibility?.reason || "",
                      }),
                    },
                  }));
                }
              } else {
                setErrorFromBackend((prevState) => {
                  const { ageEligibilityError, ...rest } = prevState;
                  return { ...rest };
                });
              }

              let allowFurtherExperience =
                response?.data?.experienceEligibility.eligible;
              let relevantExpEligible =
                response?.data?.relevantExpEligible.eligible;
              let relevantEligible = response?.data?.relevantExpEligible;

              if (
                (!allowFurtherExperience || !relevantExpEligible) &&
                tabIndex >= 5
              ) {
                errorCount++;

                let expEligibility = response?.data?.experienceEligibility;
                const totalRequired = expEligibility?.experienceRequired ?? "";
                const relevantRequired =
                  relevantEligible?.relevantExperienceRequired ?? "";
                const totalHave = expEligibility?.experienceHave ?? "";
                const relevantHave =
                  relevantEligible?.relevantExperienceHave ?? "";

                const buildFormattedYears = (value) => {
                  if (value === "" || value === undefined || value === null) {
                    return "";
                  }

                  const directNumber = Number(value);
                  if (!Number.isNaN(directNumber)) {
                    return directNumber.toString();
                  }

                  const parsedNumber = parseFloat(value);
                  if (!Number.isNaN(parsedNumber)) {
                    return parsedNumber.toString();
                  }

                  return value?.toString() ?? "";
                };

                const totalRequiredStr = buildFormattedYears(totalRequired);
                const relevantRequiredStr =
                  buildFormattedYears(relevantRequired);
                const totalHaveStr = buildFormattedYears(totalHave);
                const relevantHaveStr = buildFormattedYears(relevantHave);

                const experienceMessage =
                  totalRequiredStr !== "" &&
                  relevantRequiredStr !== "" &&
                  totalHaveStr !== "" &&
                  relevantHaveStr !== ""
                    ? `You are not eligible for this post, as the minimum requirement is at least ${totalRequiredStr} years of overall industry experience and ${relevantRequiredStr} years of relevant experience. As per the details provided, you have ${totalHaveStr} years of overall industry experience and ${relevantHaveStr} years of relevant experience, which do not meet the prescribed criteria.`
                    : `You are not eligible for this post due to insufficient experience.`;

                setErrorFromBackend((prevState) => ({
                  ...prevState,
                  experienceEligibilityError: {
                    ...expEligibility,
                    message: experienceMessage,
                  },
                }));
              } else {
                setErrorFromBackend((prevState) => {
                  const { experienceEligibilityError, ...rest } = prevState;
                  return { ...rest };
                });
              }
              if (errorCount > 0) {
                setShowErrorModal(true); // Show the modal if errors exist
              } else {
                setTabIndex(Math.min(applicationForm?.length, tabIndex + 1));
              }
            }
          }
        } catch (error) {
          toast.error("Something went wrong. Please try again.", {
            autoClose: 2000,
          });
        } finally {
          setIsLoading(false);
        }
      } else {
        console.log("Errors found, cannot proceed.");
      }
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [tabIndex]);

  const renderArrayFields = (field, fieldIndex, item, fieldSet) => {
    const label = field?.values?.inputFieldName;
    // Debug: Log all array fields being processed
    console.log(
      "Processing array field:",
      label,
      "ID:",
      field?.values?._id,
      "FormTab:",
      item?.formTab
    );
    // console.log({ field })
    const camelCaseKey = field?.values?._id + fieldSet.id;

    const dateDifference = (date1, date2) => {
      // console.log({ date1 }, { date2 });
      const diff = new Date(new Date(date2) - new Date(date1));
      return `${
        diff.getUTCFullYear() - 1970
      } Years ${diff.getUTCMonth()} Months ${diff.getUTCDate() - 1} Days`;
    };
    const updateExpValue = (value, tab) => {
      const updatedFields = dynamicFields.map((fs) => {
        if (fs.id === fieldSet.id) {
          let isCorrect = Date(fs.fields[fieldIndex + 1].value) >= Date(value);
          if (!isCorrect)
            setFieldErrors((prevState) => ({
              ...prevState,
              [camelCaseKey]: {
                errors: [
                  ...new Set([
                    ...(prevState[camelCaseKey]?.errors || []),
                    "Total mark should be greater then obtained mark.",
                  ]),
                ], // Append the error message
                touched: prevState?.[camelCaseKey]?.touched,
              },
            }));
          // console.log("date1", value, fs.fields[fieldIndex + 1].value);
          let percentMark = dateDifference(
            value,
            fs.fields[fieldIndex + 1].value
          );
          if (percentMark < 0 || percentMark > 100) percentMark = "Invalid";
          fs.fields[fieldIndex].value = value;

          fs.fields[fieldIndex + 5].value = percentMark;

          fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
          return { ...fs };
        }
        return fs;
      });
      setDynamicFields(updatedFields);
    };
    const updateExpValue2 = (value, tab) => {
      const updatedFields = dynamicFields.map((fs) => {
        if (fs.id === fieldSet.id) {
          let isCorrect = Date(fs.fields[fieldIndex - 1].value) >= Date(value);
          if (!isCorrect)
            setFieldErrors((prevState) => ({
              ...prevState,
              [camelCaseKey]: {
                errors: [
                  ...new Set([
                    ...(prevState[camelCaseKey]?.errors || []),
                    "Total mark should be greater then obtained mark.",
                  ]),
                ], // Append the error message
                touched: prevState?.[camelCaseKey]?.touched,
              },
            }));
          let percentMark = dateDifference(
            fs.fields[fieldIndex - 1].value,
            value
          );
          if (percentMark < 0 || percentMark > 100) percentMark = "Invalid";
          fs.fields[fieldIndex].value = value;

          fs.fields[fieldIndex + 4].value = percentMark;

          fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
          return { ...fs };
        }
        return fs;
      });
      setDynamicFields(updatedFields);
    };

    const renderPdfInputMultiple = (
      updateFieldValue,
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails
    ) => {
      // Convert fieldValue to array format (handle both legacy string and new array format)
      let fileArray = [];
      if (fieldValue) {
        if (typeof fieldValue === "string") {
          // Legacy format: comma-separated URLs
          const urls = fieldValue.split(",").filter(Boolean);
          fileArray = urls.map((url) => {
            try {
              const queryParams = new URL(url).searchParams;
              const name = queryParams.get("name") || "";
              return { file: url, name: name, verified: false };
            } catch {
              return { file: url, name: "", verified: false };
            }
          });
        } else if (Array.isArray(fieldValue)) {
          fileArray = fieldValue;
        }
      }

      // Initialize with empty file if array is empty
      if (fileArray.length === 0) {
        fileArray = [{ file: null, name: "", verified: false }];
      }

      const addFile = () => {
        const updatedFiles = [
          ...fileArray,
          { file: null, name: "", verified: false },
        ];
        updateFieldValue(updatedFiles);
        // Also update applicationDetails for validation
        const fieldId = input?.values?._id;
        if (fieldId) {
          setApplicationDetails({
            ...applicationDetails,
            [fieldId]: updatedFiles,
          });
        }
        // Trigger validation after adding file slot
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
      };

      const removeFile = (index) => {
        const updatedFiles = fileArray.filter((_, idx) => idx !== index);
        if (updatedFiles.length === 0) {
          updatedFiles.push({ file: null, name: "", verified: false });
        }
        updateFieldValue(updatedFiles);
        // Also update applicationDetails for validation
        const fieldId = input?.values?._id;
        if (fieldId) {
          setApplicationDetails({
            ...applicationDetails,
            [fieldId]: updatedFiles,
          });
        }
        // Trigger validation after removal
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
      };

      const handleFileChange = async (e, index) => {
        const file = e.target.files[0];
        if (file) {
          const isPDF = file.type === "application/pdf";
          if (!isPDF) {
            toast.warn("Invalid file type. Only PDF files are allowed.");
            // Still trigger validation to show required error if field is required
            setTimeout(() => {
              checkErrorFn(input, camelCaseKey, fileArray);
            }, 100);
            return;
          }

          const fileUrl = await AWSUpload(file);
          if (fileUrl) {
            const updatedFiles = [...fileArray];
            updatedFiles[index] = {
              ...updatedFiles[index],
              file: fileUrl,
              verified: false,
            };
            updateFieldValue(updatedFiles);
            // Also update applicationDetails for validation
            const fieldId = input?.values?._id;
            if (fieldId) {
              setApplicationDetails({
                ...applicationDetails,
                [fieldId]: updatedFiles,
              });
            }
            // Trigger validation
            setTimeout(() => {
              checkErrorFn(input, camelCaseKey, updatedFiles);
            }, 100);
            e.target.value = null;
          } else {
            // If upload fails, still trigger validation
            setTimeout(() => {
              checkErrorFn(input, camelCaseKey, fileArray);
            }, 100);
          }
        } else {
          // If no file selected, trigger validation to check if field is required
          setTimeout(() => {
            checkErrorFn(input, camelCaseKey, fileArray);
          }, 100);
        }
      };

      const handleFileNameChange = (e, index) => {
        const { value } = e.target;
        const updatedFiles = [...fileArray];
        updatedFiles[index].name = value;
        updateFieldValue(updatedFiles);
        // Also update applicationDetails for validation
        const fieldId = input?.values?._id;
        if (fieldId) {
          setApplicationDetails({
            ...applicationDetails,
            [fieldId]: updatedFiles,
          });
        }
        // Trigger validation after file name change
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
      };

      const handleOpenVerificationModal = (index) => {
        // Store the file index in a data attribute or use the existing modal system
        SetImageModalOpen(`${camelCaseKey}_${index}`);
      };

      const handleConfirmVerification = (index) => {
        const updatedFiles = [...fileArray];
        updatedFiles[index].verified = true;
        updateFieldValue(updatedFiles);
        // Also update applicationDetails for validation
        const fieldId = input?.values?._id;
        if (fieldId) {
          setApplicationDetails({
            ...applicationDetails,
            [fieldId]: updatedFiles,
          });
        }
        // Trigger validation after verification
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
        SetImageModalOpen(false);
        toast.success("File verified successfully!");
      };

      return (
        <div className=" gap-4">
          <Row className="mt-2">
            {(() => {
              const displayErrors = getDisplayErrors(camelCaseKey, {
                hideVerificationErrors:
                  applicationDetails?.[`${camelCaseKey}verified`] === true,
              });
              if (
                displayErrors.length === 0 ||
                !fieldErrors?.[camelCaseKey]?.touched
              ) {
                return null;
              }
              return displayErrors.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ));
            })()}
          </Row>

          <div className="mb-3">
            {fileArray.map((fileObj, index) => (
              <Row key={index} className="align-items-center mb-2">
                {/* File Upload */}
                <Col xs={12} md={3}>
                  <div className="d-flex flex-column">
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, index)}
                      onBlur={(e) => {
                        // Trigger validation when file input loses focus
                        checkErrorFn(input, camelCaseKey, fieldValue);
                      }}
                      style={{ display: "none" }}
                      id={`${camelCaseKey}_file_input_${index}`}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        document
                          .getElementById(`${camelCaseKey}_file_input_${index}`)
                          .click()
                      }
                      onBlur={(e) => {
                        // Trigger validation when button loses focus
                        checkErrorFn(input, camelCaseKey, fieldValue);
                      }}
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        height: "37px",
                        fontSize: "12px",
                        cursor: "pointer",
                        border: "none",
                        backgroundColor: "#921d1e",
                        color: "#fff",
                      }}
                    >
                      <span>
                        {fileObj.file ? "Choose File" : "Upload File"}
                      </span>
                    </button>
                  </div>
                </Col>

                {/* File Name Input */}
                <Col xs={12} md={4}>
                  <input
                    type="text"
                    placeholder="Enter File Name"
                    value={fileObj.name}
                    onChange={(e) => handleFileNameChange(e, index)}
                    onBlur={(e) => {
                      // Trigger validation when file name input loses focus
                      checkErrorFn(input, camelCaseKey, fieldValue);
                    }}
                    className="form-control"
                    style={style.input}
                  />
                  {!fileObj.name && fileObj.file && (
                    <span className="errorPresent" style={style.errorSpan}>
                      Please enter the file name
                    </span>
                  )}
                </Col>

                {/* Actions: Preview, Verify, Delete */}
                <Col xs={12} md={5} className="d-flex align-items-center">
                  {fileObj.file && (
                    <>
                      <img
                        src={pdfIcon}
                        alt="PDF Preview"
                        style={{ width: "40px", cursor: "pointer" }}
                        onClick={() => handleOpenVerificationModal(index)}
                        className="me-2"
                      />

                      {!fileObj.verified ? (
                        <Button
                          size="sm"
                          onClick={() => handleOpenVerificationModal(index)}
                          className="me-2"
                        >
                          Verify
                        </Button>
                      ) : (
                        <Badge
                          bg="success"
                          className="d-flex align-items-center me-2"
                        >
                          <FaCheckCircle size={"18"} className="me-1" />
                          Verified
                        </Badge>
                      )}

                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleOpenVerificationModal(index)}
                        className="me-2"
                      >
                        <IoEyeOutline size={"20"} />
                      </Button>

                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => removeFile(index)}
                      >
                        <MdDeleteOutline size={"20"} />
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            ))}

            {/* Add Another Document Button */}
            <div className="text-end">
              <Button
                style={{ backgroundColor: "brown", borderColor: "brown" }}
                onClick={addFile}
              >
                Add File
              </Button>
            </div>
          </div>

          {/* Modal for File Preview and Verification */}
          {OpenImageModal && OpenImageModal.startsWith(`${camelCaseKey}_`) && (
            <Modal
              size="lg"
              show={
                OpenImageModal && OpenImageModal.startsWith(`${camelCaseKey}_`)
              }
              onHide={() => SetImageModalOpen(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Verify Document</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                {(() => {
                  const fileIndex = OpenImageModal.split("_").pop();
                  const index = parseInt(fileIndex);
                  const fileObj = fileArray[index];
                  return fileObj?.file ? (
                    <iframe
                      src={fileObj.file}
                      width="100%"
                      style={{ border: "none", height: "50vh" }}
                      title="PDF Viewer"
                    />
                  ) : (
                    <p>No file available for preview.</p>
                  );
                })()}
              </Modal.Body>
              <Modal.Footer>
                {(() => {
                  const fileIndex = OpenImageModal.split("_").pop();
                  const index = parseInt(fileIndex);
                  const fileObj = fileArray[index];
                  return !fileObj?.verified ? (
                    <Button
                      variant="primary"
                      onClick={() => handleConfirmVerification(index)}
                    >
                      Confirm Verification
                    </Button>
                  ) : null;
                })()}
                <Button
                  variant="secondary"
                  onClick={() => SetImageModalOpen(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      );
    };

    const PdfCarousel = ({
      imageUrls,
      label,
      applicationDetails,
      setApplicationDetails,
      camelCaseKey,
      SetImageModalOpen,
    }) => {
      const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

      React.useEffect(() => {
        setCurrentImageIndex(0);
      }, []);

      const handleNext = () => {
        if (currentImageIndex < imageUrls.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        }
      };

      const handlePrev = () => {
        if (currentImageIndex > 0) {
          setCurrentImageIndex(currentImageIndex - 1);
        }
      };

      const isLastImage = currentImageIndex === imageUrls.length - 1;

      return (
        <>
          <Modal.Header
            style={{
              borderBottom: "1px solid #dee2e6",
              backgroundColor: "#f8f9fa",
              padding: "12px 20px",
            }}
          >
            <Modal.Title
              style={{ fontSize: "18px", fontWeight: "600", color: "#212529" }}
            >
              <i className="bi bi-images me-2" style={{ color: "#0d6efd" }}></i>
              Document Preview - {label || "Document"} ({currentImageIndex + 1}{" "}
              of {imageUrls.length})
            </Modal.Title>
            <div className="d-flex gap-2 align-items-center">
              <div className="d-flex gap-1 me-3">
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={currentImageIndex === 0}
                  onClick={handlePrev}
                  title="Previous"
                >
                  <FaArrowAltCircleLeft size={20} />
                </Button>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  disabled={currentImageIndex === imageUrls.length - 1}
                  onClick={handleNext}
                  title="Next"
                >
                  <FaArrowAltCircleRight size={20} />
                </Button>
              </div>
              {!applicationDetails[`${camelCaseKey}verified`] &&
                isLastImage && (
                  <Button
                    variant="success"
                    size="sm"
                    onClick={() => {
                      const updatedDetails = {
                        ...applicationDetails,
                        [`${camelCaseKey}verified`]: true,
                      };
                      setApplicationDetails(updatedDetails);

                      const userId = sessionStorage.getItem("userId");
                      if (userId) {
                        const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                        sessionStorage.setItem(sessionVerificationKey, "true");
                      }

                      toast.success("Document verified successfully");
                      SetImageModalOpen(false);
                    }}
                  >
                    <i className="bi bi-check-circle me-1"></i>
                    Verify
                  </Button>
                )}
              <Button
                variant="outline-primary"
                size="sm"
                href={imageUrls[currentImageIndex]}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-box-arrow-up-right me-1"></i>
                Open in New Tab
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => SetImageModalOpen(false)}
              >
                <i className="bi bi-x-lg me-1"></i>
                Close
              </Button>
            </div>
          </Modal.Header>
          <Modal.Body
            style={{
              padding: "0",
              backgroundColor: "#f5f5f5",
              height: "calc(100vh - 120px)",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <iframe
              src={imageUrls[currentImageIndex]}
              width="100%"
              style={{
                border: "none",
                height: "100%",
                display: "block",
              }}
              title="PDF Viewer"
            />
          </Modal.Body>
        </>
      );
    };

    const renderPdfInput = (
      updateFieldValue,
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      field,
      fieldSet,
      fieldIndex
    ) => {
      console.log({ fieldValue });

      // Check verification status from field object (like DepartmentalCandidate)
      // Also check applicationDetails as fallback for validation
      const isVerified =
        field?.verified === true ||
        applicationDetails[`${camelCaseKey}verified`] === true ||
        (input?.values?._id &&
          applicationDetails[`${input.values._id}verified`] === true);

      // Helper function to update verification status in the field object
      const updateVerificationStatus = (verified) => {
        const updatedFields = dynamicFields.map((fs) => {
          if (fs.id === fieldSet.id) {
            const updatedFieldSet = { ...fs };
            updatedFieldSet.fields = updatedFieldSet.fields.map((f, idx) => {
              if (idx === fieldIndex) {
                return { ...f, verified: verified };
              }
              return f;
            });
            return updatedFieldSet;
          }
          return fs;
        });
        setDynamicFields(updatedFields);
      };

      return (
        <div className="imageDiv d-flex align-items-center gap-4">
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: window.innerWidth > 768 ? "40%" : "100%",
            }}
          >
            <div className="d-flex flex-column">
              <button
                className="me-4"
                style={{
                  borderRadius: "10px",
                  height: "40px",
                  padding: "5px 10px",
                  fontSize: "12px",
                  cursor: "pointer",
                  margin: "15px 0",
                  border: "none",
                  backgroundColor: "#921d1e",
                  color: "#fff",
                }}
                onClick={() =>
                  document.getElementById(`${camelCaseKey}_fileInput`).click()
                }
              >
                Upload File
              </button>

              {(() => {
                const displayErrors = getDisplayErrors(camelCaseKey, {
                  hideVerificationErrors: isVerified,
                });
                if (
                  displayErrors.length === 0 ||
                  !fieldErrors?.[camelCaseKey]?.touched
                ) {
                  return null;
                }
                return displayErrors.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ));
              })()}
              <br />
              {fieldValue?.trim() && !isVerified && (
                <span
                  key={"Dgf"}
                  className="errorPresent "
                  style={{
                    ...style.errorSpan,
                    marginTop: "-25px",
                    paddingBottom: "20px",
                  }}
                >
                  {"Please Verify The File"}
                  <br />
                </span>
              )}
            </div>
            <input
              type="file"
              accept="application/pdf"
              id={`${camelCaseKey}_fileInput`}
              style={{
                top: 0,
                left: 0,
                opacity: 0,
                width: "100%",
                height: "100%",
                cursor: "pointer",
              }}
              onChange={(e) => {
                // Reset verification when new file is uploaded (like DepartmentalCandidate)
                updateVerificationStatus(false);
                handleUploadImageArray(e, camelCaseKey, updateFieldValue);

                fieldErrors?.[camelCaseKey]?.touched &&
                  checkErrorFn(input, camelCaseKey, e.target.value);
                e.target.value = null;
              }}
              onBlur={(e) => {
                checkErrorFn(input, camelCaseKey, fieldValue);
              }}
            />
          </div>

          {fieldValue?.trim() && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  marginTop: "-55px",
                }}
              >
                <img
                  src={pdfIcon}
                  alt="PDF preview"
                  style={{
                    marginLeft: "10px",
                    width: "50px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowIframe(camelCaseKey);
                  }}
                />

                {!isVerified && (
                  <Button
                    className="ms-2 verifybutton verifyBtn"
                    onClick={() => setShowIframe(camelCaseKey)}
                  >
                    Verify
                  </Button>
                )}

                {isVerified && (
                  <Badge bg="success" className="fw-bold ms-2">
                    <FaCheckCircle size={"18"} className="me-2" />
                    Verified
                  </Badge>
                )}

                <Button
                  style={{ marginLeft: "0px" }}
                  variant="outline"
                  onClick={() => setShowIframe(camelCaseKey)}
                >
                  <IoEyeOutline size={"25"} />
                </Button>

                <Button
                  className="ms-2"
                  variant="outline"
                  onClick={() => {
                    updateFieldValue(null);
                    updateVerificationStatus(false);
                  }}
                >
                  <MdDeleteOutline size={"25"} />
                </Button>
              </div>
            </div>
          )}

          {showIframe && (
            <Modal
              show={showIframe === camelCaseKey}
              onHide={() => setShowIframe(false)}
              size="lg"
              centered
              style={{ zIndex: 10000 }}
            >
              <Modal.Header
                style={{
                  borderBottom: "1px solid #dee2e6",
                  backgroundColor: "#f8f9fa",
                  padding: "12px 20px",
                }}
              >
                <Modal.Title
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#212529",
                  }}
                >
                  <i
                    className="bi bi-file-earmark-pdf me-2"
                    style={{ color: "#dc3545" }}
                  ></i>
                  Document Preview - {label || "Document"}
                </Modal.Title>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => setShowIframe(false)}
                >
                  <i className="bi bi-x-lg me-1"></i>
                  Close
                </Button>
              </Modal.Header>
              <Modal.Body
                className="text-center"
                style={{
                  padding: "0",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <iframe
                  src={fieldValue}
                  width="100%"
                  style={{
                    border: "none",
                    height: "80vh",
                    display: "block",
                  }}
                  title="PDF Viewer"
                  type="application/pdf"
                />
                {!isVerified && (
                  <Button
                    className="mt-2 mb-2"
                    variant="success"
                    onClick={() => {
                      // Update verification in field object (like DepartmentalCandidate)
                      updateVerificationStatus(true);

                      // Also update applicationDetails for backward compatibility and validation
                      const fieldId = input?.values?._id;
                      setApplicationDetails((prev) => {
                        const updated = {
                          ...prev,
                          [`${camelCaseKey}verified`]: true,
                        };
                        // Also set by field ID for checkErrorsClass validation
                        if (fieldId) {
                          updated[`${fieldId}verified`] = true;
                        }
                        return updated;
                      });

                      // Store in sessionStorage for persistence (with file URL keys for restoration)
                      const userId = sessionStorage.getItem("userId");
                      if (userId) {
                        // Store with camelCaseKey (for current session)
                        const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                        sessionStorage.setItem(sessionVerificationKey, "true");

                        // Also store verification with file URL as key (stable identifier)
                        // This allows restoration when fieldSet.id changes
                        const currentFieldValue =
                          fieldValue || applicationDetails[camelCaseKey];
                        if (
                          currentFieldValue &&
                          typeof currentFieldValue === "string" &&
                          currentFieldValue.trim() !== ""
                        ) {
                          try {
                            // Extract file identifier from URL
                            let fileIdentifier = currentFieldValue;
                            try {
                              const url = new URL(currentFieldValue);
                              fileIdentifier =
                                url.pathname || currentFieldValue;
                            } catch (e) {
                              fileIdentifier = currentFieldValue;
                            }

                            // Store with pathname-based key
                            const fileUrlKey = `verification_${userId}_file_${fileIdentifier.substring(
                              0,
                              200
                            )}`;
                            sessionStorage.setItem(fileUrlKey, "true");

                            // Also store with base64 encoded full URL as backup
                            const fileUrlKeyBase64 = `verification_${userId}_file_b64_${btoa(
                              currentFieldValue
                            ).substring(0, 150)}`;
                            sessionStorage.setItem(fileUrlKeyBase64, "true");
                          } catch (e) {
                            // If encoding fails, continue without it
                          }
                        }
                      }

                      // Clear any verification errors from fieldErrors state
                      setFieldErrors((prevErrors) => {
                        const currentErrors =
                          prevErrors[camelCaseKey]?.errors || [];
                        const filteredErrors = currentErrors.filter(
                          (err) =>
                            !err.includes("verify") &&
                            !err.includes("Verify") &&
                            !err.includes("verification") &&
                            !err.includes("Please Verify The File") &&
                            !err.includes(
                              "Please verify the uploaded document before proceeding."
                            ) &&
                            !err.includes(
                              "Please verify all uploaded documents before proceeding."
                            )
                        );
                        return {
                          ...prevErrors,
                          [camelCaseKey]: {
                            errors: filteredErrors,
                            touched: true,
                          },
                        };
                      });

                      toast.success("Document verified successfully");
                      setShowIframe(false);

                      // Re-validate to ensure error is cleared
                      setTimeout(() => {
                        if (input) {
                          checkErrorFn(input, camelCaseKey, fieldValue);
                        }
                      }, 100);
                    }}
                  >
                    Confirm Verification
                  </Button>
                )}
                <Button
                  className="mt-2 mb-2"
                  variant="secondary"
                  onClick={() => setShowIframe(false)}
                >
                  Close
                </Button>
              </Modal.Body>
            </Modal>
          )}
        </div>
      );
    };

    const renderImageInputMultiple = (
      updateFieldValue,
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails
    ) => {
      // Convert fieldValue to array format (handle both legacy string and new array format)
      let imageUrls = [];
      if (fieldValue) {
        if (typeof fieldValue === "string") {
          imageUrls = fieldValue.split(",").filter(Boolean);
        } else if (Array.isArray(fieldValue)) {
          imageUrls = fieldValue.map((item) =>
            typeof item === "string" ? item : item?.file || ""
          );
        }
      }

      const handleDeleteImage = (index) => {
        const updatedImageUrls = imageUrls.filter((_, idx) => idx !== index);
        const updatedImageUrlsString =
          Array.isArray(updatedImageUrls) &&
          typeof updatedImageUrls[0] !== "string"
            ? updatedImageUrls.map((item) => item?.file || "").join(",")
            : updatedImageUrls.join(",");

        setApplicationDetails({
          ...applicationDetails,
          [`${camelCaseKey}verified`]: false, // Reset verified status
        });
        updateFieldValue(updatedImageUrlsString);
      };

      return (
        <div className="imageDiv d-flex align-items-center gap-4">
          <div style={{ position: "relative", display: "inline-block" }}>
            <div className="flex-wrap">
              <button
                style={{
                  borderRadius: "10px",
                  height: "40px",
                  padding: "5px 15px",
                  fontSize: "12px",
                  cursor: "pointer",
                  margin: "15px 0",
                  border: "none",
                  backgroundColor: "#921d1e",
                  // fieldErrors?.[camelCaseKey]?.touched &&
                  // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                  //   ? "#921d1e"
                  //   : "#f0f0f0",
                  color: "#fff",
                  // fieldErrors?.[camelCaseKey]?.touched &&
                  // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                  //   ? "#fff"
                  //   : "#333",
                }}
                onClick={() =>
                  document.getElementById(`${camelCaseKey}_imageInput`).click()
                }
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
              >
                Upload File
              </button>
              <br />
              {(() => {
                const displayErrors = getDisplayErrors(camelCaseKey, {
                  hideVerificationErrors:
                    applicationDetails?.[`${camelCaseKey}verified`] === true,
                });
                if (
                  displayErrors.length === 0 ||
                  !fieldErrors?.[camelCaseKey]?.touched
                ) {
                  return null;
                }
                return displayErrors.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ));
              })()}
              <br />
              {fieldValue && !applicationDetails[`${camelCaseKey}verified`] && (
                <span
                  key={"Dgf"}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {"Please Verify The Images"}
                  <br />
                </span>
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              multiple
              id={`${camelCaseKey}_imageInput`}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: "100%",
                height: "100%",
                cursor: "pointer",
              }}
              onChange={(e) => {
                handleUploadImagesArray(e, camelCaseKey, updateFieldValue);
                fieldErrors?.[camelCaseKey]?.touched &&
                  checkErrorFn(input, camelCaseKey, e.target.value);
                e.target.value = null;
              }}
              onBlur={(e) => {
                checkErrorFn(input, camelCaseKey, fieldValue);
              }}
            />
          </div>

          {/* Display Multiple Images */}
          {imageUrls.length > 0 && (
            <>
              <div className="d-flex flex-wrap">
                {imageUrls.map((url, index) => (
                  <div
                    key={index}
                    className="position-relative m-2 ms-3"
                    style={{ display: "inline-block" }}
                  >
                    <img
                      src={url}
                      alt={`${label} ${index + 1}`}
                      style={{
                        height: "50px",
                        width: "auto",
                      }}
                      className="p-2"
                      onClick={() => SetImageModalOpen(camelCaseKey)}
                    />
                    <Button
                      className="position-absolute p-0 m-0"
                      variant="outline"
                      style={{ top: "20px", right: "-15px" }}
                      size="sm"
                      onClick={() => SetImageModalOpen(camelCaseKey)}
                    >
                      <IoEyeOutline size={"25"} />
                    </Button>
                    <Button
                      className="position-absolute p-0 m-0 "
                      variant="outline"
                      style={{ top: "20px", right: "-40px" }}
                      size="sm"
                      onClick={() => handleDeleteImage(index)}
                    >
                      <MdDeleteOutline size={"25"} />
                    </Button>
                  </div>
                ))}
              </div>

              {!applicationDetails[`${camelCaseKey}verified`] && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    className="ms-4 verifybutton verifyBtn"
                    onClick={() => SetImageModalOpen(camelCaseKey)}
                    style={{ marginLeft: "auto" }}
                  >
                    Verify
                  </Button>
                </div>
              )}

              {applicationDetails[`${camelCaseKey}verified`] && (
                <div
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  className={"fw-bold ms-4"}
                >
                  <Badge bg="success">
                    <FaCheckCircle size={"18"} className="me-2" />
                    Verified
                  </Badge>
                </div>
              )}
            </>
          )}

          {/* Image Modal for Verification */}
          {OpenImageModal && (
            <Modal
              size="xl"
              show={OpenImageModal == camelCaseKey}
              onHide={() => SetImageModalOpen(false)}
              centered
              aria-labelledby="example-custom-modal-styling-title"
            >
              <Modal.Body className="text-center">
                <ImageCarousel
                  imageUrls={imageUrls}
                  label={label}
                  applicationDetails={applicationDetails}
                  setApplicationDetails={setApplicationDetails}
                  camelCaseKey={camelCaseKey}
                  SetImageModalOpen={SetImageModalOpen}
                />
              </Modal.Body>
            </Modal>
          )}
        </div>
      );
    };

    const ImageCarousel = ({
      imageUrls,
      label,
      applicationDetails,
      setApplicationDetails,
      camelCaseKey,
      SetImageModalOpen,
    }) => {
      const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

      // Reset currentImageIndex when modal opens
      React.useEffect(() => {
        setCurrentImageIndex(0);
      }, []);

      const handleNext = () => {
        if (currentImageIndex < imageUrls.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        }
      };

      const handlePrev = () => {
        if (currentImageIndex > 0) {
          setCurrentImageIndex(currentImageIndex - 1);
        }
      };

      const isLastImage = currentImageIndex === imageUrls.length - 1;

      return (
        <>
          <img
            src={imageUrls[currentImageIndex]}
            alt={`${label} ${currentImageIndex + 1}`}
            style={{
              maxHeight: "80vh",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />

          <div className="d-flex justify-content-center mb-2">
            <Button
              className="me-2"
              variant="secondary-primary"
              disabled={currentImageIndex === 0}
              onClick={handlePrev}
            >
              <FaArrowAltCircleLeft size={30} />
            </Button>
            <Button
              variant="secondary-primary"
              disabled={currentImageIndex === imageUrls.length - 1}
              onClick={handleNext}
            >
              <FaArrowAltCircleRight size={30} />
            </Button>
          </div>
          {!applicationDetails[`${camelCaseKey}verified`] && isLastImage && (
            <Button
              className="mt-2"
              style={{ borderRadius: "10px" }}
              onClick={() => {
                const updatedDetails = {
                  ...applicationDetails,
                  [`${camelCaseKey}verified`]: true,
                };
                setApplicationDetails(updatedDetails);

                // Save verification status to sessionStorage for persistence
                const userId = sessionStorage.getItem("userId");
                if (userId) {
                  const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                  sessionStorage.setItem(sessionVerificationKey, "true");
                }

                // Clear verification errors
                setFieldErrors((prevErrors) => {
                  const currentErrors = prevErrors[camelCaseKey]?.errors || [];
                  const filteredErrors = currentErrors.filter(
                    (err) =>
                      err !== "This field is required." &&
                      !err.includes("verify") &&
                      !err.includes("Verify") &&
                      !err.includes("verification") &&
                      !err.includes("Please Verify The Images") &&
                      !err.includes(
                        "Please verify the uploaded document before proceeding."
                      ) &&
                      !err.includes(
                        "Please verify all uploaded documents before proceeding."
                      )
                  );
                  return {
                    ...prevErrors,
                    [camelCaseKey]: {
                      errors: filteredErrors,
                      touched: true,
                    },
                  };
                });

                SetImageModalOpen(false);
                toast.success("Document verified successfully");
              }}
            >
              Confirm Verification
            </Button>
          )}
          <Button
            className="mt-2"
            style={{ borderRadius: "10px" }}
            variant="secondary"
            onClick={() => SetImageModalOpen(false)}
          >
            Close
          </Button>
        </>
      );
    };

    const renderImageInput = (
      updateFieldValue,
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails
    ) => (
      <div className="imageDiv d-flex align-items-center gap-4  ">
        <div style={{ position: "relative", display: "inline-block" }}>
          <div className="d-flex flex-column  mt-5 mb-5">
            <button
              className="me-4"
              style={{
                borderRadius: "10px",
                height: "40px",
                padding: "5px 15px",
                fontSize: "12px",
                cursor: "pointer",
                margin: "15px 0",
                border: "none",
                backgroundColor: "#921d1e",
                // fieldErrors?.[camelCaseKey]?.touched &&
                // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                //   ? "#921d1e"
                //   : "#f0f0f0", // Error background color

                // border:
                //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                //     ? "1px solid red"
                //     : "1px solid #ccc", // Error border
                color: "#fff",
                // fieldErrors?.[camelCaseKey]?.touched &&
                // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                //   ? "#fff"
                //   : "#333", // Error background color
              }}
              onClick={() =>
                document.getElementById(`${camelCaseKey}_fileInput`).click()
              }
            >
              Upload File
            </button>

            <br />
            {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              fieldErrors?.[camelCaseKey]?.touched &&
              fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
            <br />
            {fieldValue && !applicationDetails[`${camelCaseKey}verified`] && (
              <span
                key={"Dgf"}
                className="errorPresent"
                style={style.errorSpan}
              >
                {"Please Verify The Image"}
                <br />
              </span>
            )}
          </div>
          <input
            type="file"
            accept="image/*"
            id={`${camelCaseKey}_fileInput`}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              width: "100%",
              height: "100%",
              cursor: "pointer",
            }}
            onChange={(e) => {
              handleUploadImageArray(e, camelCaseKey, updateFieldValue);

              setApplicationDetails({
                ...applicationDetails,
                [`${camelCaseKey}verified`]: true,
              });
              fieldErrors?.[camelCaseKey]?.touched &&
                checkErrorFn(input, camelCaseKey, e.target.value);
              e.target.value = null;
            }}
            onBlur={(e) => {
              checkErrorFn(input, camelCaseKey, fieldValue);
            }}
          />
        </div>

        {fieldValue && (
          <>
            <img
              src={fieldValue}
              style={{ marginLeft: "10px", width: "100px", cursor: "pointer" }}
              onClick={() => {
                setShowIframe(camelCaseKey);
              }}
            />
            {!applicationDetails[`${camelCaseKey}verified`] && (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  className="ms-2 verifybutton verifyBtn"
                  onClick={() => setShowIframe(camelCaseKey)}
                >
                  Verify
                </Button>
              </div>
            )}

            {applicationDetails[`${camelCaseKey}verified`] && (
              <div
                style={{ display: "flex", justifyContent: "flex-end" }}
                className={"fw-bold"}
              >
                <Badge bg="success">
                  <FaCheckCircle size={"18"} className="me-2" />
                  Verified
                </Badge>
              </div>
            )}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                className="ms-2"
                variant="outline"
                onClick={() => {
                  updateFieldValue(null);
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey + "verified"]: false,
                  });
                }}
                style={{ marginLeft: "auto" }}
              >
                <MdDeleteOutline size={"25"}></MdDeleteOutline>
              </Button>
            </div>
          </>
        )}

        {showIframe && (
          <Modal
            show={showIframe === camelCaseKey}
            onHide={() => setShowIframe(false)}
            size="lg"
            centered
            style={{ zIndex: 10000 }}
          >
            <Modal.Header
              style={{
                borderBottom: "1px solid #dee2e6",
                backgroundColor: "#f8f9fa",
                padding: "12px 20px",
              }}
            >
              <Modal.Title
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#212529",
                }}
              >
                <i
                  className="bi bi-image me-2"
                  style={{ color: "#0d6efd" }}
                ></i>
                Image Preview - {label || "Document"}
              </Modal.Title>
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={() => setShowIframe(false)}
              >
                <i className="bi bi-x-lg me-1"></i>
                Close
              </Button>
            </Modal.Header>
            <Modal.Body
              className="text-center"
              style={{
                padding: "20px",
                backgroundColor: "#f5f5f5",
              }}
            >
              <img
                src={fieldValue}
                style={{
                  maxHeight: "80vh",
                  maxWidth: "100%",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                }}
                alt="Document preview"
              />
              {!applicationDetails[camelCaseKey + "verified"] && (
                <Button
                  className="mt-2 mb-2"
                  variant="success"
                  onClick={() => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [`${camelCaseKey}verified`]: true,
                    });

                    // Clear verification errors
                    setFieldErrors((prevErrors) => {
                      const currentErrors =
                        prevErrors[camelCaseKey]?.errors || [];
                      const filteredErrors = currentErrors.filter(
                        (err) =>
                          !err.includes("verify") &&
                          !err.includes("Verify") &&
                          !err.includes("verification") &&
                          !err.includes("Please Verify The Image") &&
                          !err.includes(
                            "Please verify the uploaded document before proceeding."
                          ) &&
                          !err.includes(
                            "Please verify all uploaded documents before proceeding."
                          )
                      );
                      return {
                        ...prevErrors,
                        [camelCaseKey]: {
                          errors: filteredErrors,
                          touched: true,
                        },
                      };
                    });

                    toast.success("Document verified successfully");
                    setShowIframe(false);
                  }}
                >
                  Confirm Verification
                </Button>
              )}
              <Button
                className="mt-2 mb-2"
                variant="secondary"
                onClick={() => setShowIframe(false)}
              >
                Close
              </Button>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );

    const updateMarkValue = (value, tab) => {
      const updatedFields = dynamicFields.map((fs) => {
        if (fs.id === fieldSet.id) {
          // Convert to numbers, handling empty strings and null values
          let obtainedMarkValue = fs.fields[fieldIndex - 1]?.value;
          let obtainedMark =
            obtainedMarkValue === "" ||
            obtainedMarkValue === null ||
            obtainedMarkValue === undefined
              ? 0
              : Number(obtainedMarkValue) || 0;
          let totalMark =
            value === "" || value === null || value === undefined
              ? 0
              : Number(value) || 0;

          // Skip validation if either value is not a valid number or is 0
          if (isNaN(totalMark) || isNaN(obtainedMark) || totalMark === 0) {
            // Clear errors if values are empty or invalid
            if (totalMark === 0 || obtainedMark === 0) {
              const obtainedMarkField = fs.fields[fieldIndex - 1];
              const obtainedMarkKey =
                obtainedMarkField?.values?._id + "__" + fieldSet.id;

              // Clear errors from both fields
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: (prevState[camelCaseKey]?.errors || []).filter(
                    (err) =>
                      err !==
                      "Mark Obtained cannot be greater than Mark Out of."
                  ),
                  touched: prevState?.[camelCaseKey]?.touched || true,
                },
                ...(obtainedMarkKey
                  ? {
                      [obtainedMarkKey]: {
                        errors: (
                          prevState[obtainedMarkKey]?.errors || []
                        ).filter(
                          (err) =>
                            err !==
                            "Mark Obtained cannot be greater than Mark Out of."
                        ),
                        touched: prevState?.[obtainedMarkKey]?.touched || true,
                      },
                    }
                  : {}),
              }));
            }
            fs.fields[fieldIndex].value = value;
            fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
            return { ...fs };
          }

          // Get field keys for error handling
          const obtainedMarkField = fs.fields[fieldIndex - 1];
          const obtainedMarkKey =
            obtainedMarkField?.values?._id + "__" + fieldSet.id;
          const percentageField = fs.fields[fieldIndex + 1];
          const percentageKey =
            percentageField?.values?._id + "__" + fieldSet.id;

          // Validate: Mark Obtained should be <= Mark Out of
          let isMarkValid = obtainedMark <= totalMark;

          // Validate percentage: should be <= 100%
          let percentMark =
            totalMark === 0 ? 0 : (obtainedMark / totalMark) * 100;
          let isPercentageValid = percentMark >= 0 && percentMark <= 100;

          // Update errors for both fields - clear or set error based on validation
          const errorMessage =
            "Mark Obtained cannot be greater than Mark Out of.";

          setFieldErrors((prevState) => {
            const newState = { ...prevState };

            // Update Mark Out of field errors
            if (!isMarkValid) {
              newState[camelCaseKey] = {
                errors: [
                  ...new Set([
                    ...(prevState[camelCaseKey]?.errors || []).filter(
                      (err) => err !== errorMessage
                    ),
                    errorMessage,
                  ]),
                ],
                touched: prevState?.[camelCaseKey]?.touched || true,
              };
            } else {
              // Clear error if valid
              newState[camelCaseKey] = {
                errors: (prevState[camelCaseKey]?.errors || []).filter(
                  (err) => err !== errorMessage
                ),
                touched: prevState?.[camelCaseKey]?.touched || true,
              };
            }

            // Update Mark Obtained field errors
            if (obtainedMarkKey) {
              if (!isMarkValid) {
                newState[obtainedMarkKey] = {
                  errors: [
                    ...new Set([
                      ...(prevState[obtainedMarkKey]?.errors || []).filter(
                        (err) => err !== errorMessage
                      ),
                      errorMessage,
                    ]),
                  ],
                  touched: prevState?.[obtainedMarkKey]?.touched || true,
                };
              } else {
                // Clear error if valid
                newState[obtainedMarkKey] = {
                  errors: (prevState[obtainedMarkKey]?.errors || []).filter(
                    (err) => err !== errorMessage
                  ),
                  touched: prevState?.[obtainedMarkKey]?.touched || true,
                };
              }
            }

            return newState;
          });

          // Update percentage value and validate - ONLY if NOT Additional Qualification
          // For Additional Qualification, percentage should be manually entered
          if (fieldSet?.tab !== "additionalQualification") {
            if (!isPercentageValid) {
              // Set error for percentage field if it exceeds 100%
              if (percentageKey) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [percentageKey]: {
                    errors: [
                      ...new Set([
                        ...(prevState[percentageKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        "Percentage of Mark cannot be greater than 100%.",
                      ]),
                    ],
                    touched: prevState?.[percentageKey]?.touched || true,
                  },
                }));
              }
              percentMark = "Invalid";
            } else {
              // Clear percentage error if valid
              if (percentageKey) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [percentageKey]: {
                    errors: (prevState[percentageKey]?.errors || []).filter(
                      (err) =>
                        err !==
                        "Percentage of Mark cannot be greater than 100%."
                    ),
                    touched: prevState?.[percentageKey]?.touched || true,
                  },
                }));
              }
            }

            // Auto-calculate percentage only if NOT Additional Qualification
            if (fs.fields[fieldIndex + 1]) {
              fs.fields[fieldIndex + 1].value = isPercentageValid
                ? Number(percentMark).toFixed(2)
                : percentMark;
            }
          }

          fs.fields[fieldIndex].value = value;
          fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
          return { ...fs };
        }
        return fs;
      });
      setDynamicFields(updatedFields);
    };

    const updateMarkValue2 = (value, tab) => {
      const updatedFields = dynamicFields.map((fs) => {
        if (fs.id === fieldSet.id) {
          // Convert to numbers, handling empty strings and null values
          let obtainedMark =
            value === "" || value === null || value === undefined
              ? 0
              : Number(value) || 0;
          let totalMarkValue = fs.fields[fieldIndex + 1]?.value;
          let totalMark =
            totalMarkValue === "" ||
            totalMarkValue === null ||
            totalMarkValue === undefined
              ? 0
              : Number(totalMarkValue) || 0;

          // Skip validation if either value is not a valid number or is 0
          if (isNaN(totalMark) || isNaN(obtainedMark) || totalMark === 0) {
            // Clear errors if values are empty or invalid
            if (totalMark === 0 || obtainedMark === 0) {
              const totalMarkField = fs.fields[fieldIndex + 1];
              const totalMarkKey =
                totalMarkField?.values?._id + "__" + fieldSet.id;

              // Clear errors from both fields
              setFieldErrors((prevState) => ({
                ...prevState,
                [camelCaseKey]: {
                  errors: (prevState[camelCaseKey]?.errors || []).filter(
                    (err) =>
                      err !==
                      "Mark Obtained cannot be greater than Mark Out of."
                  ),
                  touched: prevState?.[camelCaseKey]?.touched || true,
                },
                ...(totalMarkKey
                  ? {
                      [totalMarkKey]: {
                        errors: (prevState[totalMarkKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Mark Obtained cannot be greater than Mark Out of."
                        ),
                        touched: prevState?.[totalMarkKey]?.touched || true,
                      },
                    }
                  : {}),
              }));
            }
            fs.fields[fieldIndex].value = value;
            fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
            return { ...fs };
          }

          // Get field keys for error handling
          const totalMarkField = fs.fields[fieldIndex + 1];
          const totalMarkKey = totalMarkField?.values?._id + "__" + fieldSet.id;
          const percentageField = fs.fields[fieldIndex + 2];
          const percentageKey =
            percentageField?.values?._id + "__" + fieldSet.id;

          // Validate: Mark Obtained should be <= Mark Out of
          let isMarkValid = obtainedMark <= totalMark;

          // Validate percentage: should be <= 100%
          let percentMark =
            totalMark === 0 ? 0 : (obtainedMark / totalMark) * 100;
          let isPercentageValid = percentMark >= 0 && percentMark <= 100;

          // Update errors for both fields - clear or set error based on validation
          const errorMessage =
            "Mark Obtained cannot be greater than Mark Out of.";

          setFieldErrors((prevState) => {
            const newState = { ...prevState };

            // Update Mark Obtained field errors
            if (!isMarkValid) {
              newState[camelCaseKey] = {
                errors: [
                  ...new Set([
                    ...(prevState[camelCaseKey]?.errors || []).filter(
                      (err) => err !== errorMessage
                    ),
                    errorMessage,
                  ]),
                ],
                touched: prevState?.[camelCaseKey]?.touched || true,
              };
            } else {
              // Clear error if valid
              newState[camelCaseKey] = {
                errors: (prevState[camelCaseKey]?.errors || []).filter(
                  (err) => err !== errorMessage
                ),
                touched: prevState?.[camelCaseKey]?.touched || true,
              };
            }

            // Update Mark Out of field errors
            if (totalMarkKey) {
              if (!isMarkValid) {
                newState[totalMarkKey] = {
                  errors: [
                    ...new Set([
                      ...(prevState[totalMarkKey]?.errors || []).filter(
                        (err) => err !== errorMessage
                      ),
                      errorMessage,
                    ]),
                  ],
                  touched: prevState?.[totalMarkKey]?.touched || true,
                };
              } else {
                // Clear error if valid
                newState[totalMarkKey] = {
                  errors: (prevState[totalMarkKey]?.errors || []).filter(
                    (err) => err !== errorMessage
                  ),
                  touched: prevState?.[totalMarkKey]?.touched || true,
                };
              }
            }

            return newState;
          });

          // Update percentage value and validate - ONLY if NOT Additional Qualification
          // For Additional Qualification, percentage should be manually entered
          if (fieldSet?.tab !== "additionalQualification") {
            if (!isPercentageValid) {
              // Set error for percentage field if it exceeds 100%
              if (percentageKey) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [percentageKey]: {
                    errors: [
                      ...new Set([
                        ...(prevState[percentageKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        "Percentage of Mark cannot be greater than 100%.",
                      ]),
                    ],
                    touched: prevState?.[percentageKey]?.touched || true,
                  },
                }));
              }
              percentMark = "Invalid";
            } else {
              // Clear percentage error if valid
              if (percentageKey) {
                setFieldErrors((prevState) => ({
                  ...prevState,
                  [percentageKey]: {
                    errors: (prevState[percentageKey]?.errors || []).filter(
                      (err) =>
                        err !==
                        "Percentage of Mark cannot be greater than 100%."
                    ),
                    touched: prevState?.[percentageKey]?.touched || true,
                  },
                }));
              }
            }

            // Auto-calculate percentage only if NOT Additional Qualification
            if (fs.fields[fieldIndex + 2]) {
              fs.fields[fieldIndex + 2].value = isPercentageValid
                ? Number(percentMark).toFixed(2)
                : percentMark;
            }
          }

          fs.fields[fieldIndex].value = value;
          fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
          return { ...fs };
        }
        return fs;
      });
      setDynamicFields(updatedFields);
    };

    const updateFieldValue = (value, tab) => {
      const updatedFields = dynamicFields.map((fs) => {
        if (fs.id === fieldSet.id) {
          const field = fs.fields[fieldIndex];
          const fieldType = field?.values?.inputFieldType;

          // For file upload fields (pdf/image), reset verification when value changes
          if (fieldType === "pdf" || fieldType === "image") {
            fs.fields[fieldIndex] = {
              ...field,
              value: value,
              verified: false, // Explicitly set verified to false for new uploads or when file is removed
              tab: tab || camelCase(fs?.tab),
            };
          } else {
            fs.fields[fieldIndex].value = value;
            fs.fields[fieldIndex].tab = tab || camelCase(fs?.tab);
          }
          return { ...fs };
        }
        return fs;
      });
      setDynamicFields(updatedFields);

      // Also clear verification from applicationDetails when file is uploaded or removed
      const fieldId = field?.values?._id;
      if (
        fieldId &&
        (field?.values?.inputFieldType === "pdf" ||
          field?.values?.inputFieldType === "image")
      ) {
        const camelCaseKeyForAppDetails = fieldId + fieldSet.id;
        setApplicationDetails((prev) => {
          const updated = { ...prev };
          // Clear verification status
          delete updated[`${camelCaseKeyForAppDetails}verified`];
          if (fieldId) {
            delete updated[`${fieldId}verified`];
          }
          return updated;
        });

        // Also clear verification from sessionStorage for this specific field
        const userId = sessionStorage.getItem("userId");
        if (userId) {
          const sessionKey = `verification_${userId}_${camelCaseKeyForAppDetails}`;
          sessionStorage.removeItem(sessionKey);
        }
      }
    };
    const renderInput = (
      type,
      field,
      fieldIndex,
      fieldProps,
      item = null,
      idx = null
    ) => {
      const commonProps = {
        className: "form-check-input",
        style: { border: "1px solid brown", borderRadius: "10px" },
        ...fieldProps,
      };

      const camelCaseKey = field?.values?._id + "__" + fieldSet.id;
      if (type === "checkbox" || type === "radio") {
        return (
          <div className="form-check" key={`${item.label}.${idx}`}>
            <input {...commonProps} type={type} value={item.value} />
            <label
              className="form-check-label"
              htmlFor={commonProps.id}
              style={style.label}
            >
              {item.label}
            </label>
          </div>
        );
      }

      // console.log("er3", { field });
      // console.log(label, "label");
      switch (label) {
        case "Mark Out of":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  updateFieldValue(e.target.value);
                  updateMarkValue(e.target.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
        case "Mark Obtained":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  updateFieldValue(e.target.value);
                  updateMarkValue2(e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
        case "Percentage of Marks/CGPA/Grade":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  // Allow manual input for Additional Qualification
                  // For other sections, this will be handled by auto-calculation
                  updateFieldValue(e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;

        case "Total Experience":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                // onChange={(e) => updateFieldValue(e.target.value)}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
        case "Start Date of Service":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  //  updateFieldValue(e.target.value)
                  updateExpValue(e.target.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );

        case "End date of Service":
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  updateFieldValue(e.target.value);
                  updateExpValue2(e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );

        default:
          return (
            <>
              <input
                className="form-control"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={type === "string" ? "text" : type}
                // {...fieldProps}
                value={field?.value}
                onChange={(e) => {
                  updateFieldValue(e.target.value);
                  checkErrorFn(field, camelCaseKey, e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(field, camelCaseKey, field?.value);
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
      }
    };

    const renderSelectOptionsForDesirableQualification = () => {
      // Get already selected values
      const selectedValues =
        field?.values?.inputFieldTags?.map((tag) => tag.label) || [];

      return applicationDetails?.vacancyId?.department?.desirableQualification
        ?.filter((option) => !selectedValues.includes(option.qualification)) // Exclude already selected
        ?.map((option, idx) => (
          <option
            key={`${option.qualification}.${idx}`}
            value={option.qualification}
          >
            {option.qualification}
          </option>
        ));
    };

    const renderField = (field, fieldIndex) => {
      switch (field?.values?.inputFieldType) {
        case "checkbox":
          return field?.values?.inputFieldTags.map((item, idx) =>
            renderInput(
              "checkbox",
              {
                checked: checkedValues.includes(item.value),
                onChange: (e) => handleCheckboxChange(e, item),
                id: `flexCheckboxDefault1.${idx}`,
              },
              item,
              idx
            )
          );
        case "pdf":
          return renderPdfInput(
            updateFieldValue,
            field?.value,
            camelCaseKey,
            label,
            field,
            applicationDetails,
            setApplicationDetails,
            field,
            fieldSet,
            fieldIndex
          );
        case "multiplePdf":
          return renderPdfInputMultiple(
            updateFieldValue,
            field?.value,
            camelCaseKey,
            label,
            field,
            applicationDetails,
            setApplicationDetails
          );
        case "image":
          return renderImageInput(
            updateFieldValue,
            field?.value,
            camelCaseKey,
            label,
            field,
            applicationDetails,
            setApplicationDetails
          );
        case "multipleImage":
          return renderImageInputMultiple(
            updateFieldValue,
            field?.value,
            camelCaseKey,
            label,
            field,
            applicationDetails,
            setApplicationDetails
          );
        case "radio":
          return field?.values?.inputFieldTags.map((item, idx) =>
            renderInput(
              "radio",
              {
                checked: field.value === item.value,
                name: field.values.inputFieldName,
                onChange: (e) =>
                  updateFieldValue(e.target.value, item?.formTab),
                id: `flexRadioDefault1.${idx}`,
              },
              item,
              idx
            )
          );

        case "select":
          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                value={field.value}
                onChange={(e) => {
                  updateFieldValue(e.target.value);
                  checkErrorFn(field, camelCaseKey, e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(field, camelCaseKey, field?.value);
                }}
              >
                <option value="">Select</option>
                {label == "Course Name" &&
                  renderSelectOptionsForDesirableQualification()}
                {label !== "Course Name" &&
                  field?.values?.inputFieldTags?.map((option, idx) => (
                    <option key={`${option.id}`} value={option.label}>
                      {option.label}
                    </option>
                  ))}
              </select>
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );

        default:
          return renderInput(field?.values?.inputFieldType, field, fieldIndex, {
            value: field.value,
            onChange: (e) => updateFieldValue(e.target.value),
          });
      }
    };

    // Conditional logic for "Name of the Organization" field in array fields
    // Only show when "Sponsored By Organization" is selected in "Professional course" dropdown
    const professionalCourseFieldId = "68e88d008f50ed28ac76ba47";
    const organizationNameFieldId = "68e88d008f50ed28ac76ba49";

    if (field?.values?._id === organizationNameFieldId) {
      // Find the professional course field value in the same fieldSet
      const professionalCourseField = fieldSet?.fields?.find(
        (f) => f?.values?._id === professionalCourseFieldId
      );
      const professionalCourseValue = professionalCourseField?.value;

      console.log("=== DEBUGGING ARRAY FIELD CONDITIONAL ===");
      console.log("Current field ID:", field?.values?._id);
      console.log("Field name:", field?.values?.inputFieldName);
      console.log("Professional course field:", professionalCourseField);
      console.log("Professional course value:", professionalCourseValue);

      if (professionalCourseValue !== "Sponsored By Organization") {
        console.log(
          "HIDING array field - value is not 'Sponsored By Organization'"
        );
        return null; // Skip rendering this field
      } else {
        console.log(
          "SHOWING array field - value is 'Sponsored By Organization'"
        );
      }
    }

    return (
      <Col
        key={fieldIndex}
        xs={window.innerWidth >= 793 ? field?.values?.columnLength : 12}
        md={field?.values?.columnLength}
      >
        {field?.values?.inputFieldType === "SubHeading" ? (
          <>
            <label className="ps-0 ms-0 form-label form-heading-main">
              {label}
            </label>
          </>
        ) : (
          <>
            <label
              className="inputBoxHeadForm upload-head-gap"
              style={style.label}
            >
              {label}
              {field?.values?.isRequired && label && (
                <span className="mx-1 text-danger star">*</span>
              )}
            </label>
            {renderField(field, fieldIndex)}
          </>
        )}
      </Col>
    );
  };

  const checkErrorFn = async (input, camelCaseKey, fieldValue) => {
    // console.log("check this ", { input }, { camelCaseKey }, { fieldValue });

    // Get the actual current value from applicationDetails or dynamicFields
    // This ensures we validate against the latest state, not a stale value
    let actualValue = fieldValue;

    // Get field label to check if it's Country, State, or District field
    const fieldLabel = input?.values?.inputFieldName;
    const isCountryField = fieldLabel === "Country";
    const isStateField = fieldLabel === "State";
    const isDistrictField = fieldLabel === "District";

    // Special handling for Course Type fields - always use passed fieldValue to avoid stale state
    const courseTypeFieldIdCheck = "6933c2114c6c63e650c80f76"; // AGM Sales Marketing Graduation
    const courseTypePostGradFieldIdCheck = "6933c07e4c6c63e650c809a0"; // Geology Post Graduation
    const courseTypeBEJobFieldIdCheck = "6932c7eb4c6c63e650c7aaeb"; // BE Job
    const courseTypeLegalGradFieldIdCheck = "6932c5664c6c63e650c7a4b4"; // Legal Job Graduation
    const courseTypeLegalLLBFieldIdCheck = "6932c5664c6c63e650c7a4cc"; // Legal Job LLB Degree
    const isCourseTypeField =
      input?.values?._id === courseTypeFieldIdCheck ||
      input?.values?._id === courseTypePostGradFieldIdCheck ||
      input?.values?._id === courseTypeBEJobFieldIdCheck ||
      input?.values?._id === courseTypeLegalGradFieldIdCheck ||
      input?.values?._id === courseTypeLegalLLBFieldIdCheck;

    // Try to get value from applicationDetails first (unless it's Course Type field)
    if (!isCourseTypeField && applicationDetails && camelCaseKey) {
      const fieldId = input?.values?._id;
      // Check applicationDetails with field ID
      if (fieldId && applicationDetails[fieldId] !== undefined) {
        actualValue = applicationDetails[fieldId];
      }
      // Check applicationDetails with camelCaseKey
      else if (applicationDetails[camelCaseKey] !== undefined) {
        actualValue = applicationDetails[camelCaseKey];
      }
    }
    // For Course Type field, always use the passed fieldValue to ensure we have the latest value
    else if (isCourseTypeField) {
      actualValue = fieldValue;
    }

    // If not found in applicationDetails, try dynamicFields
    if (
      (actualValue === fieldValue ||
        actualValue === undefined ||
        actualValue === null) &&
      dynamicFields
    ) {
      try {
        // Find the field in dynamicFields
        for (const fieldSet of dynamicFields) {
          const foundField = fieldSet.fields?.find((f) => {
            const fieldKey = f?.values?._id + fieldSet.id;
            return (
              fieldKey === camelCaseKey || f?.values?._id === input?.values?._id
            );
          });
          if (foundField && foundField.value !== undefined) {
            actualValue = foundField.value;
            break;
          }
        }
      } catch (error) {
        // If error accessing dynamicFields, use the passed fieldValue
        console.error("Error accessing dynamicFields:", error);
      }
    }

    // Normalize "Select Country", "Select State", and "Select District" to empty string for validation
    // This should be done after getting the actual value from all sources
    if (
      isCountryField &&
      (actualValue === "Select Country" || actualValue === "")
    ) {
      actualValue = "";
    } else if (
      isStateField &&
      (actualValue === "Select State" || actualValue === "")
    ) {
      actualValue = "";
    } else if (
      isDistrictField &&
      (actualValue === "Select District" || actualValue === "" || !actualValue)
    ) {
      actualValue = "";
    }

    // Helper function to check if field value is empty
    const isEmptyValue = (value) => {
      if (value === null || value === undefined) return true;
      if (Array.isArray(value)) {
        // For arrays, check if there are any valid files
        if (value.length === 0) return true;
        // Check if array has at least one valid file (with file URL)
        return !value.some((item) => {
          if (typeof item === "string") return item && item.trim() !== "";
          if (typeof item === "object" && item !== null) {
            return (
              item?.file &&
              typeof item.file === "string" &&
              item.file.trim() !== ""
            );
          }
          return false;
        });
      }
      // For strings, check if empty after trim
      const stringValue = value?.toString()?.trim();
      // Also check for "Select State" and "Select District" placeholder values
      if (
        stringValue === "Select Country" ||
        stringValue === "Select State" ||
        stringValue === "Select District"
      ) {
        return true;
      }
      return !stringValue || stringValue === "";
    };

    // Convert to string for regex validation (but keep original for empty check)
    const originalValue = actualValue;
    const stringValue = Array.isArray(actualValue)
      ? actualValue
          .map((item) => (typeof item === "string" ? item : item?.file || ""))
          .filter(Boolean)
          .join(",")
      : actualValue?.toString()?.trim() || "";

    fieldValue = stringValue;

    const validationRules = input?.values?.validationReg || [];
    const regexMessages = validationRules
      .map((reg) => reg?.error_message)
      .filter(Boolean);

    const removeKnownValidationErrors = (errors = []) =>
      errors.filter(
        (error) =>
          error !== "This field is required." && !regexMessages.includes(error)
      );

    // Business Excellence conditional validation
    // Field IDs: Business Excellence Certification: 693682fe4c6c63e650c921b8, Upload Certificate: 693682fe4c6c63e650c921fb
    const BUSINESS_EXCELLENCE_CERTIFICATION_ID = "693682fe4c6c63e650c921b8";
    const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
    const fieldId = input?.values?._id;
    const isUploadCertificateField =
      fieldId === UPLOAD_CERTIFICATE_ID ||
      camelCaseKey === camelCase(UPLOAD_CERTIFICATE_ID);

    // Determine if Upload Certificate should be required based on Business Excellence Certification value
    let shouldBeRequired = input.values.isRequired;
    if (isUploadCertificateField) {
      // Get Business Excellence Certification value (check both field ID and camelCase key)
      const businessExcellenceValue =
        applicationDetails?.[BUSINESS_EXCELLENCE_CERTIFICATION_ID] ||
        applicationDetails?.[camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID)];

      // Check if Business Excellence Certification has any value (array or string)
      // Also check for "Select" or empty string
      const hasBusinessExcellenceValue =
        businessExcellenceValue &&
        businessExcellenceValue !== "Select" &&
        businessExcellenceValue !== "" &&
        ((Array.isArray(businessExcellenceValue) &&
          businessExcellenceValue.length > 0 &&
          businessExcellenceValue.some((item) => {
            if (typeof item === "string")
              return item.trim() !== "" && item.trim() !== "Select";
            if (typeof item === "object" && item !== null)
              return (
                item.value &&
                item.value.trim() !== "" &&
                item.value.trim() !== "Select"
              );
            return false;
          })) ||
          (typeof businessExcellenceValue === "string" &&
            businessExcellenceValue.trim() !== "" &&
            businessExcellenceValue.trim() !== "Select"));

      // Make Upload Certificate required if Business Excellence Certification has a value
      shouldBeRequired = hasBusinessExcellenceValue;
    }

    if (!shouldBeRequired && isEmptyValue(originalValue)) {
      // Optional field left blank: clear ALL errors including "This field is required."
      setFieldErrors((prevState) => {
        const currentErrors = prevState?.[camelCaseKey]?.errors || [];
        // Remove "This field is required." error explicitly
        const filteredErrors = currentErrors.filter(
          (err) => err !== "This field is required."
        );
        // Also remove known validation errors
        const finalErrors = removeKnownValidationErrors(filteredErrors);

        return {
          ...prevState,
          [camelCaseKey]: {
            errors: finalErrors,
            touched: true,
          },
        };
      });
      return;
    }

    if (shouldBeRequired && isEmptyValue(originalValue)) {
      // Required field missing: add required message but keep any cross-field errors.
      setFieldErrors((prevState) => ({
        ...prevState,
        [camelCaseKey]: {
          errors: [
            ...new Set([
              ...removeKnownValidationErrors(prevState?.[camelCaseKey]?.errors),
              "This field is required.",
            ]),
          ],
          touched: true,
        },
      }));
      return;
    }

    // Check file verification for file upload fields
    // This applies to multiplePdf and other file upload types
    const isFileUploadField =
      input?.values?.inputFieldType === "multiplePdf" ||
      input?.values?.inputFieldType === "multipleImage" ||
      input?.values?.inputFieldType === "image" ||
      input?.values?.inputFieldType === "pdf";

    let hasVerificationError = false;

    if (isFileUploadField && !isEmptyValue(originalValue)) {
      // Check if files are uploaded but not verified
      if (Array.isArray(originalValue)) {
        // For array of file objects, check each file
        // Only check files that actually have a file URL (not empty placeholders)
        const filesWithUrl = originalValue.filter((item) => {
          if (typeof item === "object" && item !== null) {
            return (
              item?.file &&
              typeof item.file === "string" &&
              item.file.trim() !== ""
            );
          }
          return false;
        });

        // Check if any file with URL is not verified
        const unverifiedFiles = filesWithUrl.filter((item) => !item.verified);

        if (unverifiedFiles.length > 0 && filesWithUrl.length > 0) {
          hasVerificationError = true;
          // Add verification error but don't return - continue with other validations
          setFieldErrors((prevState) => ({
            ...prevState,
            [camelCaseKey]: {
              errors: [
                ...new Set([
                  ...(prevState[camelCaseKey]?.errors || []),
                  "Please verify all uploaded documents before proceeding.",
                ]),
              ],
              touched: true,
            },
          }));
        } else if (filesWithUrl.length > 0) {
          // All files are verified, remove verification error if it exists
          setFieldErrors((prevState) => {
            const currentErrors = prevState?.[camelCaseKey]?.errors || [];
            const filteredErrors = currentErrors.filter(
              (error) =>
                !error.includes("verify") &&
                !error.includes("Verify") &&
                !error.includes("verification")
            );
            return {
              ...prevState,
              [camelCaseKey]: {
                errors: filteredErrors,
                touched: true,
              },
            };
          });
        }
      } else if (
        typeof originalValue === "string" &&
        originalValue.trim() !== ""
      ) {
        // For legacy string format, check the verified flag in applicationDetails
        // Also check field.verified for array fields (Training Details)
        const fieldId = input?.values?._id;
        // Check both field ID format and camelCase format for verified key
        const verifiedKeyById = fieldId ? `${fieldId}verified` : null;
        const verifiedKeyByCamelCase = `${camelCaseKey}verified`;

        // Check verification status using both possible keys in applicationDetails
        let isVerified = false;
        if (verifiedKeyById && applicationDetails?.[verifiedKeyById] === true) {
          isVerified = true;
        } else if (applicationDetails?.[verifiedKeyByCamelCase] === true) {
          isVerified = true;
        } else if (
          verifiedKeyById &&
          applicationDetails?.[verifiedKeyById] === false
        ) {
          isVerified = false;
        } else if (applicationDetails?.[verifiedKeyByCamelCase] === false) {
          isVerified = false;
        } else {
          // Also check field.verified for array fields (Training Details)
          // Try to find the field in dynamicFields
          if (dynamicFields && dynamicFields.length > 0) {
            for (const fieldSet of dynamicFields) {
              const foundField = fieldSet.fields?.find((f) => {
                const fieldKey = f?.values?._id + fieldSet.id;
                return fieldKey === camelCaseKey || f?.values?._id === fieldId;
              });
              if (foundField && foundField.verified === true) {
                isVerified = true;
                // Also update applicationDetails to keep them in sync
                if (verifiedKeyById) {
                  setApplicationDetails((prev) => ({
                    ...prev,
                    [verifiedKeyById]: true,
                    [verifiedKeyByCamelCase]: true,
                  }));
                }
                break;
              }
            }
          }

          // If still not verified and not explicitly set, default to false
          if (!isVerified) {
            isVerified = false;
          }
        }

        if (!isVerified && applicationDetails) {
          hasVerificationError = true;
          // File exists but not verified
          // setFieldErrors((prevState) => ({
          //   ...prevState,
          //   [camelCaseKey]: {
          //     errors: [
          //       ...new Set([
          //         ...(prevState[camelCaseKey]?.errors || []),
          //         "Please verify the uploaded document before proceeding.",
          //       ]),
          //     ],
          //     touched: true,
          //   },
          // }));
        } else if (isVerified && applicationDetails) {
          // File is verified, remove verification error if it exists
          setFieldErrors((prevState) => {
            const currentErrors = prevState?.[camelCaseKey]?.errors || [];
            const filteredErrors = currentErrors.filter(
              (error) =>
                !error.includes("verify") &&
                !error.includes("Verify") &&
                !error.includes("verification") &&
                !error.includes("Please Verify The File") &&
                !error.includes(
                  "Please verify the uploaded document before proceeding."
                ) &&
                !error.includes(
                  "Please verify all uploaded documents before proceeding."
                )
            );
            return {
              ...prevState,
              [camelCaseKey]: {
                errors: filteredErrors,
                touched: true,
              },
            };
          });
        }
      }
    }

    // Special validation for Course Type fields:
    // - ID: 6933c2114c6c63e650c80f76 (AGM Sales Marketing Graduation)
    // - ID: 6933c07e4c6c63e650c809a0 (Geology Post Graduation)
    // - ID: 6932c7eb4c6c63e650c7aaeb (BE Job)
    // - ID: 6932c5664c6c63e650c7a4b4 (Legal Job Graduation)
    // - ID: 6932c5664c6c63e650c7a4cc (Legal Job LLB Degree)
    // If value is "Correspondence", show error and modal
    const courseTypeFieldIdValidation = "6933c2114c6c63e650c80f76"; // AGM Sales Marketing Graduation
    const courseTypePostGradFieldIdValidation = "6933c07e4c6c63e650c809a0"; // Geology Post Graduation
    const courseTypeBEJobFieldIdValidation = "6932c7eb4c6c63e650c7aaeb"; // BE Job
    const courseTypeLegalGradFieldIdValidation = "6932c5664c6c63e650c7a4b4"; // Legal Job Graduation
    const courseTypeLegalLLBFieldIdValidation = "6932c5664c6c63e650c7a4cc"; // Legal Job LLB Degree
    const graduationCourseNameFieldId = "66a687874db5f02d6861ed09"; // Course Name (Graduation)

    // Check if this is a legal job course type field
    const isLegalGradCourseType =
      input?.values?._id === courseTypeLegalGradFieldIdValidation;
    const isLegalLLBCourseType =
      input?.values?._id === courseTypeLegalLLBFieldIdValidation;

    // For legal jobs, check if "Course Name (Graduation)" is "integrated llb"
    let shouldApplyCondition = true;

    if (isLegalGradCourseType || isLegalLLBCourseType) {
      // Get the graduation course name value
      const graduationCourseName =
        applicationDetails?.[graduationCourseNameFieldId] ||
        applicationDetails?.[camelCase(graduationCourseNameFieldId)];
      const normalizedCourseName = String(graduationCourseName || "")
        .trim()
        .toLowerCase();
      const isIntegratedLLB = normalizedCourseName === "integrated llb";

      if (isIntegratedLLB) {
        // If "integrated llb" is selected, apply condition only to graduation course type
        shouldApplyCondition = isLegalGradCourseType;
      } else {
        // If NOT "integrated llb", apply condition only to LLB course type
        shouldApplyCondition = isLegalLLBCourseType;
      }

      // If this field shouldn't have the condition applied, clear any existing correspondence errors
      if (!shouldApplyCondition) {
        setFieldErrors((prevState) => {
          const currentErrors = prevState?.[camelCaseKey]?.errors || [];
          const filteredErrors = currentErrors.filter(
            (error) =>
              !error.includes("Correspondence course type is not eligible")
          );
          if (filteredErrors.length !== currentErrors.length) {
            return {
              ...prevState,
              [camelCaseKey]: {
                errors: filteredErrors,
                touched: prevState?.[camelCaseKey]?.touched || true,
              },
            };
          }
          return prevState;
        });
        // Skip the correspondence validation for this field
        // Continue with other validations below
      }
    }

    if (
      input?.values?._id === courseTypeFieldIdValidation ||
      input?.values?._id === courseTypePostGradFieldIdValidation ||
      input?.values?._id === courseTypeBEJobFieldIdValidation ||
      (isLegalGradCourseType && shouldApplyCondition) ||
      (isLegalLLBCourseType && shouldApplyCondition)
    ) {
      // Normalize the value for comparison (trim whitespace)
      const normalizedValue = stringValue?.trim();

      // Only show error if value is exactly "Correspondence" (case-sensitive exact match)
      if (normalizedValue === "Correspondence") {
        // Only show error and modal if value is exactly "Correspondence"
        setFieldErrors((prevState) => {
          const currentErrors = prevState?.[camelCaseKey]?.errors || [];
          // Remove any existing Correspondence errors first, then add the new one
          const filteredErrors = currentErrors.filter(
            (error) =>
              !error.includes("Correspondence course type is not eligible")
          );
          return {
            ...prevState,
            [camelCaseKey]: {
              errors: [
                ...new Set([
                  ...filteredErrors,
                  "Correspondence course type is not eligible for this position.",
                ]),
              ],
              touched: true,
            },
          };
        });
        // Show the "not eligible" modal
        setShowNotEligibleModal(true);
        return; // Return early to prevent further validation
      } else {
        // Clear the Correspondence error if value is NOT "Correspondence"
        // This ensures error is removed when "Regular" or any other value is selected
        // IMPORTANT: Clear error immediately and close modal before continuing validation
        setFieldErrors((prevState) => {
          const currentErrors = prevState?.[camelCaseKey]?.errors || [];
          const filteredErrors = currentErrors.filter(
            (error) =>
              !error.includes("Correspondence course type is not eligible")
          );
          return {
            ...prevState,
            [camelCaseKey]: {
              errors: filteredErrors,
              touched: prevState?.[camelCaseKey]?.touched || true,
            },
          };
        });
        // Close modal if it's open (in case user changed from Correspondence to something else)
        setShowNotEligibleModal(false);
        // Continue with normal validation - don't return early
      }
    }

    let errCount = 0;

    for (let index = 0; index < validationRules.length; index++) {
      const reg = validationRules[index];
      if (!reg?.applicable_regex) continue;

      const regex = new RegExp(reg.applicable_regex);

      if (!regex.test(fieldValue)) {
        errCount++;
        // If the regex does not match the field value, append the specific error but keep other errors.
        setFieldErrors((prevState) => ({
          ...prevState,
          [camelCaseKey]: {
            errors: [
              ...new Set([
                ...(prevState[camelCaseKey]?.errors || []),
                reg.error_message,
              ]),
            ],
            touched: true,
          },
        }));
      }
    }

    if (errCount < 1) {
      // All regex validations passed: remove only the errors originating from those regexes.
      // But keep verification errors if files are not verified
      setFieldErrors((prevState) => {
        const currentErrors = prevState?.[camelCaseKey]?.errors || [];
        const verificationErrors = currentErrors.filter(
          (error) =>
            error.includes("verify") ||
            error.includes("Verify") ||
            error.includes("verification")
        );

        // If there are verification errors, keep them along with regex-cleared errors
        // Also clear Correspondence error if value is not "Correspondence"
        const courseTypeFieldId = "6933c2114c6c63e650c80f76";
        const filteredErrors = removeKnownValidationErrors(currentErrors);
        // If this is the Course Type field and value is not "Correspondence", also remove Correspondence error
        const finalFilteredErrors =
          input?.values?._id === courseTypeFieldId &&
          stringValue !== "Correspondence"
            ? filteredErrors.filter(
                (error) =>
                  !error.includes("Correspondence course type is not eligible")
              )
            : filteredErrors;

        const finalErrors =
          verificationErrors.length > 0
            ? [...new Set([...finalFilteredErrors, ...verificationErrors])]
            : finalFilteredErrors;

        return {
          ...prevState,
          [camelCaseKey]: {
            errors: finalErrors,
            touched: true,
          },
        };
      });
    }
  };

  const getStatesByCountry = (countryName) => {
    const foundCountry = countriesData.find(
      (country) => country.name === countryName
    );
    return foundCountry ? foundCountry.states.map((state) => state.state) : [];
  };

  const getDistrictsByState = (countryName, stateName) => {
    const foundCountry = countriesData.find(
      (country) => country.name === countryName
    );
    const foundState = foundCountry?.states.find(
      (state) => state.state === stateName
    );
    return foundState ? foundState.districts : [];
  };

  const [isSameAsCorrespondence, setIsSameAsCorrespondence] = useState(false);

  // Handle checkbox change
  const handleCheckboxChange_ = (e) => {
    setIsSameAsCorrespondence(e.target.checked);
  };
  useEffect(() => {
    if (
      applicationDetails?.["66a37bab1b102d1ba93eee2f"] &&
      applicationDetails?.advertisement?.advertisementClosingDate
    ) {
      const rawBirth = applicationDetails["66a37bab1b102d1ba93eee2f"];
      const rawClosing =
        applicationDetails?.advertisement?.advertisementClosingDate;

      // Debug: show the raw strings you'll be parsing
      console.log("rawBirth:", rawBirth);
      console.log("rawClosing:", rawClosing);

      // Explicit parser: treat "DD/MM/YYYY" when string contains "/"
      const parseForceDDMMYYYY = (s) => {
        if (!s) return null;
        if (s instanceof Date && !isNaN(s))
          return new Date(s.getFullYear(), s.getMonth(), s.getDate());
        if (typeof s !== "string") {
          // try numeric / timestamp fallback
          const d = new Date(s);
          return isNaN(d)
            ? null
            : new Date(d.getFullYear(), d.getMonth(), d.getDate());
        }

        const str = s.trim();
        // If format contains '/', assume DD/MM/YYYY (explicit)
        if (str.includes("/")) {
          const parts = str.split("/").map((p) => p.trim());
          if (parts.length === 3) {
            const dd = parseInt(parts[0], 10);
            const mm = parseInt(parts[1], 10);
            const yyyy = parseInt(parts[2], 10);
            if (![dd, mm, yyyy].some(Number.isNaN))
              return new Date(yyyy, mm - 1, dd);
          }
        }

        // If contains '-', try ISO YYYY-MM-DD first, then DD-MM-YYYY
        if (str.includes("-")) {
          const parts = str.split("-").map((p) => p.trim());
          if (parts.length === 3) {
            if (parts[0].length === 4) {
              // YYYY-MM-DD
              const yyyy = parseInt(parts[0], 10);
              const mm = parseInt(parts[1], 10);
              const dd = parseInt(parts[2], 10);
              if (![yyyy, mm, dd].some(Number.isNaN))
                return new Date(yyyy, mm - 1, dd);
            } else {
              // assume DD-MM-YYYY
              const dd = parseInt(parts[0], 10);
              const mm = parseInt(parts[1], 10);
              const yyyy = parseInt(parts[2], 10);
              if (![dd, mm, yyyy].some(Number.isNaN))
                return new Date(yyyy, mm - 1, dd);
            }
          }
        }

        // Fallback: let Date try, then normalize
        const fallback = new Date(str);
        if (!isNaN(fallback))
          return new Date(
            fallback.getFullYear(),
            fallback.getMonth(),
            fallback.getDate()
          );
        return null;
      };

      const birth = parseForceDDMMYYYY(rawBirth);
      const closing = parseForceDDMMYYYY(rawClosing);

      // Extra debug: show parsed date objects and components
      console.log(
        "parsedBirth:",
        birth,
        birth &&
          `${birth.getFullYear()}-${birth.getMonth() + 1}-${birth.getDate()}`
      );
      console.log(
        "parsedClosing:",
        closing,
        closing &&
          `${closing.getFullYear()}-${
            closing.getMonth() + 1
          }-${closing.getDate()}`
      );

      if (!birth || !closing) {
        console.warn(
          "Parsing failed for birth or closing date. See logs above."
        );
        return;
      }

      // Compute age correctly: calculate from birth date to closing date
      // Start with the birth date and add years, months, days until we reach closing date
      let years = closing.getFullYear() - birth.getFullYear();
      let months = closing.getMonth() - birth.getMonth();
      let days = closing.getDate() - birth.getDate();

      // If the birthday hasn't occurred yet in the closing year, subtract one year
      // Check if closing month/day is before birth month/day
      if (months < 0 || (months === 0 && days < 0)) {
        years -= 1;
        months += 12;
        // Recalculate days after adjusting months
        if (days < 0) {
          const daysInPrevMonth = new Date(
            closing.getFullYear(),
            closing.getMonth(),
            0
          ).getDate();
          days = closing.getDate() + (daysInPrevMonth - birth.getDate());
        }
      } else {
        // Birthday has occurred, but we may still need to adjust days
        if (days < 0) {
          // Get the number of days in the month before the closing date
          const daysInPrevMonth = new Date(
            closing.getFullYear(),
            closing.getMonth(),
            0
          ).getDate();
          days += daysInPrevMonth;
          months -= 1;
        }
      }

      // Final check: if months are still negative after adjustments
      if (months < 0) {
        months += 12;
        years -= 1;
      }

      // Final validation: ensure we don't have negative values
      if (years < 0) {
        years = 0;
        months = 0;
        days = 0;
      }

      const formattedAge = `${years} years, ${months} months, ${days} days`;
      console.log("formattedAge", formattedAge);

      setApplicationDetails((prev) => ({ ...prev, ageDetail: formattedAge }));
    }
  }, [
    applicationDetails?.["66a37bab1b102d1ba93eee2f"],
    applicationDetails?.advertisement?.advertisementClosingDate,
  ]);

  //useEffects For Validations
  useEffect(() => {
    if (isSameAsCorrespondence) {
      setApplicationDetails((prev) => ({
        ...prev,
        // Add the properties from correspondence details you want to copy here
        ["66a672c14db5f02d6861e92f"]: prev?.["66a66fd74db5f02d6861e871"], // Example
        ["66a672c14db5f02d6861e930"]: prev?.["66a66fd74db5f02d6861e872"], // Example
        ["66a672c14db5f02d6861e931"]: prev?.["66a66fd74db5f02d6861e873"], // Example
        ["66a672c14db5f02d6861e932"]: prev?.["66a6705e4db5f02d6861e894"], // Example
        ["66a672c14db5f02d6861e933"]: prev?.["66a6705e4db5f02d6861e895"], // Example
        ["66a672c14db5f02d6861e934"]: prev?.["66a6705e4db5f02d6861e896"], // Example
        ["67456a28ba7bd153d04f3f61"]: prev?.["6745678fba7bd153d04f3e61"],
      }));
    }
  }, [isSameAsCorrespondence]);

  useEffect(() => {
    // Assuming formData contains the data when the component loads
    if (
      applicationDetails?.["66a672c14db5f02d6861e92f"] ===
        applicationDetails?.["66a66fd74db5f02d6861e871"] &&
      applicationDetails?.["66a672c14db5f02d6861e930"] ===
        applicationDetails?.["66a66fd74db5f02d6861e872"] &&
      applicationDetails?.["66a672c14db5f02d6861e931"] ===
        applicationDetails?.["66a66fd74db5f02d6861e873"] &&
      applicationDetails?.["66a672c14db5f02d6861e932"] ===
        applicationDetails?.["66a6705e4db5f02d6861e894"] &&
      applicationDetails?.["66a672c14db5f02d6861e933"] ===
        applicationDetails?.["66a6705e4db5f02d6861e895"] &&
      applicationDetails?.["66a672c14db5f02d6861e934"] ===
        applicationDetails?.["66a6705e4db5f02d6861e896"] &&
      applicationDetails?.["67456a28ba7bd153d04f3f61"] ===
        applicationDetails?.["6745678fba7bd153d04f3e61"]
    ) {
      // If correspondence and permanent addresses are the same, set the checkbox to true
      setIsSameAsCorrespondence(true);
    } else {
      // Otherwise, set the checkbox to false
      setIsSameAsCorrespondence(false);
    }
  }, [applicationDetails]);

  useEffect(() => {
    let markTotalIn10thId = "66a687874db5f02d6861ed06";
    let markObtainedIn10thId = "66a687874db5f02d6861ed05";
    let percentageIn10thId = "66a687874db5f02d6861ed07";

    let markTotalIn12thId = "66a731359680c25e280d6e4b";
    let markObtainedIn12thId = "66a730c29680c25e280d6de8";
    let percentageIn12thId = "66a7359a9680c25e280d6f16";

    let markTotalInGrThId = "66a687874db5f02d6861ed10";
    let markObtainedInGrThId = "66a687874db5f02d6861ed0f";
    let percentageInGrThId = "66a687874db5f02d6861ed11";

    let markTotalInPostGrThId = "676a57139e167618b7ec04af";
    let markObtainedInPostGrThId = "676a57139e167618b7ec04ad";
    let percentageInPostGrThId = "676a57139e167618b7ec04b1";

    let markTotalInLLBId = "68ecd888eb422bea55aa71b2";
    let markObtainedInLLBId = "68ecd888eb422bea55aa71b0";
    let percentageInLLBId = "68ecd888eb422bea55aa71b4";

    // Validate 10th Grade marks
    const obtained10th =
      Number(applicationDetails?.[markObtainedIn10thId]) || 0;
    const total10th = Number(applicationDetails?.[markTotalIn10thId]) || 0;
    const isMarkValid10th = obtained10th <= total10th;
    const percentage10th = total10th > 0 ? (obtained10th / total10th) * 100 : 0;
    const isPercentageValid10th = percentage10th >= 0 && percentage10th <= 100;

    // Validate 12th Grade marks
    const obtained12th =
      Number(applicationDetails?.[markObtainedIn12thId]) || 0;
    const total12th = Number(applicationDetails?.[markTotalIn12thId]) || 0;
    const isMarkValid12th = obtained12th <= total12th;
    const percentage12th = total12th > 0 ? (obtained12th / total12th) * 100 : 0;
    const isPercentageValid12th = percentage12th >= 0 && percentage12th <= 100;

    // Validate Graduation marks
    const obtainedGr = Number(applicationDetails?.[markObtainedInGrThId]) || 0;
    const totalGr = Number(applicationDetails?.[markTotalInGrThId]) || 0;
    const isMarkValidGr = obtainedGr <= totalGr;
    const percentageGr = totalGr > 0 ? (obtainedGr / totalGr) * 100 : 0;
    const isPercentageValidGr = percentageGr >= 0 && percentageGr <= 100;

    // Validate Post-Graduation marks
    const obtainedPostGr =
      Number(applicationDetails?.[markObtainedInPostGrThId]) || 0;
    const totalPostGr =
      Number(applicationDetails?.[markTotalInPostGrThId]) || 0;
    const isMarkValidPostGr = obtainedPostGr <= totalPostGr;
    const percentagePostGr =
      totalPostGr > 0 ? (obtainedPostGr / totalPostGr) * 100 : 0;
    const isPercentageValidPostGr =
      percentagePostGr >= 0 && percentagePostGr <= 100;

    // Validate LLB marks
    const obtainedLLB = Number(applicationDetails?.[markObtainedInLLBId]) || 0;
    const totalLLB = Number(applicationDetails?.[markTotalInLLBId]) || 0;
    const isMarkValidLLB = obtainedLLB <= totalLLB;
    const percentageLLB = totalLLB > 0 ? (obtainedLLB / totalLLB) * 100 : 0;
    const isPercentageValidLLB = percentageLLB >= 0 && percentageLLB <= 100;

    // Update errors for 10th Grade
    setFieldErrors((prevState) => {
      const newState = { ...prevState };

      // Mark validation for 10th
      if (!isMarkValid10th && obtained10th > 0 && total10th > 0) {
        newState[markObtainedIn10thId] = {
          errors: [
            ...new Set([
              ...(prevState[markObtainedIn10thId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markObtainedIn10thId]?.touched || true,
        };
        newState[markTotalIn10thId] = {
          errors: [
            ...new Set([
              ...(prevState[markTotalIn10thId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markTotalIn10thId]?.touched || true,
        };
      } else if (isMarkValid10th) {
        // Clear errors if valid
        if (newState[markObtainedIn10thId]) {
          newState[markObtainedIn10thId] = {
            ...newState[markObtainedIn10thId],
            errors: (newState[markObtainedIn10thId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
        if (newState[markTotalIn10thId]) {
          newState[markTotalIn10thId] = {
            ...newState[markTotalIn10thId],
            errors: (newState[markTotalIn10thId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
      }

      // Percentage validation for 10th
      if (!isPercentageValid10th && percentage10th > 100) {
        newState[percentageIn10thId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageIn10thId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageIn10thId]?.touched || true,
        };
      } else if (isPercentageValid10th) {
        if (newState[percentageIn10thId]) {
          newState[percentageIn10thId] = {
            ...newState[percentageIn10thId],
            errors: (newState[percentageIn10thId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Mark validation for 12th
      if (!isMarkValid12th && obtained12th > 0 && total12th > 0) {
        newState[markObtainedIn12thId] = {
          errors: [
            ...new Set([
              ...(prevState[markObtainedIn12thId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markObtainedIn12thId]?.touched || true,
        };
        newState[markTotalIn12thId] = {
          errors: [
            ...new Set([
              ...(prevState[markTotalIn12thId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markTotalIn12thId]?.touched || true,
        };
      } else if (isMarkValid12th) {
        if (newState[markObtainedIn12thId]) {
          newState[markObtainedIn12thId] = {
            ...newState[markObtainedIn12thId],
            errors: (newState[markObtainedIn12thId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
        if (newState[markTotalIn12thId]) {
          newState[markTotalIn12thId] = {
            ...newState[markTotalIn12thId],
            errors: (newState[markTotalIn12thId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
      }

      // Percentage validation for 12th
      if (!isPercentageValid12th && percentage12th > 100) {
        newState[percentageIn12thId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageIn12thId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageIn12thId]?.touched || true,
        };
      } else if (isPercentageValid12th) {
        if (newState[percentageIn12thId]) {
          newState[percentageIn12thId] = {
            ...newState[percentageIn12thId],
            errors: (newState[percentageIn12thId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Mark validation for Graduation
      if (!isMarkValidGr && obtainedGr > 0 && totalGr > 0) {
        newState[markObtainedInGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[markObtainedInGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markObtainedInGrThId]?.touched || true,
        };
        newState[markTotalInGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[markTotalInGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markTotalInGrThId]?.touched || true,
        };
      } else if (isMarkValidGr) {
        if (newState[markObtainedInGrThId]) {
          newState[markObtainedInGrThId] = {
            ...newState[markObtainedInGrThId],
            errors: (newState[markObtainedInGrThId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
        if (newState[markTotalInGrThId]) {
          newState[markTotalInGrThId] = {
            ...newState[markTotalInGrThId],
            errors: (newState[markTotalInGrThId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
      }

      // Percentage validation for Graduation
      if (!isPercentageValidGr && percentageGr > 100) {
        newState[percentageInGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageInGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageInGrThId]?.touched || true,
        };
      } else if (isPercentageValidGr) {
        if (newState[percentageInGrThId]) {
          newState[percentageInGrThId] = {
            ...newState[percentageInGrThId],
            errors: (newState[percentageInGrThId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Mark validation for Post-Graduation
      if (!isMarkValidPostGr && obtainedPostGr > 0 && totalPostGr > 0) {
        newState[markObtainedInPostGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[markObtainedInPostGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markObtainedInPostGrThId]?.touched || true,
        };
        newState[markTotalInPostGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[markTotalInPostGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markTotalInPostGrThId]?.touched || true,
        };
      } else if (isMarkValidPostGr) {
        if (newState[markObtainedInPostGrThId]) {
          newState[markObtainedInPostGrThId] = {
            ...newState[markObtainedInPostGrThId],
            errors: (newState[markObtainedInPostGrThId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
        if (newState[markTotalInPostGrThId]) {
          newState[markTotalInPostGrThId] = {
            ...newState[markTotalInPostGrThId],
            errors: (newState[markTotalInPostGrThId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
      }

      // Percentage validation for Post-Graduation
      if (!isPercentageValidPostGr && percentagePostGr > 100) {
        newState[percentageInPostGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageInPostGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageInPostGrThId]?.touched || true,
        };
      } else if (isPercentageValidPostGr) {
        if (newState[percentageInPostGrThId]) {
          newState[percentageInPostGrThId] = {
            ...newState[percentageInPostGrThId],
            errors: (newState[percentageInPostGrThId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Mark validation for LLB
      if (!isMarkValidLLB && obtainedLLB > 0 && totalLLB > 0) {
        newState[markObtainedInLLBId] = {
          errors: [
            ...new Set([
              ...(prevState[markObtainedInLLBId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markObtainedInLLBId]?.touched || true,
        };
        newState[markTotalInLLBId] = {
          errors: [
            ...new Set([
              ...(prevState[markTotalInLLBId]?.errors || []).filter(
                (err) =>
                  err !== "Mark Obtained cannot be greater than Mark Out of."
              ),
              "Mark Obtained cannot be greater than Mark Out of.",
            ]),
          ],
          touched: prevState?.[markTotalInLLBId]?.touched || true,
        };
      } else if (isMarkValidLLB) {
        if (newState[markObtainedInLLBId]) {
          newState[markObtainedInLLBId] = {
            ...newState[markObtainedInLLBId],
            errors: (newState[markObtainedInLLBId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
        if (newState[markTotalInLLBId]) {
          newState[markTotalInLLBId] = {
            ...newState[markTotalInLLBId],
            errors: (newState[markTotalInLLBId].errors || []).filter(
              (err) =>
                err !== "Mark Obtained cannot be greater than Mark Out of."
            ),
          };
        }
      }

      // Percentage validation for LLB
      if (!isPercentageValidLLB && percentageLLB > 100) {
        newState[percentageInLLBId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageInLLBId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageInLLBId]?.touched || true,
        };
      } else if (isPercentageValidLLB) {
        if (newState[percentageInLLBId]) {
          newState[percentageInLLBId] = {
            ...newState[percentageInLLBId],
            errors: (newState[percentageInLLBId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Also validate the actual percentage value stored in applicationDetails
      // This handles cases where percentage might be set directly or calculated incorrectly
      const storedPercentagePostGr =
        parseFloat(applicationDetails?.[percentageInPostGrThId]) || 0;
      const storedPercentageLLB =
        parseFloat(applicationDetails?.[percentageInLLBId]) || 0;

      // Validate stored Post-Graduation percentage
      if (storedPercentagePostGr > 100) {
        newState[percentageInPostGrThId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageInPostGrThId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageInPostGrThId]?.touched || true,
        };
      } else if (storedPercentagePostGr >= 0 && storedPercentagePostGr <= 100) {
        if (newState[percentageInPostGrThId]) {
          newState[percentageInPostGrThId] = {
            ...newState[percentageInPostGrThId],
            errors: (newState[percentageInPostGrThId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      // Validate stored LLB percentage
      if (storedPercentageLLB > 100) {
        newState[percentageInLLBId] = {
          errors: [
            ...new Set([
              ...(prevState[percentageInLLBId]?.errors || []).filter(
                (err) =>
                  err !== "Percentage of Mark cannot be greater than 100%."
              ),
              "Percentage of Mark cannot be greater than 100%.",
            ]),
          ],
          touched: prevState?.[percentageInLLBId]?.touched || true,
        };
      } else if (storedPercentageLLB >= 0 && storedPercentageLLB <= 100) {
        if (newState[percentageInLLBId]) {
          newState[percentageInLLBId] = {
            ...newState[percentageInLLBId],
            errors: (newState[percentageInLLBId].errors || []).filter(
              (err) => err !== "Percentage of Mark cannot be greater than 100%."
            ),
          };
        }
      }

      return newState;
    });
  }, [applicationDetails]);

  useEffect(() => {
    // Define the field IDs
    const yearofPassing10thId = "66a687874db5f02d6861ed02";
    const yearofPassing12thId = "66a727079680c25e280d6b2d";
    const yearofPassingGraduationId = "66a687874db5f02d6861ed0d";
    const birthDateId = "66a37bab1b102d1ba93eee2f";

    const year12 = Number(applicationDetails?.[yearofPassing12thId]);
    const year10 = Number(applicationDetails?.[yearofPassing10thId]);
    const yearGrad = Number(applicationDetails?.[yearofPassingGraduationId]);
    const birthYear = new Date(
      applicationDetails?.[birthDateId]
    )?.getFullYear();
    const year12length = applicationDetails?.[yearofPassing12thId];
    const year10length = applicationDetails?.[yearofPassing10thId];
    const yearGradlength = applicationDetails?.[yearofPassingGraduationId];

    let newFieldErrors = { ...fieldErrors };

    // Validation: Ensure the years are 4 digits
    const validateYearLength = (year, id, label) => {
      if (year?.length > 4 || year?.length < 4) {
        newFieldErrors = {
          ...newFieldErrors,
          [id]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[id]?.errors || []),
                `${label} must be 4 digits`,
              ]),
            ],
            touched: newFieldErrors?.[id]?.touched,
          },
        };
      } else {
        newFieldErrors = {
          ...newFieldErrors,
          [id]: {
            errors: newFieldErrors?.[id]?.errors?.filter(
              (error) => error !== `${label} must be 4 digits`
            ),
            touched: newFieldErrors?.[id]?.touched,
          },
        };
      }
    };

    // Validate year length for 10th, 12th, and Graduation years
    validateYearLength(year10length, yearofPassing10thId, "10th Passing year");
    validateYearLength(year12length, yearofPassing12thId, "12th Passing year");
    validateYearLength(
      yearGradlength,
      yearofPassingGraduationId,
      "Graduation Passing year"
    );

    // Check if year12 is less than year10
    if (year12 <= year10) {
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing12thId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassing12thId]?.errors || []),
              "12th Passing year cannot be less than 10th Passing year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassing12thId]?.touched,
        },
        [yearofPassing10thId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassing10thId]?.errors || []),
              "10th Passing year cannot be greater than 12th Passing year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
      };
    } else {
      // Clear the error messages
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing12thId]: {
          errors: newFieldErrors?.[yearofPassing12thId]?.errors?.filter(
            (error) =>
              error !==
              "12th Passing year cannot be less than 10th Passing year"
          ),
          touched: newFieldErrors?.[yearofPassing12thId]?.touched,
        },
        [yearofPassing10thId]: {
          errors: newFieldErrors?.[yearofPassing10thId]?.errors?.filter(
            (error) =>
              error !==
              "10th Passing year cannot be greater than 12th Passing year"
          ),
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
      };
    }

    // Check if yearGrad is less than year10 or year12
    if (yearGrad <= year10) {
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassingGraduationId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassingGraduationId]?.errors || []),
              "Graduation Passing year cannot be less than 10th or 12th Passing year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassingGraduationId]?.touched,
        },
        ...(yearGrad <= year10 && {
          [yearofPassing10thId]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[yearofPassing10thId]?.errors || []),
                "10th Passing year cannot be greater than Graduation Passing year",
              ]),
            ],
            touched: newFieldErrors?.[yearofPassing10thId]?.touched,
          },
        }),
        ...(yearGrad <= year12 && {
          [yearofPassing12thId]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[yearofPassing12thId]?.errors || []),
                "12th Passing year cannot be greater than Graduation Passing year",
              ]),
            ],
            touched: newFieldErrors?.[yearofPassing12thId]?.touched,
          },
        }),
      };
    } else if (yearGrad <= year12 && yearGrad > year10) {
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassingGraduationId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassingGraduationId]?.errors || []),
              "Graduation Passing year cannot be less than 10th or 12th Passing year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassingGraduationId]?.touched,
        },
        [yearofPassing10thId]: {
          errors: newFieldErrors?.[yearofPassing10thId]?.errors?.filter(
            (error) =>
              error !==
              "10th Passing year cannot be greater than Graduation Passing year"
          ),
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
        ...(yearGrad < year12 && {
          [yearofPassing12thId]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[yearofPassing12thId]?.errors || []),
                "12th Passing year cannot be greater than Graduation Passing year",
              ]),
            ],
            touched: newFieldErrors?.[yearofPassing12thId]?.touched,
          },
        }),
      };
    } else {
      // Clear the error messages for Graduation check
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassingGraduationId]: {
          errors: newFieldErrors?.[yearofPassingGraduationId]?.errors?.filter(
            (error) =>
              error !==
              "Graduation Passing year cannot be less than 10th or 12th Passing year"
          ),
          touched: newFieldErrors?.[yearofPassingGraduationId]?.touched,
        },
        [yearofPassing10thId]: {
          errors: newFieldErrors?.[yearofPassing10thId]?.errors?.filter(
            (error) =>
              error !==
              "10th Passing year cannot be greater than Graduation Passing year"
          ),
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
        [yearofPassing12thId]: {
          errors: newFieldErrors?.[yearofPassing12thId]?.errors?.filter(
            (error) =>
              error !==
              "12th Passing year cannot be greater than Graduation Passing year"
          ),
          touched: newFieldErrors?.[yearofPassing12thId]?.touched,
        },
      };
    }

    if (birthYear >= year12) {
      // console.log({ year12 }, { birthYear }, { year10 }, { yearGrad });
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing12thId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassing12thId]?.errors || []),
              "12th cannot be greater than or equal to Birth year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassing12thId]?.touched,
        },
      };
    } else {
      // Clear birth year related errors
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing12thId]: {
          errors: newFieldErrors?.[yearofPassing12thId]?.errors?.filter(
            (error) =>
              error !== "12th cannot be greater than or equal to Birth year"
          ),
          touched: newFieldErrors?.[yearofPassing12thId]?.touched,
        },
      };
    }

    if (birthYear >= year10) {
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing10thId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassing10thId]?.errors || []),
              "10th Passing year cannot be less than or equal to BirthYear",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
      };
    } else {
      // Clear birth year related errors
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassing10thId]: {
          errors: newFieldErrors?.[yearofPassing10thId]?.errors?.filter(
            (error) =>
              error !==
              "10th Passing year cannot be less than or equal to BirthYear"
          ),
          touched: newFieldErrors?.[yearofPassing10thId]?.touched,
        },
      };
    }
    if (birthYear >= yearGrad) {
      // console.log({year12},{birthYear},{year10},{yearGrad})
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassingGraduationId]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[yearofPassingGraduationId]?.errors || []),
              "Graduation year cannot be less than or equal to Birth year",
            ]),
          ],
          touched: newFieldErrors?.[yearofPassingGraduationId]?.touched,
        },
      };
    } else {
      // Clear birth year related errors
      newFieldErrors = {
        ...newFieldErrors,
        [yearofPassingGraduationId]: {
          errors: newFieldErrors?.[yearofPassingGraduationId]?.errors?.filter(
            (error) =>
              error !==
              "Graduation year cannot be less than or equal to Birth year"
          ),
          touched: newFieldErrors?.[yearofPassingGraduationId]?.touched,
        },
      };
    }

    // Post-Graduation year of passing validation
    const yearofPassingPostGraduationId = "676a57139e167618b7ec04a7";
    const yearPostGrad = Number(
      applicationDetails?.[yearofPassingPostGraduationId]
    );
    const yearPostGradlength =
      applicationDetails?.[yearofPassingPostGraduationId];

    // Validate year length for Post-Graduation
    if (yearPostGradlength) {
      validateYearLength(
        yearPostGradlength,
        yearofPassingPostGraduationId,
        "Post-Graduation Passing year"
      );
    }

    // Check if yearPostGrad is less than year10, year12, or yearGrad
    // Only validate if yearPostGrad has a valid value and the previous years also have valid values
    if (yearPostGrad && yearPostGrad > 0) {
      const hasError =
        (year10 && year10 > 0 && yearPostGrad <= year10) ||
        (year12 && year12 > 0 && yearPostGrad <= year12) ||
        (yearGrad && yearGrad > 0 && yearPostGrad <= yearGrad);

      if (hasError) {
        // Only show error on Post-Graduation field, not on other fields
        newFieldErrors = {
          ...newFieldErrors,
          [yearofPassingPostGraduationId]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[yearofPassingPostGraduationId]?.errors ||
                  []),
                "Post-Graduation Passing year cannot be less than 10th, 12th, or Graduation Passing year",
              ]),
            ],
            touched: newFieldErrors?.[yearofPassingPostGraduationId]?.touched,
          },
        };
      } else {
        // Clear the error message for Post-Graduation check if all conditions are met
        newFieldErrors = {
          ...newFieldErrors,
          [yearofPassingPostGraduationId]: {
            errors: newFieldErrors?.[
              yearofPassingPostGraduationId
            ]?.errors?.filter(
              (error) =>
                error !==
                "Post-Graduation Passing year cannot be less than 10th, 12th, or Graduation Passing year"
            ),
            touched: newFieldErrors?.[yearofPassingPostGraduationId]?.touched,
          },
        };
      }
    }

    // LLB Degree year of passing validation
    const yearofPassingLLBId = "68ecd888eb422bea55aa71aa";
    const yearLLB = Number(applicationDetails?.[yearofPassingLLBId]);
    const yearLLBlength = applicationDetails?.[yearofPassingLLBId];

    // Validate year length for LLB
    if (yearLLBlength) {
      validateYearLength(yearLLBlength, yearofPassingLLBId, "LLB Passing year");
    }

    // Check if yearLLB is less than year10, year12, or yearGrad
    // Only validate if yearLLB has a valid value and the previous years also have valid values
    if (yearLLB && yearLLB > 0) {
      const hasError =
        (year10 && year10 > 0 && yearLLB <= year10) ||
        (year12 && year12 > 0 && yearLLB <= year12) ||
        (yearGrad && yearGrad > 0 && yearLLB <= yearGrad);

      if (hasError) {
        // Only show error on LLB field, not on other fields
        newFieldErrors = {
          ...newFieldErrors,
          [yearofPassingLLBId]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[yearofPassingLLBId]?.errors || []),
                "LLB Passing year cannot be less than 10th, 12th, or Graduation Passing year",
              ]),
            ],
            touched: newFieldErrors?.[yearofPassingLLBId]?.touched,
          },
        };
      } else {
        // Clear the error message for LLB check if all conditions are met
        newFieldErrors = {
          ...newFieldErrors,
          [yearofPassingLLBId]: {
            errors: newFieldErrors?.[yearofPassingLLBId]?.errors?.filter(
              (error) =>
                error !==
                "LLB Passing year cannot be less than 10th, 12th, or Graduation Passing year"
            ),
            touched: newFieldErrors?.[yearofPassingLLBId]?.touched,
          },
        };
      }
    }

    // Age eligibility validation removed from here - now only validated on Save & Next button click
    // This allows all personal details (category, gender, DOB) to be filled before validation
    // Age relaxation depends on combination of fields in personal details tab

    setFieldErrors(newFieldErrors);

    const alternateMobileId = "66cd254c1f0526789fdae6e6";
    const mobileNumber = "mobileNumber";
    const alternateMobileNo = applicationDetails?.[alternateMobileId];
    const alternateMobile = applicationDetails?.[mobileNumber];
    const validateMobileLength = (MobileId, id, label) => {
      if (MobileId?.length > 10 || MobileId?.length < 10) {
        newFieldErrors = {
          ...newFieldErrors,
          [id]: {
            errors: [
              ...new Set([
                ...(newFieldErrors[id]?.errors || []),
                `${label} must be 10 digits`,
              ]),
            ],
            touched: newFieldErrors?.[id]?.touched,
          },
        };
      } else {
        newFieldErrors = {
          ...newFieldErrors,
          [id]: {
            errors: newFieldErrors?.[id]?.errors?.filter(
              (error) => error !== `${label} must be 10 digits`
            ),
            touched: newFieldErrors?.[id]?.touched,
          },
        };
      }
    };
    if (Number(alternateMobileNo) === alternateMobile) {
      // console.log("alter", Number(alternateMobileNo));
      //("alternate,", alternateMobile);
      newFieldErrors = {
        ...newFieldErrors,
        [mobileNumber]: {
          errors: [
            ...new Set([
              ...(newFieldErrors[mobileNumber]?.errors || []),
              "Mobile No and Alternate Mobile No. Cannot be same",
            ]),
          ],
          touched: newFieldErrors?.[mobileNumber]?.touched,
        },
      };
    }

    validateMobileLength(
      alternateMobileNo,
      alternateMobileId,
      "Alternate Mobile No."
    );

    // Business Excellence Certification change handler - re-validate Upload Certificate
    const BUSINESS_EXCELLENCE_CERTIFICATION_ID = "693682fe4c6c63e650c921b8";
    const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
    const businessExcellenceValue =
      applicationDetails?.[BUSINESS_EXCELLENCE_CERTIFICATION_ID] ||
      applicationDetails?.[camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID)];
    const uploadCertKey = camelCase(UPLOAD_CERTIFICATE_ID);
    const uploadCertValue =
      applicationDetails?.[UPLOAD_CERTIFICATE_ID] ||
      applicationDetails?.[uploadCertKey];

    // Check if Business Excellence Certification is empty/Select
    const isEmptyOrSelect =
      !businessExcellenceValue ||
      businessExcellenceValue === "" ||
      businessExcellenceValue === "Select" ||
      (Array.isArray(businessExcellenceValue) &&
        businessExcellenceValue.length === 0) ||
      (Array.isArray(businessExcellenceValue) &&
        businessExcellenceValue.every(
          (item) =>
            !item ||
            (typeof item === "string" && item.trim() === "") ||
            (typeof item === "object" &&
              item !== null &&
              (!item.value || item.value.trim() === ""))
        ));

    // If Business Excellence Certification is cleared and Upload Certificate has errors, clear them
    if (isEmptyOrSelect && fieldErrors?.[uploadCertKey]) {
      setFieldErrors((prevState) => {
        const newState = { ...prevState };
        if (newState[uploadCertKey]) {
          newState[uploadCertKey] = {
            ...newState[uploadCertKey],
            errors: newState[uploadCertKey].errors.filter(
              (err) => err !== "This field is required."
            ),
          };
        }
        return newState;
      });
    }

    // Re-validate Upload Certificate when Business Excellence Certification changes
    if (
      uploadCertValue !== undefined &&
      fieldErrors?.[uploadCertKey]?.touched
    ) {
      // Find the Upload Certificate field in the form to validate it
      if (applicationForm) {
        for (const tab of applicationForm) {
          if (tab?.inputElements) {
            const uploadCertField = tab.inputElements.find(
              (field) =>
                field?.values?._id === UPLOAD_CERTIFICATE_ID ||
                camelCase(field?.values?._id) === uploadCertKey
            );
            if (uploadCertField) {
              // Trigger validation
              setTimeout(() => {
                checkErrorFn(uploadCertField, uploadCertKey, uploadCertValue);
              }, 100);
              break;
            }
          }
        }
      }
    }
  }, [applicationDetails]);

  const renderNonArrayFields = (item) => {
    // Function to render select input
    const renderSelectInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      const select12thDeploma =
        applicationDetails?.["67927705f2187a33680afe54"];
      let declarationForRegular = "67ff440db370dd13383a5de5";
      let declarationForRegularPost = "6805fe403021950f0696c2e0";
      const appliedEarlier = applicationDetails?.["68e505a0eb422bea55a9ac0f"];
      const shortlistedPersonalInterview =
        applicationDetails?.["68e505a0eb422bea55a9ac15"];

      console.log(label, "label");
      switch (label) {
        case "Select One of the Below":
          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue || ""} // Ensure empty string if no value is selected
                onChange={(e) => {
                  const selectedValue = e.target.value;

                  // Update state with the selected value
                  setApplicationDetails((prevDetails) => ({
                    ...prevDetails,
                    [camelCaseKey]: selectedValue,
                  }));

                  // Trigger validation if field has been interacted with
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, selectedValue);
                  }
                }}
                onBlur={() => {
                  // Always validate when losing focus
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {input?.values?.inputFieldTags
                  ?.filter(
                    (item) =>
                      applicationDetails?.vacancyId?.department
                        ?.diplomaQualification?.length > 0
                        ? true // Show all options if diplomaQualification exists
                        : item.label === "12th" // Show only "12th" when diplomaQualification is empty
                  )
                  .map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
              </select>

              {/* Display validation errors if present */}
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );

        case "Stream/Branch":
          if (
            camelCaseKey === "6745516aba7bd153d04f36f2" &&
            select12thDeploma === "12th"
          ) {
            return (
              <>
                <select
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                    <span
                      key={idx}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else if (
            camelCaseKey === "6745516aba7bd153d04f36f2" &&
            select12thDeploma === "Diploma"
          ) {
            return (
              <>
                <>
                  <select
                    style={
                      fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                      fieldErrors?.[camelCaseKey]?.touched
                        ? { ...style.input, ...style.errorBox }
                        : style.input
                    }
                    placeholder={label}
                    value={fieldValue}
                    onChange={(e) => {
                      setApplicationDetails({
                        ...applicationDetails,
                        [camelCaseKey]: e.target.value,
                      });

                      fieldErrors?.[camelCaseKey]?.touched &&
                        checkErrorFn(input, camelCaseKey, e.target.value);
                    }}
                    onBlur={(e) => {
                      checkErrorFn(input, camelCaseKey, fieldValue);
                    }}
                  >
                    <option value="" className="text-muted">
                      Select
                    </option>
                    {applicationDetails?.vacancyId?.department?.diplomaQualification?.map(
                      (item, idx) => (
                        <option key={idx} value={item.qualification}>
                          {item.qualification}
                        </option>
                      )
                    )}
                  </select>
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                </>
              </>
            );
          } else if (camelCaseKey === "68e67d5e9698f142bc5322b7") {
            return (
              <>
                <>
                  <select
                    style={
                      fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                      fieldErrors?.[camelCaseKey]?.touched
                        ? { ...style.input, ...style.errorBox }
                        : style.input
                    }
                    placeholder={label}
                    value={fieldValue}
                    onChange={(e) => {
                      setApplicationDetails({
                        ...applicationDetails,
                        [camelCaseKey]: e.target.value,
                      });

                      fieldErrors?.[camelCaseKey]?.touched &&
                        checkErrorFn(input, camelCaseKey, e.target.value);
                    }}
                    onBlur={(e) => {
                      checkErrorFn(input, camelCaseKey, fieldValue);
                    }}
                  >
                    <option value="" className="text-muted">
                      Select
                    </option>
                    {applicationDetails?.vacancyId?.department?.desirableQualification?.map(
                      (option, idx) => (
                        <option
                          key={`${option.qualification}.${idx}`}
                          value={option.qualification}
                        >
                          {option.qualification}
                        </option>
                      )
                    )}
                  </select>
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                </>
              </>
            );
          } else {
            return (
              <>
                <select
                  disabled={true}
                  // className="inputBoxForm text-dark"
                  style={style.input}
                  placeholder={label}
                  value={fieldValue}
                  max={new Date().toISOString().split("T")[0]}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {/* {applicationDetails?.vacancyId?.department?.essentialQualification?.map(
                (item, idx) => (
                  <option key={idx} value={item.qualification}>
                    {item.qualification}
                  </option>
                )
              )} */}
                </select>
              </>
            );
          }

        case "Board/Council":
          if (
            camelCaseKey === "66a726919680c25e280d6ad0" &&
            select12thDeploma === "12th"
          ) {
            return (
              <>
                <select
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                    <span
                      key={idx}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else if (camelCaseKey === "66a687874db5f02d6861ed01") {
            return (
              <>
                <select
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                    <span
                      key={idx}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          }
          return null;

        case "Gender":
          return (
            <>
              <select
                // className="inputBoxForm text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                max={new Date().toISOString().split("T")[0]}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {onlyWomenAllowed ? (
                  <>
                    <option key={"femaleOnly"} value={"Female"}>
                      Female
                    </option>
                  </>
                ) : (
                  input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))
                )}
              </select>
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
        case "Course Name (Graduation)":
          return (
            <>
              <select
                // className="inputBoxForm text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });

                  // Check if "Integrated LLB" is selected
                  if (e.target.value === "Integrated LLB") {
                    setShowIntegratedLLBDialog(true);
                    setHideLLBSection(true); // Hide LLB section immediately
                  } else {
                    // Reset LLB section visibility when other options are selected
                    setHideLLBSection(false);
                  }

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, e.target.value);

                  // Re-validate course type fields when graduation course name changes
                  // This ensures the correspondence condition is applied/removed correctly
                  const courseTypeLegalGradFieldId = "6932c5664c6c63e650c7a4b4"; // Legal Job Graduation
                  const courseTypeLegalLLBFieldId = "6932c5664c6c63e650c7a4cc"; // Legal Job LLB Degree

                  // Find and re-validate the graduation course type field
                  dynamicFields.forEach((fieldSet) => {
                    fieldSet.fields.forEach((field) => {
                      if (field?.values?._id === courseTypeLegalGradFieldId) {
                        const gradCourseTypeKey = camelCase(
                          courseTypeLegalGradFieldId + fieldSet.id
                        );
                        const gradCourseTypeValue =
                          applicationDetails?.[gradCourseTypeKey] ||
                          applicationDetails?.[courseTypeLegalGradFieldId];
                        if (fieldErrors?.[gradCourseTypeKey]?.touched) {
                          checkErrorFn(
                            field,
                            gradCourseTypeKey,
                            gradCourseTypeValue
                          );
                        }
                      }
                      // Find and re-validate the LLB course type field
                      if (field?.values?._id === courseTypeLegalLLBFieldId) {
                        const llbCourseTypeKey = camelCase(
                          courseTypeLegalLLBFieldId + fieldSet.id
                        );
                        const llbCourseTypeValue =
                          applicationDetails?.[llbCourseTypeKey] ||
                          applicationDetails?.[courseTypeLegalLLBFieldId];
                        if (fieldErrors?.[llbCourseTypeKey]?.touched) {
                          checkErrorFn(
                            field,
                            llbCourseTypeKey,
                            llbCourseTypeValue
                          );
                        }
                      }
                    });
                  });
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                max={new Date().toISOString().split("T")[0]}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {applicationDetails?.vacancyId?.department?.graduationQualification?.map(
                  (item, idx) => (
                    <option key={idx} value={item.qualification}>
                      {item.qualification}
                    </option>
                  )
                )}
              </select>
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;

        case "Were you shortlisted for Personal Interview (PI)?":
          if (
            camelCaseKey === "68e505a0eb422bea55a9ac15" &&
            appliedEarlier === "Yes"
          ) {
            return (
              <>
                <select
                  // className="inputBoxForm text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  max={new Date().toISOString().split("T")[0]}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                    <span className="errorPresent" style={style.errorSpan}>
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else {
            return null;
          }

        case "Had you appeared for Personal Interview (PI)?":
          if (
            camelCaseKey === "68e505a0eb422bea55a9ac17" &&
            appliedEarlier === "Yes" &&
            shortlistedPersonalInterview === "Yes"
          ) {
            return (
              <>
                <select
                  // className="inputBoxForm text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  max={new Date().toISOString().split("T")[0]}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                    <span className="errorPresent" style={style.errorSpan}>
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else {
            return null;
          }

        case "Were you selected?":
          if (
            camelCaseKey === "68e505a0eb422bea55a9ac19" &&
            appliedEarlier === "Yes" &&
            shortlistedPersonalInterview === "Yes" &&
            applicationDetails?.["68e505a0eb422bea55a9ac17"] === "Yes"
          ) {
            return (
              <>
                <select
                  // className="inputBoxForm text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  placeholder={label}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });

                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, e.target.value);
                  }}
                  onBlur={(e) => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  max={new Date().toISOString().split("T")[0]}
                >
                  <option value="" className="text-muted">
                    Select
                  </option>
                  {input?.values?.inputFieldTags.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                    <span className="errorPresent" style={style.errorSpan}>
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else {
            return null;
          }
        // shortlistedPersonalInterview

        case "Course Name (Post Graduation)":
          // (applicationDetails?.vacancyId?.department,"applicationDetails?.vacancyId?.department")
          return (
            <>
              <select
                // className="inputBoxForm text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, e.target.value);
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                max={new Date().toISOString().split("T")[0]}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {applicationDetails?.vacancyId?.department?.postGraduationQualification?.map(
                  (item, idx) => (
                    <option key={idx} value={item.qualification}>
                      {item.qualification}
                    </option>
                  )
                )}
              </select>
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
        //                   case "Stream/Branch":
        //           // (applicationDetails?.vacancyId?.department,"applicationDetails?.vacancyId?.department")
        //           // if(camelCaseKey == "68e67d5e9698f142bc5322b7"){
        //             console.log("first",camelCaseKey)
        //           return (
        //             <>
        //               <select
        //                 // className="inputBoxForm text-dark"
        //                 style={
        //                   fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
        //                   fieldErrors?.[camelCaseKey]?.touched
        //                     ? { ...style.input, ...style.errorBox }
        //                     : style.input
        //                 }
        //                 placeholder={label}
        //                 value={fieldValue}
        //                 onChange={(e) => {
        //                   setApplicationDetails({
        //                     ...applicationDetails,
        //                     [camelCaseKey]: e.target.value,
        //                   });

        //                   fieldErrors?.[camelCaseKey]?.touched &&
        //                     checkErrorFn(input, camelCaseKey, e.target.value);
        //                 }}
        //                 onBlur={(e) => {
        //                   checkErrorFn(input, camelCaseKey, fieldValue);
        //                 }}
        //                 max={new Date().toISOString().split("T")[0]}
        //               >
        //                 <option value="" className="text-muted">
        //                   Select
        //                 </option>
        //                 {applicationDetails?.vacancyId?.department?.desirableQualification?.map((option, idx) => (
        //           <option
        //             key={`${option.qualification}.${idx}`}
        //             value={option.qualification}
        //           >
        //             {option.qualification}
        //           </option>
        //                   )
        //                 )}
        //               </select>
        //               {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
        //                 fieldErrors?.[camelCaseKey]?.touched &&
        //                 fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
        //                   <span className="errorPresent" style={style.errorSpan}>
        //                     {err}
        //                     <br />
        //                   </span>
        //                 ))}
        //             </>
        //           );

        //           break;

        // // renderSelectOptionsForDesirableQualification

        case "Country": {
          const isCommDetails = item?.formTab === "COMMUNICATION DETAILS";
          const isCorrCountry = input?.values?._id === CORR_COUNTRY_ID;
          const isPermCountry = input?.values?._id === PERM_COUNTRY_ID;
          const isAddressCountry =
            isCommDetails && (isCorrCountry || isPermCountry);

          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  const selectedCountry = e.target.value;

                  if (isAddressCountry) {
                    setApplicationDetails((prev) => {
                      const updates = {
                        ...prev,
                        [camelCaseKey]: selectedCountry,
                      };
                      if (isCorrCountry) {
                        updates[CORR_STATE_ID] = "";
                        updates[CORR_DISTRICT_ID] = "";
                      } else if (isPermCountry) {
                        updates[PERM_STATE_ID] = "";
                        updates[PERM_DISTRICT_ID] = "";
                      }
                      return updates;
                    });
                  } else {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: selectedCountry,
                    });
                    setSelectedCountry(selectedCountry);
                    const newStates = getStatesByCountry(selectedCountry);
                    setStates(newStates);
                    setSelectedState("");
                    setDistricts([]);
                  }

                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  // Mark field as touched if not already
                  if (!fieldErrors?.[camelCaseKey]?.touched) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: prevState?.[camelCaseKey]?.errors || [],
                        touched: true,
                      },
                    }));
                  }
                  // Validate on blur with current value from applicationDetails or event target
                  const currentValue =
                    applicationDetails?.[camelCaseKey] ||
                    e.target.value ||
                    fieldValue;
                  checkErrorFn(input, camelCaseKey, currentValue);
                }}
              >
                <option value="">Select Country</option>
                {countriesData.map((country) => {
                  return (
                    <option key={country.name} value={country.name}>
                      {country.name}
                    </option>
                  );
                })}
              </select>
              {/* Display error messages */}
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                  <span
                    key={index}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
        }

        case "State": {
          const isCommDetailsState = item?.formTab === "COMMUNICATION DETAILS";
          const isCorrState = input?.values?._id === CORR_STATE_ID;
          const isPermState = input?.values?._id === PERM_STATE_ID;
          const isAddressState =
            isCommDetailsState && (isCorrState || isPermState);

          const addrCountry = isAddressState
            ? isCorrState
              ? applicationDetails?.[CORR_COUNTRY_ID]
              : applicationDetails?.[PERM_COUNTRY_ID]
            : selectedCountry;
          const addrStates = addrCountry ? getStatesByCountry(addrCountry) : [];

          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  const selectedStateVal = e.target.value;

                  if (isAddressState) {
                    setApplicationDetails((prev) => {
                      const updates = {
                        ...prev,
                        [camelCaseKey]: selectedStateVal,
                      };
                      if (isCorrState) updates[CORR_DISTRICT_ID] = "";
                      else if (isPermState) updates[PERM_DISTRICT_ID] = "";
                      return updates;
                    });
                  } else {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: selectedStateVal,
                    });
                    setSelectedState(selectedStateVal);
                    const newDistricts = getDistrictsByState(
                      selectedCountry,
                      selectedStateVal
                    );
                    setDistricts(newDistricts);
                  }

                  // Mark field as touched immediately on change
                  if (!fieldErrors?.[camelCaseKey]?.touched) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: prevState?.[camelCaseKey]?.errors || [],
                        touched: true,
                      },
                    }));
                  }

                  // Normalize value for validation
                  const valueToValidate =
                    !e.target.value ||
                    e.target.value === "" ||
                    e.target.value === "Select State"
                      ? ""
                      : e.target.value;

                  // Force isRequired to true for State fields
                  const inputToValidate = {
                    ...input,
                    values: { ...input.values, isRequired: true },
                  };
                  checkErrorFn(inputToValidate, camelCaseKey, valueToValidate);
                }}
                onBlur={(e) => {
                  // Mark field as touched if not already
                  if (!fieldErrors?.[camelCaseKey]?.touched) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: prevState?.[camelCaseKey]?.errors || [],
                        touched: true,
                      },
                    }));
                  }
                  // Validate on blur with current value from applicationDetails or event target
                  const currentValue =
                    applicationDetails?.[camelCaseKey] ||
                    e.target.value ||
                    fieldValue;
                  // Normalize value for validation
                  const valueToValidate =
                    !currentValue ||
                    currentValue === "" ||
                    currentValue === "Select State"
                      ? ""
                      : currentValue;
                  // Force isRequired to true for State fields
                  const inputToValidate = {
                    ...input,
                    values: { ...input.values, isRequired: true },
                  };
                  checkErrorFn(inputToValidate, camelCaseKey, valueToValidate);
                }}
                disabled={!addrCountry}
              >
                <option value="">Select State</option>
                {(isAddressState ? addrStates : states).map((state, idx) => (
                  <option key={idx} value={state}>
                    {state}
                  </option>
                ))}
              </select>
              {/* Display error messages */}
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                  <span
                    key={index}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
        }

        case "District": {
          const isCommDetailsDistrict =
            item?.formTab === "COMMUNICATION DETAILS";
          const isCorrDistrict = input?.values?._id === CORR_DISTRICT_ID;
          const isPermDistrict = input?.values?._id === PERM_DISTRICT_ID;
          const isAddressDistrict =
            isCommDetailsDistrict && (isCorrDistrict || isPermDistrict);

          const addrCountryDist = isAddressDistrict
            ? isCorrDistrict
              ? applicationDetails?.[CORR_COUNTRY_ID]
              : applicationDetails?.[PERM_COUNTRY_ID]
            : selectedCountry;
          const addrStateDist = isAddressDistrict
            ? isCorrDistrict
              ? applicationDetails?.[CORR_STATE_ID]
              : applicationDetails?.[PERM_STATE_ID]
            : selectedState;
          const addrDistricts =
            addrCountryDist && addrStateDist
              ? getDistrictsByState(addrCountryDist, addrStateDist)
              : [];

          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue || ""}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });

                  // Mark field as touched immediately on change
                  if (!fieldErrors?.[camelCaseKey]?.touched) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: prevState?.[camelCaseKey]?.errors || [],
                        touched: true,
                      },
                    }));
                  }

                  // Normalize value for validation
                  const valueToValidate =
                    !e.target.value ||
                    e.target.value === "" ||
                    e.target.value === "Select District"
                      ? ""
                      : e.target.value;

                  // Force isRequired to true for District fields
                  const inputToValidate = {
                    ...input,
                    values: { ...input.values, isRequired: true },
                  };
                  checkErrorFn(inputToValidate, camelCaseKey, valueToValidate);
                }}
                onBlur={(e) => {
                  // Mark field as touched if not already
                  if (!fieldErrors?.[camelCaseKey]?.touched) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: prevState?.[camelCaseKey]?.errors || [],
                        touched: true,
                      },
                    }));
                  }
                  // Validate on blur with current value from applicationDetails or event target
                  const currentValue =
                    applicationDetails?.[camelCaseKey] ||
                    e.target.value ||
                    fieldValue;
                  // Normalize value for validation
                  const valueToValidate =
                    !currentValue ||
                    currentValue === "" ||
                    currentValue === "Select District"
                      ? ""
                      : currentValue;
                  // Force isRequired to true for District fields
                  const inputToValidate = {
                    ...input,
                    values: { ...input.values, isRequired: true },
                  };
                  checkErrorFn(inputToValidate, camelCaseKey, valueToValidate);
                }}
                disabled={!addrStateDist}
              >
                <option value="">Select District</option>
                {(isAddressDistrict ? addrDistricts : districts).map(
                  (district, idx) => (
                    <option key={idx} value={district}>
                      {district}
                    </option>
                  )
                )}
              </select>
              {/* Display error messages */}
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                  <span
                    key={index}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
        }
        case "Do you want to join OMC on regular basis or on deputation, in case got selected":
          return (
            <>
              <select
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails((prec) => ({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  }));
                  if (e.target.value == "Deputation") {
                    setShowDeputationModal(true);
                  }
                }}
                onBlur={() => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {input?.values?.inputFieldTags.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>

              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;

        default:
          return (
            <>
              <select
                // className="inputBoxForm text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  const selectedValue = e.target.value;

                  // Business Excellence Certification field change handler
                  // Field IDs: Business Excellence Certification: 693682fe4c6c63e650c921b8, Upload Certificate: 693682fe4c6c63e650c921fb
                  const BUSINESS_EXCELLENCE_CERTIFICATION_ID =
                    "693682fe4c6c63e650c921b8";
                  const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
                  const isBusinessExcellenceField =
                    input?.values?._id ===
                      BUSINESS_EXCELLENCE_CERTIFICATION_ID ||
                    camelCaseKey ===
                      camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID);

                  if (isBusinessExcellenceField) {
                    // If Business Excellence Certification is cleared (empty or "Select"), clear Upload Certificate
                    const uploadCertKey = camelCase(UPLOAD_CERTIFICATE_ID);
                    const uploadCertFieldId = UPLOAD_CERTIFICATE_ID;

                    if (
                      !selectedValue ||
                      selectedValue === "" ||
                      selectedValue === "Select"
                    ) {
                      // Clear Upload Certificate value and errors
                      setApplicationDetails((prev) => {
                        const updated = { ...prev };
                        delete updated[uploadCertKey];
                        delete updated[uploadCertFieldId];
                        return updated;
                      });

                      // Clear Upload Certificate errors
                      setFieldErrors((prevState) => {
                        const newState = { ...prevState };
                        delete newState[uploadCertKey];
                        delete newState[uploadCertFieldId];
                        return newState;
                      });
                    }
                  }

                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: selectedValue,
                  });

                  // Special check for Course Type fields:
                  // - ID: 6933c2114c6c63e650c80f76 (AGM Sales Marketing Graduation)
                  // - ID: 6933c07e4c6c63e650c809a0 (Geology Post Graduation)
                  // - ID: 6932c7eb4c6c63e650c7aaeb (BE Job)
                  // - ID: 6932c5664c6c63e650c7a4b4 (Legal Job Graduation)
                  // - ID: 6932c5664c6c63e650c7a4cc (Legal Job LLB Degree)
                  // Always trigger validation for these fields to handle both Correspondence and other values
                  const courseTypeFieldId = "6933c2114c6c63e650c80f76"; // AGM Sales Marketing Graduation
                  const courseTypePostGradFieldId = "6933c07e4c6c63e650c809a0"; // Geology Post Graduation
                  const courseTypeBEJobFieldId = "6932c7eb4c6c63e650c7aaeb"; // BE Job
                  const courseTypeLegalGradFieldId = "6932c5664c6c63e650c7a4b4"; // Legal Job Graduation
                  const courseTypeLegalLLBFieldId = "6932c5664c6c63e650c7a4cc"; // Legal Job LLB Degree
                  if (
                    input?.values?._id === courseTypeFieldId ||
                    input?.values?._id === courseTypePostGradFieldId ||
                    input?.values?._id === courseTypeBEJobFieldId ||
                    input?.values?._id === courseTypeLegalGradFieldId ||
                    input?.values?._id === courseTypeLegalLLBFieldId
                  ) {
                    // Always mark field as touched first
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState[camelCaseKey],
                        touched: true,
                      },
                    }));

                    // If value is NOT "Correspondence", immediately clear the error and close modal
                    if (selectedValue !== "Correspondence") {
                      // Clear the Correspondence error immediately - do this synchronously
                      setFieldErrors((prevState) => {
                        const currentErrors =
                          prevState?.[camelCaseKey]?.errors || [];
                        const filteredErrors = currentErrors.filter(
                          (error) =>
                            !error.includes(
                              "Correspondence course type is not eligible"
                            )
                        );
                        return {
                          ...prevState,
                          [camelCaseKey]: {
                            errors: filteredErrors,
                            touched: true,
                          },
                        };
                      });
                      // Close modal if it's open
                      setShowNotEligibleModal(false);
                      // Call checkErrorFn with the new value - it will use the passed selectedValue
                      // and won't re-add the Correspondence error since the value is not "Correspondence"
                      checkErrorFn(input, camelCaseKey, selectedValue);
                    } else {
                      // If "Correspondence" is selected, trigger validation which will show error and modal
                      checkErrorFn(input, camelCaseKey, selectedValue);
                    }
                  } else {
                    fieldErrors?.[camelCaseKey]?.touched &&
                      checkErrorFn(input, camelCaseKey, selectedValue);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                max={new Date().toISOString().split("T")[0]}
              >
                <option value="" className="text-muted">
                  Select
                </option>
                {input?.values?.inputFieldTags.map((item, idx) => (
                  <option key={idx} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
      }
    };

    // Function to render radio input
    const renderRadioInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => (
      <div className="d-flex flex-wrap flex-row">
        {input?.values?.inputFieldTags.map((item, idx) => (
          <div
            className="form-check form-check-inline"
            key={`${item.label}.${idx}`}
          >
            <input
              className="form-check-input "
              // style={{ border: "1px solid black", borderRadius: "10px" }}
              type="radio"
              name={camelCaseKey}
              id={`flexRadioDefault1.${idx}`}
              value={item.value}
              checked={fieldValue === item.value}
              onChange={(e) =>
                setApplicationDetails({
                  ...applicationDetails,
                  [camelCaseKey]: e.target.value,
                })
              }
              max={new Date().toISOString().split("T")[0]}
            />
            <label
              className="form-check-label"
              htmlFor={`flexRadioDefault1.${idx}`}
            >
              {item.label}
            </label>
          </div>
        ))}
      </div>
    );

    // Function to render note
    const renderNote = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => (
      // <></>
      <div className="d-flex flex-wrap fw-bolder mb-3">
        <div
          style={{
            fontFamily: "'Roboto', sans-serif",
            color: "brown",
          }}
          dangerouslySetInnerHTML={{ __html: input?.values?.note }}
        ></div>
      </div>
    );

    // Function to render checkbox input
    const renderCheckboxInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => (
      <>
        {input?.values?.inputFieldTags.map((item, idx) => (
          <div
            className="form-check form-switch mb-2"
            key={`${item.label}.${idx}`}
          >
            <input
              className="form-check-input "
              style={{ borderRadius: "10px", height: "16px" }}
              type="checkbox"
              value={item.value}
              checked={checkedValues.includes(item.value)}
              onChange={(e) => handleCheckboxChange(e, item)}
              id={`flexCheckboxDefault1.${idx}`}
              max={new Date().toISOString().split("T")[0]}
            />
            <label
              className="form-check-label inputBoxHeadForm"
              htmlFor={`flexCheckboxDefault1.${idx}`}
            >
              {item.label}
            </label>
          </div>
        ))}
      </>
    );

    const renderImageInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => (
      <div className="imageDiv d-flex flex-row align-items-center gap-4">
        <div
          style={{
            position: "relative",
            // display: "inline-block",
            width: window.innerWidth > 768 ? "200px" : "100%",
          }}
        >
          <div className="flex-wrap">
            <button
              style={{
                width: "100%",
                borderRadius: "10px",
                height: "40px",
                padding: "5px 15px",
                fontSize: "12px",
                cursor: "pointer",
                // margin: "15px 0",
                border: "none",
                backgroundColor: "#921d1e",
                // fieldErrors?.[camelCaseKey]?.touched &&
                // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                //   ? "#921d1e"
                //   : "#f0f0f0",

                color: "#fff",
                // fieldErrors?.[camelCaseKey]?.touched &&
                // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                //   ? "#fff"
                //   : "#333",
              }}
              onClick={() =>
                document.getElementById(`${camelCaseKey}_imageInput`).click()
              }
              onBlur={(e) => {
                checkErrorFn(input, camelCaseKey, fieldValue);
              }}
            >
              Upload Image
            </button>
            {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              fieldErrors?.[camelCaseKey]?.touched &&
              fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
            <br />
            {fieldValue && !applicationDetails[`${camelCaseKey}verified`] && (
              <span
                key={"Dgf"}
                className="errorPresent"
                style={style.errorSpan}
              >
                {"Please Verify The Image"}
                <br />
              </span>
            )}
          </div>

          <input
            type="file"
            accept="image/*"
            id={`${camelCaseKey}_imageInput`}
            style={{
              // position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              width: "100%",
              // height: "100%",
              display: "none",
              cursor: "pointer",
            }}
            onChange={(e) => {
              //("file-", e);
              handleUploadImage(e, camelCaseKey);
              setApplicationDetails({
                ...applicationDetails,
                [`${camelCaseKey}verified`]: false, // Set verified status to false on image upload
              });
              fieldErrors?.[camelCaseKey]?.touched &&
                checkErrorFn(input, camelCaseKey, e.target.value);
              e.target.value = null;
            }}
            onBlur={(e) => {
              checkErrorFn(input, camelCaseKey, fieldValue);
            }}
          />
        </div>

        {/* Error Display */}

        {/* Image Preview and Verification Button */}
        {applicationDetails[camelCaseKey] && (
          <>
            <img
              key={label}
              src={fieldValue}
              alt={label}
              style={{
                // border: "1px solid black",
                height: "100px",
                width: "100px",
                objectFit: "contain",
              }}
              className="p-2 ms-4"
              onClick={() => SetImageModalOpen(camelCaseKey)}
            />
            <div className="d-flex align-items-center gap-4">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="outline"
                  onClick={() => SetImageModalOpen(camelCaseKey)}
                >
                  <IoEyeOutline size={"20"} />
                </Button>
                <Button
                  className="ms-2"
                  variant="outline"
                  onClick={() => handleUploadImage(null, camelCaseKey)}
                  style={{ marginLeft: "auto" }}
                >
                  <MdDeleteOutline size={"25"}></MdDeleteOutline>
                </Button>
              </div>
              {!applicationDetails[`${camelCaseKey}verified`] && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    className="ms-2 verifybutton verifyBtn"
                    onClick={() => SetImageModalOpen(camelCaseKey)}
                    style={{ marginLeft: "auto" }}
                  >
                    Verify
                  </Button>
                </div>
              )}

              {applicationDetails[`${camelCaseKey}verified`] && (
                <div
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  className={"fw-bold"}
                >
                  <Badge bg="success">
                    <FaCheckCircle size={"18"} className="me-2" />
                    Verified
                  </Badge>
                </div>
              )}
            </div>
          </>
        )}

        {/* Image Modal for Verification */}
        {OpenImageModal && (
          <Modal
            size="sm"
            show={OpenImageModal === camelCaseKey}
            onHide={() => SetImageModalOpen(false)}
            centered
            aria-labelledby="example-custom-modal-styling-title"
          >
            <Modal.Body className="text-center">
              <img
                src={fieldValue}
                key={label}
                alt={label}
                style={{
                  maxHeight: "60vh",
                  objectFit: "contain",
                }}
              />
              {!applicationDetails[camelCaseKey + "verified"] && (
                <Button
                  className="mt-2"
                  style={{ borderRadius: "10px" }}
                  onClick={() => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [`${camelCaseKey}verified`]: true,
                    });
                    SetImageModalOpen(false);
                  }}
                >
                  {"Confirm Verification"}
                </Button>
              )}
              <Button
                className="mt-2"
                style={{ borderRadius: "10px" }}
                variant="secondary"
                onClick={() => SetImageModalOpen(false)}
              >
                Close
              </Button>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
    const renderPdfInputMultiple = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      // Convert fieldValue to array format (handle both legacy string and new array format)
      let fileArray = [];
      const currentValue = applicationDetails[camelCaseKey] || fieldValue;
      if (currentValue) {
        if (typeof currentValue === "string") {
          // Legacy format: comma-separated URLs
          const urls = currentValue.split(",").filter(Boolean);
          fileArray = urls.map((url) => {
            try {
              const queryParams = new URL(url).searchParams;
              const name = queryParams.get("name") || "";
              return { file: url, name: name, verified: false };
            } catch {
              return { file: url, name: "", verified: false };
            }
          });
        } else if (Array.isArray(currentValue)) {
          fileArray = currentValue;
        }
      }

      // Initialize with empty file if array is empty
      if (fileArray.length === 0) {
        fileArray = [{ file: null, name: "", verified: false }];
      }

      const addFile = () => {
        const updatedFiles = [
          ...fileArray,
          { file: null, name: "", verified: false },
        ];
        setApplicationDetails({
          ...applicationDetails,
          [camelCaseKey]: updatedFiles,
        });
      };

      const removeFile = (index) => {
        const updatedFiles = fileArray.filter((_, idx) => idx !== index);
        if (updatedFiles.length === 0) {
          updatedFiles.push({ file: null, name: "", verified: false });
        }
        setApplicationDetails({
          ...applicationDetails,
          [camelCaseKey]: updatedFiles,
        });
        // Trigger validation after removal
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
      };

      const handleFileChange = async (e, index) => {
        const file = e.target.files[0];
        if (file) {
          const isPDF = file.type === "application/pdf";
          if (!isPDF) {
            toast.warn("Invalid file type. Only PDF files are allowed.");
            return;
          }

          const fileUrl = await AWSUpload(file);
          if (fileUrl) {
            const updatedFiles = [...fileArray];
            updatedFiles[index] = {
              ...updatedFiles[index],
              file: fileUrl,
              verified: false,
            };
            setApplicationDetails({
              ...applicationDetails,
              [camelCaseKey]: updatedFiles,
            });
            // Trigger validation after file upload
            setTimeout(() => {
              checkErrorFn(input, camelCaseKey, updatedFiles);
            }, 100);
            e.target.value = null;
          }
        }
      };

      const handleFileNameChange = (e, index) => {
        const { value } = e.target;
        const updatedFiles = [...fileArray];
        updatedFiles[index].name = value;
        setApplicationDetails({
          ...applicationDetails,
          [camelCaseKey]: updatedFiles,
        });
      };

      const handleOpenVerificationModal = (index) => {
        SetImageModalOpen(`${camelCaseKey}_${index}`);
      };

      const handleConfirmVerification = (index) => {
        const updatedFiles = [...fileArray];
        updatedFiles[index].verified = true;
        setApplicationDetails({
          ...applicationDetails,
          [camelCaseKey]: updatedFiles,
        });
        // Trigger validation after verification
        setTimeout(() => {
          checkErrorFn(input, camelCaseKey, updatedFiles);
        }, 100);
        SetImageModalOpen(false);
        toast.success("File verified successfully!");
      };

      return (
        <div className=" gap-4">
          <Row className="mt-2">
            {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              fieldErrors?.[camelCaseKey]?.touched &&
              fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                <span
                  key={idx}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
          </Row>

          <div className="mb-3">
            {fileArray.map((fileObj, index) => (
              <Row key={index} className="align-items-center mb-2">
                {/* File Upload */}
                <Col xs={12} md={3}>
                  <div className="d-flex flex-column">
                    <input
                      type="file"
                      accept=".pdf"
                      onChange={(e) => handleFileChange(e, index)}
                      onBlur={() => {
                        // Trigger validation with current file array
                        const currentValue =
                          applicationDetails[camelCaseKey] || fieldValue;
                        checkErrorFn(input, camelCaseKey, currentValue);
                      }}
                      style={{ display: "none" }}
                      id={`${camelCaseKey}_file_input_${index}`}
                    />
                    <button
                      type="button"
                      onClick={() =>
                        document
                          .getElementById(`${camelCaseKey}_file_input_${index}`)
                          .click()
                      }
                      onBlur={() => {
                        // Trigger validation when button loses focus
                        const currentValue =
                          applicationDetails[camelCaseKey] || fieldValue;
                        checkErrorFn(input, camelCaseKey, currentValue);
                      }}
                      style={{
                        width: "100%",
                        borderRadius: "10px",
                        height: "37px",
                        fontSize: "12px",
                        cursor: "pointer",
                        border: "none",
                        backgroundColor: "#921d1e",
                        color: "#fff",
                      }}
                    >
                      <span>
                        {fileObj.file ? "Choose File" : "Upload File"}
                      </span>
                    </button>
                  </div>
                </Col>

                {/* File Name Input */}
                <Col xs={12} md={4}>
                  <input
                    type="text"
                    placeholder="Enter File Name"
                    value={fileObj.name}
                    onChange={(e) => handleFileNameChange(e, index)}
                    onBlur={() => {
                      // Trigger validation with current file array
                      const currentValue =
                        applicationDetails[camelCaseKey] || fieldValue;
                      checkErrorFn(input, camelCaseKey, currentValue);
                    }}
                    className="form-control"
                    style={style.input}
                  />
                  {!fileObj.name && fileObj.file && (
                    <span className="errorPresent" style={style.errorSpan}>
                      Please enter the file name
                    </span>
                  )}
                </Col>

                {/* Actions: Preview, Verify, Delete */}
                <Col xs={12} md={5} className="d-flex align-items-center">
                  {fileObj.file && (
                    <>
                      <img
                        src={pdfIcon}
                        alt="PDF Preview"
                        style={{ width: "40px", cursor: "pointer" }}
                        onClick={() => handleOpenVerificationModal(index)}
                        className="me-2"
                      />

                      {!fileObj.verified ? (
                        <Button
                          size="sm"
                          onClick={() => handleOpenVerificationModal(index)}
                          className="me-2"
                        >
                          Verify
                        </Button>
                      ) : (
                        <Badge
                          bg="success"
                          className="d-flex align-items-center me-2"
                        >
                          <FaCheckCircle size={"18"} className="me-1" />
                          Verified
                        </Badge>
                      )}

                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleOpenVerificationModal(index)}
                        className="me-2"
                      >
                        <IoEyeOutline size={"20"} />
                      </Button>

                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => removeFile(index)}
                      >
                        <MdDeleteOutline size={"20"} />
                      </Button>
                    </>
                  )}
                </Col>
              </Row>
            ))}

            {/* Add Another Document Button */}
            <div className="text-end">
              <Button
                style={{ backgroundColor: "brown", borderColor: "brown" }}
                onClick={addFile}
              >
                Add File
              </Button>
            </div>
          </div>

          {/* Modal for File Preview and Verification */}
          {OpenImageModal && OpenImageModal.startsWith(`${camelCaseKey}_`) && (
            <Modal
              size="lg"
              show={
                OpenImageModal && OpenImageModal.startsWith(`${camelCaseKey}_`)
              }
              onHide={() => SetImageModalOpen(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Verify Document</Modal.Title>
              </Modal.Header>
              <Modal.Body className="text-center">
                {(() => {
                  const fileIndex = OpenImageModal.split("_").pop();
                  const index = parseInt(fileIndex);
                  const fileObj = fileArray[index];
                  return fileObj?.file ? (
                    <iframe
                      src={fileObj.file}
                      width="100%"
                      style={{ border: "none", height: "50vh" }}
                      title="PDF Viewer"
                    />
                  ) : (
                    <p>No file available for preview.</p>
                  );
                })()}
              </Modal.Body>
              <Modal.Footer>
                {(() => {
                  const fileIndex = OpenImageModal.split("_").pop();
                  const index = parseInt(fileIndex);
                  const fileObj = fileArray[index];
                  return !fileObj?.verified ? (
                    <Button
                      variant="primary"
                      onClick={() => handleConfirmVerification(index)}
                    >
                      Confirm Verification
                    </Button>
                  ) : null;
                })()}
                <Button
                  variant="secondary"
                  onClick={() => SetImageModalOpen(false)}
                >
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          )}
        </div>
      );
    };
    const renderImageInputMultiple = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      // Convert to array format (handle both legacy string and new array format)
      let imageUrls = [];
      const currentValue = applicationDetails[camelCaseKey];
      if (currentValue) {
        if (typeof currentValue === "string") {
          imageUrls = currentValue.split(",").filter(Boolean);
        } else if (Array.isArray(currentValue)) {
          imageUrls = currentValue.map((item) =>
            typeof item === "string" ? item : item?.file || ""
          );
        }
      }

      const handleDeleteImage = (index) => {
        const updatedImageUrls = imageUrls.filter((_, idx) => idx !== index);
        const updatedImageUrlsString =
          Array.isArray(updatedImageUrls) &&
          typeof updatedImageUrls[0] !== "string"
            ? updatedImageUrls.map((item) => item?.file || "").join(",")
            : updatedImageUrls.join(",");
        setApplicationDetails({
          ...applicationDetails,
          [camelCaseKey]: updatedImageUrlsString,
          [`${camelCaseKey}verified`]: false, // Reset verified status
        });
      };

      return (
        <div className="imageDiv d-flex align-items-center gap-0">
          <div
            style={{
              position: "relative",
              display: "inline-block",
              width: window.innerWidth > 768 ? "200px" : "100%",
            }}
          >
            <div className="flex-wrap">
              <button
                style={{
                  width: "100%",
                  borderRadius: "10px",
                  height: "40px",
                  padding: "5px 15px",
                  fontSize: "12px",
                  cursor: "pointer",
                  // margin: "15px 0",
                  marginTop: "0",
                  border: "none",
                  backgroundColor: "#921d1e",
                  // fieldErrors?.[camelCaseKey]?.touched &&
                  // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                  //   ? "#921d1e"
                  //   : "#f0f0f0",
                  color: "#fff",
                  // fieldErrors?.[camelCaseKey]?.touched &&
                  // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                  //   ? "#fff"
                  //   : "#333",
                }}
                onClick={() =>
                  document.getElementById(`${camelCaseKey}_imageInput`).click()
                }
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
              >
                Upload Images
              </button>
              <br />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                  <span
                    key={idx}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
              <br />
              {fieldValue && !applicationDetails[`${camelCaseKey}verified`] && (
                <span
                  key={"Dgf"}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {"Please Verify The Images"}
                  <br />
                </span>
              )}
            </div>

            <input
              type="file"
              accept="image/*"
              multiple
              id={`${camelCaseKey}_imageInput`}
              style={{
                // position: "absolute",
                top: 0,
                left: 0,
                opacity: 0,
                width: "100%",
                // height: "100%",
                display: "none",
                cursor: "pointer",
              }}
              onChange={(e) => {
                handleUploadImages(
                  e,
                  camelCaseKey,
                  applicationDetails,
                  setApplicationDetails
                );
                fieldErrors?.[camelCaseKey]?.touched &&
                  checkErrorFn(input, camelCaseKey, e.target.value);
                e.target.value = null;
              }}
              onBlur={(e) => {
                checkErrorFn(input, camelCaseKey, fieldValue);
              }}
            />
          </div>

          {/* Display Multiple Images */}
          {/* Document upload  image other relevent Imgs */}
          {imageUrls.length > 0 && (
            <>
              <div className=" ">
                {imageUrls.map((url, index) => (
                  <div
                    key={index}
                    className="m-2 mt-1 ms-2 d-flex gap-3"
                    // style={{ display: 'inline-block' }}
                  >
                    <img
                      src={url}
                      alt={`${label} ${index + 1}`}
                      style={{
                        height: "60px",
                        width: "85px",
                        objectFit: "contain",
                      }}
                      className="p-2"
                      onClick={() => SetImageModalOpen(true)}
                    />
                    <Button
                      className="ms-2 p-0 m-0"
                      variant="outline"
                      // style={{ top: '20px', right: '-18px' }}
                      size="sm"
                      onClick={() => SetImageModalOpen(true)}
                    >
                      <IoEyeOutline size={"25"} />
                    </Button>
                    <Button
                      className="p-0 m-0 "
                      variant="outline"
                      // style={{ top: '20px', right: '-40px' }}

                      size="sm"
                      onClick={() => handleDeleteImage(index)}
                    >
                      <MdDeleteOutline size={"25"} />
                    </Button>
                  </div>
                ))}
              </div>

              {!applicationDetails[`${camelCaseKey}verified`] && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    className="ms-3 verifybutton verifyBtn"
                    onClick={() => SetImageModalOpen(camelCaseKey)}
                    style={{ marginLeft: "auto" }}
                  >
                    Verify
                  </Button>
                </div>
              )}

              {applicationDetails[`${camelCaseKey}verified`] && (
                <div
                  style={{ display: "flex", justifyContent: "flex-end" }}
                  className={"fw-bold ms-3"}
                >
                  <Badge bg="success">
                    <FaCheckCircle size={"18"} className="me-2" />
                    Verified
                  </Badge>
                </div>
              )}
            </>
          )}

          {/* Image Modal for Verification */}
          {OpenImageModal && (
            <Modal
              size="lg"
              show={OpenImageModal == camelCaseKey}
              onHide={() => SetImageModalOpen(false)}
              centered
              aria-labelledby="example-custom-modal-styling-title"
            >
              <Modal.Body className="text-center">
                <ImageCarousel
                  imageUrls={imageUrls}
                  label={label}
                  applicationDetails={applicationDetails}
                  setApplicationDetails={setApplicationDetails}
                  camelCaseKey={camelCaseKey}
                  SetImageModalOpen={SetImageModalOpen}
                />
              </Modal.Body>
            </Modal>
          )}
        </div>
      );
    };

    const ImageCarousel = ({
      imageUrls,
      label,
      applicationDetails,
      setApplicationDetails,
      camelCaseKey,
      SetImageModalOpen,
    }) => {
      const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

      // Reset currentImageIndex when modal opens
      React.useEffect(() => {
        setCurrentImageIndex(0);
      }, []);

      const handleNext = () => {
        if (currentImageIndex < imageUrls.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        }
      };

      const handlePrev = () => {
        if (currentImageIndex > 0) {
          setCurrentImageIndex(currentImageIndex - 1);
        }
      };

      const isLastImage = currentImageIndex === imageUrls.length - 1;

      return (
        <>
          <img
            src={imageUrls[currentImageIndex]}
            alt={`${label} ${currentImageIndex + 1}`}
            style={{
              maxHeight: "80vh",
              objectFit: "contain",
              marginBottom: "10px",
            }}
          />

          <div className="d-flex justify-content-center mb-2">
            <Button
              className="me-2"
              variant="secondary-primary"
              disabled={currentImageIndex === 0}
              onClick={handlePrev}
            >
              <FaArrowAltCircleLeft size={30} />
            </Button>
            <Button
              variant="secondary-primary"
              disabled={currentImageIndex === imageUrls.length - 1}
              onClick={handleNext}
            >
              <FaArrowAltCircleRight size={30} />
            </Button>
          </div>
          {!applicationDetails[`${camelCaseKey}verified`] && isLastImage && (
            <Button
              className="mt-2"
              style={{ borderRadius: "10px" }}
              onClick={() => {
                const updatedDetails = {
                  ...applicationDetails,
                  [`${camelCaseKey}verified`]: true,
                };
                setApplicationDetails(updatedDetails);

                // Save verification status to sessionStorage for persistence
                const userId = sessionStorage.getItem("userId");
                if (userId) {
                  const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                  sessionStorage.setItem(sessionVerificationKey, "true");
                }

                // Clear verification errors
                setFieldErrors((prevErrors) => {
                  const currentErrors = prevErrors[camelCaseKey]?.errors || [];
                  const filteredErrors = currentErrors.filter(
                    (err) =>
                      !err.includes("verify") &&
                      !err.includes("Verify") &&
                      !err.includes("verification") &&
                      !err.includes("Please Verify The Images") &&
                      !err.includes(
                        "Please verify the uploaded document before proceeding."
                      ) &&
                      !err.includes(
                        "Please verify all uploaded documents before proceeding."
                      )
                  );
                  return {
                    ...prevErrors,
                    [camelCaseKey]: {
                      errors: filteredErrors,
                      touched: true,
                    },
                  };
                });

                SetImageModalOpen(false);
                toast.success("Document verified successfully");
              }}
            >
              Confirm Verification
            </Button>
          )}
          <Button
            className="mt-2"
            style={{ borderRadius: "10px" }}
            variant="secondary"
            onClick={() => SetImageModalOpen(false)}
          >
            Close
          </Button>
        </>
      );
    };

    const PdfCarousel = ({
      imageUrls,
      label,
      applicationDetails,
      setApplicationDetails,
      camelCaseKey,
      SetImageModalOpen,
    }) => {
      const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

      // Reset currentImageIndex when modal opens
      React.useEffect(() => {
        setCurrentImageIndex(0);
      }, []);

      const handleNext = () => {
        if (currentImageIndex < imageUrls.length - 1) {
          setCurrentImageIndex(currentImageIndex + 1);
        }
      };

      const handlePrev = () => {
        if (currentImageIndex > 0) {
          setCurrentImageIndex(currentImageIndex - 1);
        }
      };

      const isLastImage = currentImageIndex === imageUrls.length - 1;

      return (
        <>
          <iframe
            src={imageUrls[currentImageIndex]}
            width="100%"
            style={{ border: "none", height: "80vh" }}
            title="PDF Viewer"
          />

          <div className="d-flex justify-content-center mb-2">
            <Button
              className="me-2"
              variant="secondary-primary"
              disabled={currentImageIndex === 0}
              onClick={handlePrev}
            >
              <FaArrowAltCircleLeft size={30} />
            </Button>
            <Button
              variant="secondary-primary"
              disabled={currentImageIndex === imageUrls.length - 1}
              onClick={handleNext}
            >
              <FaArrowAltCircleRight size={30} />
            </Button>
          </div>
          {!applicationDetails[`${camelCaseKey}verified`] && isLastImage && (
            <Button
              className="mt-2"
              style={{ borderRadius: "10px" }}
              onClick={() => {
                const updatedDetails = {
                  ...applicationDetails,
                  [`${camelCaseKey}verified`]: true,
                };
                setApplicationDetails(updatedDetails);

                // Save verification status to sessionStorage for persistence
                const userId = sessionStorage.getItem("userId");
                if (userId) {
                  const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                  sessionStorage.setItem(sessionVerificationKey, "true");
                }

                // Clear verification errors
                setFieldErrors((prevErrors) => {
                  const currentErrors = prevErrors[camelCaseKey]?.errors || [];
                  const filteredErrors = currentErrors.filter(
                    (err) =>
                      !err.includes("verify") &&
                      !err.includes("Verify") &&
                      !err.includes("verification") &&
                      !err.includes("Please Verify The Images") &&
                      !err.includes(
                        "Please verify the uploaded document before proceeding."
                      ) &&
                      !err.includes(
                        "Please verify all uploaded documents before proceeding."
                      )
                  );
                  return {
                    ...prevErrors,
                    [camelCaseKey]: {
                      errors: filteredErrors,
                      touched: true,
                    },
                  };
                });

                SetImageModalOpen(false);
                toast.success("Document verified successfully");
              }}
            >
              Confirm Verification
            </Button>
          )}
          <Button
            className="mt-2"
            style={{ borderRadius: "10px" }}
            variant="secondary"
            onClick={() => SetImageModalOpen(false)}
          >
            Close
          </Button>
        </>
      );
    };

    const renderPdfInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      //("cmlkeyins", camelCaseKey);
      // (camelCaseKey==="6719d8603ac83738a0ba5fd7" && applicationDetails["66a728ec9680c25e280d6bf6"]==="CGPA")||
      // (camelCaseKey==="6719d9653ac83738a0ba6155" && applicationDetails["66a687874db5f02d6861ed0e"]==="CGPA")

      if (camelCaseKey === "6719d53d3ac83738a0ba587a") {
        //("found here");
        if (
          applicationDetails["66a687874db5f02d6861ed04"] === "CGPA/OGPA" ||
          applicationDetails["66a687874db5f02d6861ed04"] === "Grade"
        ) {
          return (
            <div className="imageDiv d-flex align-items-center gap-4">
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: window.innerWidth > 768 ? "200px" : "100%",
                }}
              >
                <div className="d-flex flex-column">
                  <button
                    className="me-4"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      height: "40px",
                      padding: "5px 15px",
                      fontSize: "12px",
                      cursor: "pointer",
                      // margin: '15px 0',
                      marginTop: "0",
                      border: "none",
                      backgroundColor: "#921d1e",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#921d1e"
                      //   : "#f0f0f0", // Error background color

                      // border:
                      //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //     ? "1px solid red"
                      //     : "1px solid #ccc", // Error border
                      color: "#fff",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#fff"
                      //   : "#333", // Error background color
                    }}
                    onClick={() =>
                      document
                        .getElementById(`${camelCaseKey}_fileInput`)
                        .click()
                    }
                  >
                    Upload File
                  </button>
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                  {fieldValue &&
                    !applicationDetails[`${camelCaseKey}verified`] && (
                      <span
                        key={"Dgf"}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {"Please Verify The File"}
                        <br />
                      </span>
                    )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  id={`${camelCaseKey}_fileInput`}
                  style={{
                    // position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    // height: "100%",
                    display: "none",
                    cursor: "pointer",
                  }}
                  onChange={async (e) => {
                    const uploadedUrl = await handleUploadImage(
                      e,
                      camelCaseKey
                    );
                    setApplicationDetails((prev) => ({
                      ...prev,
                      [`${camelCaseKey}verified`]: false,
                    }));

                    // Validate after upload completes using the actual uploaded URL
                    if (fieldErrors?.[camelCaseKey]?.touched && input) {
                      checkErrorFn(input, camelCaseKey, uploadedUrl || "");
                    }

                    e.target.value = null;
                  }}
                  onBlur={(e) => {
                    // Mark field as touched and validate
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                />
              </div>

              {applicationDetails[camelCaseKey] && (
                <div className="d-flex align-items-center gap-4">
                  <img
                    src={pdfIcon}
                    alt="PDF preview"
                    style={{
                      marginLeft: "10px",
                      width: "50px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowIframe(camelCaseKey);
                    }}
                  />
                  {!applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="ms-2 verifybutton verifyBtn"
                        onClick={() => setShowIframe(camelCaseKey)}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      className={"fw-bold"}
                    >
                      <Badge bg="success">
                        <FaCheckCircle size={"18"} className="me-2" />
                        Verified
                      </Badge>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      variant="outline"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      <IoEyeOutline size={"20"} />
                    </Button>
                    <Button
                      className="ms-2"
                      variant="outline"
                      onClick={() => handleUploadImage(null, camelCaseKey)}
                      style={{ marginLeft: "auto" }}
                    >
                      {/* <Badge bg="danger" > */}
                      <MdDeleteOutline size={"20"} />
                      {/* <span className='ps-2'>Delete</span> */}
                      {/* </Badge> */}
                      {/* <MdDeleteOutline size={"25"}></MdDeleteOutline> */}
                    </Button>
                  </div>
                </div>
              )}

              {showIframe && (
                <Modal
                  show={showIframe === camelCaseKey}
                  onHide={() => setShowIframe(false)}
                  size="lg"
                  centered
                  style={{ zIndex: 10000 }}
                >
                  <Modal.Header
                    style={{
                      borderBottom: "1px solid #dee2e6",
                      backgroundColor: "#f8f9fa",
                      padding: "12px 20px",
                    }}
                  >
                    <Modal.Title
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#212529",
                      }}
                    >
                      <i
                        className="bi bi-file-earmark-pdf me-2"
                        style={{ color: "#dc3545" }}
                      ></i>
                      Document Preview - {label || "Document"}
                    </Modal.Title>
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => setShowIframe(false)}
                    >
                      <i className="bi bi-x-lg me-1"></i>
                      Close
                    </Button>
                  </Modal.Header>
                  <Modal.Body
                    className="text-center"
                    style={{
                      padding: "0",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <iframe
                      src={fieldValue}
                      width="100%"
                      style={{
                        border: "none",
                        height: "80vh",
                        display: "block",
                      }}
                      title="PDF Viewer"
                      type="application/pdf"
                    />
                    {!applicationDetails[camelCaseKey + "verified"] && (
                      <Button
                        className="mt-2 mb-2"
                        variant="success"
                        onClick={() => {
                          const updatedDetails = {
                            ...applicationDetails,
                            [`${camelCaseKey}verified`]: true,
                          };
                          setApplicationDetails(updatedDetails);

                          const userId = sessionStorage.getItem("userId");
                          if (userId) {
                            const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                            sessionStorage.setItem(
                              sessionVerificationKey,
                              "true"
                            );
                          }

                          // Clear verification errors
                          setFieldErrors((prevErrors) => {
                            const currentErrors =
                              prevErrors[camelCaseKey]?.errors || [];
                            const filteredErrors = currentErrors.filter(
                              (err) =>
                                !err.includes("verify") &&
                                !err.includes("Verify") &&
                                !err.includes("verification") &&
                                !err.includes("Please Verify The File") &&
                                !err.includes(
                                  "Please verify the uploaded document before proceeding."
                                ) &&
                                !err.includes(
                                  "Please verify all uploaded documents before proceeding."
                                )
                            );
                            return {
                              ...prevErrors,
                              [camelCaseKey]: {
                                errors: filteredErrors,
                                touched: true,
                              },
                            };
                          });

                          toast.success("Document verified successfully");
                          setShowIframe(false);

                          // Re-validate to ensure error is cleared
                          setTimeout(() => {
                            if (input) {
                              checkErrorFn(input, camelCaseKey, fieldValue);
                            }
                          }, 100);
                        }}
                      >
                        Confirm Verification
                      </Button>
                    )}
                    <Button
                      className="mt-2 mb-2"
                      variant="secondary"
                      onClick={() => setShowIframe(false)}
                    >
                      Close
                    </Button>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          );
        }
      } else if (camelCaseKey === "6719d8603ac83738a0ba5fd7") {
        //("found here");
        if (
          applicationDetails["66a728ec9680c25e280d6bf6"] === "CGPA/OGPA" ||
          applicationDetails["66a728ec9680c25e280d6bf6"] === "Grade"
        ) {
          return (
            <div className="imageDiv d-flex align-items-center gap-4">
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: window.innerWidth > 768 ? "200px" : "100%",
                }}
              >
                <div className="d-flex flex-column">
                  <button
                    className="me-4"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      height: "40px",
                      padding: "5px 15px",
                      fontSize: "12px",
                      cursor: "pointer",
                      // margin: "15px 0",
                      marginTop: "0",
                      border: "none",
                      backgroundColor: "#921d1e",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#921d1e"
                      //   : "#f0f0f0", // Error background color

                      // border:
                      //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //     ? "1px solid red"
                      //     : "1px solid #ccc", // Error border
                      color: "#fff",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#fff"
                      //   : "#333", // Error background color
                    }}
                    onClick={() =>
                      document
                        .getElementById(`${camelCaseKey}_fileInput`)
                        .click()
                    }
                  >
                    Upload File
                  </button>
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                  {fieldValue &&
                    !applicationDetails[`${camelCaseKey}verified`] && (
                      <span
                        key={"Dgf"}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {"Please Verify The File"}
                        <br />
                      </span>
                    )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  id={`${camelCaseKey}_fileInput`}
                  style={{
                    // position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    // height: "100%",
                    cursor: "pointer",
                    display: "none",
                  }}
                  onChange={async (e) => {
                    const uploadedUrl = await handleUploadImage(
                      e,
                      camelCaseKey
                    );
                    setApplicationDetails((prev) => ({
                      ...prev,
                      [`${camelCaseKey}verified`]: false,
                    }));

                    // Always mark field as touched and validate after upload completes
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));

                    // Validate after upload completes using the actual uploaded URL
                    if (input) {
                      checkErrorFn(input, camelCaseKey, uploadedUrl || "");
                    }

                    e.target.value = null;
                  }}
                  onBlur={(e) => {
                    // Mark field as touched and validate
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                />
              </div>

              {applicationDetails[camelCaseKey] && (
                <div className="d-flex align-items-center gap-4">
                  <img
                    src={pdfIcon}
                    alt="PDF preview"
                    style={{
                      marginLeft: "10px",
                      width: "50px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowIframe(camelCaseKey);
                    }}
                  />
                  {!applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="ms-2 verifybutton verifyBtn"
                        onClick={() => setShowIframe(camelCaseKey)}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      className={"fw-bold"}
                    >
                      <Badge bg="success">
                        <FaCheckCircle size={"18"} className="me-2" />
                        Verified
                      </Badge>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      variant="outline"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      <IoEyeOutline size={"20"} />
                    </Button>
                    <Button
                      className="ms-2"
                      variant="outline"
                      onClick={() => handleUploadImage(null, camelCaseKey)}
                      style={{ marginLeft: "auto" }}
                    >
                      {/* <Badge bg="danger" > */}
                      <MdDeleteOutline size={"20"} />
                      {/* <span className='ps-2'>Delete</span> */}
                      {/* </Badge> */}
                      {/* <MdDeleteOutline size={"25"}></MdDeleteOutline> */}
                    </Button>
                  </div>
                </div>
              )}

              {showIframe && (
                <Modal
                  size="lg"
                  show={showIframe === camelCaseKey}
                  onHide={() => setShowIframe(false)}
                  centered
                  aria-labelledby="example-custom-modal-styling-title"
                >
                  <Modal.Body className="text-center">
                    <iframe
                      src={fieldValue}
                      width="100%"
                      style={{ border: "none", height: "80vh" }}
                      title="PDF Viewer"
                      type="application/pdf"
                    />
                    <div className="mt-2">
                      <a
                        href={fieldValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link"
                      >
                        Open in new tab
                      </a>
                    </div>
                    {!applicationDetails[camelCaseKey + "verified"] && (
                      <Button
                        className="mt-2"
                        style={{ borderRadius: "10px" }}
                        onClick={() => {
                          const updatedDetails = {
                            ...applicationDetails,
                            [`${camelCaseKey}verified`]: true,
                          };
                          setApplicationDetails(updatedDetails);

                          // Save verification status to sessionStorage for persistence
                          const userId = sessionStorage.getItem("userId");
                          if (userId) {
                            const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                            sessionStorage.setItem(
                              sessionVerificationKey,
                              "true"
                            );
                          }

                          setShowIframe(false);
                          toast.success("Document verified successfully");
                        }}
                      >
                        {"Confirm Verification"}
                      </Button>
                    )}
                    <Button
                      className="mt-2"
                      style={{ borderRadius: "10px" }}
                      variant="secondary"
                      onClick={() => setShowIframe(false)}
                    >
                      Close
                    </Button>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          );
        }
      } else if (camelCaseKey === "6719d9653ac83738a0ba6155") {
        //("found here");
        if (
          applicationDetails["66a687874db5f02d6861ed0e"] === "CGPA/OGPA" ||
          applicationDetails["66a687874db5f02d6861ed0e"] === "Grade"
        ) {
          return (
            <div className="imageDiv d-flex align-items-center gap-4">
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: window.innerWidth > 768 ? "200px" : "100%",
                }}
              >
                <div className="d-flex flex-column">
                  <button
                    className="me-4"
                    style={{
                      width: "100%",
                      borderRadius: "10px",

                      height: "40px",
                      padding: "5px 15px",
                      fontSize: "12px",
                      cursor: "pointer",
                      marginTop: "0",
                      // margin: "15px 0",
                      border: "none",
                      backgroundColor: "#921d1e",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#921d1e"
                      //   : "#f0f0f0", // Error background color

                      // border:
                      //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //     ? "1px solid red"
                      //     : "1px solid #ccc", // Error border
                      color: "#fff",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#fff"
                      //   : "#333", // Error background color
                    }}
                    onClick={() =>
                      document
                        .getElementById(`${camelCaseKey}_fileInput`)
                        .click()
                    }
                  >
                    Upload File
                  </button>

                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors
                      ?.filter((err) => {
                        // Don't show verification errors if document is verified
                        if (applicationDetails[`${camelCaseKey}verified`]) {
                          return (
                            !err.includes("verify") &&
                            !err.includes("Verify") &&
                            !err.includes("verification") &&
                            !err.includes("Please Verify The File") &&
                            !err.includes(
                              "Please verify the uploaded document before proceeding."
                            ) &&
                            !err.includes(
                              "Please verify all uploaded documents before proceeding."
                            )
                          );
                        }
                        return true;
                      })
                      ?.map((err, idx) => (
                        <span
                          key={idx}
                          className="errorPresent"
                          style={style.errorSpan}
                        >
                          {err}
                          <br />
                        </span>
                      ))}
                  <br />
                  {fieldValue &&
                    !applicationDetails[`${camelCaseKey}verified`] && (
                      <span
                        key={"Dgf"}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {"Please Verify The File"}
                        <br />
                      </span>
                    )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  id={`${camelCaseKey}_fileInput`}
                  style={{
                    // position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    // height: "100%",
                    display: "none",
                    cursor: "pointer",
                  }}
                  onChange={async (e) => {
                    const uploadedUrl = await handleUploadImage(
                      e,
                      camelCaseKey
                    );
                    setApplicationDetails((prev) => ({
                      ...prev,
                      [`${camelCaseKey}verified`]: false,
                    }));

                    // Always mark field as touched and validate after upload completes
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));

                    // Validate after upload completes using the actual uploaded URL
                    if (input) {
                      checkErrorFn(input, camelCaseKey, uploadedUrl || "");
                    }

                    e.target.value = null;
                  }}
                  onBlur={(e) => {
                    // Mark field as touched and validate
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                />
              </div>

              {applicationDetails[camelCaseKey] && (
                <div className="d-flex align-items-center gap-4">
                  <img
                    src={pdfIcon}
                    alt="PDF preview"
                    style={{
                      marginLeft: "10px",
                      width: "50px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowIframe(camelCaseKey);
                    }}
                  />
                  {!applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="ms-2 verifybutton verifyBtn"
                        onClick={() => setShowIframe(camelCaseKey)}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      className={"fw-bold"}
                    >
                      <Badge bg="success">
                        <FaCheckCircle size={"18"} className="me-2" />
                        Verified
                      </Badge>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      variant="outline"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      <IoEyeOutline size={"20"} />
                    </Button>
                    <Button
                      className="ms-2"
                      variant="outline"
                      onClick={() => handleUploadImage(null, camelCaseKey)}
                      style={{ marginLeft: "auto" }}
                    >
                      {/* <Badge bg="danger" > */}
                      <MdDeleteOutline size={"20"} />
                      {/* <span className='ps-2'>Delete</span> */}
                      {/* </Badge> */}
                      {/* <MdDeleteOutline size={"25"}></MdDeleteOutline> */}
                    </Button>
                  </div>
                </div>
              )}

              {showIframe && (
                <Modal
                  size="lg"
                  show={showIframe === camelCaseKey}
                  onHide={() => setShowIframe(false)}
                  centered
                  aria-labelledby="example-custom-modal-styling-title"
                >
                  <Modal.Body className="text-center">
                    <iframe
                      src={fieldValue}
                      width="100%"
                      style={{ border: "none", height: "80vh" }}
                      title="PDF Viewer"
                      type="application/pdf"
                    />
                    <div className="mt-2">
                      <a
                        href={fieldValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link"
                      >
                        Open in new tab
                      </a>
                    </div>
                    {!applicationDetails[camelCaseKey + "verified"] && (
                      <Button
                        className="mt-2"
                        style={{ borderRadius: "10px" }}
                        onClick={() => {
                          const updatedDetails = {
                            ...applicationDetails,
                            [`${camelCaseKey}verified`]: true,
                          };
                          setApplicationDetails(updatedDetails);

                          // Save verification status to sessionStorage for persistence
                          const userId = sessionStorage.getItem("userId");
                          if (userId) {
                            const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                            sessionStorage.setItem(
                              sessionVerificationKey,
                              "true"
                            );
                          }

                          // Clear verification error after verification
                          setFieldErrors((prevState) => {
                            const currentErrors =
                              prevState?.[camelCaseKey]?.errors || [];
                            const filteredErrors = currentErrors.filter(
                              (error) =>
                                !error.includes("verify") &&
                                !error.includes("Verify") &&
                                !error.includes("verification") &&
                                !error.includes("Please verify")
                            );
                            return {
                              ...prevState,
                              [camelCaseKey]: {
                                errors: filteredErrors,
                                touched:
                                  prevState?.[camelCaseKey]?.touched || true,
                              },
                            };
                          });

                          // Trigger validation to update error state
                          setTimeout(() => {
                            if (input) {
                              checkErrorFn(
                                input,
                                camelCaseKey,
                                updatedDetails[camelCaseKey] || ""
                              );
                            }
                          }, 100);

                          setShowIframe(false);
                          toast.success("Document verified successfully");
                        }}
                      >
                        {"Confirm Verification"}
                      </Button>
                    )}
                    <Button
                      className="mt-2"
                      style={{ borderRadius: "10px" }}
                      variant="secondary"
                      onClick={() => setShowIframe(false)}
                    >
                      Close
                    </Button>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          );
        }
      } else if (camelCaseKey === "676a57139e167618b7ec04b5") {
        if (
          applicationDetails["676a57139e167618b7ec04ab"] == "CGPA/OGPA" ||
          applicationDetails["676a57139e167618b7ec04ab"] === "Grade"
        ) {
          return (
            <div className="imageDiv d-flex align-items-center gap-4">
              <div style={{ position: "relative", display: "inline-block" }}>
                <div className="d-flex flex-column">
                  <button
                    className="me-4"
                    style={{
                      borderRadius: "10px",
                      height: "40px",
                      padding: "5px 15px",
                      fontSize: "12px",
                      cursor: "pointer",
                      margin: "15px 0",
                      border: "none",
                      backgroundColor: "#921d1e",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#921d1e"
                      //   : "#f0f0f0", // Error background color

                      // border:
                      //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //     ? "1px solid red"
                      //     : "1px solid #ccc", // Error border
                      color: "#fff",
                      // fieldErrors?.[camelCaseKey]?.touched &&
                      // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                      //   ? "#fff"
                      //   : "#333", // Error background color
                    }}
                    onClick={() =>
                      document
                        .getElementById(`${camelCaseKey}_fileInput`)
                        .click()
                    }
                  >
                    Upload File
                  </button>

                  <br />
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                  <br />
                  {fieldValue &&
                    !applicationDetails[`${camelCaseKey}verified`] && (
                      <span
                        key={"Dgf"}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {"Please Verify The File"}
                        <br />
                      </span>
                    )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  id={`${camelCaseKey}_fileInput`}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  onChange={async (e) => {
                    const uploadedUrl = await handleUploadImage(
                      e,
                      camelCaseKey
                    );
                    setApplicationDetails((prev) => ({
                      ...prev,
                      [`${camelCaseKey}verified`]: false,
                    }));

                    // Validate after upload completes using the actual uploaded URL
                    if (fieldErrors?.[camelCaseKey]?.touched && input) {
                      checkErrorFn(input, camelCaseKey, uploadedUrl || "");
                    }

                    e.target.value = null;
                  }}
                  onBlur={(e) => {
                    // Mark field as touched and validate
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                />
              </div>

              {applicationDetails[camelCaseKey] && (
                <>
                  <img
                    src={pdfIcon}
                    alt="PDF preview"
                    style={{
                      marginLeft: "10px",
                      width: "40px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowIframe(camelCaseKey);
                    }}
                  />
                  {!applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="ms-2 verifybutton verifyBtn"
                        onClick={() => setShowIframe(camelCaseKey)}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      className={"fw-bold"}
                    >
                      <Badge bg="success">
                        <FaCheckCircle size={"18"} className="me-2" />
                        Verified
                      </Badge>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      variant="outline"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      <IoEyeOutline size={"20"} />
                    </Button>
                    <Button
                      className="ms-2"
                      variant="outline"
                      onClick={() => handleUploadImage(null, camelCaseKey)}
                      style={{ marginLeft: "auto" }}
                    >
                      {/* <Badge bg="danger" > */}
                      <MdDeleteOutline size={"20"} />
                      {/* <span className='ps-2'>Delete</span> */}
                      {/* </Badge> */}
                      {/* <MdDeleteOutline size={"25"}></MdDeleteOutline> */}
                    </Button>
                  </div>
                </>
              )}

              {showIframe && (
                <Modal
                  size="lg"
                  show={showIframe === camelCaseKey}
                  onHide={() => setShowIframe(false)}
                  centered
                  aria-labelledby="example-custom-modal-styling-title"
                >
                  <Modal.Body className="text-center">
                    <iframe
                      src={fieldValue}
                      width="100%"
                      style={{ border: "none", height: "80vh" }}
                      title="PDF Viewer"
                      type="application/pdf"
                    />
                    <div className="mt-2">
                      <a
                        href={fieldValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link"
                      >
                        Open in new tab
                      </a>
                    </div>
                    {!applicationDetails[camelCaseKey + "verified"] && (
                      <Button
                        className="mt-2"
                        style={{ borderRadius: "10px" }}
                        onClick={() => {
                          const updatedDetails = {
                            ...applicationDetails,
                            [`${camelCaseKey}verified`]: true,
                          };
                          setApplicationDetails(updatedDetails);

                          // Save verification status to sessionStorage for persistence
                          const userId = sessionStorage.getItem("userId");
                          if (userId) {
                            const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                            sessionStorage.setItem(
                              sessionVerificationKey,
                              "true"
                            );
                          }

                          setShowIframe(false);
                          toast.success("Document verified successfully");
                        }}
                      >
                        {"Confirm Verification"}
                      </Button>
                    )}
                    <Button
                      className="mt-2"
                      style={{ borderRadius: "10px" }}
                      variant="secondary"
                      onClick={() => setShowIframe(false)}
                    >
                      Close
                    </Button>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          );
        }
      } else if (camelCaseKey === "68ecd888eb422bea55aa71b8") {
        // LLB Conversion Formula
        if (
          applicationDetails["68ecd888eb422bea55aa71ae"] === "CGPA/OGPA" ||
          applicationDetails["68ecd888eb422bea55aa71ae"] === "Grade"
        ) {
          return (
            <div className="imageDiv d-flex align-items-center gap-4">
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: window.innerWidth > 768 ? "200px" : "100%",
                }}
              >
                <div className="d-flex flex-column">
                  <button
                    className="me-4"
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      height: "40px",
                      padding: "5px 15px",
                      fontSize: "12px",
                      cursor: "pointer",
                      marginTop: "0",
                      border: "none",
                      backgroundColor: "#921d1e",
                      color: "#fff",
                    }}
                    onClick={() =>
                      document
                        .getElementById(`${camelCaseKey}_fileInput`)
                        .click()
                    }
                  >
                    Upload File
                  </button>
                  {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched &&
                    fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                      <span
                        key={idx}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {err}
                        <br />
                      </span>
                    ))}
                  <br />
                  {fieldValue &&
                    !applicationDetails[`${camelCaseKey}verified`] && (
                      <span
                        key={"Dgf"}
                        className="errorPresent"
                        style={style.errorSpan}
                      >
                        {"Please Verify The File"}
                        <br />
                      </span>
                    )}
                </div>
                <input
                  type="file"
                  accept="application/pdf"
                  id={`${camelCaseKey}_fileInput`}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    width: "100%",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  onChange={async (e) => {
                    const uploadedUrl = await handleUploadImage(
                      e,
                      camelCaseKey
                    );
                    setApplicationDetails((prev) => ({
                      ...prev,
                      [`${camelCaseKey}verified`]: false,
                    }));

                    // Validate after upload completes using the actual uploaded URL
                    if (fieldErrors?.[camelCaseKey]?.touched && input) {
                      checkErrorFn(input, camelCaseKey, uploadedUrl || "");
                    }

                    e.target.value = null;
                  }}
                  onBlur={(e) => {
                    // Mark field as touched and validate
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        ...prevState?.[camelCaseKey],
                        touched: true,
                      },
                    }));
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                />
              </div>

              {applicationDetails[camelCaseKey] && (
                <div className="d-flex align-items-center gap-4">
                  <img
                    src={pdfIcon}
                    alt="PDF preview"
                    style={{
                      marginLeft: "10px",
                      width: "50px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setShowIframe(camelCaseKey);
                    }}
                  />
                  {!applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="ms-2 verifybutton verifyBtn"
                        onClick={() => setShowIframe(camelCaseKey)}
                      >
                        Verify
                      </Button>
                    </div>
                  )}

                  {applicationDetails[`${camelCaseKey}verified`] && (
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                      className={"fw-bold"}
                    >
                      <Badge bg="success">
                        <FaCheckCircle size={"18"} className="me-2" />
                        Verified
                      </Badge>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      style={{ marginLeft: "0px" }}
                      variant="outline"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      <IoEyeOutline size={"20"} />
                    </Button>
                    <Button
                      className="ms-2"
                      variant="outline"
                      onClick={() => handleUploadImage(null, camelCaseKey)}
                      style={{ marginLeft: "auto" }}
                    >
                      <MdDeleteOutline size={"20"} />
                    </Button>
                  </div>
                </div>
              )}

              {showIframe && (
                <Modal
                  size="lg"
                  show={showIframe === camelCaseKey}
                  onHide={() => setShowIframe(false)}
                  centered
                  aria-labelledby="example-custom-modal-styling-title"
                >
                  <Modal.Body className="text-center">
                    <iframe
                      src={fieldValue}
                      width="100%"
                      style={{ border: "none", height: "80vh" }}
                      title="PDF Viewer"
                      type="application/pdf"
                    />
                    <div className="mt-2">
                      <a
                        href={fieldValue}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-link"
                      >
                        Open in new tab
                      </a>
                    </div>
                    {!applicationDetails[camelCaseKey + "verified"] && (
                      <Button
                        className="mt-2"
                        style={{ borderRadius: "10px" }}
                        onClick={() => {
                          const updatedDetails = {
                            ...applicationDetails,
                            [`${camelCaseKey}verified`]: true,
                          };
                          setApplicationDetails(updatedDetails);

                          // Save verification status to sessionStorage for persistence
                          const userId = sessionStorage.getItem("userId");
                          if (userId) {
                            const sessionVerificationKey = `verification_${userId}_${camelCaseKey}`;
                            sessionStorage.setItem(
                              sessionVerificationKey,
                              "true"
                            );
                          }

                          setShowIframe(false);
                          toast.success("Document verified successfully");
                        }}
                      >
                        {"Confirm Verification"}
                      </Button>
                    )}
                    <Button
                      className="mt-2"
                      style={{ borderRadius: "10px" }}
                      variant="secondary"
                      onClick={() => setShowIframe(false)}
                    >
                      Close
                    </Button>
                  </Modal.Body>
                </Modal>
              )}
            </div>
          );
        }
      } else {
        return (
          <div className="imageDiv d-flex align-items-center gap-4">
            <div style={{ position: "relative", display: "inline-block" }}>
              <div className="d-flex flex-column">
                <button
                  className="me-4"
                  style={{
                    borderRadius: "10px",
                    height: "40px",
                    padding: "5px 15px",
                    fontSize: "12px",
                    cursor: "pointer",
                    margin: "15px 0",
                    border: "none",
                    backgroundColor: "#921d1e",
                    // fieldErrors?.[camelCaseKey]?.touched &&
                    // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                    //   ? "#921d1e"
                    //   : "#f0f0f0", // Error background color

                    // border:
                    //   fieldErrors?.[camelCaseKey]?.touched && fieldErrors?.[camelCaseKey]?.errors?.length > 0
                    //     ? "1px solid red"
                    //     : "1px solid #ccc", // Error border
                    color: "#fff",
                    // fieldErrors?.[camelCaseKey]?.touched &&
                    // fieldErrors?.[camelCaseKey]?.errors?.length > 0
                    //   ? "#fff"
                    //   : "#333", // Error background color
                  }}
                  onClick={() =>
                    document.getElementById(`${camelCaseKey}_fileInput`).click()
                  }
                >
                  Upload File
                </button>

                <br />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors?.map((err, idx) => (
                    <span
                      key={idx}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
                <br />
                {fieldValue &&
                  !applicationDetails[`${camelCaseKey}verified`] && (
                    <span
                      key={"Dgf"}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {"Please Verify The File"}
                      <br />
                    </span>
                  )}
              </div>
              <input
                type="file"
                accept="application/pdf"
                id={`${camelCaseKey}_fileInput`}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  opacity: 0,
                  width: "100%",
                  height: "100%",
                  cursor: "pointer",
                }}
                onChange={(e) => {
                  handleUploadImage(e, camelCaseKey);
                  setApplicationDetails({
                    ...applicationDetails,
                    [`${camelCaseKey}verified`]: false,
                  });

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  e.target.value = null;
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
              />
            </div>

            {applicationDetails[camelCaseKey] && (
              <>
                <img
                  src={pdfIcon}
                  alt="PDF preview"
                  style={{
                    marginLeft: "10px",
                    width: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setShowIframe(camelCaseKey);
                  }}
                />
                {!applicationDetails[`${camelCaseKey}verified`] && (
                  <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      className="ms-2 verifybutton verifyBtn"
                      onClick={() => setShowIframe(camelCaseKey)}
                    >
                      Verify
                    </Button>
                  </div>
                )}

                {applicationDetails[`${camelCaseKey}verified`] && (
                  <div
                    style={{ display: "flex", justifyContent: "flex-end" }}
                    className={"fw-bold"}
                  >
                    <Badge bg="success">
                      <FaCheckCircle size={"18"} className="me-2" />
                      Verified
                    </Badge>
                  </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button
                    className="ms-2"
                    variant="outline"
                    onClick={() => handleUploadImage(null, camelCaseKey)}
                    style={{ marginLeft: "auto" }}
                  >
                    <Badge bg="danger">
                      <MdDeleteOutline size={"18"} />
                      <span className="ps-2">Delete</span>
                    </Badge>
                    {/* <MdDeleteOutline size={"25"}></MdDeleteOutline> */}
                  </Button>
                </div>
              </>
            )}

            {showIframe && (
              <Modal
                size="lg"
                show={showIframe === camelCaseKey}
                onHide={() => setShowIframe(false)}
                centered
                aria-labelledby="example-custom-modal-styling-title"
              >
                <Modal.Body className="text-center">
                  <iframe
                    src={fieldValue}
                    width="100%"
                    style={{ border: "none", height: "80vh" }}
                    title="PDF Viewer"
                  />
                  {!applicationDetails[camelCaseKey + "verified"] && (
                    <Button
                      className="mt-2"
                      style={{ borderRadius: "10px" }}
                      onClick={() => {
                        setApplicationDetails({
                          ...applicationDetails,
                          [`${camelCaseKey}verified`]: true,
                        });
                        setShowIframe(false);
                      }}
                    >
                      {"Confirm Verification"}
                    </Button>
                  )}
                  <Button
                    className="mt-2"
                    style={{ borderRadius: "10px" }}
                    variant="secondary"
                    onClick={() => setShowIframe(false)}
                  >
                    Close
                  </Button>
                </Modal.Body>
              </Modal>
            )}
          </div>
        );
      }
    };

    // Function to render textarea input
    const renderTextareaInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      switch (label) {
        default:
          //("Label value:", {label}); // Logs the value of label to the console
          return (
            <>
              <Form.Control
                as="textarea"
                style={{
                  ...style.input,
                  ...(fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? style.errorBox
                    : {}),
                  height:
                    label === " Why Should I consider Myself Suitable"
                      ? "300px"
                      : "150px",
                }}
                className=""
                placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  const updatedValue = e.target.value;

                  // Update application details
                  setApplicationDetails((prevDetails) => ({
                    ...prevDetails,
                    [camelCaseKey]: updatedValue,
                  }));

                  // Clear error if the user starts typing
                  if (updatedValue.trim() !== "") {
                    setFieldErrors((prevErrors) => ({
                      ...prevErrors,
                      [camelCaseKey]: { errors: [], touched: true },
                    }));
                  }
                }}
                // onBlur={(e) => {
                //   const value = e.target.value;

                //   // Validate on blur
                //   if (!value.trim()) {
                //     setFieldErrors((prevErrors) => ({
                //       ...prevErrors,
                //       [camelCaseKey]: {
                //         errors: ["This field is required."],
                //         touched: true,
                //       },
                //     }));
                //   } else {
                //     setFieldErrors((prevErrors) => ({
                //       ...prevErrors,
                //       [camelCaseKey]: { errors: [], touched: true },
                //     }));
                //   }
                // }}
                required={input.values.isRequired}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                // required={false}
                maxLength={1000}
                minLength={500}
              />
              {/* Display error messages */}
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                  <span
                    key={index}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );

          break;
      }
    };

    const handelApplicationDetailsChange = (data) => {
      setApplicationDetails({
        ...applicationDetails,
        ...data,
      });
    };

    const renderTextInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      // FORCE CHECK AT THE VERY BEGINNING: Check if this is Graduation/Post-Graduation/LLB percentage field with mark type "Percentage"
      const fieldId = input?.values?._id || "";
      const fieldIdStr = String(fieldId);
      const camelCaseKeyStr = String(camelCaseKey || "");

      const isGrPercentageField =
        fieldIdStr === "66a687874db5f02d6861ed11" ||
        camelCaseKeyStr === "66a687874db5f02d6861ed11" ||
        camelCaseKeyStr.includes("66a687874db5f02d6861ed11") ||
        fieldIdStr.includes("66a687874db5f02d6861ed11");
      const isPostGrPercentageField =
        fieldIdStr === "676a57139e167618b7ec04b1" ||
        camelCaseKeyStr === "676a57139e167618b7ec04b1" ||
        camelCaseKeyStr.includes("676a57139e167618b7ec04b1") ||
        fieldIdStr.includes("676a57139e167618b7ec04b1");
      const isLLBPercentageField =
        fieldIdStr === "68ecd888eb422bea55aa71b4" ||
        camelCaseKeyStr === "68ecd888eb422bea55aa71b4" ||
        camelCaseKeyStr.includes("68ecd888eb422bea55aa71b4") ||
        fieldIdStr.includes("68ecd888eb422bea55aa71b4");

      const markTypeGrCheck =
        applicationDetails?.["66a687874db5f02d6861ed0e"] ||
        applicationDetails?.[camelCase("66a687874db5f02d6861ed0e")];
      const markTypePostGrCheck =
        applicationDetails?.["676a57139e167618b7ec04ab"] ||
        applicationDetails?.[camelCase("676a57139e167618b7ec04ab")];
      const markTypeLLBCheck =
        applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
        applicationDetails?.[camelCase("68ecd888eb422bea55aa71ae")];

      const checkIsPercentageCheck = (markType) => {
        if (!markType) return false;
        const markTypeStr = String(markType).trim();
        return (
          markTypeStr === "Percentage" ||
          markTypeStr.toLowerCase() === "percentage"
        );
      };

      const shouldBeReadOnlyAtStart =
        (isGrPercentageField && checkIsPercentageCheck(markTypeGrCheck)) ||
        (isPostGrPercentageField &&
          checkIsPercentageCheck(markTypePostGrCheck)) ||
        (isLLBPercentageField && checkIsPercentageCheck(markTypeLLBCheck));

      // If it should be read-only, return read-only input immediately
      if (shouldBeReadOnlyAtStart) {
        return (
          <>
            <input
              className="form-control text-dark"
              style={
                fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched
                  ? { ...style.input, ...style.errorBox }
                  : style.input
              }
              type={input.values.inputFieldType}
              value={fieldValue || ""}
              readOnly
              required={input.values.isRequired}
              onBlur={() => {
                const percentage = parseFloat(fieldValue) || 0;
                if (percentage > 100) {
                  setFieldErrors((prevState) => ({
                    ...prevState,
                    [camelCaseKey]: {
                      errors: [
                        ...new Set([
                          ...(prevState[camelCaseKey]?.errors || []).filter(
                            (err) =>
                              err !==
                              "Percentage of Mark cannot be greater than 100%."
                          ),
                          "Percentage of Mark cannot be greater than 100%.",
                        ]),
                      ],
                      touched: true,
                    },
                  }));
                } else {
                  setFieldErrors((prevState) => ({
                    ...prevState,
                    [camelCaseKey]: {
                      errors: (prevState[camelCaseKey]?.errors || []).filter(
                        (err) =>
                          err !==
                          "Percentage of Mark cannot be greater than 100%."
                      ),
                      touched: prevState?.[camelCaseKey]?.touched || true,
                    },
                  }));
                }
              }}
            />
            {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              fieldErrors?.[camelCaseKey]?.touched &&
              fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                <span
                  key={`error-${index}`}
                  className="errorPresent"
                  style={style.errorSpan}
                >
                  {err}
                  <br />
                </span>
              ))}
          </>
        );
      }

      const selectFromFollowing10th =
        applicationDetails?.["66a687874db5f02d6861ed04"];
      const selectFromFollowing12th =
        applicationDetails?.["66a728ec9680c25e280d6bf6"];
      const selectFromFollowingGradu =
        applicationDetails?.["66a687874db5f02d6861ed0e"];

      const BoardCouncilFor10thType =
        applicationDetails?.["66a687874db5f02d6861ed01"];
      const BoardCouncilFor12thType =
        applicationDetails?.["66a726919680c25e280d6ad0"];
      const stremandBranchDiploma =
        applicationDetails?.["6745516aba7bd153d04f36f2"];

      const stremandBranch = applicationDetails?.["68e67d5e9698f142bc5322b7"];
      const isMatch =
        camelCaseKey === "68e74ef6c921b345b802ba05" &&
        stremandBranch === "Others";
      if (isMatch) console.log({ stremandBranch, isMatch }); // BoardCouncilFor10thType === "Others" ? then exicute 674ea5f2ba7bd153d0509340 else totally dont exicute it

      let renderType = applicationDetails?.["66a687874db5f02d6861ed04"];

      const BoardCouncilId = "674ea5f2ba7bd153d0509340";

      // Define the IDs for 10th Grade
      const markType10th = applicationDetails?.["66a687874db5f02d6861ed04"];
      const markTotalIn10thId = "66a687874db5f02d6861ed06";
      const markObtainedIn10thId = "66a687874db5f02d6861ed05";
      const percentageIn10thId = "66a687874db5f02d6861ed07";
      // Define the IDs for 12th Grade
      const markType12th = applicationDetails?.["66a728ec9680c25e280d6bf6"];
      const markTotalIn12thId = "66a731359680c25e280d6e4b";
      const markObtainedIn12thId = "66a730c29680c25e280d6de8";
      const percentageIn12thId = "66a7359a9680c25e280d6f16";

      // Define the IDs for Graduate/Higher Secondary
      // Mark type field IDs
      const markTypeGrFieldId = "66a687874db5f02d6861ed0e";
      const markTypePostGrFieldId = "676a57139e167618b7ec04ab";

      // Get mark types using both raw ID and camelCase key (for compatibility)
      const markTypeGr =
        applicationDetails?.[markTypeGrFieldId] ||
        applicationDetails?.[camelCase(markTypeGrFieldId)];

      const markTotalInGrThId = "66a687874db5f02d6861ed10";
      const markObtainedInGrThId = "66a687874db5f02d6861ed0f";
      const percentageInGrThId = "66a687874db5f02d6861ed11";
      const select12thDeploma =
        applicationDetails?.["67927705f2187a33680afe54"];

      const appliedEarlier = applicationDetails?.["68e505a0eb422bea55a9ac0f"];

      // Get mark types using both raw ID and camelCase key (for compatibility)
      const markTypePostGr =
        applicationDetails?.[markTypePostGrFieldId] ||
        applicationDetails?.[camelCase(markTypePostGrFieldId)];

      //("markTypePostGr", markTypePostGr);
      const markTotalInPostGrThId = "676a57139e167618b7ec04af";
      const markObtainedInPostGrThId = "676a57139e167618b7ec04ad";
      const percentageInPostGrThId = "676a57139e167618b7ec04b1";

      // Define the IDs for LLB Degree
      const markTypeLLB = applicationDetails?.["68ecd888eb422bea55aa71ae"];
      const markTotalInLLBId = "68ecd888eb422bea55aa71b2";
      const markObtainedInLLBId = "68ecd888eb422bea55aa71b0";
      const percentageInLLBId = "68ecd888eb422bea55aa71b4";
      const updateMarkValueNonArray = (camelCaseKey, value) => {
        // Helper function to validate marks and percentage
        const validateMarksAndPercentage = (
          obtained,
          total,
          obtainedKey,
          totalKey,
          percentageKey
        ) => {
          const obtainedNum = parseFloat(obtained) || 0;
          const totalNum = parseFloat(total) || 0;

          // Validate: Mark Obtained should be <= Mark Out of
          const isMarkValid = obtainedNum <= totalNum;

          // Validate percentage: should be <= 100%
          let percentage = 0;
          if (totalNum > 0) {
            percentage = (obtainedNum / totalNum) * 100;
          }
          const isPercentageValid = percentage >= 0 && percentage <= 100;

          // Update errors for Mark Obtained field
          if (!isMarkValid && obtainedKey) {
            setFieldErrors((prevState) => ({
              ...prevState,
              [obtainedKey]: {
                errors: [
                  ...new Set([
                    ...(prevState[obtainedKey]?.errors || []).filter(
                      (err) =>
                        err !==
                        "Mark Obtained cannot be greater than Mark Out of."
                    ),
                    "Mark Obtained cannot be greater than Mark Out of.",
                  ]),
                ],
                touched: prevState?.[obtainedKey]?.touched || true,
              },
            }));
          } else if (isMarkValid && obtainedKey) {
            // Clear mark validation error if valid
            setFieldErrors((prevState) => ({
              ...prevState,
              [obtainedKey]: {
                errors: (prevState[obtainedKey]?.errors || []).filter(
                  (err) =>
                    err !== "Mark Obtained cannot be greater than Mark Out of."
                ),
                touched: prevState?.[obtainedKey]?.touched || true,
              },
            }));
          }

          // Update errors for Mark Out of field
          if (!isMarkValid && totalKey) {
            setFieldErrors((prevState) => ({
              ...prevState,
              [totalKey]: {
                errors: [
                  ...new Set([
                    ...(prevState[totalKey]?.errors || []).filter(
                      (err) =>
                        err !==
                        "Mark Obtained cannot be greater than Mark Out of."
                    ),
                    "Mark Obtained cannot be greater than Mark Out of.",
                  ]),
                ],
                touched: prevState?.[totalKey]?.touched || true,
              },
            }));
          } else if (isMarkValid && totalKey) {
            // Clear mark validation error if valid
            setFieldErrors((prevState) => ({
              ...prevState,
              [totalKey]: {
                errors: (prevState[totalKey]?.errors || []).filter(
                  (err) =>
                    err !== "Mark Obtained cannot be greater than Mark Out of."
                ),
                touched: prevState?.[totalKey]?.touched || true,
              },
            }));
          }

          // Update errors for Percentage field
          if (!isPercentageValid && percentageKey) {
            setFieldErrors((prevState) => ({
              ...prevState,
              [percentageKey]: {
                errors: [
                  ...new Set([
                    ...(prevState[percentageKey]?.errors || []).filter(
                      (err) =>
                        err !==
                        "Percentage of Mark cannot be greater than 100%."
                    ),
                    "Percentage of Mark cannot be greater than 100%.",
                  ]),
                ],
                touched: prevState?.[percentageKey]?.touched || true,
              },
            }));
          } else if (isPercentageValid && percentageKey) {
            // Clear percentage error if valid
            setFieldErrors((prevState) => ({
              ...prevState,
              [percentageKey]: {
                errors: (prevState[percentageKey]?.errors || []).filter(
                  (err) =>
                    err !== "Percentage of Mark cannot be greater than 100%."
                ),
                touched: prevState?.[percentageKey]?.touched || true,
              },
            }));
          }

          return { isMarkValid, isPercentageValid };
        };

        // Helper function to calculate and update percentage
        const calculateAndUpdatePercentage = (
          obtained,
          total,
          percentageId,
          obtainedKey,
          totalKey
        ) => {
          let percentage = 0;

          if (total > 0) {
            percentage = (obtained / total) * 100;
            percentage = percentage.toFixed(2).toString();
          }

          // Validate marks and percentage
          validateMarksAndPercentage(
            obtained,
            total,
            obtainedKey,
            totalKey,
            percentageId
          );

          // Update the percentage field with two decimal places
          return { percentageId, percentage };
        };

        // Determine which group the camelCaseKey belongs to and update accordingly

        switch (camelCaseKey) {
          // 10th Grade
          case markObtainedIn10thId: {
            const obtained = parseFloat(value) || 0;
            const total =
              parseFloat(applicationDetails[markTotalIn10thId]) || 0;
            if (markType10th == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageIn10thId,
                markObtainedIn10thId,
                markTotalIn10thId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedIn10thId,
              markTotalIn10thId,
              percentageIn10thId
            );
            break;
          }
          case markTotalIn10thId: {
            const total = parseFloat(value) || 0;
            const obtained =
              parseFloat(applicationDetails[markObtainedIn10thId]) || 0;
            if (markType10th == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageIn10thId,
                markObtainedIn10thId,
                markTotalIn10thId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedIn10thId,
              markTotalIn10thId,
              percentageIn10thId
            );
            break;
          }

          // 12th Grade
          case markObtainedIn12thId: {
            const obtained = parseFloat(value) || 0;
            const total =
              parseFloat(applicationDetails[markTotalIn12thId]) || 0;
            if (markType12th == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageIn12thId,
                markObtainedIn12thId,
                markTotalIn12thId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedIn12thId,
              markTotalIn12thId,
              percentageIn12thId
            );
            break;
          }
          case markTotalIn12thId: {
            const total = parseFloat(value) || 0;
            const obtained =
              parseFloat(applicationDetails[markObtainedIn12thId]) || 0;
            if (markType12th == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageIn12thId,
                markObtainedIn12thId,
                markTotalIn12thId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedIn12thId,
              markTotalIn12thId,
              percentageIn12thId
            );
            break;
          }

          // Graduate/Higher Secondary
          case markObtainedInGrThId: {
            const obtained = parseFloat(value) || 0;
            const total =
              parseFloat(applicationDetails[markTotalInGrThId]) || 0;
            if (markTypeGr == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInGrThId,
                markObtainedInGrThId,
                markTotalInGrThId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInGrThId,
              markTotalInGrThId,
              percentageInGrThId
            );
            break;
          }
          case markTotalInGrThId: {
            const total = parseFloat(value) || 0;
            const obtained =
              parseFloat(applicationDetails[markObtainedInGrThId]) || 0;
            if (markTypeGr == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInGrThId,
                markObtainedInGrThId,
                markTotalInGrThId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInGrThId,
              markTotalInGrThId,
              percentageInGrThId
            );
            break;
          }

          case markObtainedInPostGrThId: {
            const obtained = parseFloat(value) || 0;
            const total =
              parseFloat(applicationDetails[markTotalInPostGrThId]) || 0;
            if (markTypePostGr == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInPostGrThId,
                markObtainedInPostGrThId,
                markTotalInPostGrThId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInPostGrThId,
              markTotalInPostGrThId,
              percentageInPostGrThId
            );
            break;
          }
          case markTotalInPostGrThId: {
            const total = parseFloat(value) || 0;
            const obtained =
              parseFloat(applicationDetails[markObtainedInPostGrThId]) || 0;
            if (markTypePostGr == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInPostGrThId,
                markObtainedInPostGrThId,
                markTotalInPostGrThId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInPostGrThId,
              markTotalInPostGrThId,
              percentageInPostGrThId
            );
            break;
          }

          // LLB Degree
          case markObtainedInLLBId: {
            const obtained = parseFloat(value) || 0;
            const total = parseFloat(applicationDetails[markTotalInLLBId]) || 0;
            if (markTypeLLB == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInLLBId,
                markObtainedInLLBId,
                markTotalInLLBId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInLLBId,
              markTotalInLLBId,
              percentageInLLBId
            );
            break;
          }
          case markTotalInLLBId: {
            const total = parseFloat(value) || 0;
            const obtained =
              parseFloat(applicationDetails[markObtainedInLLBId]) || 0;
            if (markTypeLLB == "Percentage") {
              return calculateAndUpdatePercentage(
                obtained,
                total,
                percentageInLLBId,
                markObtainedInLLBId,
                markTotalInLLBId
              );
            }
            // Validate even if not Percentage type
            validateMarksAndPercentage(
              obtained,
              total,
              markObtainedInLLBId,
              markTotalInLLBId,
              percentageInLLBId
            );
            break;
          }

          default:
            // If the key does not match any of the above, do nothing
            break;
        }
      };
      console.log({ label });
      switch (label) {
        case "Board/Council":
          if (
            camelCaseKey === "674ee278ba7bd153d050ab35" &&
            select12thDeploma === "Diploma"
          ) {
            return (
              <></>
              //   <>
              //   <input
              //     className="form-control text-dark"
              //     style={
              //       fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              //       fieldErrors?.[camelCaseKey]?.touched
              //         ? { ...style.input, ...style.errorBox }
              //         : style.input
              //     }
              //     type={input.values.inputFieldType}
              //     value={fieldValue}
              //     onChange={(e) => {
              //       setApplicationDetails({
              //         ...applicationDetails,
              //         [camelCaseKey]: e.target.value,
              //       });
              //       if (fieldErrors?.[camelCaseKey]?.touched) {
              //         checkErrorFn(input, camelCaseKey, e.target.value);
              //       }
              //     }}
              //     onBlur={() => {
              //       checkErrorFn(input, camelCaseKey, fieldValue);
              //     }}
              //     required={input.values.isRequired}
              //     max={new Date().toISOString().split("T")[0]}
              //   />
              //   {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
              //     fieldErrors?.[camelCaseKey]?.touched &&
              //     fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
              //       <span
              //         key={`error-${index}`}
              //         className="errorPresent"
              //         style={style.errorSpan}
              //       >
              //         {err}
              //         <br />
              //       </span>
              //     ))}
              // </>
            );
          }

        case "Board/Council":
          if (
            camelCaseKey === "674ea5f2ba7bd153d0509340" &&
            BoardCouncilFor10thType === "Others"
          ) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else if (
            camelCaseKey === "674ee278ba7bd153d050ab35" &&
            BoardCouncilFor12thType == "Others" &&
            select12thDeploma === "12th"
          ) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          }

          return null;
        case "Mark Obtained":
        case "Mark Obtained":
          // Define the condition based on camelCaseKey and selectFromFollowing variables
          const isGradeSelectedObtained =
            (camelCaseKey === "66a687874db5f02d6861ed05" &&
              selectFromFollowing10th === "Grade") ||
            (camelCaseKey === "66a730c29680c25e280d6de8" &&
              selectFromFollowing12th === "Grade") ||
            (camelCaseKey === "66a687874db5f02d6861ed0f" &&
              selectFromFollowingGradu === "Grade") ||
            (camelCaseKey === "676a57139e167618b7ec04ad" &&
              markTypePostGr === "Grade") ||
            (camelCaseKey === "68ecd888eb422bea55aa71b0" &&
              markTypeLLB === "Grade");

          if (isGradeSelectedObtained) {
            // Render read-only input with empty value
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value="" // Always empty when Grade is selected
                  readOnly
                />
              </>
            );
          } else {
            // Render interactive input with value and event handlers
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    // Update marks obtained and corresponding percentage
                    const data___ = updateMarkValueNonArray(
                      camelCaseKey,
                      e.target.value
                    );
                    setApplicationDetails((prevDetails) => ({
                      ...prevDetails,
                      [camelCaseKey]: e.target.value,
                      [data___?.percentageId]: data___?.percentage,
                    }));

                    // Check for errors if the field has been touched
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    // Validate on blur
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {/* Display error messages if any */}
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          }

          // Optional: Remove this return null if it's unreachable
          return null;

        case "Mark Out of":

        case "Mark Out of":
          // Define the condition based on camelCaseKey and selectFromFollowing variables
          const isGradeSelected =
            (camelCaseKey === "66a687874db5f02d6861ed06" &&
              selectFromFollowing10th === "Grade") ||
            (camelCaseKey === "66a731359680c25e280d6e4b" &&
              selectFromFollowing12th === "Grade") ||
            (camelCaseKey === "66a687874db5f02d6861ed10" &&
              selectFromFollowingGradu === "Grade") ||
            (camelCaseKey === "676a57139e167618b7ec04af" &&
              markTypePostGr === "Grade") ||
            (camelCaseKey === "68ecd888eb422bea55aa71b2" &&
              markTypeLLB === "Grade");

          if (isGradeSelected) {
            // Render read-only input with empty value
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value="" // Always empty
                  readOnly
                />
              </>
            );
          } else {
            // Render interactive input with value and event handlers
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    // Update application details with the new value and possibly percentage
                    const data___ = updateMarkValueNonArray(
                      camelCaseKey,
                      e.target.value
                    );
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                      [data___?.percentageId]: data___?.percentage,
                    });

                    // Check for errors if the field has been touched
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    // Validate on blur
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {/* Display error messages if any */}
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          }
        case "Stream/Branch":
          console.log("first");
          if (
            camelCaseKey === "68e74ef6c921b345b802ba05" &&
            stremandBranch === "Others"
          ) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else if (
            camelCaseKey === "68eb40c2c268a51cd00e9f59" &&
            select12thDeploma === "Diploma" &&
            stremandBranchDiploma === "Others"
          ) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else {
            console.log("console in else");
            return null;
          }
        // Optionally, return null or handle other cases if necessary
        // return null;

        case "Percentage of Mark":
        case "Percentage of mark":
          // Validate percentage value
          const percentageValue = parseFloat(fieldValue) || 0;
          const isPercentageFieldValid =
            percentageValue >= 0 && percentageValue <= 100;

          // Determine which mark type to check based on the percentage field ID
          // Prioritize input.values._id as it's the most reliable identifier
          const fieldId = input?.values?._id;
          let currentMarkType = null;
          let isPercentageType = false;

          // Convert to strings for reliable comparison
          const fieldIdStr = String(fieldId || "");
          const camelCaseKeyStr = String(camelCaseKey || "");

          // Helper function to check if mark type is "Percentage"
          const checkIsPercentage = (markType) => {
            if (!markType) return false;
            const markTypeStr = String(markType).trim();
            return (
              markTypeStr === "Percentage" ||
              markTypeStr.toLowerCase() === "percentage"
            );
          };

          // Direct check for Graduation, Post-Graduation, and LLB percentage fields
          // This ensures we catch them even if other matching fails
          const isGrPercentageFieldDirect =
            fieldIdStr === "66a687874db5f02d6861ed11" ||
            camelCaseKeyStr === "66a687874db5f02d6861ed11" ||
            camelCaseKeyStr.includes("66a687874db5f02d6861ed11") ||
            fieldIdStr.includes("66a687874db5f02d6861ed11");
          const isPostGrPercentageFieldDirect =
            fieldIdStr === "676a57139e167618b7ec04b1" ||
            camelCaseKeyStr === "676a57139e167618b7ec04b1" ||
            camelCaseKeyStr.includes("676a57139e167618b7ec04b1") ||
            fieldIdStr.includes("676a57139e167618b7ec04b1");
          const isLLBPercentageFieldDirect =
            fieldIdStr === "68ecd888eb422bea55aa71b4" ||
            camelCaseKeyStr === "68ecd888eb422bea55aa71b4" ||
            camelCaseKeyStr.includes("68ecd888eb422bea55aa71b4") ||
            fieldIdStr.includes("68ecd888eb422bea55aa71b4");

          // Get mark types directly from applicationDetails
          const markTypeGrDirect =
            applicationDetails?.["66a687874db5f02d6861ed0e"] ||
            applicationDetails?.[camelCase("66a687874db5f02d6861ed0e")];
          const markTypePostGrDirect =
            applicationDetails?.["676a57139e167618b7ec04ab"] ||
            applicationDetails?.[camelCase("676a57139e167618b7ec04ab")];
          const markTypeLLBDirect =
            applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
            applicationDetails?.[camelCase("68ecd888eb422bea55aa71ae")];

          // Check if these fields should be read-only based on direct matching
          const shouldBeReadOnlyDirect =
            (isGrPercentageFieldDirect &&
              checkIsPercentage(markTypeGrDirect)) ||
            (isPostGrPercentageFieldDirect &&
              checkIsPercentage(markTypePostGrDirect)) ||
            (isLLBPercentageFieldDirect &&
              checkIsPercentage(markTypeLLBDirect));

          // If direct check says it should be read-only, return read-only input immediately
          if (shouldBeReadOnlyDirect) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue || ""}
                  readOnly
                  required={input.values.isRequired}
                  onBlur={() => {
                    const percentage = parseFloat(fieldValue) || 0;
                    if (percentage > 100) {
                      setFieldErrors((prevState) => ({
                        ...prevState,
                        [camelCaseKey]: {
                          errors: [
                            ...new Set([
                              ...(prevState[camelCaseKey]?.errors || []).filter(
                                (err) =>
                                  err !==
                                  "Percentage of Mark cannot be greater than 100%."
                              ),
                              "Percentage of Mark cannot be greater than 100%.",
                            ]),
                          ],
                          touched: true,
                        },
                      }));
                    } else {
                      setFieldErrors((prevState) => ({
                        ...prevState,
                        [camelCaseKey]: {
                          errors: (
                            prevState[camelCaseKey]?.errors || []
                          ).filter(
                            (err) =>
                              err !==
                              "Percentage of Mark cannot be greater than 100%."
                          ),
                          touched: prevState?.[camelCaseKey]?.touched || true,
                        },
                      }));
                    }
                  }}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          }

          // Also check camelCase versions of field IDs for more robust matching
          const percentageIn10thIdCamel = camelCase(percentageIn10thId);
          const percentageIn12thIdCamel = camelCase(percentageIn12thId);
          const percentageInGrThIdCamel = camelCase(percentageInGrThId);
          const percentageInPostGrThIdCamel = camelCase(percentageInPostGrThId);
          const percentageInLLBIdCamel = camelCase(percentageInLLBId);

          // Direct field ID matching - SAME LOGIC AS 10th and 12th
          // Check if the field ID matches any of the percentage field IDs (raw ID, camelCase key, or camelCase of ID)
          if (
            fieldIdStr === percentageIn10thId ||
            camelCaseKeyStr === percentageIn10thId ||
            camelCaseKeyStr === percentageIn10thIdCamel ||
            camelCaseKeyStr.includes(percentageIn10thId) ||
            fieldIdStr.includes(percentageIn10thId)
          ) {
            currentMarkType = markType10th;
            isPercentageType = checkIsPercentage(markType10th);
          } else if (
            fieldIdStr === percentageIn12thId ||
            camelCaseKeyStr === percentageIn12thId ||
            camelCaseKeyStr === percentageIn12thIdCamel ||
            camelCaseKeyStr.includes(percentageIn12thId) ||
            fieldIdStr.includes(percentageIn12thId)
          ) {
            currentMarkType = markType12th;
            isPercentageType = checkIsPercentage(markType12th);
          } else if (
            fieldIdStr === percentageInGrThId ||
            camelCaseKeyStr === percentageInGrThId ||
            camelCaseKeyStr === percentageInGrThIdCamel ||
            camelCaseKeyStr.includes(percentageInGrThId) ||
            fieldIdStr.includes(percentageInGrThId)
          ) {
            // For Graduation: Apply EXACT SAME LOGIC as 10th and 12th
            // markTypeGr is already retrieved at the top of the function: applicationDetails?.["66a687874db5f02d6861ed0e"]
            currentMarkType = markTypeGr;
            isPercentageType = checkIsPercentage(markTypeGr);
            console.log(
              "=== GRADUATION PERCENTAGE FIELD (SAME LOGIC AS 10th/12th) ==="
            );
            console.log("Field ID:", fieldIdStr);
            console.log("camelCaseKey:", camelCaseKeyStr);
            console.log("percentageInGrThId:", percentageInGrThId);
            console.log("markTypeGr (from applicationDetails):", markTypeGr);
            console.log("currentMarkType:", currentMarkType);
            console.log("isPercentageType:", isPercentageType);
          } else if (
            fieldIdStr === percentageInPostGrThId ||
            camelCaseKeyStr === percentageInPostGrThId ||
            camelCaseKeyStr === percentageInPostGrThIdCamel ||
            camelCaseKeyStr.includes(percentageInPostGrThId) ||
            fieldIdStr.includes(percentageInPostGrThId)
          ) {
            // For Post Graduation: Apply EXACT SAME LOGIC as 10th and 12th
            currentMarkType = markTypePostGr;
            isPercentageType = checkIsPercentage(markTypePostGr);
            console.log(
              "=== POST-GRADUATION PERCENTAGE FIELD (SAME LOGIC AS 10th/12th) ==="
            );
            console.log("Field ID:", fieldIdStr);
            console.log("camelCaseKey:", camelCaseKeyStr);
            console.log("percentageInPostGrThId:", percentageInPostGrThId);
            console.log(
              "markTypePostGr (from applicationDetails):",
              markTypePostGr
            );
            console.log("currentMarkType:", currentMarkType);
            console.log("isPercentageType:", isPercentageType);
          } else if (
            fieldIdStr === percentageInLLBId ||
            camelCaseKeyStr === percentageInLLBId ||
            camelCaseKeyStr === percentageInLLBIdCamel ||
            camelCaseKeyStr.includes(percentageInLLBId) ||
            fieldIdStr.includes(percentageInLLBId)
          ) {
            // For LLB Degree: Apply EXACT SAME LOGIC as 10th and 12th
            currentMarkType = markTypeLLB;
            isPercentageType = checkIsPercentage(markTypeLLB);
            console.log(
              "=== LLB PERCENTAGE FIELD (SAME LOGIC AS 10th/12th) ==="
            );
            console.log("Field ID:", fieldIdStr);
            console.log("camelCaseKey:", camelCaseKeyStr);
            console.log("percentageInLLBId:", percentageInLLBId);
            console.log("markTypeLLB (from applicationDetails):", markTypeLLB);
            console.log("currentMarkType:", currentMarkType);
            console.log("isPercentageType:", isPercentageType);
          } else {
            // Fallback to renderType for backward compatibility (e.g., Additional Qualification)
            currentMarkType = renderType;
            isPercentageType = checkIsPercentage(renderType);
          }

          return isPercentageType ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue || ""}
                readOnly
                required={input.values.isRequired}
                onBlur={() => {
                  // Validate percentage on blur
                  const percentage = parseFloat(fieldValue) || 0;
                  if (percentage > 100) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: true,
                      },
                    }));
                  } else {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }
                }}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                  <span
                    key={`error-${index}`}
                    className="errorPresent"
                    style={style.errorSpan}
                  >
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : currentMarkType == "CGPA/OGPA" ? (
            <>
              {/* Check if this is a Graduation, Post-Graduation, or LLB percentage field with mark type "Percentage" */}
              {(() => {
                const isGrPercentageField =
                  fieldIdStr === percentageInGrThId ||
                  camelCaseKeyStr === percentageInGrThId ||
                  camelCaseKeyStr.includes(percentageInGrThId) ||
                  fieldIdStr.includes(percentageInGrThId);
                const isPostGrPercentageField =
                  fieldIdStr === percentageInPostGrThId ||
                  camelCaseKeyStr === percentageInPostGrThId ||
                  camelCaseKeyStr.includes(percentageInPostGrThId) ||
                  fieldIdStr.includes(percentageInPostGrThId);
                const isLLBPercentageField =
                  fieldIdStr === percentageInLLBId ||
                  camelCaseKeyStr === percentageInLLBId ||
                  camelCaseKeyStr.includes(percentageInLLBId) ||
                  fieldIdStr.includes(percentageInLLBId);
                const shouldBeReadOnly =
                  (isGrPercentageField && checkIsPercentage(markTypeGr)) ||
                  (isPostGrPercentageField &&
                    checkIsPercentage(markTypePostGr)) ||
                  (isLLBPercentageField && checkIsPercentage(markTypeLLB));

                return shouldBeReadOnly ? (
                  <>
                    <input
                      className="form-control text-dark"
                      style={
                        fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                        fieldErrors?.[camelCaseKey]?.touched
                          ? { ...style.input, ...style.errorBox }
                          : style.input
                      }
                      type={input.values.inputFieldType}
                      value={fieldValue || ""}
                      readOnly
                      required={input.values.isRequired}
                      onBlur={() => {
                        const percentage = parseFloat(fieldValue) || 0;
                        if (percentage > 100) {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: [
                                ...new Set([
                                  ...(
                                    prevState[camelCaseKey]?.errors || []
                                  ).filter(
                                    (err) =>
                                      err !==
                                      "Percentage of Mark cannot be greater than 100%."
                                  ),
                                  "Percentage of Mark cannot be greater than 100%.",
                                ]),
                              ],
                              touched: true,
                            },
                          }));
                        } else {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: (
                                prevState[camelCaseKey]?.errors || []
                              ).filter(
                                (err) =>
                                  err !==
                                  "Percentage of Mark cannot be greater than 100%."
                              ),
                              touched:
                                prevState?.[camelCaseKey]?.touched || true,
                            },
                          }));
                        }
                      }}
                    />
                    {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                      fieldErrors?.[camelCaseKey]?.touched &&
                      fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                        <span
                          key={`error-${index}`}
                          className="errorPresent"
                          style={style.errorSpan}
                        >
                          {err}
                          <br />
                        </span>
                      ))}
                  </>
                ) : (
                  <>
                    <input
                      className="form-control text-dark"
                      style={
                        fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                        fieldErrors?.[camelCaseKey]?.touched
                          ? { ...style.input, ...style.errorBox }
                          : style.input
                      }
                      type={input.values.inputFieldType}
                      // placeholder={label}
                      value={fieldValue}
                      readOnly={(() => {
                        // FORCE CHECK: Make read-only if this is Graduation/Post-Graduation/LLB percentage field with mark type "Percentage"
                        const fieldIdForCheck = input?.values?._id || "";
                        const fieldIdStrForCheck = String(fieldIdForCheck);
                        const camelCaseKeyStrForCheck = String(
                          camelCaseKey || ""
                        );

                        const isGrPercentageFieldCheck =
                          fieldIdStrForCheck === "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStrForCheck ===
                            "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStrForCheck.includes(
                            "66a687874db5f02d6861ed11"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "66a687874db5f02d6861ed11"
                          );
                        const isPostGrPercentageFieldCheck =
                          fieldIdStrForCheck === "676a57139e167618b7ec04b1" ||
                          camelCaseKeyStrForCheck ===
                            "676a57139e167618b7ec04b1" ||
                          camelCaseKeyStrForCheck.includes(
                            "676a57139e167618b7ec04b1"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "676a57139e167618b7ec04b1"
                          );
                        const isLLBPercentageFieldCheck =
                          fieldIdStrForCheck === "68ecd888eb422bea55aa71b4" ||
                          camelCaseKeyStrForCheck ===
                            "68ecd888eb422bea55aa71b4" ||
                          camelCaseKeyStrForCheck.includes(
                            "68ecd888eb422bea55aa71b4"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "68ecd888eb422bea55aa71b4"
                          );

                        const markTypeGrForCheck =
                          applicationDetails?.["66a687874db5f02d6861ed0e"] ||
                          applicationDetails?.[
                            camelCase("66a687874db5f02d6861ed0e")
                          ];
                        const markTypePostGrForCheck =
                          applicationDetails?.["676a57139e167618b7ec04ab"] ||
                          applicationDetails?.[
                            camelCase("676a57139e167618b7ec04ab")
                          ];
                        const markTypeLLBForCheck =
                          applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
                          applicationDetails?.[
                            camelCase("68ecd888eb422bea55aa71ae")
                          ];

                        const checkIsPercentageForCheck = (markType) => {
                          if (!markType) return false;
                          const markTypeStr = String(markType).trim();
                          return (
                            markTypeStr === "Percentage" ||
                            markTypeStr.toLowerCase() === "percentage"
                          );
                        };

                        return (
                          (isGrPercentageFieldCheck &&
                            checkIsPercentageForCheck(markTypeGrForCheck)) ||
                          (isPostGrPercentageFieldCheck &&
                            checkIsPercentageForCheck(
                              markTypePostGrForCheck
                            )) ||
                          (isLLBPercentageFieldCheck &&
                            checkIsPercentageForCheck(markTypeLLBForCheck))
                        );
                      })()}
                      onChange={(e) => {
                        const newValue = e.target.value;

                        // FORCE CHECK: Prevent editing if this is Graduation/Post-Graduation/LLB percentage field with mark type "Percentage"
                        const fieldIdForCheck = input?.values?._id || "";
                        const fieldIdStrForCheck = String(fieldIdForCheck);
                        const camelCaseKeyStrForCheck = String(
                          camelCaseKey || ""
                        );

                        const isGrPercentageFieldCheck =
                          fieldIdStrForCheck === "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStrForCheck ===
                            "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStrForCheck.includes(
                            "66a687874db5f02d6861ed11"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "66a687874db5f02d6861ed11"
                          );
                        const isPostGrPercentageFieldCheck =
                          fieldIdStrForCheck === "676a57139e167618b7ec04b1" ||
                          camelCaseKeyStrForCheck ===
                            "676a57139e167618b7ec04b1" ||
                          camelCaseKeyStrForCheck.includes(
                            "676a57139e167618b7ec04b1"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "676a57139e167618b7ec04b1"
                          );
                        const isLLBPercentageFieldCheck =
                          fieldIdStrForCheck === "68ecd888eb422bea55aa71b4" ||
                          camelCaseKeyStrForCheck ===
                            "68ecd888eb422bea55aa71b4" ||
                          camelCaseKeyStrForCheck.includes(
                            "68ecd888eb422bea55aa71b4"
                          ) ||
                          fieldIdStrForCheck.includes(
                            "68ecd888eb422bea55aa71b4"
                          );

                        const markTypeGrForCheck =
                          applicationDetails?.["66a687874db5f02d6861ed0e"] ||
                          applicationDetails?.[
                            camelCase("66a687874db5f02d6861ed0e")
                          ];
                        const markTypePostGrForCheck =
                          applicationDetails?.["676a57139e167618b7ec04ab"] ||
                          applicationDetails?.[
                            camelCase("676a57139e167618b7ec04ab")
                          ];
                        const markTypeLLBForCheck =
                          applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
                          applicationDetails?.[
                            camelCase("68ecd888eb422bea55aa71ae")
                          ];

                        const checkIsPercentageForCheck = (markType) => {
                          if (!markType) return false;
                          const markTypeStr = String(markType).trim();
                          return (
                            markTypeStr === "Percentage" ||
                            markTypeStr.toLowerCase() === "percentage"
                          );
                        };

                        const shouldBlockEdit =
                          (isGrPercentageFieldCheck &&
                            checkIsPercentageForCheck(markTypeGrForCheck)) ||
                          (isPostGrPercentageFieldCheck &&
                            checkIsPercentageForCheck(
                              markTypePostGrForCheck
                            )) ||
                          (isLLBPercentageFieldCheck &&
                            checkIsPercentageForCheck(markTypeLLBForCheck));

                        // BLOCK EDITING if it should be read-only
                        if (shouldBlockEdit) {
                          e.preventDefault();
                          e.stopPropagation();
                          return; // Don't update the value
                        }

                        setApplicationDetails({
                          ...applicationDetails,
                          [camelCaseKey]: newValue,
                        });

                        // Validate percentage for Graduation, Post-Graduation and LLB
                        const percentageNum = parseFloat(newValue) || 0;
                        const isGrPercentage =
                          camelCaseKey === "66a687874db5f02d6861ed11" ||
                          fieldIdStr === "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStr.includes("66a687874db5f02d6861ed11");
                        const isPostGrPercentage =
                          camelCaseKey === "676a57139e167618b7ec04b1" ||
                          fieldIdStr === "676a57139e167618b7ec04b1" ||
                          camelCaseKeyStr.includes("676a57139e167618b7ec04b1");
                        const isLLBPercentage =
                          camelCaseKey === "68ecd888eb422bea55aa71b4" ||
                          fieldIdStr === "68ecd888eb422bea55aa71b4" ||
                          camelCaseKeyStr.includes("68ecd888eb422bea55aa71b4");

                        if (
                          (isGrPercentage ||
                            isPostGrPercentage ||
                            isLLBPercentage) &&
                          percentageNum > 100
                        ) {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: [
                                ...new Set([
                                  ...(
                                    prevState[camelCaseKey]?.errors || []
                                  ).filter(
                                    (err) =>
                                      err !==
                                      "Percentage of Mark cannot be greater than 100%."
                                  ),
                                  "Percentage of Mark cannot be greater than 100%.",
                                ]),
                              ],
                              touched:
                                prevState?.[camelCaseKey]?.touched || true,
                            },
                          }));
                        } else if (
                          (isPostGrPercentage || isLLBPercentage) &&
                          percentageNum >= 0 &&
                          percentageNum <= 100
                        ) {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: (
                                prevState[camelCaseKey]?.errors || []
                              ).filter(
                                (err) =>
                                  err !==
                                  "Percentage of Mark cannot be greater than 100%."
                              ),
                              touched:
                                prevState?.[camelCaseKey]?.touched || true,
                            },
                          }));
                        }

                        fieldErrors?.[camelCaseKey]?.touched &&
                          checkErrorFn(input, camelCaseKey, newValue);
                      }}
                      onBlur={(e) => {
                        const percentageNum = parseFloat(fieldValue) || 0;
                        const isGrPercentage =
                          camelCaseKey === "66a687874db5f02d6861ed11" ||
                          fieldIdStr === "66a687874db5f02d6861ed11" ||
                          camelCaseKeyStr.includes("66a687874db5f02d6861ed11");
                        const isPostGrPercentage =
                          camelCaseKey === "676a57139e167618b7ec04b1";
                        const isLLBPercentage =
                          camelCaseKey === "68ecd888eb422bea55aa71b4";

                        if (
                          (isPostGrPercentage || isLLBPercentage) &&
                          percentageNum > 100
                        ) {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: [
                                ...new Set([
                                  ...(
                                    prevState[camelCaseKey]?.errors || []
                                  ).filter(
                                    (err) =>
                                      err !==
                                      "Percentage of Mark cannot be greater than 100%."
                                  ),
                                  "Percentage of Mark cannot be greater than 100%.",
                                ]),
                              ],
                              touched: true,
                            },
                          }));
                        } else if (
                          (isGrPercentage ||
                            isPostGrPercentage ||
                            isLLBPercentage) &&
                          percentageNum >= 0 &&
                          percentageNum <= 100
                        ) {
                          setFieldErrors((prevState) => ({
                            ...prevState,
                            [camelCaseKey]: {
                              errors: (
                                prevState[camelCaseKey]?.errors || []
                              ).filter(
                                (err) =>
                                  err !==
                                  "Percentage of Mark cannot be greater than 100%."
                              ),
                              touched:
                                prevState?.[camelCaseKey]?.touched || true,
                            },
                          }));
                        }

                        checkErrorFn(input, camelCaseKey, fieldValue);
                      }}
                      required={input.values.isRequired}
                      max={new Date().toISOString().split("T")[0]}
                    />
                    {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                      fieldErrors?.[camelCaseKey]?.touched &&
                      fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                        <span className="errorPresent" style={style.errorSpan}>
                          {err}
                          <br />
                        </span>
                      ))}
                  </>
                );
              })()}
            </>
          ) : currentMarkType == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                // placeholder={label}
                value={fieldValue}
                readOnly={(() => {
                  // FORCE CHECK: Make read-only if this is Graduation/Post-Graduation/LLB percentage field with mark type "Percentage"
                  const fieldIdForCheck = input?.values?._id || "";
                  const fieldIdStrForCheck = String(fieldIdForCheck);
                  const camelCaseKeyStrForCheck = String(camelCaseKey || "");

                  const isGrPercentageFieldCheck =
                    fieldIdStrForCheck === "66a687874db5f02d6861ed11" ||
                    camelCaseKeyStrForCheck === "66a687874db5f02d6861ed11" ||
                    camelCaseKeyStrForCheck.includes(
                      "66a687874db5f02d6861ed11"
                    ) ||
                    fieldIdStrForCheck.includes("66a687874db5f02d6861ed11");
                  const isPostGrPercentageFieldCheck =
                    fieldIdStrForCheck === "676a57139e167618b7ec04b1" ||
                    camelCaseKeyStrForCheck === "676a57139e167618b7ec04b1" ||
                    camelCaseKeyStrForCheck.includes(
                      "676a57139e167618b7ec04b1"
                    ) ||
                    fieldIdStrForCheck.includes("676a57139e167618b7ec04b1");
                  const isLLBPercentageFieldCheck =
                    fieldIdStrForCheck === "68ecd888eb422bea55aa71b4" ||
                    camelCaseKeyStrForCheck === "68ecd888eb422bea55aa71b4" ||
                    camelCaseKeyStrForCheck.includes(
                      "68ecd888eb422bea55aa71b4"
                    ) ||
                    fieldIdStrForCheck.includes("68ecd888eb422bea55aa71b4");

                  const markTypeGrForCheck =
                    applicationDetails?.["66a687874db5f02d6861ed0e"] ||
                    applicationDetails?.[camelCase("66a687874db5f02d6861ed0e")];
                  const markTypePostGrForCheck =
                    applicationDetails?.["676a57139e167618b7ec04ab"] ||
                    applicationDetails?.[camelCase("676a57139e167618b7ec04ab")];
                  const markTypeLLBForCheck =
                    applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
                    applicationDetails?.[camelCase("68ecd888eb422bea55aa71ae")];

                  const checkIsPercentageForCheck = (markType) => {
                    if (!markType) return false;
                    const markTypeStr = String(markType).trim();
                    return (
                      markTypeStr === "Percentage" ||
                      markTypeStr.toLowerCase() === "percentage"
                    );
                  };

                  return (
                    (isGrPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypeGrForCheck)) ||
                    (isPostGrPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypePostGrForCheck)) ||
                    (isLLBPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypeLLBForCheck))
                  );
                })()}
                onChange={(e) => {
                  const newValue = e.target.value;

                  // FORCE CHECK: Prevent editing if this is Graduation/Post-Graduation/LLB percentage field with mark type "Percentage"
                  const fieldIdForCheck = input?.values?._id || "";
                  const fieldIdStrForCheck = String(fieldIdForCheck);
                  const camelCaseKeyStrForCheck = String(camelCaseKey || "");

                  const isGrPercentageFieldCheck =
                    fieldIdStrForCheck === "66a687874db5f02d6861ed11" ||
                    camelCaseKeyStrForCheck === "66a687874db5f02d6861ed11" ||
                    camelCaseKeyStrForCheck.includes(
                      "66a687874db5f02d6861ed11"
                    ) ||
                    fieldIdStrForCheck.includes("66a687874db5f02d6861ed11");
                  const isPostGrPercentageFieldCheck =
                    fieldIdStrForCheck === "676a57139e167618b7ec04b1" ||
                    camelCaseKeyStrForCheck === "676a57139e167618b7ec04b1" ||
                    camelCaseKeyStrForCheck.includes(
                      "676a57139e167618b7ec04b1"
                    ) ||
                    fieldIdStrForCheck.includes("676a57139e167618b7ec04b1");
                  const isLLBPercentageFieldCheck =
                    fieldIdStrForCheck === "68ecd888eb422bea55aa71b4" ||
                    camelCaseKeyStrForCheck === "68ecd888eb422bea55aa71b4" ||
                    camelCaseKeyStrForCheck.includes(
                      "68ecd888eb422bea55aa71b4"
                    ) ||
                    fieldIdStrForCheck.includes("68ecd888eb422bea55aa71b4");

                  const markTypeGrForCheck =
                    applicationDetails?.["66a687874db5f02d6861ed0e"] ||
                    applicationDetails?.[camelCase("66a687874db5f02d6861ed0e")];
                  const markTypePostGrForCheck =
                    applicationDetails?.["676a57139e167618b7ec04ab"] ||
                    applicationDetails?.[camelCase("676a57139e167618b7ec04ab")];
                  const markTypeLLBForCheck =
                    applicationDetails?.["68ecd888eb422bea55aa71ae"] ||
                    applicationDetails?.[camelCase("68ecd888eb422bea55aa71ae")];

                  const checkIsPercentageForCheck = (markType) => {
                    if (!markType) return false;
                    const markTypeStr = String(markType).trim();
                    return (
                      markTypeStr === "Percentage" ||
                      markTypeStr.toLowerCase() === "percentage"
                    );
                  };

                  const shouldBlockEdit =
                    (isGrPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypeGrForCheck)) ||
                    (isPostGrPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypePostGrForCheck)) ||
                    (isLLBPercentageFieldCheck &&
                      checkIsPercentageForCheck(markTypeLLBForCheck));

                  // BLOCK EDITING if it should be read-only
                  if (shouldBlockEdit) {
                    e.preventDefault();
                    e.stopPropagation();
                    return; // Don't update the value
                  }

                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: newValue,
                  });

                  // Validate percentage for Post-Graduation and LLB
                  const percentageNum = parseFloat(newValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, newValue);
                }}
                onBlur={(e) => {
                  const percentageNum = parseFloat(fieldValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : (
            <>
              <input
                className="form-control text-dark"
                style={style.input}
                // type={input.values.inputFieldType}
                // placeholder={label}

                // defaultValue={"test"}
                // value={fieldValue || ""}
                // onChange={(e) =>

                //   setApplicationDetails({
                //     ...applicationDetails,
                //     [camelCaseKey]: `${applicationDetails?.vacancyId?.grade?.designationPrefix} (${applicationDetails?.vacancyId?.department?.name}), Grade - ${applicationDetails?.vacancyId?.grade?.gradeName}`,
                //   })
                // }
                // required={input.values.isRequired}
              />
            </>
          );

        case "Grade Obtained":
          return camelCaseKey === "673b18a3b182bc6699a164a4" &&
            markType10th === "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "673b3b84b182bc6699a175fd" &&
            markType12th === "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "673c52c4b182bc6699a19cae" &&
            markTypeGr == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "676a57139e167618b7ec04b3" &&
            markTypePostGr == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "68ecd888eb422bea55aa71b6" &&
            markTypeLLB == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : (
            <></>
          );

        case "Please mention graduation degree":
          return camelCaseKey == "68e74ef6c921b345b802ba05" &&
            stremandBranch === "Others" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "673b3b84b182bc6699a175fd" &&
            markType12th === "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "673c52c4b182bc6699a19cae" &&
            markTypeGr == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : camelCaseKey === "676a57139e167618b7ec04b3" &&
            markTypePostGr == "Grade" ? (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                value={fieldValue}
                onChange={(e) => {
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: e.target.value,
                  });
                  if (fieldErrors?.[camelCaseKey]?.touched) {
                    checkErrorFn(input, camelCaseKey, e.target.value);
                  }
                }}
                onBlur={(e) => {
                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          ) : (
            <></>
          );

        case "Application ID":
          return (
            <>
              <input
                className="form-control text-dark"
                style={style.input}
                type={input.values.inputFieldType}
                // placeholder={label}
                value={fieldValue || applicationID}
                onChange={(e) =>
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: applicationID,
                  })
                }
                disabled={true}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
            </>
          );
          break;

        case "Post you have applied for?":
        case "During the year?":
          if (
            (camelCaseKey === "68e505a0eb422bea55a9ac11" ||
              "68e505a0eb422bea55a9ac13") &&
            appliedEarlier === "Yes"
          ) {
            return (
              <>
                <input
                  className="form-control text-dark"
                  style={
                    fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                    fieldErrors?.[camelCaseKey]?.touched
                      ? { ...style.input, ...style.errorBox }
                      : style.input
                  }
                  type={input.values.inputFieldType}
                  value={fieldValue}
                  onChange={(e) => {
                    setApplicationDetails({
                      ...applicationDetails,
                      [camelCaseKey]: e.target.value,
                    });
                    if (fieldErrors?.[camelCaseKey]?.touched) {
                      checkErrorFn(input, camelCaseKey, e.target.value);
                    }
                  }}
                  onBlur={() => {
                    checkErrorFn(input, camelCaseKey, fieldValue);
                  }}
                  required={input.values.isRequired}
                  max={new Date().toISOString().split("T")[0]}
                />
                {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched &&
                  fieldErrors?.[camelCaseKey]?.errors.map((err, index) => (
                    <span
                      key={`error-${index}`}
                      className="errorPresent"
                      style={style.errorSpan}
                    >
                      {err}
                      <br />
                    </span>
                  ))}
              </>
            );
          } else {
            return null;
          }

        case "Advertisement Details":
          return (
            <input
              className="form-control text-dark"
              style={style.input}
              type={input.values.inputFieldType}
              value={
                fieldValue ||
                `${applicationDetails?.advertisement?.advertisementHeading} (No. ${applicationDetails?.advertisement?.advertisementNumber})`
              }
              onChange={(e) =>
                setApplicationDetails({
                  ...applicationDetails,
                  [camelCaseKey]: `${applicationDetails?.advertisement?.advertisementHeading} (No. ${applicationDetails?.advertisement?.advertisementNumber})`,
                })
              }
              disabled={true}
              required={input.values.isRequired}
              max={
                input.values.inputFieldType === "date"
                  ? new Date().toISOString().split("T")[0]
                  : undefined
              }
            />
          );

          break;

        case "Post Name":
          return (
            <input
              className="form-control text-dark"
              style={style.input}
              type={input.values.inputFieldType}
              // placeholder={label}
              disabled={true}
              value={
                fieldValue ||
                `${applicationDetails?.vacancyId?.grade?.designationPrefix} (${applicationDetails?.vacancyId?.department?.name}), Grade - ${applicationDetails?.vacancyId?.grade?.gradeName}`
              }
              onChange={(e) =>
                setApplicationDetails({
                  ...applicationDetails,
                  [camelCaseKey]: `${applicationDetails?.vacancyId?.grade?.designationPrefix} (${applicationDetails?.vacancyId?.department?.name}), Grade - ${applicationDetails?.vacancyId?.grade?.gradeName}`,
                })
              }
              required={input.values.isRequired}
              max={
                input.values.inputFieldType === "date"
                  ? new Date().toISOString().split("T")[0]
                  : undefined
              }
            />
          );
          break;

        case "Age":
          return (
            <>
              <input
                className="form-control text-dark"
                style={style.input}
                type="text"
                value={applicationDetails?.ageDetail}
                disabled
                required={input.values.isRequired}
                max={
                  input.values.inputFieldType === "date"
                    ? new Date().toISOString().split("T")[0]
                    : undefined
                }
              />
              <span
                className="fw-bold text-nowrap"
                style={{
                  fontSize: "0.8em", // Makes the text smaller
                  verticalAlign: "baseline",
                  color: "brown",
                }}
              >
                ( Age As on Advt. Closing Date{" "}
                {formatDate(
                  applicationDetails?.advertisement?.advertisementClosingDate
                )}
                )
              </span>
            </>
          );
          break;
        case "Date of Birth":
        case "Date Of Birth":
          return (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                // placeholder={label}
                value={fieldValue}
                disabled
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;

        case "Applicant's Full Name":
        case "Mobile Number":
        case "Email":
          return (
            <input
              className="form-control text-dark"
              style={style.input}
              type={input.values.inputFieldType}
              // placeholder={label}
              disabled={true}
              value={applicationDetails?.[`${camelCase(label)}`]}
              required={input.values.isRequired}
              onChange={() => {}}
            />
          );
          break;
        case "Alternate Mobile Number":
          return (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type="number"
                // placeholder={label}
                value={fieldValue}
                onChange={(e) => {
                  const newValue = e.target.value;
                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: newValue,
                  });

                  // Validate percentage for Post-Graduation and LLB
                  const percentageNum = parseFloat(newValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, newValue);
                }}
                onBlur={(e) => {
                  const percentageNum = parseFloat(fieldValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
              {applicationDetails[camelCaseKey] ==
                applicationDetails?.["mobileNumber"] && (
                <span className="errorPresent" style={style.errorSpan}>
                  {"Cannot be same as registered number"}
                  <br />
                </span>
              )}
            </>
          );
          break;
        default:
          // Check if this is a Year of Passing field (10th, 12th, Graduation, Post-Graduation, or LLB)
          const yearofPassing10thId = "66a687874db5f02d6861ed02";
          const yearofPassing12thId = "66a727079680c25e280d6b2d";
          const yearofPassingGraduationId = "66a687874db5f02d6861ed0d";
          // Post Graduation Year of Passing - check both possible IDs
          const yearofPassingPostGraduationId1 = "676a57139e167618b7ec04ac";
          const yearofPassingPostGraduationId2 = "676a57139e167618b7ec04a7";
          const yearofPassingLLBId = "68ecd888eb422bea55aa71ad";

          // Check by field ID
          const isYearOfPassingById =
            camelCaseKey === yearofPassing10thId ||
            camelCaseKey === yearofPassing12thId ||
            camelCaseKey === yearofPassingGraduationId ||
            camelCaseKey === yearofPassingPostGraduationId1 ||
            camelCaseKey === yearofPassingPostGraduationId2 ||
            camelCaseKey === yearofPassingLLBId;

          // Also check by label as fallback (to catch any "Year of Passing" field regardless of ID)
          const isYearOfPassingByLabel =
            label &&
            (label.toLowerCase().includes("year of passing") ||
              label.toLowerCase() === "year of passing");

          const isYearOfPassingField =
            isYearOfPassingById || isYearOfPassingByLabel;

          return (
            <>
              <input
                className="form-control text-dark"
                style={
                  fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                  fieldErrors?.[camelCaseKey]?.touched
                    ? { ...style.input, ...style.errorBox }
                    : style.input
                }
                type={input.values.inputFieldType}
                // placeholder={label}
                value={fieldValue}
                maxLength={isYearOfPassingField ? 4 : undefined}
                onChange={(e) => {
                  let newValue = e.target.value;

                  // For Year of Passing fields, restrict to maximum 4 digits
                  if (isYearOfPassingField) {
                    // Remove any non-digit characters and limit to 4 digits
                    newValue = newValue.replace(/\D/g, "").slice(0, 4);
                  }

                  setApplicationDetails({
                    ...applicationDetails,
                    [camelCaseKey]: newValue,
                  });

                  // Validate percentage for Post-Graduation and LLB
                  const percentageNum = parseFloat(newValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  fieldErrors?.[camelCaseKey]?.touched &&
                    checkErrorFn(input, camelCaseKey, newValue);
                }}
                onBlur={(e) => {
                  const percentageNum = parseFloat(fieldValue) || 0;
                  const isPostGrPercentage =
                    camelCaseKey === "676a57139e167618b7ec04b1";
                  const isLLBPercentage =
                    camelCaseKey === "68ecd888eb422bea55aa71b4";

                  if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum > 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: [
                          ...new Set([
                            ...(prevState[camelCaseKey]?.errors || []).filter(
                              (err) =>
                                err !==
                                "Percentage of Mark cannot be greater than 100%."
                            ),
                            "Percentage of Mark cannot be greater than 100%.",
                          ]),
                        ],
                        touched: true,
                      },
                    }));
                  } else if (
                    (isPostGrPercentage || isLLBPercentage) &&
                    percentageNum >= 0 &&
                    percentageNum <= 100
                  ) {
                    setFieldErrors((prevState) => ({
                      ...prevState,
                      [camelCaseKey]: {
                        errors: (prevState[camelCaseKey]?.errors || []).filter(
                          (err) =>
                            err !==
                            "Percentage of Mark cannot be greater than 100%."
                        ),
                        touched: prevState?.[camelCaseKey]?.touched || true,
                      },
                    }));
                  }

                  checkErrorFn(input, camelCaseKey, fieldValue);
                }}
                required={input.values.isRequired}
                max={new Date().toISOString().split("T")[0]}
              />
              {fieldErrors?.[camelCaseKey]?.errors?.length > 0 &&
                fieldErrors?.[camelCaseKey]?.touched &&
                fieldErrors?.[camelCaseKey]?.errors?.map((err) => (
                  <span className="errorPresent" style={style.errorSpan}>
                    {err}
                    <br />
                  </span>
                ))}
            </>
          );
          break;
      }
    };

    const renderInput = (
      fieldValue,
      camelCaseKey,
      label,
      input,
      applicationDetails,
      setApplicationDetails,
      checkedValues,
      handleCheckboxChange,
      handleUploadImage
    ) => {
      switch (input.values.inputFieldType) {
        // case "date":
        //   return renderDateInput(
        //     fieldValue,
        //     camelCaseKey,
        //     label,
        //     input,
        //     applicationDetails,
        //     setApplicationDetails,
        //     checkedValues,
        //     handleCheckboxChange,
        //     handleUploadImage
        //   );
        case "select":
          return renderSelectInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "radio":
          return renderRadioInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "note":
          return renderNote(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "checkbox":
          return renderCheckboxInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "image":
          return renderImageInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "multipleImage":
          return renderImageInputMultiple(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "pdf":
          return renderPdfInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );

        case "multiplePdf":
          return renderPdfInputMultiple(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );

        case "textarea":
          return renderTextareaInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
        case "DomicileOfOdisha":
          return (
            <DomicileOfOdisha
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              applicationDetails={applicationDetails}
              style={style}
            />
          );
        case "DepartmentalCandidate":
          return (
            <DepartmentalCandidate
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              applicationDetails={applicationDetails}
              closingDate={closingDate}
              style={style}
            />
          );
        case "AreYouASportsMan":
          return (
            <AreYouASportsMan
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              applicationDetails={applicationDetails}
              style={style}
            />
          );
        case "ReservationCategory":
          return (
            <ReservationCategory
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              applicationDetails={applicationDetails}
              style={style}
              allowedCategory={allowedCategory}
            />
          );
        case "ExServicemen":
          return (
            <ExServicemen
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              applicationDetails={applicationDetails}
              style={style}
              closingDate={closingDate}
            />
          );
        case "PersonWithDisability":
          return (
            <PersonWithDisability
              handelApplicationDetailsChange={(d) =>
                handelApplicationDetailsChange(d)
              }
              allowedPwbdType={state?.post?.posting?.allowedPwbdType}
              applicationDetails={applicationDetails}
              style={style}
            />
          );
        case "Experience-Static":
          return (
            <ExperienceInputs
              checkErrorFn={checkErrorFn}
              setApplicationDetails={setApplicationDetails}
              applicationDetails={applicationDetails}
              style={style}
              postandvacancyDetails={state.post?.posting}
              applicationID={applicationID}
              advertisementClosingDate={
                applicationDetails?.advertisement?.advertisementClosingDate
              }
              application={application}
              applicationForm={applicationForm}
            />
          );

        default:
          return renderTextInput(
            fieldValue,
            camelCaseKey,
            label,
            input,
            applicationDetails,
            setApplicationDetails,
            checkedValues,
            handleCheckboxChange,
            handleUploadImage
          );
      }
    };

    const renderGroupedInputs = (inputs, isReviewMode = false) => {
      let groupedElements = [];
      let currentSubheading = null;
      let currentGroup = [];

      // Track if we're currently in the LLB Degree section
      let isInLLBSection = false;

      inputs.forEach((input, idx) => {
        const camelCaseKey = camelCase(input.values._id);
        const label = input.values.inputFieldName;
        //("lable", label);

        // FIRST: Check if this is the LLB Course Type field (ID: 6932c5664c6c63e650c7a4cc)
        // Hide it immediately when Integrated LLB is selected, regardless of section
        // This field appears in Graduation Details section but should be hidden when Integrated LLB is selected
        if (
          hideLLBSection &&
          (input.values._id === "6932c5664c6c63e650c7a4cc" ||
            camelCaseKey === "6932c5664c6c63e650c7a4cc")
        ) {
          return; // Skip rendering this field
        }

        // Check if this is the LLB Degree subheading
        if (input.values.inputFieldType === "SubHeading") {
          if (label === "LLB Degree" || label.includes("LLB Degree")) {
            isInLLBSection = true; // We're entering the LLB section
            if (hideLLBSection) {
              return; // Skip the subheading itself and all fields in this section
            }
          } else {
            // We've moved to a different section
            isInLLBSection = false;
          }
        }

        // Hide LLB Degree section fields when Integrated LLB is selected
        // Only hide Course Type field (ID: 6932c5664c6c63e650c7a4cc) when it's in LLB Degree section, not in 10th/12th
        if (
          hideLLBSection &&
          input.values.inputFieldType !== "SubHeading" && // Don't filter subheadings here, already handled above
          (camelCaseKey.startsWith("68ecd888eb422bea55aa71") ||
            (input.values._id === "6932c5664c6c63e650c7a4cc" &&
              isInLLBSection) ||
            (camelCaseKey === "6932c5664c6c63e650c7a4cc" && isInLLBSection) ||
            (label.includes("LLB") && isInLLBSection) ||
            (label.includes("LLB Degree") && isInLLBSection) ||
            (label.includes("LLB Certificates") && isInLLBSection) ||
            (label.includes("LLB Marksheets") && isInLLBSection) ||
            (label.toLowerCase().includes("course type") &&
              input.values._id &&
              input.values._id.startsWith("69") &&
              isInLLBSection) ||
            isInLLBSection)
        ) {
          return; // Skip rendering this field
        }

        const fieldValue = applicationDetails
          ? applicationDetails[camelCaseKey]
          : "";

        if (input.values.inputFieldType === "SubHeading") {
          // Push the current group to groupedElements if there's any
          if (currentGroup.length > 0) {
            groupedElements.push(
              <Card key={currentSubheading} className="mb-2 dynamicFormcards">
                <Col
                  key={idx}
                  xs={
                    window.innerWidth >= 793 ? input?.values?.columnLength : 12
                  }
                  md={input.values.columnLength}
                  className=""
                >
                  {" "}
                  <Row>{currentGroup}</Row>
                </Col>
              </Card>
            );
            currentGroup = [];
          }
          currentSubheading = idx;
          currentGroup.push(
            <label
              className="form-label form-heading-main"
              style={
                isReviewMode
                  ? {
                      backgroundColor: "#f5f5f5",
                      color: "black",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                      padding: "8px 12px",
                      marginBottom: "15px",
                      marginTop: "10px",
                      fontWeight: "600",
                      display: "block",
                      width: "100%",
                      border: "1px solid #e0e0e0",
                    }
                  : {}
              }
            >
              {label === " Document Upload" ? (
                <>
                  {label}
                  <span
                    style={{
                      color: "brown",
                      margin: "10px",
                      fontFamily: "Roboto",
                      fontWeight: "bold",
                      fontSize: "11px",
                      lineHeight: "10.55px",
                    }}
                    className="Documentdploadvalidation"
                  >
                    (Only JPG and PDF files are accepted, with a maximum file
                    size of 1 MB.)
                  </span>
                </>
              ) : label === "Permanent Address" ? (
                <>
                  {label}

                  <div className="form-check m-0 p-0" key={`pA_checkbox`}>
                    <input
                      id="pA_checkbox"
                      type={"checkbox"}
                      checked={isSameAsCorrespondence}
                      onChange={handleCheckboxChange_}
                    />
                    <label
                      htmlFor={"pA_checkbox"}
                      style={{ ...style.label, marginLeft: "5px" }}
                    >
                      Same as correspondence address
                    </label>
                  </div>
                </>
              ) : label === "Grade" ? (
                <></>
              ) : (
                label
              )}
            </label>
            //  </Col>
          );
        } else {
          // Debug: Log all fields being processed
          console.log(
            "Processing field:",
            input.values.inputFieldName,
            "ID:",
            input.values._id
          );

          // Conditional logic for "Name of the Organization" field
          // Only show when "Sponsored By Organization" is selected in "Professional course" dropdown
          const professionalCourseFieldId = "68e88d008f50ed28ac76ba47";
          const organizationNameFieldId = "68e88d008f50ed28ac76ba49";

          if (input.values._id === organizationNameFieldId) {
            const professionalCourseValue =
              applicationDetails[camelCase(professionalCourseFieldId)];
            console.log("=== DEBUGGING CONDITIONAL FIELD ===");
            console.log("Current field ID:", input.values._id);
            console.log("Field name:", input.values.inputFieldName);
            console.log(
              "Professional course field ID:",
              professionalCourseFieldId
            );
            console.log("Professional course value:", professionalCourseValue);
            console.log("CamelCase key:", camelCase(professionalCourseFieldId));
            console.log(
              "Application details keys:",
              Object.keys(applicationDetails)
            );

            if (professionalCourseValue !== "Sponsored By Organization") {
              console.log(
                "HIDING field - value is not 'Sponsored By Organization'"
              );
              return; // Skip rendering this field
            } else {
              console.log(
                "SHOWING field - value is 'Sponsored By Organization'"
              );
            }
          }

          // Business Excellence conditional rendering
          // Field IDs: Business Excellence Certification: 693682fe4c6c63e650c921b8, Upload Certificate: 693682fe4c6c63e650c921fb
          const BUSINESS_EXCELLENCE_CERTIFICATION_ID =
            "693682fe4c6c63e650c921b8";
          const UPLOAD_CERTIFICATE_ID = "693682fe4c6c63e650c921fb";
          const uploadCertificateFieldId = input.values._id;
          const isUploadCertificateField =
            uploadCertificateFieldId === UPLOAD_CERTIFICATE_ID ||
            camelCaseKey === camelCase(UPLOAD_CERTIFICATE_ID);

          if (isUploadCertificateField) {
            // Get Business Excellence Certification value (check both field ID and camelCase key)
            const businessExcellenceValue =
              applicationDetails?.[BUSINESS_EXCELLENCE_CERTIFICATION_ID] ||
              applicationDetails?.[
                camelCase(BUSINESS_EXCELLENCE_CERTIFICATION_ID)
              ];

            // Check if Business Excellence Certification is empty, "Select", or has no value
            const isEmptyOrSelect =
              !businessExcellenceValue ||
              businessExcellenceValue === "" ||
              businessExcellenceValue === "Select" ||
              (Array.isArray(businessExcellenceValue) &&
                businessExcellenceValue.length === 0) ||
              (Array.isArray(businessExcellenceValue) &&
                businessExcellenceValue.every(
                  (item) =>
                    !item ||
                    (typeof item === "string" && item.trim() === "") ||
                    (typeof item === "object" &&
                      item !== null &&
                      (!item.value || item.value.trim() === ""))
                ));

            // Hide Upload Certificate field if Business Excellence Certification is empty/Select
            if (isEmptyOrSelect) {
              return; // Skip rendering this field
            }
          }

          currentGroup.push(
            <Col
              key={idx}
              xs={window.innerWidth >= 793 ? input?.values?.columnLength : 12}
              md={input.values.columnLength}
              className="mb-2"
            >
              {" "}
              <>
                {camelCaseKey === "6719d53d3ac83738a0ba587a" ? (
                  applicationDetails["66a687874db5f02d6861ed04"] ===
                    "CGPA/OGPA" ||
                  applicationDetails["66a687874db5f02d6861ed04"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "6719d8603ac83738a0ba5fd7" ? (
                  applicationDetails["66a728ec9680c25e280d6bf6"] ===
                    "CGPA/OGPA" ||
                  applicationDetails["66a728ec9680c25e280d6bf6"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "6719d9653ac83738a0ba6155" ? (
                  applicationDetails["66a687874db5f02d6861ed0e"] ===
                    "CGPA/OGPA" ||
                  applicationDetails["66a687874db5f02d6861ed0e"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "676a57139e167618b7ec04b5" ? (
                  applicationDetails["676a57139e167618b7ec04ab"] ===
                    "CGPA/OGPA" ||
                  applicationDetails["676a57139e167618b7ec04ab"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "68ecd888eb422bea55aa71b8" ? (
                  applicationDetails["68ecd888eb422bea55aa71ae"] ===
                    "CGPA/OGPA" ||
                  applicationDetails["68ecd888eb422bea55aa71ae"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "674ea5f2ba7bd153d0509340" ? (
                  applicationDetails["66a687874db5f02d6861ed01"] ===
                  "Others" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "674ee278ba7bd153d050ab35" ? (
                  applicationDetails["66a726919680c25e280d6ad0"] === "Others" &&
                  applicationDetails["67927705f2187a33680afe54"] === "12th" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "66a726919680c25e280d6ad0" ? (
                  applicationDetails["67927705f2187a33680afe54"] === "12th" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : // camelCaseKey === "67928864f2187a33680b0362" ? (
                //   applicationDetails["67927705f2187a33680afe54"] ===
                //   "Diploma" ? (
                //     <label
                //       className="inputBoxHeadForm upload-head-gap mt-2"
                //       style={style.label}
                //     >
                //       {label}
                //       {input.values.isRequired && label && (
                //         <span className="mx-1 text-danger star">*</span>
                //       )}
                //     </label>
                //   ) : <></>)
                //   :
                // camelCaseKey === "674ee278ba7bd153d050ab35" ? (
                //   applicationDetails["67927705f2187a33680afe54"] ===
                //   "Diploma" ?  <></>  : (
                //     <label
                //       className="inputBoxHeadForm upload-head-gap mt-2"
                //       style={style.label}
                //     >
                //       {label}
                //       {input.values.isRequired && label && (
                //         <span className="mx-1 text-danger star">*</span>
                //       )}
                //     </label>
                //   ))
                // board and council label

                camelCaseKey === "67270267df49515ae469b46d" ? (
                  applicationDetails["67270267df49515ae469b465"] ===
                  "CGPA/OGPA" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "673b18a3b182bc6699a164a4" ? (
                  applicationDetails["66a687874db5f02d6861ed04"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "673b3b84b182bc6699a175fd" ? (
                  applicationDetails["66a728ec9680c25e280d6bf6"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "673c52c4b182bc6699a19cae" ? (
                  applicationDetails["66a687874db5f02d6861ed0e"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "676a57139e167618b7ec04b3" ? (
                  applicationDetails["676a57139e167618b7ec04ab"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "68ecd888eb422bea55aa71b6" ? (
                  applicationDetails["68ecd888eb422bea55aa71ae"] === "Grade" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "68eb40c2c268a51cd00e9f59" ? (
                  applicationDetails?.["67927705f2187a33680afe54"] ===
                    "Diploma" &&
                  applicationDetails?.["6745516aba7bd153d04f36f2"] ===
                    "Others" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>

                    //                 camelCaseKey === "68eb40c2c268a51cd00e9f59" && select12thDeploma === "Diploma" &&
                    // stremandBranchDiploma === "Others"
                  )
                ) : camelCaseKey === "68e74ef6c921b345b802ba05" ? (
                  applicationDetails["68e67d5e9698f142bc5322b7"] ===
                  "Others" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : [
                    "68e505a0eb422bea55a9ac11",
                    "68e505a0eb422bea55a9ac13",
                    "68e505a0eb422bea55a9ac15",
                  ].includes(camelCaseKey) ? (
                  applicationDetails["68e505a0eb422bea55a9ac0f"] === "Yes" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : //              (camelCaseKey === "68e505a0eb422bea55a9ac17") &&
                // appliedEarlier === "Yes" && shortlistedPersonalInterview === "Yes"
                camelCaseKey === "68e505a0eb422bea55a9ac17" ? (
                  applicationDetails["68e505a0eb422bea55a9ac0f"] === "Yes" &&
                  applicationDetails?.["68e505a0eb422bea55a9ac15"] === "Yes" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : camelCaseKey === "68e505a0eb422bea55a9ac19" ? (
                  applicationDetails["68e505a0eb422bea55a9ac0f"] === "Yes" &&
                  applicationDetails?.["68e505a0eb422bea55a9ac15"] === "Yes" &&
                  applicationDetails?.["68e505a0eb422bea55a9ac17"] === "Yes" ? (
                    <label
                      className="inputBoxHeadForm upload-head-gap mt-2"
                      style={style.label}
                    >
                      {label}
                      {input.values.isRequired && label && (
                        <span className="mx-1 text-danger star">*</span>
                      )}
                    </label>
                  ) : (
                    <></>
                  )
                ) : (
                  <label
                    className="inputBoxHeadForm upload-head-gap mt-2"
                    style={style.label}
                  >
                    {label}
                    {input.values.isRequired && label && (
                      <span className="mx-1 text-danger star">*</span>
                    )}
                  </label>
                )}

                {renderInput(
                  fieldValue,
                  camelCaseKey,
                  label,
                  input,
                  applicationDetails,
                  setApplicationDetails,
                  checkedValues,
                  handleCheckboxChange,
                  handleUploadImage
                )}
              </>
            </Col>
          );
        }
      });
      if (currentGroup.length > 0) {
        groupedElements.push(
          <Card key={currentSubheading} className="mb-2 dynamicFormcards">
            <Row>{currentGroup}</Row>
          </Card>
        );
      }

      return groupedElements;
    };

    // Check if we're in review mode
    const isReviewMode = tabIndex === applicationForm?.length;

    return (
      <Row className="ml-1">
        {renderGroupedInputs(item.values, isReviewMode)}
      </Row>
    );
  };

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleTabClick = () => {
    setIsMobileMenuOpen(false);
  };

  const [tablesRendered, setRendered] = useState(false);
  const [tablesRenderedquali, setTablesRenderedquali] = useState(false);

  // Helper function to safely convert any value to string for React rendering
  const safeStringValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }
    if (typeof value === "string") {
      return value;
    }
    if (typeof value === "number" || typeof value === "boolean") {
      return String(value);
    }
    if (typeof value === "object") {
      // If it's an array of objects (like departmentalFiles with {file, name, verified})
      if (Array.isArray(value)) {
        return value
          .map((item) => {
            if (typeof item === "object" && item !== null) {
              // For file objects, return the file URL or name
              return item.file || item.name || item.url || "";
            }
            return String(item);
          })
          .filter(Boolean)
          .join(", ");
      }
      // For single objects, try to extract a meaningful string value
      return value.file || value.name || value.url || value.value || "";
    }
    return String(value);
  };

  const renderTableOfIsArray = (item) => {
    if (!tablesRendered) {
      function getUniqueTabNamesAsync(data) {
        const tabNames = new Set();
        for (let i = 0; i < data.length; i++) {
          if (data[i].tab) tabNames.add(data[i].tab);
        }
        return Array.from(tabNames);
      }

      const RenderTableForFieldsWithTab = (data, targetTab) => {
        const matchingItems = data.filter(
          (item) =>
            Array.isArray(item.fields) &&
            item.fields.some((field) => field.tab === targetTab)
        );

        if (matchingItems.length === 0) return <div></div>;

        // Filter headers and ensure only matching fields with values are displayed
        const filteredHeaders = matchingItems[0].fields
          .filter((field) => {
            // Check if field has a value - use field.value from dynamicFields or check applicationDetails
            const fieldValue =
              field.value ||
              applicationDetails?.[camelCase(field?.values?._id)] ||
              applicationDetails?.[field?.values?._id] ||
              applicationDetails?.[camelCase(field?.values?.inputFieldName)] ||
              applicationDetails?.[field?.values?.inputFieldName];

            const hasValue =
              fieldValue !== null &&
              fieldValue !== undefined &&
              fieldValue !== "" &&
              fieldValue !== " " &&
              (typeof fieldValue !== "string" || fieldValue.trim() !== "") &&
              fieldValue !== "N/A" &&
              fieldValue !== "null" &&
              fieldValue !== "undefined";

            // Exclude document upload fields and file fields
            const isDocumentField =
              [
                "Certificates",
                "Mark sheets",
                "Letter Of Appointment",
                "Release Letter",
                "Proof Of Certificate",
                "Proof of Certificate",
              ].includes(field.values.inputFieldName) ||
              field.values.inputFieldType === "pdf" ||
              field.values.inputFieldType === "image" ||
              field.values.inputFieldType === "multiplePdf";

            return (
              field.tab === targetTab &&
              field.values.inputFieldType !== "SubHeading" &&
              !isDocumentField &&
              hasValue
            ); // Only include fields with values
          })
          .map((field) => field.values.inputFieldName);

        // Get the subheading if it exists
        const heading = matchingItems[0].fields
          .filter(
            (field) =>
              field.tab === targetTab &&
              field.values.inputFieldType === "SubHeading"
          )
          .map((field) => field.values.inputFieldName);

        return (
          <Card
            className="mt-2 mb-0 dynamicFormcards ms-3 me-3"
            style={{ width: "97%" }}
          >
            <Row className="mt-3">
              <label className="form-label form-heading-main">
                {heading[0]}
              </label>
              <Table
                className="ms-2 me-2"
                bordered
                style={{
                  border: "1px solid black",
                  overflow: "hidden",
                  width: "98%",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr>
                    {filteredHeaders.map((header, index) => (
                      <th
                        key={index}
                        style={{
                          border: "1px solid black",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          width: `${98 / filteredHeaders.length}%`,
                        }}
                      >
                        <label
                          className="form-label form-heading-main m-0 p-0"
                          style={style.label}
                        >
                          {header}
                        </label>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {matchingItems.map((item, rowIndex) => {
                    // Order fields to match headers exactly - this ensures correct column alignment
                    const orderedFields = filteredHeaders
                      .map((headerName) => {
                        return item.fields.find(
                          (field) =>
                            field.tab === targetTab &&
                            field.values.inputFieldType !== "SubHeading" &&
                            field.values.inputFieldName === headerName
                        );
                      })
                      .filter(Boolean); // Remove undefined fields

                    return orderedFields.length > 0 ? (
                      <tr key={rowIndex}>
                        {orderedFields.map((field, colIndex) => {
                          const isLink = /^(http|https):\/\/[^ "]+$/.test(
                            field.value
                          );
                          return !isLink ? (
                            <td
                              key={colIndex}
                              style={{
                                border: "1px solid black",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                width: `${98 / filteredHeaders.length}%`,
                              }}
                            >
                              <span
                                style={{ fontSize: "13px", fontWeight: "500" }}
                              >
                                {field.value &&
                                field.value !== " " &&
                                field.value.trim() !== ""
                                  ? safeStringValue(field.value)
                                  : "N/A"}
                              </span>
                            </td>
                          ) : null;
                        })}
                      </tr>
                    ) : null;
                  })}
                </tbody>
              </Table>
            </Row>
          </Card>
        );
      };

      const tabs = getUniqueTabNamesAsync(dynamicFields);
      return tabs.map(
        (tab) =>
          tab === camelCase(item?.formTab) &&
          RenderTableForFieldsWithTab(dynamicFields, tab)
      );
    }
  };

  const renderTableForNonArrayData = (data, item = null) => {
    // Helper function to safely convert fieldValue to string for display
    // Prevents error when fieldValue is a file object (with file, name, verified properties)
    const getSafeDisplayValue = (value) => {
      if (value === null || value === undefined) return "N/A";
      if (typeof value === "string" || typeof value === "number")
        return String(value);
      if (typeof value === "object") {
        // If it's a file object with file, name, verified properties, return "N/A" or file name
        if (
          value.hasOwnProperty("file") &&
          value.hasOwnProperty("name") &&
          value.hasOwnProperty("verified")
        ) {
          // Return the file name if available, otherwise "N/A"
          return value.name || "File uploaded";
        }
        // If it's an array, return "N/A" or string representation
        if (Array.isArray(value)) {
          return value.length > 0 ? `${value.length} item(s)` : "N/A";
        }
        // For other objects, try to stringify or return "N/A"
        try {
          return JSON.stringify(value);
        } catch {
          return "N/A";
        }
      }
      return String(value);
    };

    const subHeadings = data?.filter(
      (fieldItem) => fieldItem?.values?.inputFieldType === "SubHeading"
    );

    const getFieldsBetweenSubHeadings = (startIndex, data, subHeadingName) => {
      let fields = [];
      // Check if we're in LLB Degree section
      const isLLBSection =
        subHeadingName === "LLB Degree" ||
        subHeadingName?.includes("LLB Degree");

      for (let i = startIndex + 1; i < data?.length; i++) {
        if (data[i]?.values?.inputFieldType === "SubHeading") break;

        // Filter out LLB Course Type field (ID: 6932c5664c6c63e650c7a4cc) ONLY when in LLB Degree section
        if (
          hideLLBSection &&
          isLLBSection &&
          data[i]?.values?._id === "6932c5664c6c63e650c7a4cc"
        ) {
          continue; // Skip this field only in LLB section
        }

        fields.push(data[i]);
      }
      return fields;
    };

    // If no subheadings, render all fields in a single table without grouping
    if (!subHeadings?.length) {
      // Filter out SubHeading and note types, and get all displayable fields
      const displayableFields = data?.filter(
        (fieldItem) =>
          fieldItem?.values?.inputFieldType !== "SubHeading" &&
          fieldItem?.values?.inputFieldType !== "note" &&
          fieldItem?.values?.inputFieldType
      );

      if (!displayableFields?.length) {
        return <div>No data available</div>;
      }

      return (
        <Card
          className="mt-2 mb-0 dynamicFormcards ms-0 me-0 ps-0 pe-0"
          style={{ width: "100%" }}
        >
          <Row className="mt-3 ms-0 me-0">
            <Table
              className="ms-2 me-2"
              bordered
              style={{
                border: "1px solid black",
                overflow: "hidden",
                width: "98%",
                tableLayout: "fixed",
              }}
            >
              <thead className="p-0 m-0">
                <tr className="p-0 m-0">
                  {displayableFields?.map((field, headerIndex) => {
                    const headerName = field?.values?.inputFieldName || "";
                    const rawFieldValue =
                      applicationDetails[field?.values?._id];
                    const fieldValueForComparison =
                      typeof rawFieldValue === "string"
                        ? rawFieldValue
                        : rawFieldValue?.name || "N/A";

                    const skipCondition =
                      headerName.includes("Certificates") ||
                      headerName.includes("Marksheets") ||
                      headerName.includes("Mark Sheets") ||
                      headerName.includes("Attach the Conversion formula") ||
                      (headerName === "Board/Council" &&
                        fieldValueForComparison === "Others") ||
                      (headerName === "Board/Council" &&
                        (fieldValueForComparison === "N/A" || !rawFieldValue));

                    if (skipCondition) {
                      return null;
                    }

                    return (
                      <th
                        key={headerIndex}
                        style={{
                          border: "1px solid black",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          width: `${98 / displayableFields.length}%`,
                        }}
                      >
                        <label
                          className="form-label form-heading-main m-0 p-0"
                          style={style.label}
                        >
                          {headerName}
                        </label>
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody className="p-0 m-0">
                <tr className="p-0 m-0">
                  {displayableFields?.map((field, fieldIndex) => {
                    const headerName = field?.values?.inputFieldName || "";
                    const rawFieldValue =
                      applicationDetails[field?.values?._id];
                    const fieldValueForComparison =
                      typeof rawFieldValue === "string"
                        ? rawFieldValue
                        : rawFieldValue?.name || "N/A";
                    const fieldValue = getSafeDisplayValue(rawFieldValue);

                    const skipCondition =
                      headerName.includes("Certificates") ||
                      headerName.includes("Marksheets") ||
                      headerName.includes("Mark Sheets") ||
                      headerName.includes("Attach the Conversion formula") ||
                      (headerName === "Board/Council" &&
                        fieldValueForComparison === "Others") ||
                      (headerName === "Board/Council" &&
                        (fieldValueForComparison === "N/A" || !rawFieldValue));

                    if (skipCondition) {
                      return null;
                    }

                    return (
                      <td
                        className="p-2 m-2"
                        key={fieldIndex}
                        style={{
                          border: "1px solid black",
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          width: `${98 / displayableFields.length}%`,
                        }}
                      >
                        <span
                          style={{
                            fontSize: "13px",
                            fontWeight: "500",
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          }}
                        >
                          {fieldValue}
                        </span>
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </Table>
          </Row>
        </Card>
      );
    }

    const filteredSubHeadings =
      subHeadings?.filter((subHeading) => {
        // Filter out LLB Degree section completely when hideLLBSection is true
        if (
          hideLLBSection &&
          subHeading?.values?.inputFieldName === "LLB Degree"
        ) {
          return false;
        }

        // Filter out Bar Council Enrollment Certificate subheading for Legal department
        const isLegalDepartment =
          applicationDetails?.vacancyId?.department?.name === "Legal";
        if (
          isLegalDepartment &&
          subHeading?.values?.inputFieldName ===
            "Bar Council Enrollment Certificate"
        ) {
          return false;
        }

        return true;
      }) || [];

    return (
      <>
        {filteredSubHeadings.map((subHeading, index) => {
          const fields = getFieldsBetweenSubHeadings(
            data.indexOf(subHeading),
            data,
            subHeading?.values?.inputFieldName
          );

          return (
            <Card
              className="mt-2 mb-0 dynamicFormcards ms-0 me-0 ps-0 pe-0"
              style={{ width: "100%", padding: "0", margin: "0" }}
              key={index}
            >
              <Row className="ms-0 me-0" style={{ margin: "0" }}>
                <Col xs="12" className="ps-0 pe-0" style={{ padding: "0" }}>
                  <label
                    className="form-label form-heading-main"
                    style={{
                      backgroundColor: "#f5f5f5",
                      color: "black",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                      padding: "8px 12px",
                      marginBottom: "15px",
                      marginTop: "10px",
                      fontWeight: "600",
                      display: "block",
                      width: "100%",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    {subHeading?.values?.inputFieldName}
                  </label>
                </Col>
              </Row>
              {/* Render notes that come before the second subheading */}
              {fields.map((field, fieldIndex) => {
                // Hide LLB Course Type field (ID: 6932c5664c6c63e650c7a4cc) ONLY when in LLB Degree section
                const isLLBSection =
                  subHeading?.values?.inputFieldName === "LLB Degree" ||
                  subHeading?.values?.inputFieldName?.includes("LLB Degree");
                if (
                  hideLLBSection &&
                  isLLBSection &&
                  field?.values?._id === "6932c5664c6c63e650c7a4cc"
                ) {
                  return null; // Skip rendering this field only in LLB section
                }

                if (field?.values?.inputFieldType === "note") {
                  return (
                    <div
                      key={fieldIndex}
                      className="note-field"
                      style={{
                        margin: "10px 0",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "brown",
                      }}
                    >
                      {applicationDetails[field?.values?._id] || ""}
                    </div>
                  );
                }
                return null;
              })}

              <Table
                className="ms-2 me-2"
                bordered
                style={{
                  border: "1px solid black",
                  overflow: "hidden",
                  width: "98%",
                  tableLayout: "fixed",
                }}
              >
                <thead className="p-0 m-0">
                  <tr className="p-0 m-0">
                    {(() => {
                      let firstBoardCouncilRendered = false;

                      return fields?.map((field, headerIndex) => {
                        // Hide LLB Course Type field (ID: 6932c5664c6c63e650c7a4cc) ONLY when in LLB Degree section
                        const isLLBSection =
                          subHeading?.values?.inputFieldName === "LLB Degree" ||
                          subHeading?.values?.inputFieldName?.includes(
                            "LLB Degree"
                          );
                        if (
                          hideLLBSection &&
                          isLLBSection &&
                          field?.values?._id === "6932c5664c6c63e650c7a4cc"
                        ) {
                          return null; // Skip rendering this field header only in LLB section
                        }

                        const headerName = field?.values?.inputFieldName || "";
                        const rawFieldValue =
                          applicationDetails[field?.values?._id];
                        // For comparisons, use raw value; for display, use safe value
                        const fieldValueForComparison =
                          typeof rawFieldValue === "string"
                            ? rawFieldValue
                            : rawFieldValue?.name || "N/A";
                        const fieldValue = getSafeDisplayValue(rawFieldValue); // Safely convert to displayable string

                        //(headerIndex, headerName, fieldValue, "Header Details");

                        // Combine your existing conditions with the new ones:
                        const skipCondition =
                          headerName.includes("Certificates") ||
                          headerName.includes("Marksheets") ||
                          headerName.includes("Mark Sheets") ||
                          headerName.includes(
                            "Attach the Conversion formula"
                          ) ||
                          (headerName === "Board/Council" &&
                            fieldValueForComparison === "Others") ||
                          (headerName === "Board/Council" &&
                            (fieldValueForComparison === "N/A" ||
                              !rawFieldValue));

                        // Hide all LLB fields from APPLICATION REVIEW when hideLLBSection is true
                        // Also hide Bar Council Enrollment Certificate for Legal department - it will be shown in Documents Review instead
                        const isLLBField =
                          field?.values?._id &&
                          (field.values._id.startsWith(
                            "68ecd888eb422bea55aa71"
                          ) ||
                            field.values._id === "6932c5664c6c63e650c7a4cc");
                        const isLegalDepartment =
                          applicationDetails?.vacancyId?.department?.name ===
                          "Legal";
                        const isBarCouncilField =
                          headerName.includes("Bar Council") ||
                          headerName.includes("Enrollment Certificate");

                        if (isLLBField && hideLLBSection) {
                          // Hide all LLB fields including Bar Council Enrollment Certificate from APPLICATION REVIEW
                          // They will be displayed in Documents Review section instead
                          return null;
                        }

                        // Hide Bar Council Enrollment Certificate for Legal department (even when hideLLBSection is false)
                        if (isBarCouncilField && isLegalDepartment) {
                          return null; // Hide Bar Council field for Legal department - it will be shown in Documents Review
                        }

                        if (skipCondition) {
                          return null; // Skip rendering this header
                        }

                        // Custom logic for "Board/Council"
                        if (headerName === "Board/Council") {
                          if (!firstBoardCouncilRendered) {
                            firstBoardCouncilRendered = true; // Mark the first one as rendered
                          } else {
                            return null; // Skip rendering the second one
                          }
                        }

                        return (
                          field?.values?.inputFieldType !== "note" && (
                            <th
                              key={headerIndex}
                              style={{
                                border: "1px solid black",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                width: `${98 / fields.length}%`,
                              }}
                            >
                              <label
                                className="form-label form-heading-main m-0 p-0"
                                style={style.label}
                              >
                                {headerName}
                              </label>
                            </th>
                          )
                        );
                      });
                    })()}
                  </tr>
                </thead>

                <tbody className="p-0 m-0">
                  <tr className="p-0 m-0">
                    {(() => {
                      let firstBoardCouncilRendered = false;

                      return fields?.map((field, fieldIndex) => {
                        // Hide LLB Course Type field (ID: 6932c5664c6c63e650c7a4cc) ONLY when in LLB Degree section
                        const isLLBSection =
                          subHeading?.values?.inputFieldName === "LLB Degree" ||
                          subHeading?.values?.inputFieldName?.includes(
                            "LLB Degree"
                          );
                        if (
                          hideLLBSection &&
                          isLLBSection &&
                          field?.values?._id === "6932c5664c6c63e650c7a4cc"
                        ) {
                          return null; // Skip rendering this field cell only in LLB section
                        }

                        const headerName = field?.values?.inputFieldName || "";
                        const rawFieldValue =
                          applicationDetails[field?.values?._id];
                        // For comparisons, use raw value; for display, use safe value
                        const fieldValueForComparison =
                          typeof rawFieldValue === "string"
                            ? rawFieldValue
                            : rawFieldValue?.name || "N/A";
                        const fieldValue = getSafeDisplayValue(rawFieldValue); // Safely convert to displayable string

                        //(fieldIndex, headerName, fieldValue, "Field Details");

                        // Combine your existing conditions with the new ones:
                        const skipCondition =
                          headerName.includes("Certificates") ||
                          headerName.includes("Marksheets") ||
                          headerName.includes("Mark Sheets") ||
                          headerName.includes(
                            "Attach the Conversion formula"
                          ) ||
                          (headerName === "Board/Council" &&
                            fieldValueForComparison === "Others") ||
                          (headerName === "Board/Council" &&
                            (fieldValueForComparison === "N/A" ||
                              !rawFieldValue));

                        // Hide all LLB fields from APPLICATION REVIEW when hideLLBSection is true
                        // Also hide Bar Council Enrollment Certificate for Legal department - it will be shown in Documents Review instead
                        const isLLBField =
                          field?.values?._id &&
                          (field.values._id.startsWith(
                            "68ecd888eb422bea55aa71"
                          ) ||
                            field.values._id === "6932c5664c6c63e650c7a4cc");
                        const isLegalDepartment =
                          applicationDetails?.vacancyId?.department?.name ===
                          "Legal";
                        const isBarCouncilField =
                          headerName.includes("Bar Council") ||
                          headerName.includes("Enrollment Certificate");

                        if (isLLBField && hideLLBSection) {
                          // Hide all LLB fields including Bar Council Enrollment Certificate from APPLICATION REVIEW
                          // They will be displayed in Documents Review section instead
                          return null;
                        }

                        // Hide Bar Council Enrollment Certificate for Legal department (even when hideLLBSection is false)
                        if (isBarCouncilField && isLegalDepartment) {
                          return null; // Hide Bar Council field for Legal department - it will be shown in Documents Review
                        }

                        if (skipCondition) {
                          return null; // Skip rendering this data cell
                        }

                        // Custom logic for "Board/Council"
                        if (headerName === "Board/Council") {
                          if (!firstBoardCouncilRendered) {
                            firstBoardCouncilRendered = true; // Mark the first one as rendered
                          } else {
                            return null; // Skip rendering the second one
                          }
                        }

                        return (
                          field?.values?.inputFieldType !== "note" && (
                            <td
                              className="p-2 m-2"
                              key={fieldIndex}
                              style={{
                                border: "1px solid black",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                width: `${98 / fields.length}%`,
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                }}
                              >
                                {fieldValue}
                              </span>
                            </td>
                          )
                        );
                      });
                    })()}
                  </tr>
                </tbody>
              </Table>
            </Card>
          );
        })}
      </>
    );
  };

  useEffect(() => {
    document.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener("wheel", function (event) {
        event.preventDefault();
      });
    });
    if (tabIndex && tabIndex === applicationForm.length) {
      setTimeout(() => {
        const today = new Date().toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        });

        // Target and hide elements where the label contains "Document Upload"
        const labels = document.querySelectorAll(
          "label.form-label.form-heading-main"
        );
        labels.forEach((label) => {
          if (label.textContent.includes("Document Upload")) {
            const parentDiv = label.closest("div.row"); // Get the closest parent div
            if (parentDiv) {
              parentDiv.style.display = "none"; // Hide the parent div
            }
          }
        });

        const uploadDocument = document.querySelectorAll("label.form-label");
        uploadDocument.forEach((label) => {
          if (label.textContent.includes("Upload Resident Certificate ")) {
            const parentDiv = label.closest("div"); // Get the closest parent div
            if (parentDiv) {
              parentDiv.style.display = "none"; // Hide the parent div
            }
          }
          if (label.textContent.includes("Upload Sports Certificate")) {
            const parentDiv = label.closest("div"); // Get the closest parent div
            if (parentDiv) {
              parentDiv.style.display = "none"; // Hide the parent div
            }
          }
          if (label.textContent.includes("Upload Certificate")) {
            const parentDiv = label.closest("div"); // Get the closest parent div
            if (parentDiv) {
              parentDiv.style.display = "none"; // Hide the parent div
            }
          }
        });

        // Select all elements with the class 'imgTagRemove'
        const elements = document.querySelectorAll("img.imgTagRemove");

        // Loop through each element and remove it from the DOM
        elements.forEach((element) => element.remove());

        // Select all <a> tags in the document
        var uploadLinks = document.querySelectorAll("a");

        // Loop through each <a> tag and remove the parent div with class 'col-md-2 col-12'
        uploadLinks.forEach(function (upload) {
          var parentDiv = upload.closest(".col-md-2.col-12");
          if (parentDiv) {
            parentDiv.remove();
          }
        });

        var imageTag = document.querySelectorAll("img");

        // Loop through each <a> tag and remove the parent div with class 'col-md-2 col-12'
        imageTag.forEach(function (upload) {
          var parentDiv = upload.closest(".col-md-1.col-12", "col-md-1 col-3");
          if (parentDiv) {
            parentDiv.remove();
          }
        });

        var svgTag = document.querySelectorAll("svg");

        // Loop through each <a> tag and remove the parent div with class 'col-md-2 col-12'
        svgTag.forEach(function (upload) {
          var parentDiv = upload.closest(".col-md-2.col-12");
          if (parentDiv) {
            parentDiv.remove();
          }
        });

        // Select all elements with the class 'react-select__multi-value'
        const disabilityTypeBg = document.querySelectorAll(
          ".react-select__multi-value"
        );

        // Loop through each element and set the background color to transparent
        disabilityTypeBg.forEach((element) => {
          element.style.background = "none";
        });

        // Select all elements with the class 'react-select__multi-value__remove'
        const disabilityTypeIcon = document.querySelectorAll(
          ".react-select__multi-value__remove"
        );

        // Loop through each element and set its display property to 'none'
        disabilityTypeIcon.forEach((element) => {
          element.style.display = "none";
        });

        const correspondAddressLabels = document.querySelectorAll("label");
        correspondAddressLabels.forEach((label) => {
          if (label.innerText.trim() === "Same as correspondence address") {
            const parentDiv = label.parentElement;
            if (parentDiv) {
              parentDiv.style.display = "none";
            }
          }
        });

        document.querySelectorAll("label").forEach((label) => {
          if (
            label.textContent.includes(
              "I confirm that I fulfill the physical requirement standards for the post as laid down in the advertisement. In case of any discrepency, my candidature is laible to be cancelled."
            )
          ) {
            label.style.display = "none";
          }
        });

        document.querySelectorAll("label").forEach((label) => {
          if (
            label.textContent.includes(
              "I do hereby declare that I shall submit date-wise details of my application (s) for various vacancy (ies), for which I have applied for, at the time of Document Verification, if shortlisted."
            )
          ) {
            label.style.display = "none";
          }
        });

        const asterisks = document.querySelectorAll("span.text-danger");
        asterisks.forEach((asterisk) => {
          asterisk.style.display = "none"; // Hide the asterisk
          // asterisk.remove(); // Alternatively, you can use this to completely remove it from the DOM
        });

        const labelsToHide = [
          "Application ID",
          "Advertisement Details",
          "Post Name",
        ];

        labelsToHide.forEach((labelText) => {
          // Find all label elements
          const labels = document.querySelectorAll("label");

          labels.forEach((label) => {
            if (label.textContent.trim().includes(labelText)) {
              // Hide the label
              label.style.display = "none";

              // Get the closest parent div containing the input
              const parentDiv = label.closest("div");
              if (parentDiv) {
                const input = parentDiv?.querySelector("input");
                if (input) {
                  input.value = ""; // Clear the input value
                  input.style.display = "none"; // Hide the input
                }
              }
            }
          });
        });

        // Get the specific div by ID to modify its content
        const specificDiv = document.getElementById("printDiv_1");

        if (specificDiv) {
          specificDiv.style.position = "relative"; // Ensure relative positioning for the parent

          // Add a header with an image
          const topSection = document.createElement("div");
          topSection.style.display = "flex";
          topSection.style.flexDirection = "row-reverse";
          topSection.style.gap = "20px";
          topSection.style.alignItems = "center";
          // topSection.style.justifyContent = ""; // Ensure the elements are side by side
          topSection.style.backgroundColor = "white";
          // topSection.style.padding = "10px";
          topSection.style.marginLeft = "20px";
          topSection.style.marginRight = "20px";

          topSection.style.height = "127px";
          topSection.style.marginBottom = "30px"; // Space below the top section

          // Create a new image element
          const newImage = document.createElement("img");
          newImage.src =
            "https://dg1ya6cdc7ief.cloudfront.net/assets/images/OMC-New-Logo.svg"; // Your image URL
          newImage.alt = "omc_logo";
          newImage.style.height = "50px";
          newImage.style.width = "130px";
          newImage.style.margin = "0 10px"; // Add some space between the images
          newImage.style.display = "block"; // Ensure it is treated as a block-level element

          // Target the specific image with alt text
          const specificImage = document?.querySelector(
            'img[alt="Upload Scanned copy of your passport size photo"]'
          );
          if (specificImage) {
            specificImage.style.display = "block";
            specificImage.style.width = "180px"; // Adjust the height if needed
            specificImage.style.height = "180px"; // Adjust the height if needed
            specificImage.style.position = "absolute"; // Float it to the top left
            specificImage.style.top = "25px"; // Adjust the top offset
            specificImage.style.right = "25px"; // Adjust the left offset
            specificImage.style.zIndex = "10"; // Ensure it's above other content
            specificImage.style.margin = "0"; // Remove any margin
          } else {
            //("Image with the specified alt text not found.");
          }

          // Create a div to insert between the two images
          const textDiv = document.createElement("div");
          textDiv.classList.add("text-div"); // Add a class for easier styling
          textDiv.style.flex = "1"; // Allow it to expand between the images
          textDiv.style.textAlign = "center"; // Center the text inside the div
          textDiv.style.fontFamily = "'Roboto', sans-serif";
          textDiv.style.fontSize = "20px"; // Font size

          // Add multiple lines of text inside the textDiv
          textDiv.innerHTML = `
           <div class="d-flex flex-column justify-content-center text-center w-50 ms-5">
    <h5 class="mt-0 fw-bold text-decoration-underline fontRoboto">Application Form</h5>
  </div>
           `;

          // Append the new image to the top section
          topSection.appendChild(specificImage);
          topSection.appendChild(textDiv); // Add the div with text between the images
          topSection.appendChild(newImage); // Add new image to top section

          // Append the top section div at the beginning of the specificDiv
          specificDiv.insertBefore(topSection, specificDiv.firstChild);

          // Create a new section to hold the additional text information
          const infoSection = document.createElement("div");
          infoSection.style.margin = "20px 0"; // Add some margin to separate it from other sections
          infoSection.style.padding = "10px";
          infoSection.style.backgroundColor = "#fff"; // Optional: Background color for distinction
          infoSection.style.borderBottom = "1px solid #ddd"; // Optional: Border for clarity
          infoSection.style.marginLeft = "20px";
          infoSection.style.marginRight = "20px";
          infoSection.style.fontFamily = "'Roboto', sans-serif";

          // Add your three pieces of text information
          infoSection.innerHTML = `
          <div class='d-flex justify-content-between w-75 pb-3'>
          
          <p class='fw-bold fontRoboto'><strong>Apply Date</strong><br/> ${today}</p>
          <p class='fw-bold fontRoboto'><strong>Application No.</strong><br/> ${applicationID}</p>
          <p class='fw-bold fontRoboto'><strong>Post</strong><br/> ${applicationDetails?.vacancyId?.grade?.designationPrefix} (${applicationDetails?.vacancyId?.department?.name}), Grade - ${applicationDetails?.vacancyId?.grade?.gradeName}</p>
          <p class='pb-2 fw-bold fontRoboto'> <strong>Advertisement No.</strong><br/> ${applicationDetails?.advertisement?.advertisementNumber}</p>
          
          <div/>

        `;

          // Insert the new info section below the topSection
          specificDiv.insertBefore(
            infoSection,
            specificDiv.firstChild.nextSibling
          );

          // Create the footer section
          const bottomSection = document.createElement("div");
          bottomSection.style.textAlign = "center";
          bottomSection.style.backgroundColor = "rgba(109, 110, 113, 1)";
          bottomSection.style.padding = "10px";
          bottomSection.style.marginTop = "30px";

          // Footer text
          const footerText = document.createElement("span");
          footerText.textContent =
            "© 2024 Odisha Mining Corporation Ltd. (O M C LTD)";
          footerText.style.fontSize = "14px";
          footerText.style.color = "#fff";
          footerText.style.fontFamily = "'Roboto', sans-serif";
          footerText.style.padding = "10px";

          // Append the footer text to the bottomSection div
          // bottomSection.appendChild(footerText);

          // Append the bottom section div to the specificDiv
          // specificDiv.appendChild(bottomSection);

          // Apply styles to cards, headings, and other elements
          const cards = specificDiv.querySelectorAll(".card");
          cards.forEach((card) => {
            card.style.opacity = "1";
            card.style.border = "none";
            card.style["box-shadow"] = "0px 0px 0px";
            card.style.margin = "0";
            card.style.padding = "10px";
            // card.style.width = "210mm"
          });

          const headings = specificDiv.querySelectorAll(".form-heading-main");
          headings.forEach((heading) => {
            // heading.style.margin = "10px";
            heading.style.paddingLeft = "5px";
          });

          const highlightedHeadings =
            specificDiv.querySelectorAll(".form-heading-main");

          highlightedHeadings.forEach((heading) => {
            // Check if the parent element is a <th>
            const isInsideTableHeader = heading.closest("th");

            // Skip the elements inside a <th>
            if (isInsideTableHeader) {
              return; // Skip styling if inside <th>
            }

            // Get the text content of the heading
            const headingText = heading.innerText.trim();

            // Check if this is a main formTab heading (all uppercase, matches formTab values)
            const mainFormTabHeadings = [
              "PERSONAL DETAILS",
              "COMMUNICATION DETAILS",
              "ESSENTIAL QUALIFICATION",
              "ADDITIONAL QUALIFICATION",
              "TRAINING DETAILS",
              "EXPERIENCE",
              "OTHER ESSENTIAL",
              "DOCUMENTS",
            ];
            const isMainFormTabHeading =
              mainFormTabHeadings.includes(headingText);

            // Apply different styles based on the heading text
            if (
              headingText ===
                "Person With Benchmark Disability (PwBD) Details" ||
              headingText === "Additional Details" ||
              headingText === "Ex-Servicemen Details" ||
              headingText === "Permanent Address" ||
              headingText === "Matric/10th Details" ||
              headingText === "12th Details" ||
              headingText === "12th/Diploma/Intermediate Details" ||
              headingText === "Graduation Details"
            ) {
              // Apply a different style for specific subheadings
              heading.style.marginLeft = "10px";
              heading.style.marginRight = "10px";
              heading.style.marginTop = "10px";
              heading.style.padding = "10px";
              heading.style.backgroundColor = "#00000012"; // Light grey background
              heading.style.color = "black"; // Black font color
              heading.style.flexShrink = "inherit";
              heading.style.borderTopLeftRadius = "10px";
              heading.style.borderTopRightRadius = "10px";
            } else if (isMainFormTabHeading) {
              // Apply red background for main formTab headings (OMC branding)
              heading.style.marginLeft = "10px";
              heading.style.marginRight = "10px";
              heading.style.marginTop = "20px";
              heading.style.padding = "10px";
              heading.style.backgroundColor = "rgb(146, 29, 30)"; // OMC red color
              heading.style.color = "#ffff";
              heading.style.flexShrink = "inherit";
              heading.style.borderTopLeftRadius = "10px";
              heading.style.borderTopRightRadius = "10px";
            } else {
              // Apply grey background for other subheadings
              heading.style.marginLeft = "10px";
              heading.style.marginRight = "10px";
              heading.style.marginTop = "20px";
              heading.style.padding = "10px";
              heading.style.backgroundColor = "#6c757d"; // Grey for other subheadings
              heading.style.color = "#ffff";
              heading.style.flexShrink = "inherit";
              heading.style.borderTopLeftRadius = "10px";
              heading.style.borderTopRightRadius = "10px";
            }
          });

          // Remove unnecessary elements
          const star = specificDiv.querySelectorAll(".star");
          star.forEach((stars) => {
            stars.style.display = "none";
          });

          const allDiv = specificDiv.querySelectorAll("div");
          allDiv.forEach((div) => {
            div.style.marginTop = "0";
            div.style.marginBottom = "0";
            div.style.paddingTop = "0";
            div.style.paddingBottom = "0";
          });

          const allpdfDocuments = specificDiv.querySelectorAll(".renderPdf");
          allpdfDocuments.forEach((pdfElement) => {
            pdfElement.remove();
          });

          // .react-select__control
          const verifybutton = specificDiv.querySelectorAll(
            ".verifybutton,.badge,.chooseFile,.btn,.Documentdploadvalidation,.react-select__indicators,.react-select__multi-value__remove"
          );
          verifybutton.forEach((ver) => {
            ver.style.display = "none";
          });

          const removeButton = specificDiv.querySelectorAll("button");
          removeButton.forEach((ver) => {
            ver.style.display = "none";
          });

          const departmentalJoiningDate = specificDiv.querySelectorAll(
            ".react-select__control,#departmentalJoiningDate,#exServicemanJoiningDate,#exServicemanRetirementDate,#Percentage_of_disability,#issuedDate,#issueDateReser,#certificateNumberReser,.react-select__multi-value"
          );
          departmentalJoiningDate.forEach((file) => {
            file.style["-webkit-calendar-picker-indicator"] = "none";

            file.style.border = "none";
            file.style.pointerEvents = "none";
            file.style.appearance = "none";
            file.style["-webkit-appearance"] = "none";
            file.style["-moz-appearance"] = "none";
            file.style["appearance"] = "none";
            file.setAttribute("type", "text");
          });

          // react-select_multi-value

          // Target the dropdown element
          const dropdownElement = document?.querySelector(
            ".css-181qgi4-control"
          );

          // Remove unwanted styles
          if (dropdownElement) {
            dropdownElement.style.border = "none"; // Remove border
            dropdownElement.style.boxShadow = "none"; // Remove any shadow effects
            dropdownElement.style.backgroundColor = "transparent"; // Make background transparent
            dropdownElement.style.padding = "0"; // Remove padding
            dropdownElement.style.margin = "0"; // Remove margins
            dropdownElement.pointerEvents = "none";
          }

          const dropdownInput = dropdownElement?.querySelector("input");
          const indicatorContainer = dropdownElement?.querySelector(
            ".css-9uufmq-IndicatorsContainer"
          );

          if (dropdownInput) {
            dropdownInput.style.border = "none"; // Remove input border
            dropdownInput.style.outline = "none"; // Remove input outline
            dropdownInput.style.background = "none"; // Remove input background
            dropdownInput.pointerEvents = "none";
          }

          if (indicatorContainer) {
            indicatorContainer.style.display = "none"; // Hide dropdown arrow/icon
            indicatorContainer.pointerEvents = "none";
          }

          const backgroundRemoveElements =
            specificDiv.querySelectorAll(".form-control");

          backgroundRemoveElements.forEach((bgRemove) => {
            bgRemove.style.backgroundColor = "transparent";
          });
          const experenceInputRemove = specificDiv.querySelectorAll(
            "#experenceInputRemove,#declaration-checkbox,#fileUpload,#allExperienceDetailsRemove,#exservicemenFileUpload,#personWithDisabilityFileUpload,#departmentalFileUpload"
          );
          experenceInputRemove.forEach((file) => {
            file.style.display = "none";
          });

          // Ensure the select with id="relation_declaration" is visible and interactive
          const relationDeclarationSelect = document.getElementById(
            "relation_declaration"
          );
          if (relationDeclarationSelect) {
            relationDeclarationSelect.style.display = "block"; // Adjust as needed (e.g., 'inline-block')
            relationDeclarationSelect.style.pointerEvents = "auto"; // Re-enable interactions
            relationDeclarationSelect.style.border = ""; // Reset border if altered
            relationDeclarationSelect.style.backgroundColor = ""; // Reset background if altered
            relationDeclarationSelect.style.appearance = ""; // Reset appearance
            // Add any other style resets as necessary
          }

          const categorySelectRemove = specificDiv.querySelectorAll(
            ".react-select:not(#relation_declaration)"
          );
          categorySelectRemove.forEach((file) => {
            file.style.border = "none";
            file.style.pointerEvents = "none";
            file.style.appearance = "none";
            file.style["-webkit-appearance"] = "none";
            file.style["-moz-appearance"] = "none";
            file.style["appearance"] = "none";
            file.style["-webkit-calendar-picker-indicator"] = "none";
          });
          //  css-181qgi4-control

          const selectRemove = specificDiv.querySelectorAll(
            "select:not(#relation_declaration), .form-control:not(#relation_declaration)"
          );
          selectRemove.forEach((file) => {
            file.style.border = "none";
            file.style.pointerEvents = "none";
            file.style.appearance = "none";
            file.style["-webkit-appearance"] = "none";
            file.style["-moz-appearance"] = "none";
            file.style["appearance"] = "none";
            file.style["-webkit-calendar-picker-indicator"] = "none";
          });
        }
      }, 300);
    }
  }, [tabIndex]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const printRef = useRef();

  //("applicationDetails+++++", applicationDetails);

  return Loading ? (
    <>
      <Preloader />
    </>
  ) : (
    <>
      <HamburgerMenu />
      {!isLoading && !isLoading2 && (
        <div className="m-0 p-0 background__main">
          <Tabs
            className="job-article tf-tab single-job d-flex flex-md-row flex-column applyjob-tab"
            selectedIndex={tabIndex}
            onSelect={(index) => setTabIndex(index)}
          >
            {isMobileMenuOpen && (
              <div className="dropdown-background" onClick={toggleMenu} />
            )}

            <div
              className={`mobile-Tab-items dropdown-menu-transition ${
                isMobileMenuOpen ? "open" : ""
              }`}
            >
              <div
                className={`mobile-header bg-light px-3 py-2 ${
                  isMobile ? "d-md-none" : "custom-card-tabSide"
                }`}
              >
                {/* Button to toggle mobile menu, visible only on mobile */}
                {isMobile && (
                  <button
                    className="toggle-icon-form-close"
                    onClick={toggleMobileMenu}
                  >
                    <IoMdClose />
                  </button>
                )}

                <TabList
                  className={`${
                    isMobile ? "menu-tab-mobile" : "menu-tab"
                  } ps-0`}
                >
                  {applicationForm?.map((item, idx) => (
                    <Tab
                      className={`${isMobile ? "px-2 py-2" : "mb-4"}`}
                      style={{
                        // borderBottom: "1px solid #DCDCDC",
                        backgroundColor:
                          tabIndex === idx
                            ? "#921D1E"
                            : tabIndexFromDb >= idx
                            ? "#0B633612"
                            : "",
                        color:
                          tabIndex === idx
                            ? "#fff"
                            : tabIndexFromDb >= idx
                            ? "#0B6336"
                            : "#000",
                        border:
                          tabIndex === idx
                            ? "1px solid #921D1E00"
                            : tabIndexFromDb >= idx
                            ? "1px solid #0B6336"
                            : "1px solid #921D1E1A",
                        pointerEvents: tabIndexFromDb >= idx ? "" : "none",
                      }}
                      key={idx}
                      onClick={() => handleTabClick(idx)}
                    >
                      {/* Conditionally render tick mark next to formTab in mobile view */}
                      <div
                        style={{
                          display: isMobile ? "flex" : "block",
                          justifyContent: isMobile
                            ? "space-between"
                            : "flex-start",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {item?.formTab}
                        {isMobile && tabIndexFromDb >= idx && <span>✔</span>}
                      </div>
                    </Tab>
                  ))}
                  {/* <Tab
                    className={`${isMobile ? "px-2 py-2" : "mb-4"}`}
                    // style={{ borderBottom: "1px solid #DCDCDC" }}
                    style={{
                      pointerEvents: "none",
                      backgroundColor: tabIndex === "all_Document_Review" ? "green" : "",
                      color: tabIndex === "all_Document_Review" ? "#fff" : "#000"
                    }}
                    key={"all_Document_Review"}
                    // onClick={() => handleTabClick("review")}
                  >
                    {"ALL DOCUMENT REVIEW"}
                  </Tab> */}
                  <Tab
                    className={`${isMobile ? "px-2 py-2" : "mb-4"}`}
                    // style={{ borderBottom: "1px solid #DCDCDC" }}
                    style={{
                      pointerEvents: "none",
                      backgroundColor: tabIndex === "review" ? "green" : "",
                      color: tabIndex === "review" ? "#fff" : "#000",
                    }}
                    key={"review"}
                    onClick={() => handleTabClick("review")}
                  >
                    {"APPLICATION REVIEW"}
                  </Tab>
                </TabList>
              </div>
            </div>

            <div
              style={{
                width: "100%",
                // height:"90vh",
                // overflow: "scroll",
              }}
            >
              {applicationForm?.map((item, index) => {
                return (
                  <>
                    <TabPanel key={index}>
                      <Card className="pt-2 pb-2 mt-2 top-card-dynamic shadow-sm">
                        <ul
                          className="d-flex justify-content-between align-items-center"
                          style={{ listStyleType: "none", padding: 0 }}
                        >
                          {applicationForm?.map((item, idx) => {
                            const isCompleted = tabIndex > idx;
                            const isActive = tabIndex === idx;

                            return (
                              <li
                                key={idx}
                                className="text-center dynamicFormBulletsWrap"
                                style={{
                                  color:
                                    isCompleted || isActive
                                      ? "rgba(0, 0, 0, 1)"
                                      : "gray", // Text color
                                }}
                              >
                                <div
                                  className="dynamicFormBulletsTick"
                                  style={{
                                    backgroundColor: isCompleted
                                      ? "green"
                                      : isActive
                                      ? "brown"
                                      : "gray", // Color based on status
                                  }}
                                >
                                  ✓
                                </div>
                                <span
                                  className="dynamicFormBulletsFont"
                                  style={{
                                    fontWeight: isActive ? "bold" : "normal",
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.formTab}
                                </span>
                                {idx !== applicationForm.length - 1 && (
                                  <div
                                    className="dynamicFormBulletsText"
                                    style={{
                                      backgroundColor: isCompleted
                                        ? "lightgray"
                                        : "lightgray",
                                    }}
                                  />
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </Card>
                      <div
                        className={"captureErrorFor_" + index}
                        id="main-form-dynamic"
                      >
                        {/* Heading Of Each Page on Tabs */}
                        <div
                          className="applyJobMainHead d-flex align-items-center justify-content-between gap-2"
                          style={{
                            width: "calc(100% - 50px)",
                            right: "25px",
                            left: "auto",
                            padding: "0",
                            margin: "0",
                          }}
                        >
                          <div
                            className="d-flex align-items-center gap-2"
                            style={{ flex: "0 0 auto" }}
                          >
                            <div
                              className="cursor-pointer d-md-none toggle-icon-form"
                              onClick={toggleMenu}
                            >
                              <i class="bi bi-list"></i>
                            </div>
                            <h5
                              className="applyJobMainHeadFont"
                              style={{ margin: "0" }}
                            >
                              APPLICATION FORM - {item?.formTab}
                            </h5>
                          </div>
                          <div style={{ flex: "0 0 auto", marginLeft: "auto" }}>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => openUserManual(item?.formTab)}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                backgroundColor: "#921d1e",
                                color: "#ffffff",
                                border: "none",
                                fontSize: "13px",
                                padding: "6px 12px",
                                borderRadius: "5px",
                                fontWeight: "500",
                                cursor: "pointer",
                              }}
                            >
                              <FaBook
                                style={{ fontSize: "14px", color: "#ffffff" }}
                              />
                              <span className="d-none d-md-inline">
                                User Manual
                              </span>
                            </Button>
                          </div>
                        </div>

                        <Row className="m-0">
                          {tabIndex === 3 && (
                            <>
                              <div className="custom-card-tabMain">
                                <Card className="mb-2 dynamicFormcards card ">
                                  <div class="row">
                                    <label class="form-label form-heading-main">
                                      Note
                                    </label>
                                    <div class="mb-2 col-12">
                                      {/* <label class="inputBoxHeadForm upload-head-gap mt-2" >NOTE</label> */}
                                      <div class="d-flex flex-wrap inputBoxHeadForm">
                                        <div
                                          style={{
                                            fontFamily: "'Roboto', sans-serif",
                                            color: "brown",
                                          }}
                                          className="fw-bolder mb-1"
                                        >
                                          <p>
                                            <span>
                                              NOTE 1: If you have any Additional
                                              Qualification kindly click "Add
                                              New" Button to provide the
                                              details. If you dont have any
                                              Additional Qualification you can
                                              simply click "Save & Next" to
                                              continue.
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                      {/* <div class="d-flex flex-wrap inputBoxHeadForm"> */}
                                      <div
                                        style={{
                                          fontFamily: "'Roboto', sans-serif",
                                          color: "brown",
                                        }}
                                        className="fw-bolder mb-1"
                                      >
                                        {/* <p> */}
                                        <span>
                                          NOTE 2: For file uploads, only PDF
                                          format is accepted. The maximum file
                                          size should not exceed 2 MB. Ensure
                                          that the uploaded document is clear
                                          and legible.
                                        </span>
                                        {/* </p> */}
                                      </div>
                                      <div
                                        style={{
                                          fontFamily: "'Roboto', sans-serif",
                                          color: "brown",
                                        }}
                                        className="fw-bolder mb-3"
                                      ></div>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            </>
                          )}

                          {tabIndex === 4 && (
                            <>
                              <div className="custom-card-tabMain">
                                <Card className="mb-2 dynamicFormcards card">
                                  <div class="row">
                                    <label class="form-label form-heading-main">
                                      Note
                                    </label>
                                    <div class="mb-2 col-12">
                                      {/* <label class="inputBoxHeadForm upload-head-gap mt-2" >NOTE</label> */}
                                      <div class="d-flex flex-wrap inputBoxHeadForm">
                                        <div
                                          style={{
                                            fontFamily: "'Roboto', sans-serif",
                                            color: "brown",
                                          }}
                                          className="fw-bolder mb-3"
                                        >
                                          <p>
                                            <span>
                                              Note 1: If you have any
                                              Training/Professional Body
                                              Membership Details kindly click
                                              "Add New" Button to provide the
                                              details. If you dont have any
                                              Training/Professional Body
                                              Membership Details you can simply
                                              click "Save & Next" to continue.
                                            </span>
                                          </p>
                                        </div>
                                      </div>
                                      {/* <div class="d-flex flex-wrap inputBoxHeadForm"> */}
                                      <div
                                        style={{
                                          fontFamily: "'Roboto', sans-serif",
                                          color: "brown",
                                        }}
                                        className="fw-bolder mb-1"
                                      >
                                        {/* <p> */}
                                        <span>
                                          Note 2: For file uploads, only PDF
                                          format is accepted. The maximum file
                                          size should not exceed 2 MB. Ensure
                                          that the uploaded document is clear
                                          and legible
                                        </span>
                                        {/* </p> */}
                                      </div>
                                      {/* </div> */}
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            </>
                          )}

                          {tabIndex === 5 && (
                            <>
                              <div className="custom-card-tabMain">
                                <Card className="mb-2 dynamicFormcards card">
                                  <div class="row">
                                    <label class="form-label form-heading-main">
                                      Note
                                    </label>
                                    <div class="mb-2 col-12">
                                      {/* <label class="inputBoxHeadForm upload-head-gap mt-2" >NOTE</label> */}
                                      <div class="d-flex flex-wrap inputBoxHeadForm">
                                        <div>
                                          <ol
                                            style={{
                                              fontFamily:
                                                "'Roboto', sans-serif",
                                              color: "brown",
                                            }}
                                            className="fw-bolder mb-3"
                                          >
                                            <li>
                                              1. You need to give details of
                                              your work experience & proceed.
                                            </li>
                                            <li>
                                              2. If you have any Additional
                                              Experience kindly click "Add New"
                                              Button to provide the details.
                                            </li>
                                            <li>
                                              3. Please list your latest
                                              experience first, followed by the
                                              rest in chronological order.
                                            </li>
                                            <li>
                                              4. You may furnish the details
                                              regarding training; however,
                                              experience as a trainee in any
                                              organization(s) you have worked /
                                              working will not be considered as
                                              part of the total or relevant
                                              experience.
                                            </li>
                                            <li>
                                              5. Ensure that the total service
                                              period provided in post-wise
                                              details matches the total
                                              experience for the organization.
                                            </li>
                                            <li>
                                              6. Use the "Add Post Wise Details"
                                              button under post-wise experience
                                              to include multiple posts or
                                              designations held in the same
                                              organization during your mentioned
                                              experience period.
                                            </li>
                                            <li>
                                              7. Use the "Add Relevant
                                              Experience" button under the
                                              Relevant Experience section to
                                              include relevant experience(s)
                                              within the same organization
                                              during your mentioned experience
                                              period.
                                            </li>
                                            <li>
                                              8. Starting year of your
                                              experience can not be less than
                                              passing year of essential
                                              qualification.
                                            </li>
                                            <li>
                                              9. For file uploads, only PDF
                                              format is accepted. The maximum
                                              file size should not exceed 2 MB.
                                              Ensure that the uploaded document
                                              is clear and legible.
                                            </li>
                                          </ol>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Card>
                              </div>
                            </>
                          )}

                          {item?.isArray ? (
                            dynamicFields?.map((fieldSet, indexOfFieldSet) => {
                              return (
                                <>
                                  {fieldSet?.tab ===
                                    camelCase(item?.formTab) && (
                                    <div className="custom-card-tabMain">
                                      <Card className="mt-2 mb-0 dynamicFormcards">
                                        {/* {console.log({ fieldSet })} */}
                                        {/* <Col key={idx} xs={input.values.columnLength} className=""> */}
                                        <Row key={fieldSet.id} className="mt-3">
                                          {fieldSet?.fields.map(
                                            (field, fieldIndex) =>
                                              renderArrayFields(
                                                field,
                                                fieldIndex,
                                                item,
                                                fieldSet
                                              )
                                          )}
                                          <div className="text-end">
                                            <Button
                                              className="btn btn-danger my-1"
                                              onClick={() =>
                                                handleDeleteFieldSet(
                                                  fieldSet,
                                                  indexOfFieldSet
                                                )
                                              }
                                            >
                                              Delete
                                            </Button>
                                          </div>
                                        </Row>
                                        {/* </Col> */}
                                      </Card>
                                    </div>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <div className="">
                              <Row>
                                {/* <Col sm="0" md="2" >

                            </Col> */}
                                <div>
                                  <Col sm="12" md="12" className="">
                                    <div className="custom-card-tabMain">
                                      {renderNonArrayFields(item)}
                                    </div>
                                  </Col>
                                </div>
                                {/* <Col sm="0" md="2" >

                            </Col> */}
                              </Row>
                            </div>
                          )}

                          {/* Additional logic for "Education Details" tab */}

                          {/* Conditionally display Add button based on formTab */}
                          {item?.isArray && (
                            <div className="text-center my-5 ">
                              {/* {handleBlankAddFieldSet(item?.values, item?.formTab, index)
                              }                               */}
                              <Button
                                className="bottom-card-submit-button registrationFont mt-4 "
                                onClick={() =>
                                  handleAddFieldSet(
                                    item?.values,
                                    item?.formTab,
                                    index
                                  )
                                }
                              >
                                Add New
                              </Button>
                            </div>
                          )}
                        </Row>
                      </div>
                    </TabPanel>
                  </>
                );
              })}
              {/* <TabPanel key={"all_Document_Review"}>
            <div className="d-flex align-items-center justify-content-center">
              <img src={paymentSuccess} alt="" />
            </div>
              </TabPanel> */}
              <TabPanel key={"review"}>
                <div className="applyJobMainHead d-flex align-items-center gap-2">
                  <div
                    className="cursor-pointer d-md-none"
                    onClick={toggleMenu}
                  >
                    <i class="bi bi-list"></i>
                  </div>
                  <h5 className="applyJobMainHeadFont">
                    {"APPLICATION REVIEW"}
                  </h5>
                </div>
                <div
                  style={{
                    width: "100%",
                    overflowX: "auto",
                  }}
                >
                  <div
                    ref={printRef}
                    id="printDiv_1"
                    className="pt-3"
                    style={{
                      minWidth: "795px",
                      margin: "0 auto",
                    }}
                  >
                    {applicationForm?.map((item, index) => {
                      // Helper function to check if section has data
                      const sectionHasData = () => {
                        if (!item) return false;

                        // For array sections, check if there's data in dynamicFields
                        if (item?.isArray) {
                          const tabName = camelCase(item?.formTab);
                          const hasArrayData = dynamicFields?.some(
                            (fieldSet) =>
                              fieldSet?.tab === tabName &&
                              fieldSet?.fields?.length > 0
                          );
                          return hasArrayData;
                        }

                        // For non-array sections, check if any field has a value
                        if (item?.values && Array.isArray(item.values)) {
                          return item.values.some((input) => {
                            if (!input?.values) return false;

                            const camelCaseKey = camelCase(input.values._id);
                            const fieldId = input.values._id;
                            const camelCaseFieldName = camelCase(
                              input.values.inputFieldName
                            );
                            const fieldName = input.values.inputFieldName;

                            // Get field value
                            let rawValue = "";
                            if (applicationDetails) {
                              rawValue =
                                applicationDetails[camelCaseKey] ||
                                applicationDetails[fieldId] ||
                                applicationDetails[camelCaseFieldName] ||
                                applicationDetails[fieldName] ||
                                "";
                            }

                            // Helper to check if value is valid
                            const hasValue = (value) => {
                              if (value === null || value === undefined)
                                return false;
                              if (typeof value === "string") {
                                const trimmed = value.trim();
                                if (trimmed === "No" || trimmed === "Yes")
                                  return true;
                                return (
                                  trimmed !== "" &&
                                  trimmed !== "N/A" &&
                                  trimmed !== "null" &&
                                  trimmed !== "undefined" &&
                                  trimmed !== " "
                                );
                              }
                              if (typeof value === "object") {
                                if (Array.isArray(value)) {
                                  return (
                                    value.length > 0 &&
                                    value.some((item) => {
                                      if (
                                        typeof item === "object" &&
                                        item !== null
                                      ) {
                                        return (
                                          item.file ||
                                          item.name ||
                                          item.url ||
                                          item.value
                                        );
                                      }
                                      return item && String(item).trim() !== "";
                                    })
                                  );
                                }
                                return Object.keys(value).some((key) => {
                                  const val = value[key];
                                  return (
                                    val !== null &&
                                    val !== undefined &&
                                    val !== "" &&
                                    val !== "N/A"
                                  );
                                });
                              }
                              return true;
                            };

                            // Check for special components
                            const isSpecialComponent = [
                              "ReservationCategory",
                              "DepartmentalCandidate",
                              "PersonWithDisability",
                              "AreYouASportsMan",
                              "ExServicemen",
                              "DomicileOfOdisha",
                              "Experience-Static",
                            ].includes(input.values.inputFieldType);

                            if (isSpecialComponent) {
                              if (
                                input.values.inputFieldType ===
                                "ReservationCategory"
                              ) {
                                const reservationValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.reservationCategory;
                                return (
                                  reservationValue !== null &&
                                  reservationValue !== undefined &&
                                  reservationValue !== "" &&
                                  (typeof reservationValue === "string"
                                    ? reservationValue.trim() !== ""
                                    : true)
                                );
                              } else if (
                                input.values.inputFieldType ===
                                "DepartmentalCandidate"
                              ) {
                                const deptCandidateValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.departmentalCandidate;
                                return (
                                  deptCandidateValue !== null &&
                                  deptCandidateValue !== undefined &&
                                  deptCandidateValue !== "" &&
                                  (typeof deptCandidateValue === "string"
                                    ? deptCandidateValue.trim() !== ""
                                    : true)
                                );
                              } else if (
                                input.values.inputFieldType ===
                                "PersonWithDisability"
                              ) {
                                const pwbdValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.benchmarkDisability ||
                                  applicationDetails?.disabilityType;
                                return hasValue(pwbdValue);
                              } else if (
                                input.values.inputFieldType ===
                                "AreYouASportsMan"
                              ) {
                                const sportsValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.areYouASportsMan;
                                return hasValue(sportsValue);
                              } else if (
                                input.values.inputFieldType === "ExServicemen"
                              ) {
                                const exServiceValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.exServiceman;
                                return hasValue(exServiceValue);
                              } else if (
                                input.values.inputFieldType ===
                                "DomicileOfOdisha"
                              ) {
                                const domicileValue =
                                  applicationDetails?.[camelCaseKey] ||
                                  applicationDetails?.[fieldId] ||
                                  applicationDetails?.domicileOfOdisha;
                                return hasValue(domicileValue);
                              } else if (
                                input.values.inputFieldType ===
                                "Experience-Static"
                              ) {
                                return true; // Experience is always shown if it exists
                              }
                              return false;
                            }

                            // For regular fields, skip SubHeadings and notes
                            if (
                              input.values.inputFieldType === "SubHeading" ||
                              input.values.inputFieldType === "note"
                            ) {
                              return false; // Don't count these as data
                            }

                            return hasValue(rawValue);
                          });
                        }

                        return false;
                      };

                      const hasData = sectionHasData();

                      return (
                        <>
                          {hasData && (
                            <div key={index}>
                              {/* Display formTab as main heading - only if section has data */}
                              {/* Exclude EXPERIENCE and DOCUMENTS as they have special handling before their respective sections */}
                              {item?.formTab &&
                                item?.formTab !== "EXPERIENCE" &&
                                item?.formTab !== "DOCUMENTS" && (
                                  <label
                                    className="form-label form-heading-main"
                                    style={{
                                      backgroundColor: "rgb(146, 29, 30)",
                                      color: "white",
                                      borderTopLeftRadius: "10px",
                                      borderTopRightRadius: "10px",
                                      borderBottom: "none",
                                      padding: "10px",
                                      marginTop: "0",
                                      marginBottom: "0",
                                      marginLeft: "12px",
                                      marginRight: "12px",
                                      width: "calc(100% - 24px)",
                                    }}
                                  >
                                    {item.formTab}
                                  </label>
                                )}

                              <Row className="m-0">
                                {item?.isArray ? (
                                  renderTableOfIsArray(item)
                                ) : (
                                  <div className="">
                                    <Row>
                                      <div
                                        className={
                                          item?.formTab ===
                                          "ESSENTIAL QUALIFICATION"
                                            ? "ps-0 pe-0"
                                            : ""
                                        }
                                      >
                                        <Col xs="12" className="">
                                          <div className="custom-card-tabMain">
                                            <div className="p-0 m-0">
                                              {item?.formTab ===
                                              "ESSENTIAL QUALIFICATION"
                                                ? renderTableForNonArrayData(
                                                    item?.values
                                                  )
                                                : renderNonArrayFields(item)}
                                            </div>
                                          </div>
                                        </Col>
                                      </div>
                                    </Row>
                                  </div>
                                )}
                              </Row>
                            </div>
                          )}
                        </>
                      );
                    })}

                    {/* Check if EXPERIENCE formTab has data and show heading before Total Experience */}
                    {(() => {
                      const experienceTab = applicationForm?.find(
                        (item) => item?.formTab === "EXPERIENCE"
                      );
                      if (experienceTab) {
                        // Check if EXPERIENCE section has data
                        const hasExperienceData = () => {
                          if (!experienceTab) return false;
                          if (experienceTab?.isArray) {
                            const tabName = camelCase(experienceTab?.formTab);
                            return dynamicFields?.some(
                              (fieldSet) =>
                                fieldSet?.tab === tabName &&
                                fieldSet?.fields?.length > 0
                            );
                          }
                          if (
                            experienceTab?.values &&
                            Array.isArray(experienceTab.values)
                          ) {
                            return experienceTab.values.some((input) => {
                              if (!input?.values) return false;
                              const camelCaseKey = camelCase(input.values._id);
                              const fieldId = input.values._id;
                              const camelCaseFieldName = camelCase(
                                input.values.inputFieldName
                              );
                              const fieldName = input.values.inputFieldName;
                              let rawValue = "";
                              if (applicationDetails) {
                                rawValue =
                                  applicationDetails[camelCaseKey] ||
                                  applicationDetails[fieldId] ||
                                  applicationDetails[camelCaseFieldName] ||
                                  applicationDetails[fieldName] ||
                                  "";
                              }
                              const hasValue = (value) => {
                                if (value === null || value === undefined)
                                  return false;
                                if (typeof value === "string") {
                                  const trimmed = value.trim();
                                  if (trimmed === "No" || trimmed === "Yes")
                                    return true;
                                  return (
                                    trimmed !== "" &&
                                    trimmed !== "N/A" &&
                                    trimmed !== "null" &&
                                    trimmed !== "undefined" &&
                                    trimmed !== " "
                                  );
                                }
                                if (typeof value === "object") {
                                  if (Array.isArray(value)) {
                                    return (
                                      value.length > 0 &&
                                      value.some((item) => {
                                        if (
                                          typeof item === "object" &&
                                          item !== null
                                        ) {
                                          return (
                                            item.file ||
                                            item.name ||
                                            item.url ||
                                            item.value
                                          );
                                        }
                                        return (
                                          item && String(item).trim() !== ""
                                        );
                                      })
                                    );
                                  }
                                  return Object.keys(value).some((key) => {
                                    const val = value[key];
                                    return (
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "" &&
                                      val !== "N/A"
                                    );
                                  });
                                }
                                return true;
                              };
                              const isSpecialComponent = [
                                "ReservationCategory",
                                "DepartmentalCandidate",
                                "PersonWithDisability",
                                "AreYouASportsMan",
                                "ExServicemen",
                                "DomicileOfOdisha",
                                "Experience-Static",
                              ].includes(input.values.inputFieldType);
                              if (
                                isSpecialComponent &&
                                input.values.inputFieldType ===
                                  "Experience-Static"
                              ) {
                                return true;
                              }
                              if (
                                input.values.inputFieldType === "SubHeading" ||
                                input.values.inputFieldType === "note"
                              ) {
                                return false;
                              }
                              return hasValue(rawValue);
                            });
                          }
                          return false;
                        };

                        // Also check if there's experience data in applicationDetails
                        const hasExperienceTableData =
                          applicationDetails?.newStaticExperience &&
                          Array.isArray(
                            applicationDetails.newStaticExperience
                          ) &&
                          applicationDetails.newStaticExperience.length > 0;

                        if (hasExperienceData() || hasExperienceTableData) {
                          return (
                            <label
                              className="form-label form-heading-main"
                              style={{
                                backgroundColor: "rgb(146, 29, 30)",
                                color: "white",
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                                borderBottom: "none",
                                padding: "10px",
                                marginTop: "0",
                                marginBottom: "0",
                                marginLeft: "12px",
                                marginRight: "12px",
                                width: "calc(100% - 24px)",
                              }}
                            >
                              EXPERIENCE
                            </label>
                          );
                        }
                      }
                      return null;
                    })()}

                    {/* Render Total Experience section under EXPERIENCE tab */}
                    {applicationForm?.find(
                      (item) => item?.formTab?.toUpperCase() === "EXPERIENCE"
                    ) && (
                      <Card
                        className="mt-2 mb-0 dynamicFormcards ms-3 me-3"
                        style={{ width: "97%" }}
                      >
                        <Row className="mt-3">
                          <label
                            className="form-label form-heading-main"
                            style={{
                              backgroundColor: "#6c757d",
                              color: "white",
                              borderTopLeftRadius: "10px",
                              borderTopRightRadius: "10px",
                              padding: "10px",
                            }}
                          >
                            Total Experience
                          </label>
                        </Row>
                        <div>
                          <table
                            bordered
                            className="specific-table"
                            style={{
                              overflow: "hidden",
                              width: "98%",
                              tableLayout: "fixed",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  border: "1px solid black",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  fontWeight: "bold",
                                }}
                              >
                                <th>Name of Organization</th>
                                <th>Type of Organization</th>
                                <th>Type of Service</th>
                                <th>Status of Service</th>
                                <th>Nature of Business</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Total Experience</th>
                              </tr>
                            </thead>
                            <tbody>
                              {applicationDetails?.newStaticExperience?.map(
                                (entry, index) => (
                                  <tr key={index}>
                                    <td>{entry?.nameOfOrganization}</td>
                                    <td>{entry?.typeOfOrganization}</td>
                                    <td>{entry?.typeOfService}</td>
                                    <td>{entry?.statusOfService}</td>
                                    <td>
                                      {entry?.natureOfBusiness === "Other"
                                        ? entry?.natureOfBusinessOther
                                        : entry?.natureOfBusiness}
                                    </td>
                                    <td>{entry?.startDateOfService}</td>
                                    <td>{entry?.endDateOfService}</td>
                                    <td>{entry?.totalExperience}</td>
                                  </tr>
                                )
                              )}
                            </tbody>
                          </table>
                        </div>

                        <div className="mt-3">
                          <p className="fw-bold">
                            Total Experience (excluding trainee period):
                            <span style={{ color: "brown" }}>
                              {
                                applicationDetails?.finalSummeryExp
                                  ?.total_postWiseTotalExperienceWithoutTrainee
                              }
                            </span>
                          </p>
                          <p className="fw-bold">
                            Refer to Annexure I for post-wise experience
                            details.
                          </p>
                        </div>

                        <div className="mt-3">
                          <p className="fw-bold">
                            Total Relevant Experience (excluding trainee
                            period):
                            <span style={{ color: "brown" }}>
                              {
                                applicationDetails?.finalSummeryExp
                                  ?.total_relevantTotalExperienceWithoutTrainee
                              }
                            </span>
                          </p>
                          <p className="fw-bold">
                            Refer to Annexure II for relevant experience
                            details.
                          </p>
                        </div>

                        <div className="mt-3">
                          <p className="fw-bold">
                            Annexure I: Post-wise Experience Details
                          </p>
                          <table
                            bordered
                            className="specific-table"
                            style={{
                              overflow: "hidden",
                              width: "98%",
                              tableLayout: "fixed",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  border: "1px solid black",
                                  whiteSpace: "normal",
                                  wordWrap: "break-word",
                                  fontWeight: "bold",
                                }}
                              >
                                <th>Name of Organization</th>
                                <th>Employee Category</th>
                                <th>Nature of Job Handled</th>
                                <th>Designation</th>
                                <th>From</th>
                                <th>To</th>
                                <th>Total Experience</th>
                              </tr>
                            </thead>
                            <tbody>
                              {applicationDetails?.newStaticExperience?.flatMap(
                                (entry, index) =>
                                  entry?.postWiseDetails.map(
                                    (post, postIndex) => (
                                      <tr key={`${index}-${postIndex}`}>
                                        <td>{entry?.nameOfOrganization}</td>
                                        <td>
                                          {post?.isTrainee === "Yes"
                                            ? "Trainee"
                                            : "Other ( Regular / Contractual / Probationer )"}
                                        </td>
                                        <td>
                                          {post?.natureOfJobHandled || "N/A"}
                                        </td>
                                        <td>{post?.designation}</td>
                                        <td>{post?.startDateOfService}</td>
                                        <td>{post?.endDateOfService}</td>
                                        <td>{post?.totalExperience}</td>
                                      </tr>
                                    )
                                  )
                              )}
                            </tbody>
                          </table>
                        </div>

                        {applicationDetails?.newStaticExperience?.some(
                          (entry) => entry?.relevantExperience?.length > 0
                        ) && (
                          <div className="mt-3">
                            <p className="fw-bold">
                              Annexure II: Relevant Experience Details
                            </p>
                            <table
                              bordered
                              className="specific-table"
                              style={{
                                overflow: "hidden",
                                width: "98%",
                                tableLayout: "fixed",
                              }}
                            >
                              <thead>
                                <tr
                                  style={{
                                    border: "1px solid black",
                                    whiteSpace: "normal",
                                    wordWrap: "break-word",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <th>Name of Organization</th>
                                  <th>Employee Category</th>
                                  <th>Nature of Job Handled</th>
                                  {applicationDetails?.vacancyId?.department?.name
                                    ?.trim()
                                    ?.toLowerCase() === "sales & marketing" && (
                                    <>
                                      <th>Sales & Marketing experience</th>
                                      <th>
                                        Please specify the related finished
                                        product
                                      </th>
                                    </>
                                  )}
                                  {applicationDetails?.vacancyId?.department?.name
                                    ?.trim()
                                    ?.toLowerCase() === "geology" && (
                                    <>
                                      <th>Name of the metalliferous mine</th>
                                      <th>Location</th>
                                    </>
                                  )}
                                  <th>From</th>
                                  <th>To</th>
                                  <th>Total Experience</th>
                                </tr>
                              </thead>
                              <tbody>
                                {applicationDetails?.newStaticExperience?.flatMap(
                                  (entry, index) =>
                                    entry?.relevantExperience?.map(
                                      (post, postIndex) => (
                                        <tr key={`${index}-${postIndex}`}>
                                          <td>
                                            {entry?.nameOfOrganization || "N/A"}
                                          </td>
                                          <td>
                                            {post?.isTrainee === "Yes"
                                              ? "Trainee"
                                              : "Other ( Regular / Contractual / Probationer )"}
                                          </td>
                                          <td>
                                            {post?.relevantNatureOfJobHandled ||
                                              post?.natureOfJobHandled ||
                                              "N/A"}
                                          </td>
                                          {applicationDetails?.vacancyId?.department?.name
                                            ?.trim()
                                            ?.toLowerCase() ===
                                            "sales & marketing" && (
                                            <>
                                              <td>
                                                {post?.salesMarketingExperience ||
                                                  "N/A"}
                                              </td>
                                              <td>
                                                {post?.relatedFinishedProduct ||
                                                  "N/A"}
                                              </td>
                                            </>
                                          )}
                                          {applicationDetails?.vacancyId?.department?.name
                                            ?.trim()
                                            ?.toLowerCase() === "geology" && (
                                            <>
                                              <td>
                                                {post?.nameOfMetalliferousMine ||
                                                  "N/A"}
                                              </td>
                                              <td>
                                                {post?.mineLocation || "N/A"}
                                              </td>
                                            </>
                                          )}
                                          <td>
                                            {post?.startDateOfService || "N/A"}
                                          </td>
                                          <td>
                                            {post?.endDateOfService || "N/A"}
                                          </td>
                                          <td>
                                            {post?.totalExperience || "N/A"}
                                          </td>
                                        </tr>
                                      )
                                    )
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </Card>
                    )}

                    {/* Check if DOCUMENTS formTab has data and show heading before Documents Review */}
                    {(() => {
                      const documentsTab = applicationForm?.find(
                        (item) => item?.formTab === "DOCUMENTS"
                      );
                      if (documentsTab) {
                        // Check if DOCUMENTS section has data
                        const hasDocumentsData = () => {
                          if (!documentsTab) return false;
                          if (documentsTab?.isArray) {
                            const tabName = camelCase(documentsTab?.formTab);
                            return dynamicFields?.some(
                              (fieldSet) =>
                                fieldSet?.tab === tabName &&
                                fieldSet?.fields?.length > 0
                            );
                          }
                          if (
                            documentsTab?.values &&
                            Array.isArray(documentsTab.values)
                          ) {
                            return documentsTab.values.some((input) => {
                              if (!input?.values) return false;
                              const camelCaseKey = camelCase(input.values._id);
                              const fieldId = input.values._id;
                              const camelCaseFieldName = camelCase(
                                input.values.inputFieldName
                              );
                              const fieldName = input.values.inputFieldName;
                              let rawValue = "";
                              if (applicationDetails) {
                                rawValue =
                                  applicationDetails[camelCaseKey] ||
                                  applicationDetails[fieldId] ||
                                  applicationDetails[camelCaseFieldName] ||
                                  applicationDetails[fieldName] ||
                                  "";
                              }
                              const hasValue = (value) => {
                                if (value === null || value === undefined)
                                  return false;
                                if (typeof value === "string") {
                                  const trimmed = value.trim();
                                  if (trimmed === "No" || trimmed === "Yes")
                                    return true;
                                  return (
                                    trimmed !== "" &&
                                    trimmed !== "N/A" &&
                                    trimmed !== "null" &&
                                    trimmed !== "undefined" &&
                                    trimmed !== " "
                                  );
                                }
                                if (typeof value === "object") {
                                  if (Array.isArray(value)) {
                                    return (
                                      value.length > 0 &&
                                      value.some((item) => {
                                        if (
                                          typeof item === "object" &&
                                          item !== null
                                        ) {
                                          return (
                                            item.file ||
                                            item.name ||
                                            item.url ||
                                            item.value
                                          );
                                        }
                                        return (
                                          item && String(item).trim() !== ""
                                        );
                                      })
                                    );
                                  }
                                  return Object.keys(value).some((key) => {
                                    const val = value[key];
                                    return (
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "" &&
                                      val !== "N/A"
                                    );
                                  });
                                }
                                return true;
                              };
                              const isSpecialComponent = [
                                "ReservationCategory",
                                "DepartmentalCandidate",
                                "PersonWithDisability",
                                "AreYouASportsMan",
                                "ExServicemen",
                                "DomicileOfOdisha",
                                "Experience-Static",
                              ].includes(input.values.inputFieldType);
                              if (isSpecialComponent) {
                                return false; // Don't count special components for documents
                              }
                              if (
                                input.values.inputFieldType === "SubHeading" ||
                                input.values.inputFieldType === "note"
                              ) {
                                return false;
                              }
                              return hasValue(rawValue);
                            });
                          }
                          return false;
                        };

                        if (hasDocumentsData()) {
                          return (
                            <label
                              className="form-label form-heading-main"
                              style={{
                                backgroundColor: "rgb(146, 29, 30)",
                                color: "white",
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                                borderBottom: "none",
                                padding: "10px",
                                marginTop: "0",
                                marginBottom: "0",
                                marginLeft: "12px",
                                marginRight: "12px",
                                width: "calc(100% - 24px)",
                              }}
                            >
                              DOCUMENTS
                            </label>
                          );
                        }
                      }
                      return null;
                    })()}

                    <Card
                      className="mt-2 mb-0 dynamicFormcards ms-3 me-3"
                      style={{ width: "97%" }}
                    >
                      <Row className="mt-3">
                        <label
                          className="form-label form-heading-main"
                          style={{
                            backgroundColor: "#6c757d",
                            color: "white",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                            padding: "10px",
                          }}
                        >
                          Documents Review
                        </label>
                        <div>
                          <Col xs="12" className="">
                            <div className="custom-card-tabMain">
                              <div className="p-0 m-0">
                                <Table
                                  bordered
                                  className="specific-table"
                                  style={{
                                    overflow: "hidden",
                                    width: "98%",
                                    tableLayout: "fixed",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Field Name
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        File Name
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                      >
                                        Is Uploaded
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                      >
                                        Verified Status
                                      </th>
                                      <th
                                        style={{
                                          border: "1px solid black",
                                          whiteSpace: "normal",
                                          wordWrap: "break-word",
                                          fontWeight: "bold",
                                          textAlign: "center",
                                        }}
                                      >
                                        View
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(() => {
                                      // Use Set to track processed documents and prevent duplicates
                                      const processedDocuments = new Set();

                                      // Helper function to create unique key for a document
                                      // Use only fileUrl to prevent same file appearing multiple times with different fieldIds
                                      const getDocumentKey = (fileUrl) => {
                                        return fileUrl;
                                      };

                                      // Helper function to check and mark document as processed
                                      const isDocumentProcessed = (
                                        fieldId,
                                        fileUrl
                                      ) => {
                                        const key = getDocumentKey(fileUrl);
                                        if (processedDocuments.has(key)) {
                                          return true;
                                        }
                                        processedDocuments.add(key);
                                        return false;
                                      };

                                      // Collect all document rows
                                      const documentRows = [];

                                      {
                                        /* Dynamically display all uploaded documents from applicationForm */
                                      }
                                      applicationForm?.forEach((formItem) => {
                                        if (!formItem?.values) return;

                                        formItem.values.forEach((field) => {
                                          const fieldId = field?.values?._id;
                                          const fieldName =
                                            field?.values?.inputFieldName || "";
                                          const inputFieldType =
                                            field?.values?.inputFieldType;

                                          // Check if this is a file upload field
                                          const isFileUploadField =
                                            inputFieldType === "pdf" ||
                                            inputFieldType === "image" ||
                                            inputFieldType === "multiplePdf" ||
                                            inputFieldType === "multipleImage";

                                          if (!isFileUploadField || !fieldId)
                                            return;

                                          const fieldValue =
                                            applicationDetails[fieldId];
                                          if (!fieldValue) return;

                                          // Handle different file formats - preserve full object structure
                                          let fileArray = [];
                                          if (
                                            typeof fieldValue === "string" &&
                                            fieldValue.trim() !== ""
                                          ) {
                                            // Legacy format: comma-separated URLs
                                            const urls = fieldValue
                                              .split(",")
                                              .filter(Boolean);
                                            fileArray = urls.map((url) => ({
                                              file: url,
                                              name: "",
                                              verified: false,
                                            }));
                                          } else if (
                                            Array.isArray(fieldValue)
                                          ) {
                                            // New format: array of objects or strings
                                            fileArray = fieldValue
                                              .map((item) => {
                                                if (typeof item === "string") {
                                                  return {
                                                    file: item,
                                                    name: "",
                                                    verified: false,
                                                  };
                                                }
                                                if (
                                                  typeof item === "object" &&
                                                  item?.file
                                                ) {
                                                  return {
                                                    file: item.file,
                                                    name: item.name || "",
                                                    verified:
                                                      item.verified || false,
                                                  };
                                                }
                                                return null;
                                              })
                                              .filter(
                                                (item) =>
                                                  item &&
                                                  item.file &&
                                                  typeof item.file ===
                                                    "string" &&
                                                  item.file.trim() !== ""
                                              );
                                          }

                                          if (fileArray.length === 0) return;

                                          // Process each file and add to documentRows if not duplicate
                                          fileArray.forEach(
                                            (fileObj, fileIndex) => {
                                              const fileUrl = fileObj.file;

                                              // Check if this document has already been processed
                                              if (
                                                isDocumentProcessed(
                                                  fieldId,
                                                  fileUrl
                                                )
                                              ) {
                                                return; // Skip duplicate
                                              }

                                              const inputtedFileName =
                                                fileObj.name || "";

                                              // Extract original file name from URL
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string" &&
                                                  fileUrl.trim() !== ""
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  // Try to get from query params first
                                                  const nameFromQuery =
                                                    url.searchParams.get(
                                                      "name"
                                                    );
                                                  if (nameFromQuery) {
                                                    originalFileName =
                                                      nameFromQuery;
                                                  } else {
                                                    // Get from pathname
                                                    const pathParts =
                                                      url.pathname.split("/");
                                                    const lastPart =
                                                      pathParts[
                                                        pathParts.length - 1
                                                      ];
                                                    if (
                                                      lastPart &&
                                                      lastPart !== ""
                                                    ) {
                                                      originalFileName =
                                                        lastPart;
                                                    }
                                                  }
                                                }
                                              } catch (error) {
                                                // If URL parsing fails, try to extract from string
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const parts =
                                                    fileUrl.split("/");
                                                  originalFileName =
                                                    parts[parts.length - 1] ||
                                                    "File";
                                                } else {
                                                  originalFileName = "File";
                                                }
                                              }

                                              // Display field name with index if multiple files
                                              const displayFieldName =
                                                fileArray.length > 1
                                                  ? `${fieldName} (${
                                                      fileIndex + 1
                                                    })`
                                                  : fieldName;

                                              // Combine file names - prefer inputted name, fallback to original
                                              const displayFileName =
                                                inputtedFileName ||
                                                originalFileName ||
                                                "-";

                                              // Check verified status - check both fileObj.verified and applicationDetails verified flag
                                              const isVerified =
                                                fileObj.verified ||
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] ||
                                                false;

                                              documentRows.push(
                                                <tr
                                                  key={`${fieldId}-${fileIndex}`}
                                                >
                                                  <td>{displayFieldName}</td>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          );
                                        });
                                      });

                                      {
                                        /* Also check dynamicFields for file uploads */
                                      }
                                      dynamicFields?.forEach((fieldSet) => {
                                        if (!fieldSet?.fields) return;

                                        fieldSet.fields.forEach((field) => {
                                          const fieldId = field?.values?._id;
                                          const fieldName =
                                            field?.values?.inputFieldName || "";
                                          const inputFieldType =
                                            field?.values?.inputFieldType;

                                          // Check if this is a file upload field
                                          const isFileUploadField =
                                            inputFieldType === "pdf" ||
                                            inputFieldType === "image" ||
                                            inputFieldType === "multiplePdf" ||
                                            inputFieldType === "multipleImage";

                                          if (!isFileUploadField || !fieldId)
                                            return;

                                          const fieldValue =
                                            field.value ||
                                            applicationDetails[fieldId];
                                          if (!fieldValue) return;

                                          // Handle different file formats - preserve full object structure
                                          let fileArray = [];
                                          if (
                                            typeof fieldValue === "string" &&
                                            fieldValue.trim() !== ""
                                          ) {
                                            // Legacy format: comma-separated URLs
                                            const urls = fieldValue
                                              .split(",")
                                              .filter(Boolean);
                                            fileArray = urls.map((url) => ({
                                              file: url,
                                              name: "",
                                              verified: false,
                                            }));
                                          } else if (
                                            Array.isArray(fieldValue)
                                          ) {
                                            // New format: array of objects or strings
                                            fileArray = fieldValue
                                              .map((item) => {
                                                if (typeof item === "string") {
                                                  return {
                                                    file: item,
                                                    name: "",
                                                    verified: false,
                                                  };
                                                }
                                                if (
                                                  typeof item === "object" &&
                                                  item?.file
                                                ) {
                                                  return {
                                                    file: item.file,
                                                    name: item.name || "",
                                                    verified:
                                                      item.verified || false,
                                                  };
                                                }
                                                return null;
                                              })
                                              .filter(
                                                (item) =>
                                                  item &&
                                                  item.file &&
                                                  typeof item.file ===
                                                    "string" &&
                                                  item.file.trim() !== ""
                                              );
                                          }

                                          if (fileArray.length === 0) return;

                                          // Process each file and add to documentRows if not duplicate
                                          fileArray.forEach(
                                            (fileObj, fileIndex) => {
                                              const fileUrl = fileObj.file;

                                              // Check if this document has already been processed
                                              if (
                                                isDocumentProcessed(
                                                  fieldId,
                                                  fileUrl
                                                )
                                              ) {
                                                return; // Skip duplicate
                                              }

                                              const inputtedFileName =
                                                fileObj.name || "";

                                              // Extract original file name from URL
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string" &&
                                                  fileUrl.trim() !== ""
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  // Try to get from query params first
                                                  const nameFromQuery =
                                                    url.searchParams.get(
                                                      "name"
                                                    );
                                                  if (nameFromQuery) {
                                                    originalFileName =
                                                      nameFromQuery;
                                                  } else {
                                                    // Get from pathname
                                                    const pathParts =
                                                      url.pathname.split("/");
                                                    const lastPart =
                                                      pathParts[
                                                        pathParts.length - 1
                                                      ];
                                                    if (
                                                      lastPart &&
                                                      lastPart !== ""
                                                    ) {
                                                      originalFileName =
                                                        lastPart;
                                                    }
                                                  }
                                                }
                                              } catch (error) {
                                                // If URL parsing fails, try to extract from string
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const parts =
                                                    fileUrl.split("/");
                                                  originalFileName =
                                                    parts[parts.length - 1] ||
                                                    "File";
                                                } else {
                                                  originalFileName = "File";
                                                }
                                              }

                                              // Display field name with index if multiple files
                                              const displayFieldName =
                                                fileArray.length > 1
                                                  ? `${fieldName} (${
                                                      fileIndex + 1
                                                    })`
                                                  : fieldName;

                                              // Combine file names - prefer inputted name, fallback to original
                                              const displayFileName =
                                                inputtedFileName ||
                                                originalFileName ||
                                                "-";

                                              // Check verified status - check both fileObj.verified and applicationDetails verified flag
                                              const isVerified =
                                                fileObj.verified ||
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] ||
                                                false;

                                              documentRows.push(
                                                <tr
                                                  key={`dynamic-${fieldId}-${fileIndex}`}
                                                >
                                                  <td>{displayFieldName}</td>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          );
                                        });
                                      });

                                      {
                                        /* Legacy hardcoded fields for backward compatibility */
                                      }
                                      if (
                                        applicationDetails.sportCertificateFile
                                      ) {
                                        const fileUrl =
                                          applicationDetails.sportCertificateFile;
                                        const fieldId = "sportCertificateFile";

                                        if (
                                          !isDocumentProcessed(fieldId, fileUrl)
                                        ) {
                                          let originalFileName = "";
                                          try {
                                            if (
                                              fileUrl &&
                                              typeof fileUrl === "string"
                                            ) {
                                              const url = new URL(fileUrl);
                                              originalFileName =
                                                url.searchParams.get("name") ||
                                                url.pathname.split("/").pop() ||
                                                "";
                                            }
                                          } catch {
                                            if (
                                              fileUrl &&
                                              typeof fileUrl === "string"
                                            ) {
                                              originalFileName =
                                                fileUrl.split("/").pop() || "";
                                            }
                                          }
                                          const displayFileName =
                                            originalFileName || "-";
                                          const isVerified =
                                            applicationDetails[
                                              `${fieldId}verified`
                                            ] || false;

                                          documentRows.push(
                                            <tr key="sportCertificateFile">
                                              <td>Sport Certificate</td>
                                              <td>{displayFileName}</td>
                                              <td className="docTableIcon">
                                                <IoCheckmarkCircleOutline
                                                  color="green"
                                                  size={"22"}
                                                />
                                              </td>
                                              <td className="docTableIcon">
                                                {isVerified ? (
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                ) : (
                                                  <span
                                                    style={{ color: "#dc3545" }}
                                                  >
                                                    Not Verified
                                                  </span>
                                                )}
                                              </td>
                                              <td className="docTableIcon">
                                                <div
                                                  style={{ marginLeft: "0px" }}
                                                  variant="outline"
                                                  onClick={() =>
                                                    handleViewFile(
                                                      fieldId,
                                                      fileUrl
                                                    )
                                                  }
                                                >
                                                  <IoEyeOutline size={"25"} />
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        }
                                      }
                                      {
                                        applicationDetails.reservationCertificateFile && (
                                          <tr>
                                            <td>Reservation Certificate</td>
                                            {(() => {
                                              const fileUrl =
                                                applicationDetails.reservationCertificateFile;
                                              const fieldId =
                                                "reservationCertificateFile";
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  originalFileName =
                                                    url.searchParams.get(
                                                      "name"
                                                    ) ||
                                                    url.pathname
                                                      .split("/")
                                                      .pop() ||
                                                    "";
                                                }
                                              } catch {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  originalFileName =
                                                    fileUrl.split("/").pop() ||
                                                    "";
                                                }
                                              }
                                              const displayFileName =
                                                originalFileName || "-";
                                              const isVerified =
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] || false;
                                              return (
                                                <>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              );
                                            })()}
                                          </tr>
                                        );
                                      }
                                      {
                                        applicationDetails[
                                          "6719d53d3ac83738a0ba587a"
                                        ] && (
                                          <tr>
                                            <td>
                                              Proof of CGPA/OGPA to percentage
                                              conversion Formula for 10th
                                            </td>
                                            {(() => {
                                              const fileUrl =
                                                applicationDetails[
                                                  "6719d53d3ac83738a0ba587a"
                                                ];
                                              const fieldId =
                                                "6719d53d3ac83738a0ba587a";
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  originalFileName =
                                                    url.searchParams.get(
                                                      "name"
                                                    ) ||
                                                    url.pathname
                                                      .split("/")
                                                      .pop() ||
                                                    "";
                                                }
                                              } catch {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  originalFileName =
                                                    fileUrl.split("/").pop() ||
                                                    "";
                                                }
                                              }
                                              const displayFileName =
                                                originalFileName || "-";
                                              const isVerified =
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] || false;
                                              return (
                                                <>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              );
                                            })()}
                                          </tr>
                                        );
                                      }
                                      {
                                        applicationDetails[
                                          "670573c622eac4495862458b"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac4495862458b"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac4495862458b";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={index}>
                                                <td>10th Certificate</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }

                                      {
                                        applicationDetails[
                                          "670573c622eac4495862458d"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac4495862458d"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac4495862458d";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={index}>
                                                <td>10th Marksheet</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }
                                      {
                                        applicationDetails[
                                          "6719d8603ac83738a0ba5fd7"
                                        ] && (
                                          <tr>
                                            <td>
                                              Proof of CGPA/OGPA to percentage
                                              conversion Formula for 12th
                                            </td>
                                            {(() => {
                                              const fileUrl =
                                                applicationDetails[
                                                  "6719d8603ac83738a0ba5fd7"
                                                ];
                                              const fieldId =
                                                "6719d8603ac83738a0ba5fd7";
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  originalFileName =
                                                    url.searchParams.get(
                                                      "name"
                                                    ) ||
                                                    url.pathname
                                                      .split("/")
                                                      .pop() ||
                                                    "";
                                                }
                                              } catch {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  originalFileName =
                                                    fileUrl.split("/").pop() ||
                                                    "";
                                                }
                                              }
                                              const displayFileName =
                                                originalFileName || "-";
                                              const isVerified =
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] || false;
                                              return (
                                                <>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              );
                                            })()}
                                          </tr>
                                        );
                                      }

                                      {
                                        applicationDetails[
                                          "670573c622eac4495862458f"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac4495862458f"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac4495862458f";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={`cert-${index}`}>
                                                <td>12th Certificate</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }

                                      {
                                        applicationDetails[
                                          "670573c622eac44958624591"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac44958624591"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac44958624591";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={`marksheet-${index}`}>
                                                <td>12th Marksheet</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }

                                      {
                                        applicationDetails[
                                          "6719d9653ac83738a0ba6155"
                                        ] && (
                                          <tr>
                                            <td>
                                              Proof of CGPA/OGPA to percentage
                                              conversion Formula for Graduation
                                            </td>
                                            {(() => {
                                              const fileUrl =
                                                applicationDetails[
                                                  "6719d9653ac83738a0ba6155"
                                                ];
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  originalFileName =
                                                    url.searchParams.get(
                                                      "name"
                                                    ) ||
                                                    url.pathname
                                                      .split("/")
                                                      .pop() ||
                                                    "";
                                                }
                                              } catch {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  originalFileName =
                                                    fileUrl.split("/").pop() ||
                                                    "";
                                                }
                                              }
                                              const fieldId =
                                                "6719d9653ac83738a0ba6155";
                                              const displayFileName =
                                                originalFileName || "-";
                                              const isVerified =
                                                applicationDetails[
                                                  `${fieldId}verified`
                                                ] || false;
                                              return (
                                                <>
                                                  <td>{displayFileName}</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    {isVerified ? (
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    ) : (
                                                      <span
                                                        style={{
                                                          color: "#dc3545",
                                                        }}
                                                      >
                                                        Not Verified
                                                      </span>
                                                    )}
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          fieldId,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </>
                                              );
                                            })()}
                                          </tr>
                                        );
                                      }
                                      {
                                        applicationDetails[
                                          "670573c622eac44958624593"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac44958624593"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac44958624593";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={`grad-cert-${index}`}>
                                                <td>Graduation Certificate</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }

                                      {
                                        applicationDetails[
                                          "670573c622eac44958624595"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "670573c622eac44958624595"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "670573c622eac44958624595";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr
                                                key={`grad-marksheet-${index}`}
                                              >
                                                <td>Graduation Marksheet</td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }
                                      {
                                        applicationDetails[
                                          "additionalQualification"
                                        ] &&
                                          applicationDetails[
                                            "additionalQualification"
                                          ]
                                            .map((qualification, qualIndex) => {
                                              // Guard clause - check if certificates exists and has content
                                              const hasCertificates =
                                                qualification?.certificates &&
                                                ((typeof qualification.certificates ===
                                                  "string" &&
                                                  qualification.certificates.trim()) ||
                                                  (Array.isArray(
                                                    qualification.certificates
                                                  ) &&
                                                    qualification.certificates
                                                      .length > 0 &&
                                                    qualification.certificates.some(
                                                      (item) =>
                                                        (typeof item ===
                                                          "string" &&
                                                          item.trim() !== "") ||
                                                        (typeof item ===
                                                          "object" &&
                                                          item !== null &&
                                                          item?.file &&
                                                          typeof item.file ===
                                                            "string" &&
                                                          item.file.trim() !==
                                                            "")
                                                    )));
                                              if (!hasCertificates) return null;

                                              // Handle both string and array formats for certificates
                                              const certificatesArray =
                                                typeof qualification.certificates ===
                                                "string"
                                                  ? qualification.certificates
                                                      .split(",")
                                                      .filter(
                                                        (f) =>
                                                          f && f.trim() !== ""
                                                      )
                                                  : Array.isArray(
                                                      qualification.certificates
                                                    )
                                                  ? qualification.certificates
                                                      .map((item) => {
                                                        if (
                                                          typeof item ===
                                                          "string"
                                                        ) {
                                                          return {
                                                            file: item,
                                                            name: "",
                                                            verified: false,
                                                          };
                                                        }
                                                        if (
                                                          typeof item ===
                                                            "object" &&
                                                          item !== null &&
                                                          item?.file
                                                        ) {
                                                          return {
                                                            file: item.file,
                                                            name:
                                                              item.name || "",
                                                            verified:
                                                              item.verified ||
                                                              false,
                                                          };
                                                        }
                                                        return null;
                                                      })
                                                      .filter(
                                                        (item) =>
                                                          item &&
                                                          item.file &&
                                                          typeof item.file ===
                                                            "string" &&
                                                          item.file.trim() !==
                                                            ""
                                                      )
                                                  : [];

                                              // Render each certificate file
                                              return certificatesArray.map(
                                                (certObj, certIndex) => {
                                                  const fileUrl =
                                                    typeof certObj === "string"
                                                      ? certObj
                                                      : certObj?.file || "";
                                                  const inputtedFileName =
                                                    typeof certObj ===
                                                      "object" &&
                                                    certObj !== null
                                                      ? certObj.name || ""
                                                      : "";

                                                  // Extract original file name from URL
                                                  let originalFileName = "";
                                                  try {
                                                    if (
                                                      fileUrl &&
                                                      typeof fileUrl ===
                                                        "string" &&
                                                      fileUrl.trim() !== ""
                                                    ) {
                                                      const url = new URL(
                                                        fileUrl
                                                      );
                                                      originalFileName =
                                                        url.searchParams.get(
                                                          "name"
                                                        ) ||
                                                        url.pathname
                                                          .split("/")
                                                          .pop() ||
                                                        "";
                                                    }
                                                  } catch {
                                                    if (
                                                      fileUrl &&
                                                      typeof fileUrl ===
                                                        "string" &&
                                                      fileUrl.trim() !== ""
                                                    ) {
                                                      originalFileName =
                                                        fileUrl
                                                          .split("/")
                                                          .pop() || "";
                                                    }
                                                  }

                                                  return (
                                                    <tr
                                                      key={`grad-cert-${qualIndex}-${certIndex}`}
                                                    >
                                                      <td>
                                                        Addl. Qualification
                                                        Certificate
                                                      </td>
                                                      <td>
                                                        {originalFileName ||
                                                          "-"}
                                                      </td>
                                                      <td>
                                                        {inputtedFileName ||
                                                          "-"}
                                                      </td>
                                                      <td className="docTableIcon">
                                                        <IoCheckmarkCircleOutline
                                                          color="green"
                                                          size={"22"}
                                                        />
                                                      </td>
                                                      <td className="docTableIcon">
                                                        <div
                                                          style={{
                                                            marginLeft: "0px",
                                                          }}
                                                          variant="outline"
                                                          onClick={() =>
                                                            handleViewFile(
                                                              qualification.id ||
                                                                `qual-${qualIndex}`,
                                                              fileUrl
                                                            )
                                                          }
                                                        >
                                                          <IoEyeOutline
                                                            size={"25"}
                                                          />
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              );
                                            })
                                            .flat();
                                      }

                                      {
                                        applicationDetails[
                                          "additionalQualification"
                                        ] &&
                                          applicationDetails[
                                            "additionalQualification"
                                          ].length > 0 &&
                                          applicationDetails[
                                            "additionalQualification"
                                          ].map((qualification, qualIndex) => {
                                            // Guard clause - check if markSheets exists and has content
                                            const hasMarkSheets =
                                              qualification?.markSheets &&
                                              ((typeof qualification.markSheets ===
                                                "string" &&
                                                qualification.markSheets.trim()) ||
                                                (Array.isArray(
                                                  qualification.markSheets
                                                ) &&
                                                  qualification.markSheets
                                                    .length > 0));
                                            if (!hasMarkSheets) return null;
                                            console.log(
                                              applicationDetails[
                                                "additionalQualification"
                                              ],
                                              "applicationDetails[]"
                                            );
                                            // Handle both string and array formats for markSheets
                                            const markSheetsArray =
                                              typeof qualification.markSheets ===
                                              "string"
                                                ? qualification.markSheets
                                                    .split(",")
                                                    .filter(Boolean)
                                                : Array.isArray(
                                                    qualification.markSheets
                                                  )
                                                ? qualification.markSheets.map(
                                                    (item) =>
                                                      typeof item === "string"
                                                        ? item
                                                        : item?.file || ""
                                                  )
                                                : [];

                                            return markSheetsArray
                                              .filter(
                                                (f) =>
                                                  f &&
                                                  typeof f === "string" &&
                                                  f.trim() !== ""
                                              )
                                              .map((file, index) => {
                                                let originalFileName = "";
                                                try {
                                                  if (
                                                    file &&
                                                    typeof file === "string"
                                                  ) {
                                                    const url = new URL(file);
                                                    originalFileName =
                                                      url.searchParams.get(
                                                        "name"
                                                      ) ||
                                                      url.pathname
                                                        .split("/")
                                                        .pop() ||
                                                      "";
                                                  }
                                                } catch (err) {
                                                  // fallback if 'file' is not a valid URL
                                                  if (
                                                    file &&
                                                    typeof file === "string"
                                                  ) {
                                                    originalFileName =
                                                      file.split("/").pop() ||
                                                      "";
                                                  }
                                                }

                                                return (
                                                  <tr
                                                    key={`grad-cert-${qualIndex}-${index}`}
                                                  >
                                                    <td>
                                                      Addl. Qualification
                                                      Marksheet
                                                    </td>
                                                    <td>
                                                      {originalFileName || "-"}
                                                    </td>
                                                    <td>-</td>
                                                    <td className="docTableIcon">
                                                      <IoCheckmarkCircleOutline
                                                        color="green"
                                                        size={"22"}
                                                      />
                                                    </td>
                                                    <td className="docTableIcon">
                                                      <div
                                                        style={{
                                                          marginLeft: "0px",
                                                        }}
                                                        variant="outline"
                                                        onClick={() =>
                                                          handleViewFile(
                                                            qualification.id ||
                                                              `qual-${qualIndex}`,
                                                            file
                                                          )
                                                        }
                                                      >
                                                        <IoEyeOutline
                                                          size={"25"}
                                                        />
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              });
                                          });
                                      }

                                      {
                                        applicationDetails[
                                          "6704ff8c5d92c272e0e9f2a1"
                                        ] &&
                                          (() => {
                                            const fieldValue =
                                              applicationDetails[
                                                "6704ff8c5d92c272e0e9f2a1"
                                              ];
                                            // Handle both string and array formats - preserve full object structure
                                            let fileArray = [];
                                            if (
                                              typeof fieldValue === "string" &&
                                              fieldValue.trim() !== ""
                                            ) {
                                              const urls = fieldValue
                                                .split(",")
                                                .filter(Boolean);
                                              fileArray = urls.map((url) => ({
                                                file: url,
                                                name: "",
                                                verified: false,
                                              }));
                                            } else if (
                                              Array.isArray(fieldValue)
                                            ) {
                                              fileArray = fieldValue
                                                .map((item) => {
                                                  if (
                                                    typeof item === "string"
                                                  ) {
                                                    return {
                                                      file: item,
                                                      name: "",
                                                      verified: false,
                                                    };
                                                  }
                                                  if (
                                                    typeof item === "object" &&
                                                    item?.file
                                                  ) {
                                                    return {
                                                      file: item.file,
                                                      name: item.name || "",
                                                      verified:
                                                        item.verified || false,
                                                    };
                                                  }
                                                  return null;
                                                })
                                                .filter(
                                                  (item) =>
                                                    item &&
                                                    item.file &&
                                                    typeof item.file ===
                                                      "string" &&
                                                    item.file.trim() !== ""
                                                );
                                            }
                                            return fileArray;
                                          })().map((fileObj, index) => {
                                            const fileUrl = fileObj.file;
                                            const inputtedFileName =
                                              fileObj.name || "";
                                            // Extract original file name from URL
                                            let originalFileName = "";
                                            try {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                const url = new URL(fileUrl);
                                                originalFileName =
                                                  url.searchParams.get(
                                                    "name"
                                                  ) ||
                                                  url.pathname
                                                    .split("/")
                                                    .pop() ||
                                                  "";
                                              }
                                            } catch {
                                              if (
                                                fileUrl &&
                                                typeof fileUrl === "string"
                                              ) {
                                                originalFileName =
                                                  fileUrl.split("/").pop() ||
                                                  "";
                                              }
                                            }
                                            const fieldId =
                                              "6704ff8c5d92c272e0e9f2a1";
                                            const displayFileName =
                                              inputtedFileName ||
                                              originalFileName ||
                                              "-";
                                            const isVerified =
                                              fileObj.verified ||
                                              applicationDetails[
                                                `${fieldId}verified`
                                              ] ||
                                              false;
                                            return (
                                              <tr key={`grad-cert-${index}`}>
                                                <td>
                                                  Other Relevant Documents
                                                </td>
                                                <td>{displayFileName}</td>
                                                <td className="docTableIcon">
                                                  <IoCheckmarkCircleOutline
                                                    color="green"
                                                    size={"22"}
                                                  />
                                                </td>
                                                <td className="docTableIcon">
                                                  {isVerified ? (
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  ) : (
                                                    <span
                                                      style={{
                                                        color: "#dc3545",
                                                      }}
                                                    >
                                                      Not Verified
                                                    </span>
                                                  )}
                                                </td>
                                                <td className="docTableIcon">
                                                  <div
                                                    style={{
                                                      marginLeft: "0px",
                                                    }}
                                                    variant="outline"
                                                    onClick={() =>
                                                      handleViewFile(
                                                        fieldId,
                                                        fileUrl
                                                      )
                                                    }
                                                  >
                                                    <IoEyeOutline size={"25"} />
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                      }

                                      // Add Experience documents to documentRows
                                      if (
                                        applicationDetails?.newStaticExperience
                                      ) {
                                        applicationDetails?.newStaticExperience?.forEach(
                                          (item) => {
                                            if (
                                              item?.proofOfExperienceDocument
                                            ) {
                                              item.proofOfExperienceDocument.forEach(
                                                (expData) => {
                                                  const fileUrl =
                                                    expData["fileUrl"];
                                                  if (!fileUrl) {
                                                    return;
                                                  }

                                                  // Check if this document has already been processed
                                                  if (
                                                    isDocumentProcessed(
                                                      "experience",
                                                      fileUrl
                                                    )
                                                  ) {
                                                    return; // Skip duplicate
                                                  }

                                                  const inputtedFileName =
                                                    expData?.customData || "";
                                                  // Extract original file name from URL
                                                  let originalFileName = "";
                                                  try {
                                                    if (
                                                      fileUrl &&
                                                      typeof fileUrl ===
                                                        "string"
                                                    ) {
                                                      const url = new URL(
                                                        fileUrl
                                                      );
                                                      originalFileName =
                                                        url.searchParams.get(
                                                          "name"
                                                        ) ||
                                                        url.pathname
                                                          .split("/")
                                                          .pop() ||
                                                        "";
                                                    }
                                                  } catch {
                                                    if (
                                                      fileUrl &&
                                                      typeof fileUrl ===
                                                        "string"
                                                    ) {
                                                      originalFileName =
                                                        fileUrl
                                                          .split("/")
                                                          .pop() || "";
                                                    }
                                                  }
                                                  const displayFileName =
                                                    inputtedFileName ||
                                                    originalFileName ||
                                                    "-";
                                                  const isVerified =
                                                    expData?.proofofexperienceVerified ||
                                                    false;

                                                  documentRows.push(
                                                    <tr
                                                      key={`exp-${
                                                        expData?.customData ||
                                                        Math.random()
                                                      }`}
                                                    >
                                                      <td>
                                                        Experience
                                                        Certificate/Proof of
                                                        Experience
                                                      </td>
                                                      <td>{displayFileName}</td>
                                                      <td className="docTableIcon">
                                                        <IoCheckmarkCircleOutline
                                                          color="green"
                                                          size={"22"}
                                                        />
                                                      </td>
                                                      <td className="docTableIcon">
                                                        {isVerified ? (
                                                          <IoCheckmarkCircleOutline
                                                            color="green"
                                                            size={"22"}
                                                          />
                                                        ) : (
                                                          <span
                                                            style={{
                                                              color: "#dc3545",
                                                            }}
                                                          >
                                                            Not Verified
                                                          </span>
                                                        )}
                                                      </td>
                                                      <td className="docTableIcon">
                                                        <div
                                                          style={{
                                                            marginLeft: "0px",
                                                          }}
                                                          variant="outline"
                                                          onClick={() =>
                                                            handleViewFile(
                                                              "fileUrl",
                                                              fileUrl
                                                            )
                                                          }
                                                        >
                                                          <IoEyeOutline
                                                            size={"25"}
                                                          />
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              );
                                            }
                                          }
                                        );
                                      }

                                      {
                                        /* Bar Council Enrollment Certificate - Show in Documents Review when hideLLBSection is true OR for Legal department */
                                      }
                                      {
                                        (hideLLBSection ||
                                          applicationDetails?.vacancyId
                                            ?.department?.name === "Legal") &&
                                          applicationDetails &&
                                          Object.keys(applicationDetails).some(
                                            (key) =>
                                              key.startsWith(
                                                "68ecd888eb422bea55aa71"
                                              ) &&
                                              applicationDetails[key] &&
                                              typeof applicationDetails[key] ===
                                                "string" &&
                                              applicationDetails[key].trim() !==
                                                ""
                                          ) &&
                                          Object.keys(applicationDetails)
                                            .filter(
                                              (key) =>
                                                key.startsWith(
                                                  "68ecd888eb422bea55aa71"
                                                ) &&
                                                applicationDetails[key] &&
                                                typeof applicationDetails[
                                                  key
                                                ] === "string" &&
                                                applicationDetails[
                                                  key
                                                ].trim() !== ""
                                            )
                                            .map((barCouncilKey, index) => {
                                              const fileUrl =
                                                applicationDetails[
                                                  barCouncilKey
                                                ];

                                              // Safely extract filename from URL
                                              let originalFileName = "";
                                              try {
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string" &&
                                                  fileUrl.startsWith("http")
                                                ) {
                                                  const url = new URL(fileUrl);
                                                  originalFileName =
                                                    url.searchParams.get(
                                                      "name"
                                                    ) ||
                                                    url.pathname
                                                      .split("/")
                                                      .pop() ||
                                                    "";
                                                }
                                              } catch (error) {
                                                // If URL parsing fails, try to extract from string
                                                if (
                                                  fileUrl &&
                                                  typeof fileUrl === "string"
                                                ) {
                                                  originalFileName =
                                                    fileUrl.split("/").pop() ||
                                                    "";
                                                }
                                              }

                                              return (
                                                <tr
                                                  key={`bar-council-${index}`}
                                                >
                                                  <td>
                                                    Bar Council Enrollment
                                                    Certificate
                                                  </td>
                                                  <td>
                                                    {originalFileName || "-"}
                                                  </td>
                                                  <td>-</td>
                                                  <td className="docTableIcon">
                                                    <IoCheckmarkCircleOutline
                                                      color="green"
                                                      size={"22"}
                                                    />
                                                  </td>
                                                  <td className="docTableIcon">
                                                    <div
                                                      style={{
                                                        marginLeft: "0px",
                                                      }}
                                                      variant="outline"
                                                      onClick={() =>
                                                        handleViewFile(
                                                          barCouncilKey,
                                                          fileUrl
                                                        )
                                                      }
                                                    >
                                                      <IoEyeOutline
                                                        size={"25"}
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            });
                                      }

                                      // Collect all directly rendered sections and add to documentRows
                                      // Note: All sections that were rendered directly are now added to documentRows above

                                      // Return all collected document rows
                                      return documentRows;
                                    })()}
                                  </tbody>
                                </Table>
                                {showIframe && (
                                  <Modal
                                    size="lg"
                                    show={showIframe === camelCaseKey}
                                    onHide={() => setShowIframe(false)}
                                    centered
                                    aria-labelledby="example-custom-modal-styling-title"
                                  >
                                    <Modal.Body className="text-center">
                                      <iframe
                                        src={fieldValue}
                                        width="100%"
                                        style={{
                                          border: "none",
                                          height: "80vh",
                                        }}
                                        title="PDF Viewer"
                                      />
                                      {/* {!applicationDetails[camelCaseKey + "verified"] && (
                                          <Button
                                            className="mt-2"
                                            style={{ borderRadius: "10px" }}
                                            onClick={() => {
                                              setApplicationDetails({
                                                ...applicationDetails,
                                                [`${camelCaseKey}verified`]: true,
                                              });
                                              setShowIframe(false);
                                            }}
                                          >
                                            {"Confirm Verification"}
                                          </Button>
                                        )} */}
                                      <Button
                                        className="mt-2"
                                        style={{ borderRadius: "10px" }}
                                        variant="secondary"
                                        onClick={() => setShowIframe(false)}
                                      >
                                        Close
                                      </Button>
                                    </Modal.Body>
                                  </Modal>
                                )}
                              </div>
                            </div>
                          </Col>
                        </div>
                      </Row>
                    </Card>

                    {/* <Declaration /> */}

                    {/* Note before declaration section */}
                    <Alert
                      variant="info"
                      className="mt-3 mb-2 ms-3 me-3"
                      style={{
                        width: "97%",
                        backgroundColor: "#fce8e8",
                        border: "1px solid #921d1e",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#921d1e",
                      }}
                    >
                      <strong>Note:</strong>
                      Please confirm submission of correct details by checking
                      the declaration checkbox below and ensure you select the
                      appropriate relationship option (Son of / Daughter of /
                      Wife of) from the relationship dropdown.
                    </Alert>

                    <Card
                      className="mt-2 mb-0 dynamicFormcards ms-3 me-3"
                      style={{ width: "97%" }}
                      id="declarationCheck"
                    >
                      <Row className="mt-3 align-items-center">
                        <Col xs={12} style={{ textAlign: "left" }}>
                          <input
                            type="checkbox"
                            id="declaration-checkbox-final"
                            onChange={handleCheckboxChangeDeclare}
                            checked={
                              applicationDetails.finalSubmitDeclaration || false
                            }
                            style={{
                              width: "18px",
                              height: "18px",
                              marginRight: "12px",
                              cursor: "pointer",
                              verticalAlign: "middle",
                              accentColor: "#921d1e",
                            }}
                          />
                          <label
                            htmlFor="declaration-checkbox-final"
                            style={{
                              fontSize: "14px",
                              display: "inline",
                              cursor: "pointer",
                              verticalAlign: "middle",
                            }}
                          >
                            I{"  "}
                            <i style={{ fontStyle: "italic" }}>
                              {applicationDetails["applicantSFullName"]}
                            </i>
                            {"  "}
                            <span style={{ display: "inline-block" }}>
                              {/* Inline dropdown */}
                              <select
                                id="relation_declaration"
                                value={relation}
                                onChange={handleRelationChange}
                                style={style.input}
                              >
                                <option value="Son">Son of</option>
                                <option value="Daughter">Daughter of</option>
                                <option value="Wife">Wife of</option>
                              </select>
                            </span>
                            <i style={{ fontStyle: "italic" }}>
                              {" "}
                              {applicationDetails["66a4cb29fc50e50a0b885535"]}
                            </i>{" "}
                            do hereby declare that all the statements made in
                            the application are true and correct to the best of
                            my knowledge and belief. In the event of any
                            information being found false, my
                            candidature/appointment is liable to be
                            cancelled/terminated without any reference & notice
                            to me.
                          </label>
                        </Col>
                      </Row>
                      <Row className="mt-3 align-items-center">
                        <Col xs={12} className="text-end">
                          {applicationDetails["66cb753a8d303737cc78cd5d"] && (
                            <img
                              src={
                                applicationDetails["66cb753a8d303737cc78cd5d"]
                              }
                              alt="Sign"
                              style={{
                                width: "100px",
                                height: "auto",
                                cursor: "pointer",
                              }}
                            />
                          )}
                          <p className="fw-bolder">Candidate Signature</p>
                        </Col>
                      </Row>
                    </Card>
                  </div>
                  <div>
                    <Row className="m-0"></Row>
                  </div>
                </div>
              </TabPanel>

              <Row className="me-0">
                <div className="text-center my-2">
                  <Card className="mb-2 ms-3 pt-2 me-2 dynamicFormcards d-flex align-items-center flex-row justify-content-end ">
                    <Button
                      className="bottom-card-button registrationFont ms-5 mt-4"
                      onClick={() => setTabIndex(Math.max(0, tabIndex - 1))}
                      disabled={tabIndex === 0}
                    >
                      Back
                    </Button>
                    {tabIndex === applicationForm?.length ? (
                      <>
                        <ReactToPrint
                          trigger={() => (
                            <Button className="bottom-card-submit-button registrationFont mt-4">
                              Print Preview
                            </Button>
                          )}
                          content={() => printRef.current}
                        />

                        <Button
                          className="bottom-card-submit-button registrationFont mt-4"
                          disabled={!applicationDetails?.finalSubmitDeclaration}
                          onClick={() => {
                            setFinalSubmitModal(true);
                          }}
                        >
                          Submit Application
                        </Button>

                        {finalSubmitModal && (
                          <FinalFormSubmitModal
                            handleSubmitForm={handleSubmitForm}
                            finalSubmitModal={finalSubmitModal}
                            setFinalSubmitModal={setFinalSubmitModal}
                          />
                        )}
                      </>
                    ) : (
                      <Button
                        className="bottom-card-submit-button registrationFont mt-4 "
                        disabled={saveAndNextLoader}
                        onClick={() => {
                          handleSubmitForm("Save", false);
                        }}
                      >
                        {saveAndNextLoader ? (
                          <>
                            <Spinner size="sm" /> Validating
                          </>
                        ) : (
                          "Save & Next"
                        )}
                      </Button>
                    )}
                  </Card>
                </div>
              </Row>
            </div>
          </Tabs>
        </div>
      )}
      {/* Bottom Card */}

      <div className="custom-footer">
        <p className="custom-footer-text">
          © 2024 Odisha Mining Corporation Ltd. (O M C LTD)
        </p>
      </div>

      {/* <Footer /> */}
      {showDeputationModal && (
        <DeputationModal
          show={showDeputationModal}
          onClose={() => setShowDeputationModal(false)}
        />
      )}
      <Gotop />
      {showErrorModal && (
        <Modal show={showErrorModal} onHide={handleModalClose} centered>
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <div className="d-flex align-items-center justify-content-center w-100">
              <img src={waringSign} alt="warn" />
            </div>
            {/* <Modal.Title></Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <h2
              style={{
                color: "#921D1E",
                fontSize: "28px",
                fontFamily: "Roboto",
                textAlign: "center",
              }}
            >
              Eligibility Errors
            </h2>
            {/* <p style={{ fontSize:'16px',marginTop:'20px', fontFamily:'Roboto', textAlign:'center'}}>

        </p> */}
            {errorFromBackend?.ageEligibilityError?.message && (
              <>
                <p
                  style={{
                    fontSize: "16px",
                    marginTop: "20px",
                    fontFamily: "Roboto",
                    textAlign: "center",
                  }}
                >
                  {errorFromBackend.ageEligibilityError.message}
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    marginTop: "15px",
                    fontFamily: "Roboto",
                    textAlign: "center",
                    color: "#666",
                    fontStyle: "italic",
                  }}
                >
                  Click OK to return to All Jobs page.
                </p>
              </>
            )}
            {errorFromBackend?.experienceEligibilityError?.message && (
              <>
                <p
                  style={{
                    fontSize: "16px",
                    marginTop: "20px",
                    fontFamily: "Roboto",
                    textAlign: "center",
                  }}
                >
                  {errorFromBackend.experienceEligibilityError.message}
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    marginTop: "15px",
                    fontFamily: "Roboto",
                    textAlign: "center",
                    color: "#666",
                    fontStyle: "italic",
                  }}
                >
                  Click OK to return to All Jobs page.
                </p>
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={handleModalClose}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                color: "#921D1E",
                background: "#F9F3F4",
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Not Eligible Modal - For Correspondence Course Type */}
      {showNotEligibleModal && (
        <Modal
          show={showNotEligibleModal}
          onHide={() => {
            setShowNotEligibleModal(false);
          }}
          centered
        >
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>
              Not Eligible
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h4 style={{ color: "#921D1E", marginBottom: "20px" }}>Notice</h4>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                This qualification must have been obtained through regular mode,
                as you have selected correspondence, hence you are not eligible
                for this post.
              </p>
              {/* <p
                style={{ fontSize: "14px", color: "#666", fontStyle: "italic" }}
              >
                Please select a different course type to proceed.
              </p> */}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={() => {
                setShowNotEligibleModal(false);
              }}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                backgroundColor: "#921D1E",
                color: "white",
                padding: "8px 30px",
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Integrated LLB Dialog */}
      {showIntegratedLLBDialog && (
        <Modal
          show={showIntegratedLLBDialog}
          onHide={() => {
            setShowIntegratedLLBDialog(false);
            setHideLLBSection(false); // Reset to show LLB section if user cancels
          }}
          centered
        >
          <Modal.Header style={{ background: "#921D1E", color: "white" }}>
            <Modal.Title style={{ fontSize: "18px", fontWeight: "600" }}>
              Integrated LLB Selected
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ textAlign: "center", padding: "20px" }}>
              <h4 style={{ color: "#921D1E", marginBottom: "20px" }}>Notice</h4>
              <p
                style={{
                  fontSize: "16px",
                  lineHeight: "1.6",
                  marginBottom: "20px",
                }}
              >
                {/* You have selected "Integrated LLB" as your graduation course.
                The LLB Degree section will be removed as it's not applicable
                for integrated programs. */}
                You are not required to fillup the details under LLB column.
              </p>
              <p
                style={{ fontSize: "14px", color: "#666", fontStyle: "italic" }}
              >
                Click "OK" to proceed.
              </p>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="primary"
              onClick={() => {
                setShowIntegratedLLBDialog(false);
                setHideLLBSection(true);
              }}
              style={{
                fontSize: "16px",
                fontWeight: "600",
                fontFamily: "Roboto",
                textAlign: "center",
                border: "1px solid #DEBBBB",
                color: "#921D1E",
                background: "#F9F3F4",
                padding: "8px 24px",
              }}
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default DynamicApplicationFrom;
